import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AccessGrantNode = {
  __typename?: 'AccessGrantNode';
  channelId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  expiration?: Maybe<Scalars['DateTime']>;
  grantType: Scalars['String'];
  grantedById?: Maybe<Scalars['String']>;
  grantedByType: Scalars['String'];
  id: Scalars['String'];
  planId?: Maybe<Scalars['String']>;
  purchaseId?: Maybe<Scalars['String']>;
  revokedBy?: Maybe<Scalars['String']>;
  revokedReason?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  startedAt: Scalars['DateTime'];
  status: Scalars['String'];
  tipsterId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type AdDayStat = {
  __typename?: 'AdDayStat';
  clicks: Scalars['Int'];
  date: Scalars['String'];
  impressions: Scalars['Int'];
  uniqueViews: Scalars['Int'];
};

export type AdMiniStat = {
  __typename?: 'AdMiniStat';
  adId: Scalars['ID'];
  clicks: Scalars['Int'];
  views: Scalars['Int'];
};

export type AdStats = {
  __typename?: 'AdStats';
  clicks: Scalars['Int'];
  timeSeries: Array<AdDayStat>;
  totalCtr: Scalars['Float'];
  totalViews: Scalars['Int'];
  uniqueCtr: Scalars['Float'];
  uniqueViews: Scalars['Int'];
  viewFrequency: Scalars['Float'];
};

export enum AdVariant {
  L = 'L',
  M = 'M',
  S = 'S'
}

export type Ads = {
  __typename?: 'Ads';
  createdAt: Scalars['DateTime'];
  ctaLink?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expirationDate: Scalars['DateTime'];
  frequencyCapImpressions?: Maybe<Scalars['Int']>;
  frequencyCapWindow?: Maybe<FrequencyCapWindow>;
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  isActive: Scalars['Boolean'];
  placement?: Maybe<Array<Placement>>;
  referral?: Maybe<Scalars['String']>;
  rotationWeight?: Maybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  targets?: Maybe<Array<AdsTarget>>;
  tenantId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant?: Maybe<AdVariant>;
  visible: Scalars['Boolean'];
};

export type AdsCreationInput = {
  ctaLink?: InputMaybe<Scalars['String']>;
  ctaText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  expirationDate: Scalars['DateTime'];
  frequencyCapImpressions?: InputMaybe<Scalars['Int']>;
  frequencyCapWindow?: InputMaybe<FrequencyCapWindow>;
  imageUrl: Scalars['String'];
  isActive: Scalars['Boolean'];
  placement?: InputMaybe<Array<Placement>>;
  referral?: InputMaybe<Scalars['String']>;
  rotationWeight?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  targets?: InputMaybe<Array<AdsTargetInput>>;
  title: Scalars['String'];
  variant?: InputMaybe<AdVariant>;
  visible: Scalars['Boolean'];
};

export type AdsFilter = {
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type AdsSort = {
  createdAt?: InputMaybe<SortMethod>;
  expirationDate?: InputMaybe<SortMethod>;
  id?: InputMaybe<SortMethod>;
  imageUrl?: InputMaybe<SortMethod>;
  isActive?: InputMaybe<SortMethod>;
  placement?: InputMaybe<SortMethod>;
  referral?: InputMaybe<SortMethod>;
  startDate?: InputMaybe<SortMethod>;
  title?: InputMaybe<SortMethod>;
  updatedAt?: InputMaybe<SortMethod>;
  visible?: InputMaybe<SortMethod>;
};

export type AdsTarget = {
  __typename?: 'AdsTarget';
  adsId: Scalars['ID'];
  channelId: Scalars['ID'];
  countryIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
};

export type AdsTargetInput = {
  channelId?: InputMaybe<Scalars['ID']>;
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AdsUpdate = {
  ctaLink?: InputMaybe<Scalars['String']>;
  ctaText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  frequencyCapImpressions?: InputMaybe<Scalars['Int']>;
  frequencyCapWindow?: InputMaybe<FrequencyCapWindow>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  placement?: InputMaybe<Array<Placement>>;
  referral?: InputMaybe<Scalars['String']>;
  rotationWeight?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  targets?: InputMaybe<Array<AdsTargetInput>>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<AdVariant>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type AffilateLinkCreate = {
  channelId?: InputMaybe<Scalars['String']>;
  deal?: InputMaybe<Scalars['Float']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  internalName: Scalars['String'];
  payPerHead?: InputMaybe<Scalars['Float']>;
  pphCurrency?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
  type?: InputMaybe<AffiliateLinkType>;
  usersLimit?: InputMaybe<Scalars['Float']>;
};

export type AffilateLinkFilters = {
  channelName?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AffilateLinkStatus>;
};

export type AffilateLinkModel = {
  __typename?: 'AffilateLinkModel';
  channel?: Maybe<ChannelModel>;
  channelId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deal?: Maybe<Scalars['Float']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  internalName: Scalars['String'];
  payPerHead?: Maybe<Scalars['Float']>;
  pphCurrency?: Maybe<Scalars['String']>;
  status: AffilateLinkStatus;
  tipsterId: Scalars['String'];
  tipsterName?: Maybe<Scalars['String']>;
  type?: Maybe<AffiliateLinkType>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<AffiliateLinkUserModel>>;
  usersLimit: Scalars['Float'];
  usersNumber?: Maybe<Scalars['Float']>;
};

export type AffilateLinkSort = {
  channelName?: InputMaybe<SortMethod>;
  createdAt?: InputMaybe<SortMethod>;
  expirationDate?: InputMaybe<SortMethod>;
  id?: InputMaybe<SortMethod>;
  internalName?: InputMaybe<SortMethod>;
};

export type AffilateLinkUpdtae = {
  channelId?: InputMaybe<Scalars['String']>;
  deal?: InputMaybe<Scalars['Float']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  internalName?: InputMaybe<Scalars['String']>;
  payPerHead?: InputMaybe<Scalars['Float']>;
  pphCurrency?: InputMaybe<Scalars['String']>;
  tipsterId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AffiliateLinkType>;
  usersLimit?: InputMaybe<Scalars['Float']>;
};

/** affiliate link type - invite or affiliate */
export enum AffiliateLinkType {
  Affiliate = 'AFFILIATE',
  Invite = 'INVITE'
}

export type AffiliateLinkUserModel = {
  __typename?: 'AffiliateLinkUserModel';
  affilateLinkId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type AffiliateLinkUsersFilter = {
  affilateLinkIds?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<BetweenDates>;
};

export type AffiliateLinkUsersSort = {
  createdAt?: InputMaybe<SortMethod>;
};

export type AllAds = {
  __typename?: 'AllAds';
  ads: Array<Ads>;
  count: Scalars['Int'];
};

export type AllAffilateLinkUsers = {
  __typename?: 'AllAffilateLinkUsers';
  affilateLinkUsers?: Maybe<Array<AffiliateLinkUserModel>>;
  count: Scalars['Float'];
};

export type AllAffilateLinks = {
  __typename?: 'AllAffilateLinks';
  affilateLinks?: Maybe<Array<AffilateLinkModel>>;
  count: Scalars['Float'];
};

export type AllBonuses = {
  __typename?: 'AllBonuses';
  bonuses?: Maybe<Array<BonusModel>>;
  count: Scalars['Float'];
};

export type AllUsersModel = {
  __typename?: 'AllUsersModel';
  count: Scalars['Float'];
  users: Array<UserModel>;
};

export type AnalyticsReport = {
  __typename?: 'AnalyticsReport';
  channelName: Scalars['String'];
  channelStatus: Scalars['String'];
  countryId?: Maybe<Scalars['String']>;
  freeTips: Scalars['Float'];
  id: Scalars['ID'];
  tipstersNumber: Scalars['Float'];
  usersNumber: Scalars['Float'];
  vipTips: Scalars['Float'];
};

export type AnalyticsReportInput = {
  channelName?: InputMaybe<Scalars['String']>;
  channelStatus?: InputMaybe<ChannelStatus>;
  countryId?: InputMaybe<Scalars['String']>;
  dates?: InputMaybe<BetweenDates>;
};

export type AnalyticsReports = {
  __typename?: 'AnalyticsReports';
  analyticsReports: Array<AnalyticsReport>;
  count: Scalars['Float'];
};

export type AnonymousModel = {
  __typename?: 'AnonymousModel';
  id: Scalars['ID'];
  tipsterId: Scalars['String'];
  userId: Scalars['String'];
};

export type AutoShareContentTypeInput = {
  channelId?: InputMaybe<Scalars['ID']>;
  contentTypes: Array<AutoShareContentTypes>;
  displayType?: Scalars['String'];
  shouldUpdateMessage?: Scalars['Boolean'];
};

export enum AutoShareContentTypes {
  FreeTip = 'FREE_TIP',
  NewPost = 'NEW_POST',
  VipTip = 'VIP_TIP'
}

/** Connection type for pagination of Available Payment */
export type AvailablePaymentConnection = {
  __typename?: 'AvailablePaymentConnection';
  edges: Array<AvailablePaymentNodeEdge>;
  pageInfo: PageInfo;
};

export type AvailablePaymentNode = {
  __typename?: 'AvailablePaymentNode';
  category: Scalars['String'];
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  isAutoActivated: Scalars['Boolean'];
  paymentName: Scalars['String'];
};

export type AvailablePaymentNodeEdge = {
  __typename?: 'AvailablePaymentNodeEdge';
  /** AvailablePaymentNode node */
  node: AvailablePaymentNode;
};

/** Type of multi-leg bet */
export enum BetType {
  /** Combination bet — multiple parlay permutations from the same selections */
  Combo = 'COMBO',
  /** Standard accumulator — all legs must win */
  StraightParlay = 'STRAIGHT_PARLAY',
  /** System bet — a minimum subset of legs must win */
  System = 'SYSTEM'
}

export type BetslipMatchedEvent = {
  __typename?: 'BetslipMatchedEvent';
  event?: Maybe<SportEvent>;
  tipIndex: Scalars['Int'];
};

/** Structured data extracted from a betslip image via OCR */
export type BetslipParseResult = {
  __typename?: 'BetslipParseResult';
  /** Bookmaker name as read from the betslip */
  bookmakerName?: Maybe<Scalars['String']>;
  /** Confidence score 0-1 based on how many fields were successfully extracted */
  confidence: Scalars['Float'];
  /** All tips/selections found on the betslip */
  tips: Array<BetslipTipItem>;
  /** Combined accumulator odds for the whole slip */
  totalOdds?: Maybe<Scalars['Float']>;
};

export type BetslipTipInput = {
  awayTeam: Scalars['String'];
  homeTeam: Scalars['String'];
};

/** A single tip extracted from a betslip */
export type BetslipTipItem = {
  __typename?: 'BetslipTipItem';
  awayTeam?: Maybe<Scalars['String']>;
  /** Event date in ISO 8601 format */
  eventDate?: Maybe<Scalars['String']>;
  homeTeam?: Maybe<Scalars['String']>;
  /** Betting market (e.g. 1X2, Over 2.5, BTTS) */
  market?: Maybe<Scalars['String']>;
  /** Decimal odds for this selection */
  odds?: Maybe<Scalars['Float']>;
};

export type BetweenDates = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type BonusCreate = {
  allowedCountryIds?: InputMaybe<Array<Scalars['ID']>>;
  buttonName?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<Scalars['String']>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  rewardType?: InputMaybe<Scalars['String']>;
  socialRating?: InputMaybe<Scalars['Float']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BonusModel = {
  __typename?: 'BonusModel';
  allowedCountryIds: Array<Scalars['ID']>;
  buttonName?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  rewardType?: Maybe<Scalars['String']>;
  socialRating?: Maybe<Scalars['Float']>;
  tenantId: Scalars['String'];
  termsAndConditions?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type BonusUpdate = {
  allowedCountryIds?: InputMaybe<Array<Scalars['ID']>>;
  buttonName?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Array<Scalars['String']>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  rewardType?: InputMaybe<Scalars['String']>;
  socialRating?: InputMaybe<Scalars['Float']>;
  termsAndConditions?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BookieDayStat = {
  __typename?: 'BookieDayStat';
  clicks: Scalars['Int'];
  date: Scalars['String'];
  impressions: Scalars['Int'];
  uniqueViews: Scalars['Int'];
};

export type BookieOdd = {
  __typename?: 'BookieOdd';
  bookieId: Scalars['ID'];
  bookieImageUrl?: Maybe<Scalars['String']>;
  bookieName: Scalars['String'];
  externalId?: Maybe<Scalars['Int']>;
  odd: Scalars['Float'];
  outcomeId: Scalars['ID'];
  outcomeName: Scalars['String'];
  specialBetValue?: Maybe<Scalars['Float']>;
};

export type Bookies = {
  __typename?: 'Bookies';
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  odd?: Maybe<Scalars['Float']>;
};

export type BookmakerOption = {
  __typename?: 'BookmakerOption';
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type Category = {
  __typename?: 'Category';
  code?: Maybe<Scalars['String']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sportId: Scalars['ID'];
};

export enum CategoryEnum {
  Facts = 'FACTS',
  Fun = 'FUN',
  Other = 'OTHER',
  Sport = 'SPORT'
}

export type ChannelContent = MultitipDetailed | PollDetailed | PostDetailed | TipDetailed;

/** channel create input */
export type ChannelCreate = {
  anonymized: Scalars['Boolean'];
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ChannelCategory>;
  channelDeal: Scalars['Float'];
  channelName: Scalars['String'];
  channelStatus?: InputMaybe<ChannelStatus>;
  channelType: ChannelType;
  countryId?: InputMaybe<Scalars['String']>;
  feeForPayment: Scalars['Float'];
  logo?: InputMaybe<Scalars['String']>;
  paymentOptions: PaymentOptions;
  trialSubscription: Scalars['Float'];
  usersLimit?: InputMaybe<Scalars['Float']>;
};

export type ChannelDetailed = {
  __typename?: 'ChannelDetailed';
  anonymized: Scalars['Boolean'];
  background?: Maybe<Scalars['String']>;
  category?: Maybe<ChannelCategory>;
  channelDeal: Scalars['Float'];
  channelName: Scalars['String'];
  channelStatus: ChannelStatus;
  channelType: ChannelType;
  channelUsers: Array<ChannelUserModel>;
  countryId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  feeForPayment: Scalars['Float'];
  id: Scalars['ID'];
  inviteLink?: Maybe<Scalars['String']>;
  isUserFollowing: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  paymentOptions?: Maybe<PaymentOptions>;
  pinnedContent?: Maybe<PinnedContent>;
  pinnedContentId?: Maybe<Scalars['Float']>;
  pinnedContentType?: Maybe<Scalars['String']>;
  settings?: Maybe<Array<ChannelSetting>>;
  tipsterCount?: Maybe<Scalars['Float']>;
  trialSubscription: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  usersCount?: Maybe<Scalars['Float']>;
  usersLimit: Scalars['Float'];
};

export type ChannelFeedFilter = {
  analysis?: InputMaybe<Scalars['Boolean']>;
  contentTypes?: Array<TypesOfContent>;
  /** Filter content created after this date */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** Filter content created before this date */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  resultCreatedBeforeHours?: InputMaybe<Scalars['Float']>;
  results?: Array<TipResult>;
  sportIds?: Array<Scalars['Float']>;
  vip?: InputMaybe<Scalars['Boolean']>;
};

export type ChannelFeedResponse = {
  __typename?: 'ChannelFeedResponse';
  feed?: Maybe<Array<ChannelContent>>;
  nextCursor?: Maybe<FeedCursor>;
  previousCursor?: Maybe<FeedCursor>;
};

export type ChannelFilterInput = {
  anonymized?: InputMaybe<Scalars['Boolean']>;
  channelName?: InputMaybe<Scalars['String']>;
  channelStatus?: InputMaybe<ChannelStatus>;
  countryId?: InputMaybe<Scalars['String']>;
  tipsterId?: InputMaybe<Scalars['String']>;
};

export type ChannelListCategory = {
  __typename?: 'ChannelListCategory';
  anonymized?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  channelDeal?: Maybe<Scalars['Float']>;
  channelName?: Maybe<Scalars['String']>;
  channelStatus?: Maybe<ChannelStatus>;
  channelType?: Maybe<ChannelType>;
  countryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  feeForPayment?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  inviteLink?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  members?: Maybe<Scalars['Float']>;
  paymentOptions?: Maybe<PaymentOptions>;
  pinnedContentId?: Maybe<Scalars['Float']>;
  pinnedContentType?: Maybe<Scalars['String']>;
  stat?: Maybe<TipsterStatistics>;
  tipsters?: Maybe<Array<ChannelListCategoryUser>>;
  trialSubscription?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usersLimit?: Maybe<Scalars['Float']>;
};

/** user */
export type ChannelListCategoryUser = {
  __typename?: 'ChannelListCategoryUser';
  avatarUrl?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  sports?: Maybe<Array<UserSports>>;
};

export type ChannelListFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  sportsId?: InputMaybe<Array<Scalars['String']>>;
  statFrom?: InputMaybe<Scalars['DateTime']>;
  statTo?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ChannelModel = {
  __typename?: 'ChannelModel';
  anonymized: Scalars['Boolean'];
  background?: Maybe<Scalars['String']>;
  category?: Maybe<ChannelCategory>;
  channelDeal: Scalars['Float'];
  channelName: Scalars['String'];
  channelStatus: ChannelStatus;
  channelType: ChannelType;
  countryId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  feeForPayment: Scalars['Float'];
  id: Scalars['ID'];
  inviteLink?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  paymentOptions?: Maybe<PaymentOptions>;
  pinnedContentId?: Maybe<Scalars['Float']>;
  pinnedContentType?: Maybe<Scalars['String']>;
  settings?: Maybe<Array<ChannelSetting>>;
  tipsterCount?: Maybe<Scalars['Float']>;
  trialSubscription: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  usersCount?: Maybe<Scalars['Float']>;
  usersLimit: Scalars['Float'];
};

export type ChannelSetting = {
  __typename?: 'ChannelSetting';
  category: ChannelSettingsCategory;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: ChannelSettingsName;
  scope: ChannelSettingsScope;
  value: Scalars['String'];
};

export type ChannelSortInput = {
  anonymized?: InputMaybe<SortMethod>;
  channelDeal?: InputMaybe<SortMethod>;
  channelName?: InputMaybe<SortMethod>;
  channelStatus?: InputMaybe<SortMethod>;
  channelType?: InputMaybe<SortMethod>;
  id?: InputMaybe<SortMethod>;
};

/** Tip input parameters for updating an existing Tip */
export type ChannelUpdate = {
  anonymized?: InputMaybe<Scalars['Boolean']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ChannelCategory>;
  channelDeal?: InputMaybe<Scalars['Float']>;
  channelName?: InputMaybe<Scalars['String']>;
  channelStatus?: InputMaybe<ChannelStatus>;
  channelType?: InputMaybe<ChannelType>;
  countryId?: InputMaybe<Scalars['String']>;
  feeForPayment?: InputMaybe<Scalars['Float']>;
  logo?: InputMaybe<Scalars['String']>;
  paymentOptions?: InputMaybe<PaymentOptions>;
  settings?: InputMaybe<SettingsUpdate>;
  trialSubscription?: InputMaybe<Scalars['Float']>;
  usersLimit?: InputMaybe<Scalars['Float']>;
};

export type ChannelUserModel = {
  __typename?: 'ChannelUserModel';
  channelId: Scalars['String'];
  channelRole: ChannelRole;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type ChannelUsersList = {
  __typename?: 'ChannelUsersList';
  channelUsers: Array<ChannelUserModel>;
  totalCount: Scalars['Float'];
};

export type Channels = {
  __typename?: 'Channels';
  channels: Array<ChannelModel>;
  count: Scalars['Float'];
};

export type Chat = {
  __typename?: 'Chat';
  accepted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  hasNewMessage: Scalars['Boolean'];
  id: Scalars['ID'];
  receiverHasNewMessages: Scalars['Boolean'];
  receiverId: Scalars['ID'];
  senderHasNewMessages: Scalars['Boolean'];
  senderId: Scalars['ID'];
  subject?: Maybe<Scalars['String']>;
};

/** message input parameters for creating a new message */
export type ChatCreate = {
  email?: InputMaybe<Scalars['String']>;
  initialMessage?: InputMaybe<InitialMessage>;
  receiverId: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
};

export type ChatList = {
  __typename?: 'ChatList';
  accepted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  hasNewMessage: Scalars['Boolean'];
  id: Scalars['ID'];
  lastMessage?: Maybe<Message>;
  receiverId: Scalars['ID'];
  senderId: Scalars['ID'];
  subject?: Maybe<Scalars['String']>;
};

export type Chats = {
  __typename?: 'Chats';
  chats: Array<ChatList>;
  totalCount: Scalars['Float'];
};

/** comment input parameters for creating a new Comment */
export type CommentCreateInput = {
  contentId: Scalars['ID'];
  contentType: TypesOfContent;
  imageLink?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  userId: Scalars['ID'];
};

/** comments with user */
export type CommentDetailed = {
  __typename?: 'CommentDetailed';
  contentId: Scalars['ID'];
  contentType: TypesOfContent;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imageLink?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

/** Comment object parameters */
export type CommentModel = {
  __typename?: 'CommentModel';
  contentId: Scalars['ID'];
  contentType: TypesOfContent;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imageLink?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

/** comment input parameters for updating an existing comment */
export type CommentUpdateInput = {
  contentId?: InputMaybe<Scalars['ID']>;
  contentType?: InputMaybe<TypesOfContent>;
  imageLink?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** comment input parameters for creating a new Comment */
export type CommentsByType = {
  contentId: Scalars['ID'];
  contentType: TypesOfContent;
};

export type CommentsReturnType = {
  __typename?: 'CommentsReturnType';
  comments: Array<CommentDetailed>;
  totalCount: Scalars['Float'];
};

/** create tournament */
export type CompetitionCreate = {
  bookmarkerId?: InputMaybe<Scalars['String']>;
  channelIds?: InputMaybe<Array<Scalars['String']>>;
  competitionType?: InputMaybe<CompetitionType>;
  cta?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eligibleCountries?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  events: Array<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  marketIds?: InputMaybe<Array<Scalars['String']>>;
  maxParticipants: Scalars['Float'];
  minimumSettledTips?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  rankingMetric?: InputMaybe<Scalars['String']>;
  rankingSportIds?: InputMaybe<Array<Scalars['String']>>;
  /** List of rewards for the competition */
  rewards?: InputMaybe<Array<RewardInput>>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  termsAndconditions?: InputMaybe<Scalars['String']>;
  termsAndconditionsLink?: InputMaybe<Scalars['String']>;
  vip?: InputMaybe<Scalars['Boolean']>;
};

export enum CompetitionCreatedByType {
  Admin = 'ADMIN',
  Tipster = 'TIPSTER'
}

export type CompetitionEventData = {
  __typename?: 'CompetitionEventData';
  competitors?: Maybe<Array<Competitor>>;
  eventDate?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  oddType?: Maybe<OddType>;
  outcomeValue?: Maybe<Array<EventOutcomevalue>>;
  sportId?: Maybe<Scalars['Float']>;
  userCanVote: Scalars['Boolean'];
};

export enum CompetitionType {
  CorrectScore = 'CORRECT_SCORE',
  TipsterPerformance = 'TIPSTER_PERFORMANCE',
  VoteOutcome = 'VOTE_OUTCOME'
}

export type CompetitionUpdate = {
  bookmarkerId?: InputMaybe<Scalars['String']>;
  channelIds?: InputMaybe<Array<Scalars['String']>>;
  competitionType?: InputMaybe<CompetitionType>;
  cta?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eligibleCountries?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  events?: InputMaybe<Array<Scalars['String']>>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  marketIds?: InputMaybe<Array<Scalars['String']>>;
  maxParticipants?: InputMaybe<Scalars['Float']>;
  minimumSettledTips?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationSentAt?: InputMaybe<Scalars['DateTime']>;
  rankingMetric?: InputMaybe<Scalars['String']>;
  rankingSportIds?: InputMaybe<Array<Scalars['String']>>;
  /** List of rewards for the competition */
  rewards?: InputMaybe<Array<RewardInput>>;
  sportIds?: InputMaybe<Array<Scalars['String']>>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  termsAndconditions?: InputMaybe<Scalars['String']>;
  termsAndconditionsLink?: InputMaybe<Scalars['String']>;
  vip?: InputMaybe<Scalars['Boolean']>;
};

export type Competitor = {
  __typename?: 'Competitor';
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: CompetitorType;
};

export enum CompetitorType {
  Local = 'LOCAL',
  Visitor = 'VISITOR',
  Void = 'VOID'
}

export type ContentCompetitionEvent = {
  __typename?: 'ContentCompetitionEvent';
  blocked?: Maybe<Scalars['Boolean']>;
  channelIds?: Maybe<Array<Scalars['String']>>;
  competitionType: CompetitionType;
  createdBy?: Maybe<Scalars['String']>;
  createdByType: CompetitionCreatedByType;
  cta?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eligibleCountries?: Maybe<Array<Scalars['String']>>;
  endAt: Scalars['DateTime'];
  events: Array<CompetitionEventData>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isOpen: Scalars['Boolean'];
  marketIds?: Maybe<Array<Scalars['String']>>;
  maxParticipants: Scalars['Float'];
  minimumSettledTips?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  rankingMetric?: Maybe<Scalars['String']>;
  rankingSportIds?: Maybe<Array<Scalars['String']>>;
  remainingSlots?: Maybe<Scalars['String']>;
  rewards?: Maybe<Array<RewardItem>>;
  startAt: Scalars['DateTime'];
  status: ContentCompetitionStatusFilter;
  takenSlots?: Maybe<Scalars['String']>;
  termsAndconditions?: Maybe<Scalars['String']>;
  termsAndconditionsLink?: Maybe<Scalars['String']>;
  userCanVote?: Maybe<Scalars['Boolean']>;
  userJoined?: Maybe<Scalars['Boolean']>;
  vip?: Maybe<Scalars['Boolean']>;
};

export type ContentCompetitionFIlter = {
  competitionType?: InputMaybe<CompetitionType>;
  sportId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ContentCompetitionStatusFilter>;
};

export type ContentCompetitions = {
  __typename?: 'ContentCompetitions';
  blocked?: Maybe<Scalars['Boolean']>;
  channelIds?: Maybe<Array<Scalars['String']>>;
  competitionType: CompetitionType;
  createdBy?: Maybe<Scalars['String']>;
  createdByType: CompetitionCreatedByType;
  cta?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  eligibleCountries?: Maybe<Array<Scalars['String']>>;
  endAt: Scalars['DateTime'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isOpen: Scalars['Boolean'];
  marketIds?: Maybe<Array<Scalars['String']>>;
  maxParticipants: Scalars['Float'];
  minimumSettledTips?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  rankingMetric?: Maybe<Scalars['String']>;
  rankingSportIds?: Maybe<Array<Scalars['String']>>;
  remainingSlots?: Maybe<Scalars['String']>;
  rewards?: Maybe<Array<RewardItem>>;
  startAt: Scalars['DateTime'];
  status: ContentCompetitionStatusFilter;
  takenSlots?: Maybe<Scalars['String']>;
  termsAndconditions?: Maybe<Scalars['String']>;
  termsAndconditionsLink?: Maybe<Scalars['String']>;
  userCanVote?: Maybe<Scalars['Boolean']>;
  userJoined?: Maybe<Scalars['Boolean']>;
  vip?: Maybe<Scalars['Boolean']>;
};

export type CountryModel = {
  __typename?: 'CountryModel';
  code: Scalars['String'];
  continent: ContinentsEnum;
  id: Scalars['ID'];
  isBlacklisted?: Maybe<Scalars['Boolean']>;
  language: Scalars['String'];
  name: Scalars['String'];
};

/** Input for creating a Watchers room for a tip */
export type CreateTipRoomInput = {
  /** Cover image URL for the stream room */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  /** Planned room end time in UTC (ISO 8601) */
  endTime?: InputMaybe<Scalars['String']>;
  /** Set this cover image as the tipster default for future rooms */
  setAsDefault?: InputMaybe<Scalars['Boolean']>;
  /** Planned room start time in UTC (ISO 8601) */
  startTime?: InputMaybe<Scalars['String']>;
  /** Stream URL for the room */
  streamUrl: Scalars['String'];
  /** The tip ID to attach the room to */
  tipId: Scalars['ID'];
  /** Room title/name displayed in admin panel */
  title: Scalars['String'];
};

export type CreateTipsterInviteeModel = {
  instagramFollowers?: InputMaybe<Scalars['String']>;
  instagramName?: InputMaybe<Scalars['String']>;
  instagramURL?: InputMaybe<Scalars['String']>;
  telegramURL?: InputMaybe<Scalars['String']>;
};

/** Connection type for pagination of Currencies */
export type CurrencyConnection = {
  __typename?: 'CurrencyConnection';
  edges: Array<CurrencyNodeEdge>;
  pageInfo: PageInfo;
};

/** Currency object. It has unique code and display name */
export type CurrencyNode = Node & {
  __typename?: 'CurrencyNode';
  code: Scalars['String'];
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  symbol: Scalars['String'];
};

export type CurrencyNodeEdge = {
  __typename?: 'CurrencyNodeEdge';
  /** CurrencyNode node */
  node: CurrencyNode;
};

export type DateRange = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  deleted: Scalars['Boolean'];
};

export type DetailedTipAndMultitip = MultitipDetailed | TipDetailed;

export type EngagementSubscribersMetrics = {
  __typename?: 'EngagementSubscribersMetrics';
  activeAndOnholdSubscriptions: Scalars['Int'];
  activeSubscriptionsOnly: Scalars['Int'];
  isTrialUsed: Scalars['Int'];
  percentageActiveTrialUsed: Scalars['Float'];
  unfollowed: Scalars['Int'];
  unsubscribed: Scalars['Int'];
};

export type EntityNotificationSetting = {
  __typename?: 'EntityNotificationSetting';
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  notificationSetting: NotificationSettings;
  notificationSettingId: Scalars['Float'];
  scope: NotificationSettingScope;
  value: Scalars['Boolean'];
};

/** Indicates whether this entry is from top 10 or user position */
export enum EntryType {
  Top10 = 'TOP10',
  UserPosition = 'USER_POSITION'
}

export type EventOddTypeOutcomeMarket = {
  __typename?: 'EventOddTypeOutcomeMarket';
  bookmakerId: Scalars['Float'];
  eventId: Scalars['Float'];
  id: Scalars['ID'];
  marketId: Scalars['Float'];
  outcomeId: Scalars['Float'];
  specialBetValue?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type EventOddTypeOutcomeMarketVoted = {
  __typename?: 'EventOddTypeOutcomeMarketVoted';
  bookmakerId: Scalars['Float'];
  event?: Maybe<SportEventType>;
  eventId: Scalars['Float'];
  id: Scalars['ID'];
  market?: Maybe<Market>;
  marketId: Scalars['Float'];
  numberOfTips?: Maybe<Scalars['Float']>;
  outcome?: Maybe<Outcome>;
  outcomeId: Scalars['Float'];
  /** profit */
  profit: Scalars['String'];
  result?: Maybe<ResultType>;
  specialBetValue?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type EventOddTypeOutcomeMarketVoteds = {
  __typename?: 'EventOddTypeOutcomeMarketVoteds';
  /** avg profit */
  avgProfit: Scalars['Float'];
  eventOddTypeOutcomeMarketVoteds: Array<EventOddTypeOutcomeMarketVoted>;
  totalCount: Scalars['Float'];
};

export type EventOutcomeInput = {
  eventId: Scalars['Int'];
  outcomeId: Scalars['Int'];
};

export type EventOutcomeResult = {
  __typename?: 'EventOutcomeResult';
  eventId: Scalars['Int'];
  outcomeId: Scalars['Int'];
  outcomeName?: Maybe<Scalars['String']>;
};

export type EventOutcomevalue = {
  __typename?: 'EventOutcomevalue';
  bookmakerId?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['Float']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  oddTypeId?: Maybe<Scalars['Float']>;
  outcomeId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  specialBetValue?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type FavoriteBookie = {
  __typename?: 'FavoriteBookie';
  id: Scalars['ID'];
  tenantBookieId: Scalars['ID'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
};

export type FeedCursor = {
  __typename?: 'FeedCursor';
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
};

export type FeedCursorInput = {
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
};

export type FinancialFilterInput = {
  channel?: InputMaybe<Array<Scalars['String']>>;
  channelStatus?: InputMaybe<ChannelStatus>;
  countryChannel?: InputMaybe<Scalars['String']>;
  countryTipster?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['String']>;
  paymentOption?: InputMaybe<Payments>;
  searchQuery?: InputMaybe<Scalars['String']>;
  subsStatus?: InputMaybe<Scalars['String']>;
  subsType?: InputMaybe<SubsType>;
  tipsterId?: InputMaybe<Scalars['String']>;
  tipsterStatus?: InputMaybe<TipsterStatus>;
};

export type FinancialFilterInputs = {
  channel?: InputMaybe<Array<Scalars['String']>>;
  countryChannel?: InputMaybe<Scalars['String']>;
  countryTipster?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<BetweenDates>;
  currency?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subsStatus?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  tipsterId?: InputMaybe<Scalars['String']>;
};

export type FinancialModel = {
  __typename?: 'FinancialModel';
  channelId: Scalars['ID'];
  channelName: Scalars['String'];
  channelStatus: ChannelStatus;
  countryChannel: Scalars['String'];
  countryTipster: Scalars['String'];
  currency: Scalars['String'];
  fee: Scalars['Float'];
  id: Scalars['ID'];
  lastTransaction: Scalars['String'];
  paymentOption: Scalars['String'];
  revenueVB: Scalars['String'];
  subsStatus: Scalars['String'];
  subsType: Scalars['String'];
  subscriptionAutomatic: Scalars['String'];
  subscriptionManual: Scalars['String'];
  tipsterId?: Maybe<Scalars['ID']>;
  tipsterName: Scalars['String'];
  tipsterStatus?: Maybe<TipsterStatus>;
  users: Scalars['Float'];
};

export type FinancialPayConnection = {
  __typename?: 'FinancialPayConnection';
  edges: Array<FinancialPayNodeEdge>;
  pageInfo: PageInfo;
};

export type FinancialPayNode = Node & {
  __typename?: 'FinancialPayNode';
  channelId: Scalars['Float'];
  deletedAt: Scalars['DateTime'];
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  lastPayment: Scalars['String'];
  tipsterId: Scalars['Float'];
};

export type FinancialPayNodeEdge = {
  __typename?: 'FinancialPayNodeEdge';
  /** FinancialPayNode node */
  node: FinancialPayNode;
};

export type FinancialSortInput = {
  channelCountry?: InputMaybe<SortMethod>;
  channelId?: InputMaybe<SortMethod>;
  channelName?: InputMaybe<SortMethod>;
  channelStatus?: InputMaybe<SortMethod>;
  fee?: InputMaybe<SortMethod>;
  lastTransaction?: InputMaybe<SortMethod>;
  tipsterCountry?: InputMaybe<SortMethod>;
  tipsterId?: InputMaybe<SortMethod>;
  tipsterName?: InputMaybe<SortMethod>;
  tipsterStatus?: InputMaybe<SortMethod>;
  users?: InputMaybe<SortMethod>;
};

export type Financials = {
  __typename?: 'Financials';
  count: Scalars['Float'];
  financials: Array<FinancialModel>;
};

export type FollowersBySourceCount = {
  __typename?: 'FollowersBySourceCount';
  source: Scalars['String'];
  userCount: Scalars['Int'];
};

export enum FrequencyCapWindow {
  Day = 'DAY',
  Lifetime = 'LIFETIME'
}

export type GameScore = {
  __typename?: 'GameScore';
  ft?: Maybe<Scalars['String']>;
  ot?: Maybe<Scalars['String']>;
  penalty?: Maybe<Scalars['String']>;
  q1?: Maybe<Scalars['String']>;
  q2?: Maybe<Scalars['String']>;
  q3?: Maybe<Scalars['String']>;
  q4?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
};

/** message input parameters for creating a new message */
export type InitialMessage = {
  imageUrl?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type IntegrationSecrets = {
  __typename?: 'IntegrationSecrets';
  stripeSecretKey?: Maybe<Scalars['String']>;
  stripeWebhookSecret?: Maybe<Scalars['String']>;
};

/** waitlist input parameters for joining blacklisted waitlist */
export type JoinWaitlistCreateInput = {
  continent: WaitlistContinentsEnum;
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  email: Scalars['String'];
  gdprConcent: Scalars['Boolean'];
};

export type LeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  avatarUrl?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  lost: Scalars['Int'];
  /** Rank in the previous equivalent period, if known */
  previousRank?: Maybe<Scalars['Int']>;
  profit: Scalars['Float'];
  rank: Scalars['Int'];
  /** previousRank - rank; positive means the tipster moved up */
  rankChange?: Maybe<Scalars['Int']>;
  roi: Scalars['Float'];
  tipsterId: Scalars['ID'];
  totalTips: Scalars['Int'];
  void: Scalars['Int'];
  winRate: Scalars['Float'];
  won: Scalars['Int'];
};

export type LeaderboardFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  metric?: InputMaybe<LeaderboardMetric>;
  offset?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<LeaderboardPeriod>;
  snapshotId?: InputMaybe<Scalars['String']>;
  sportIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/** Primary metric the leaderboard is ranked by */
export enum LeaderboardMetric {
  Profit = 'PROFIT',
  Roi = 'ROI',
  WinRate = 'WIN_RATE'
}

export type LeaderboardPage = {
  __typename?: 'LeaderboardPage';
  /** Entries after the top 3, for this page */
  entries: Array<LeaderboardEntry>;
  hasNextPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  /** Minimum qualifying tips currently in effect for this tenant */
  minTipsThreshold: Scalars['Int'];
  offset: Scalars['Int'];
  /** Pass this back on subsequent page requests to keep ranks stable */
  snapshotId: Scalars['String'];
  top: Array<LeaderboardEntry>;
  /** Total number of tipsters qualifying for the leaderboard */
  totalCount: Scalars['Int'];
};

/** Time window the ranking is computed over */
export enum LeaderboardPeriod {
  All = 'ALL',
  Month = 'MONTH',
  Today = 'TODAY',
  Week = 'WEEK'
}

export type ManyTipsterInviteeModel = {
  __typename?: 'ManyTipsterInviteeModel';
  count: Scalars['Float'];
  invitees: Array<TipsterInviteeModel>;
};

export type Market = {
  __typename?: 'Market';
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sportId: Scalars['ID'];
};

export type MarketForEventList = {
  __typename?: 'MarketForEventList';
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  numberOfTips: Scalars['Float'];
  outcomeEvent: Array<OutcomeEvent>;
  userVoted?: Maybe<Scalars['Float']>;
  votes: Scalars['Float'];
  withSpecialBetValue: Scalars['Boolean'];
};

export type Message = {
  __typename?: 'Message';
  chatId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  senderId: Scalars['String'];
  text: Scalars['String'];
};

/** message input parameters for creating a new message */
export type MessageCreate = {
  chatId: Scalars['Float'];
  imageUrl?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

/** MultiTip object parameters */
export type Multitip = {
  __typename?: 'Multitip';
  analysis?: Maybe<Scalars['String']>;
  bookieId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  customBookieName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  includeInStat?: Maybe<Scalars['Boolean']>;
  isCommentsAllow: Scalars['Boolean'];
  odds?: Maybe<Scalars['Float']>;
  outcomeId?: Maybe<Scalars['ID']>;
  profit?: Maybe<Scalars['String']>;
  result?: Maybe<TipResult>;
  resultCreatedAt?: Maybe<Scalars['DateTime']>;
  stake?: Maybe<Scalars['Float']>;
  tips?: Maybe<Array<Tip>>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
  vip: Scalars['Boolean'];
};

/** Multitip input parameters object for creating a new MultiTip */
export type MultitipCreate = {
  analysis?: InputMaybe<Scalars['String']>;
  bookieId?: InputMaybe<Scalars['ID']>;
  customBookieName?: InputMaybe<Scalars['String']>;
  includeInStat?: InputMaybe<Scalars['Boolean']>;
  isCommentsAllow?: Scalars['Boolean'];
  odds?: InputMaybe<Scalars['Float']>;
  outcomeId?: InputMaybe<Scalars['ID']>;
  profit?: InputMaybe<Scalars['String']>;
  stake?: InputMaybe<Scalars['Float']>;
  tips?: InputMaybe<Array<TipCreateMultitip>>;
  vip?: Scalars['Boolean'];
};

/** MultiTip detailed object parameters */
export type MultitipDetailed = {
  __typename?: 'MultitipDetailed';
  analysis?: Maybe<Scalars['String']>;
  anonymized?: Maybe<Scalars['Boolean']>;
  audioUrl?: Maybe<Scalars['String']>;
  blocked: Scalars['Boolean'];
  bonusLink?: Maybe<Scalars['String']>;
  bookieId?: Maybe<Scalars['ID']>;
  bookieImageUrl?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  channelContentId?: Maybe<Scalars['Float']>;
  commentsCount?: Maybe<Scalars['Float']>;
  contentType?: Maybe<TypesOfContent>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customBookieName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  includeInStat?: Maybe<Scalars['Boolean']>;
  isCommentsAllow: Scalars['Boolean'];
  isSaved?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Array<TipMediaOutput>>;
  odds?: Maybe<Scalars['Float']>;
  ogImageUrl?: Maybe<Scalars['String']>;
  outcomeId?: Maybe<Scalars['ID']>;
  profit?: Maybe<Scalars['String']>;
  result?: Maybe<TipResult>;
  resultCreatedAt?: Maybe<Scalars['DateTime']>;
  stake?: Maybe<Scalars['Float']>;
  streamUrl?: Maybe<Scalars['String']>;
  tips?: Maybe<Array<TipDetailed>>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
  videoUrl?: Maybe<Scalars['String']>;
  vip: Scalars['Boolean'];
  votes?: Maybe<Vote>;
};

/** Tip input parameters for updating an existing Tip */
export type MultitipUpdate = {
  analysis?: InputMaybe<Scalars['String']>;
  bookieId?: InputMaybe<Scalars['ID']>;
  customBookieName?: InputMaybe<Scalars['String']>;
  includeInStat?: InputMaybe<Scalars['Boolean']>;
  isCommentsAllow?: InputMaybe<Scalars['Boolean']>;
  odds?: InputMaybe<Scalars['Float']>;
  outcomeId?: InputMaybe<Scalars['ID']>;
  profit?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<TipResult>;
  stake?: InputMaybe<Scalars['Float']>;
  vip?: InputMaybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activeFreeTrial?: Maybe<Scalars['Boolean']>;
  addAgentToChannel: Result;
  addFCMToken: Scalars['Boolean'];
  addTipsterToChannel: Result;
  adsCreate: Ads;
  adsDelete: Scalars['String'];
  adsImageUpload: Scalars['String'];
  adsUpdate: Ads;
  affilateLinkCreate: AffilateLinkModel;
  affilateLinkDelete: Result;
  affilateLinkUpdate: Result;
  audioUpload: Scalars['String'];
  bonusCreate: BonusModel;
  bonusDelete: Result;
  bonusReorder: Result;
  bonusUpdate: Result;
  channelCreate: ChannelModel;
  channelDelete: DeleteResult;
  channelUpdate: UpdateResult;
  chatAccept: Chat;
  chatCreate: Chat;
  chatReadManyMessages: Scalars['Boolean'];
  chatReadMessages: Chat;
  /** Save click data */
  clickAnonymous: AnonymousModel;
  /** Create a new Comment */
  commentCreate: CommentModel;
  /** Delete a Comment */
  commentDelete: Scalars['String'];
  /** Update an existing Comment */
  commentUpdate: CommentModel;
  competitionVote: ContentCompetitionEvent;
  createCompetition: ContentCompetitionEvent;
  /** Create a Watchers room for a tip and attach the stream URL */
  createTipRoom: Scalars['Boolean'];
  /** Create tipster invitees */
  createTipsterInvitees: ManyTipsterInviteeModel;
  deleteCompetition: Scalars['Boolean'];
  deleteFCMToken: Scalars['Boolean'];
  deleteNotification: Scalars['Boolean'];
  /** upload tipster stat images */
  deleteStatImage: TipsterStatImageModel;
  deleteTenantBookie: Result;
  deleteTipsterFromChannel: Result;
  downvote: ChannelContent;
  editCompetition: ContentCompetitionEvent;
  entityNotificationSettingsUpdate: EntityNotificationSetting;
  followChannel: Result;
  followChannelByInviteLink: Result;
  followChannelByLinkName: Result;
  followUserByLinkName: UserModel;
  /** Update an existing User */
  generateTipsterInviteLink: UserModel;
  grantActivate: AccessGrantNode;
  grantExtend: AccessGrantNode;
  grantRevoke: AccessGrantNode;
  imageDelete: Scalars['Boolean'];
  imageUpload: Scalars['String'];
  joinTipsterCompetition: ContentCompetitionEvent;
  joinWaitlist: Waitlist;
  markAllChannelMessageAsRead: Scalars['Boolean'];
  messageCreate: Message;
  /** Create a new Multitip */
  multitipCreate: MultitipDetailed;
  /** Remove MultiTip */
  multitipDelete: Scalars['String'];
  /** Update an existing multitip */
  multitipUpdate: Multitip;
  optionCreate: OptionModel;
  optionDelete: Scalars['String'];
  optionRearrange: Scalars['String'];
  optionUpdate: Scalars['String'];
  /** Parse a betslip image using OCR and AI to extract tip data (match, odds, bookie) */
  parseBetslip: BetslipParseResult;
  paymentAndSubscriptionUpdate: Scalars['Boolean'];
  paymentCreateIntent: PaymentInitResult;
  pinContent: UpdateResult;
  planCreate: PlanNode;
  planDiscontinue: PlanNode;
  planPurchaseCreate: PlanPurchaseResult;
  planUpdate: PlanNode;
  pollCreate: PollDetailed;
  pollDelete: Scalars['String'];
  pollUpdate: PollModel;
  pollVote: PollModel;
  postCreate: PostDetailed;
  postDelete: Scalars['String'];
  postUpdate: Post;
  priceCreate: PriceNode;
  priceDelete: Scalars['Boolean'];
  priceUpdate: Scalars['Boolean'];
  readNotification: Notification;
  readNotifications: Scalars['Boolean'];
  reorderTenantBookies: Result;
  resetRgBanner: Scalars['Boolean'];
  saveTip: Result;
  sendMagicLink: Scalars['Boolean'];
  serviceCreate: ServiceNode;
  serviceDelete: Scalars['Boolean'];
  serviceDetailsUpdate: Scalars['Boolean'];
  serviceDurationCreate: ServiceDurationNode;
  serviceDurationDelete: Scalars['Boolean'];
  serviceDurationUpdate: Scalars['Boolean'];
  serviceSubsciptionDelete: Scalars['Boolean'];
  serviceSubsciptionRenew: ServiceSubscriptionNode;
  serviceSubscriptionCreate: ServiceSubscriptionNode;
  serviceSubscriptionRenewByUser: ServiceSubscriptionNode;
  serviceSubscriptionStop: Scalars['Boolean'];
  serviceUpdate: Scalars['Boolean'];
  setDefaultTenantBookie: Result;
  setFavoriteBookie: FavoriteBookie;
  setPaid: FinancialPayNode;
  /** Validate a third-party SSO payload and return a Firebase custom token. Call signInWithCustomToken(auth, firebaseToken) on the result. No Authorization header required — this is the token-issuing endpoint. */
  ssoLogin: SsoResult;
  subscriptionCreate: SubscriptionNode;
  subscriptionDelete: Scalars['Boolean'];
  subscriptionUpdate: Scalars['Boolean'];
  supportChatCreate: Chat;
  /** Add tip to a MultiTip */
  tipAddToMultitip: Tip;
  /** Create a new Tip */
  tipCreate: TipDetailed;
  /** Remove Tip */
  tipDelete: Scalars['String'];
  /** Update an existing Tip */
  tipUpdate: Tip;
  /** Update Tipster status */
  tipsterStatusChange: UserModel;
  trackSignupStart: Scalars['Boolean'];
  trackUserMagicLink: Scalars['Boolean'];
  undoPaid: FinancialPayNode;
  unfollowChannel: Result;
  unpinContent: UpdateResult;
  unsaveTip: Result;
  updateServiceSubscription?: Maybe<Scalars['Boolean']>;
  /** Update the status (and optionally stream URL) of a Watchers room for a tip */
  updateTipRoom: Scalars['Boolean'];
  updateTipsterChannels: Result;
  /** upload tipster stat images */
  uploadStatImage: TipsterStatImageModel;
  upsertRgBanner: RgBanner;
  upsertTenantBookie: TenantBookie;
  upvote: ChannelContent;
  /** Adding bookie to an existing User */
  userAddBookie: UserBookies;
  /** Adding competition to an existing User */
  userAddCompetition: UserCompetitions;
  /** Adding market to an existing User */
  userAddMarket: UserMarkets;
  /** Adding sport to an existing User */
  userAddSport: UserSports;
  /** Create a new User */
  userCreate: UserModel;
  /** Delete a User by ID */
  userDelete: Scalars['String'];
  /** Removing market from an existing User */
  userDeleteBookie: Scalars['String'];
  /** Removing market from an existing User */
  userDeleteCompetition: Scalars['String'];
  /** Removing market from an existing User */
  userDeleteMarket: Scalars['String'];
  /** Removing sport from an existing User */
  userDeleteSport: Scalars['String'];
  /** User following a Tipster */
  userFollowTipster: UserModel;
  userPermissionsUpdate: Updated;
  /** Update User status */
  userStatusChange: UserModel;
  /** User subscribe to a Content */
  userSubscribeToContent: UserContentSubscription;
  /** User subscribe to a Tipster */
  userSubscribeToTipster: UserModel;
  /** User unfollow/remove Tipster */
  userUnfollowFromTipster: UserModel;
  /** User unsubscribe from Content */
  userUnsubscribeFromContent: Scalars['String'];
  /** User unsubscribe from Tipster */
  userUnsubscribeFromTipster: UserModel;
  /** User removing subscribtion from a tip */
  userUnsubscribeToTip: Scalars['String'];
  /** Update an existing User */
  userUpdate: UserModel;
  /** update user bookies */
  userUpdateBookies: Updated;
  /** update user competitions */
  userUpdateCompetitions: Updated;
  /** update user markets */
  userUpdateMarkets: Updated;
  /** Update an existing User */
  userUpdateProfile: UserModel;
  /** update user sports */
  userUpdateSports: Updated;
  videoUpload: Scalars['String'];
  vipInviteCreate: VipInviteNode;
  vipInviteRedeem: VipInviteRedeemResult;
  vipInviteRevoke: VipInviteNode;
  vote: Scalars['String'];
};


export type MutationActiveFreeTrialArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationAddAgentToChannelArgs = {
  agentId: Scalars['String'];
  channelId: Scalars['String'];
};


export type MutationAddFcmTokenArgs = {
  token: Scalars['String'];
};


export type MutationAddTipsterToChannelArgs = {
  channelId: Scalars['String'];
  tipsterId: Scalars['String'];
};


export type MutationAdsCreateArgs = {
  input: AdsCreationInput;
};


export type MutationAdsDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationAdsImageUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationAdsUpdateArgs = {
  id: Scalars['ID'];
  input: AdsUpdate;
};


export type MutationAffilateLinkCreateArgs = {
  input: AffilateLinkCreate;
};


export type MutationAffilateLinkDeleteArgs = {
  id: Scalars['String'];
};


export type MutationAffilateLinkUpdateArgs = {
  id: Scalars['String'];
  input: AffilateLinkUpdtae;
};


export type MutationAudioUploadArgs = {
  audio: Scalars['Upload'];
};


export type MutationBonusCreateArgs = {
  input: BonusCreate;
};


export type MutationBonusDeleteArgs = {
  id: Scalars['String'];
};


export type MutationBonusReorderArgs = {
  orderedIds: Array<Scalars['String']>;
};


export type MutationBonusUpdateArgs = {
  id: Scalars['String'];
  input: BonusUpdate;
};


export type MutationChannelCreateArgs = {
  input: ChannelCreate;
};


export type MutationChannelDeleteArgs = {
  channelId: Scalars['String'];
};


export type MutationChannelUpdateArgs = {
  channelId: Scalars['String'];
  input: ChannelUpdate;
};


export type MutationChatAcceptArgs = {
  id: Scalars['Float'];
};


export type MutationChatCreateArgs = {
  input: ChatCreate;
};


export type MutationChatReadManyMessagesArgs = {
  chatId: Array<Scalars['ID']>;
};


export type MutationChatReadMessagesArgs = {
  chatId: Scalars['ID'];
};


export type MutationClickAnonymousArgs = {
  tipsterId: Scalars['ID'];
};


export type MutationCommentCreateArgs = {
  input: CommentCreateInput;
};


export type MutationCommentDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationCommentUpdateArgs = {
  id: Scalars['ID'];
  input: CommentUpdateInput;
};


export type MutationCompetitionVoteArgs = {
  competitionId: Scalars['ID'];
  eventId: Scalars['ID'];
  outcomeId: Scalars['ID'];
};


export type MutationCreateCompetitionArgs = {
  competition: CompetitionCreate;
};


export type MutationCreateTipRoomArgs = {
  input: CreateTipRoomInput;
};


export type MutationCreateTipsterInviteesArgs = {
  input: Array<CreateTipsterInviteeModel>;
};


export type MutationDeleteCompetitionArgs = {
  competitionId: Scalars['ID'];
};


export type MutationDeleteFcmTokenArgs = {
  token: Scalars['String'];
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStatImageArgs = {
  input: Scalars['String'];
};


export type MutationDeleteTenantBookieArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTipsterFromChannelArgs = {
  channelId: Scalars['String'];
  tipsterId: Scalars['String'];
};


export type MutationDownvoteArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<FeedCursorInput>;
  id: Scalars['ID'];
  type: TypesOfContent;
};


export type MutationEditCompetitionArgs = {
  competitionId: Scalars['ID'];
  update: CompetitionUpdate;
};


export type MutationEntityNotificationSettingsUpdateArgs = {
  id: Scalars['ID'];
  scope: NotificationSettingScope;
  value: Scalars['Boolean'];
};


export type MutationFollowChannelArgs = {
  channelId: Scalars['String'];
};


export type MutationFollowChannelByInviteLinkArgs = {
  inviteLink: Scalars['String'];
};


export type MutationFollowChannelByLinkNameArgs = {
  internalName: Scalars['String'];
};


export type MutationFollowUserByLinkNameArgs = {
  linkName: Scalars['String'];
};


export type MutationGenerateTipsterInviteLinkArgs = {
  userId: Scalars['ID'];
};


export type MutationGrantActivateArgs = {
  grantId: Scalars['String'];
};


export type MutationGrantExtendArgs = {
  additionalDays: Scalars['Int'];
  grantId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationGrantRevokeArgs = {
  grantId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationImageDeleteArgs = {
  imageURL: Scalars['String'];
};


export type MutationImageUploadArgs = {
  image: Scalars['Upload'];
};


export type MutationJoinTipsterCompetitionArgs = {
  competitionId: Scalars['ID'];
};


export type MutationJoinWaitlistArgs = {
  input: JoinWaitlistCreateInput;
};


export type MutationMarkAllChannelMessageAsReadArgs = {
  channelIds: Array<Scalars['ID']>;
};


export type MutationMessageCreateArgs = {
  input: MessageCreate;
};


export type MutationMultitipCreateArgs = {
  input: MultitipCreate;
};


export type MutationMultitipDeleteArgs = {
  channelId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationMultitipUpdateArgs = {
  id: Scalars['ID'];
  input: MultitipUpdate;
};


export type MutationOptionCreateArgs = {
  input: OptionsCreateModel;
};


export type MutationOptionDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationOptionRearrangeArgs = {
  options: Array<OptionsUpdateModel>;
};


export type MutationOptionUpdateArgs = {
  id: Scalars['ID'];
  input: OptionsUpdateModel;
};


export type MutationParseBetslipArgs = {
  imageBase64: Scalars['String'];
  mimeType: Scalars['String'];
};


export type MutationPaymentAndSubscriptionUpdateArgs = {
  input: Scalars['String'];
};


export type MutationPaymentCreateIntentArgs = {
  input: PaymentInitInput;
};


export type MutationPinContentArgs = {
  channelId: Scalars['String'];
  contentId: Scalars['String'];
  contentType: TypesOfContent;
};


export type MutationPlanCreateArgs = {
  input: PlanCreateInput;
};


export type MutationPlanDiscontinueArgs = {
  id: Scalars['String'];
};


export type MutationPlanPurchaseCreateArgs = {
  input: PlanPurchaseInput;
};


export type MutationPlanUpdateArgs = {
  input: PlanUpdateInput;
};


export type MutationPollCreateArgs = {
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  input: PollCreate;
};


export type MutationPollDeleteArgs = {
  channelId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationPollUpdateArgs = {
  id: Scalars['ID'];
  input: PollUpdate;
};


export type MutationPollVoteArgs = {
  pollId: Scalars['ID'];
  selectedOptionId: Scalars['ID'];
};


export type MutationPostCreateArgs = {
  channelIds?: InputMaybe<Array<Scalars['ID']>>;
  input: PostCreateInput;
};


export type MutationPostDeleteArgs = {
  channelId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationPostUpdateArgs = {
  id: Scalars['ID'];
  input: PostUpdateInput;
};


export type MutationPriceCreateArgs = {
  input: PriceCreateInput;
};


export type MutationPriceDeleteArgs = {
  id: Scalars['String'];
};


export type MutationPriceUpdateArgs = {
  id: Scalars['String'];
  input: PriceUpdateInput;
};


export type MutationReadNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationReadNotificationsArgs = {
  id: Array<Scalars['ID']>;
};


export type MutationReorderTenantBookiesArgs = {
  items: Array<TenantBookieOrderItem>;
};


export type MutationResetRgBannerArgs = {
  countryCode: Scalars['String'];
};


export type MutationSaveTipArgs = {
  addedFromChannelId?: InputMaybe<Scalars['String']>;
  contentId: Scalars['String'];
  contentType: TipsTypes;
  tipCreatedAt?: InputMaybe<Scalars['DateTime']>;
  tipSportIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationSendMagicLinkArgs = {
  input: SendMagicLinkInput;
};


export type MutationServiceCreateArgs = {
  input: ServiceCreate;
};


export type MutationServiceDeleteArgs = {
  id: Scalars['String'];
};


export type MutationServiceDetailsUpdateArgs = {
  id: Scalars['String'];
  input: ServiceUpdate;
};


export type MutationServiceDurationCreateArgs = {
  input: ServiceDurationCreateInput;
};


export type MutationServiceDurationDeleteArgs = {
  id: Scalars['String'];
};


export type MutationServiceDurationUpdateArgs = {
  id: Scalars['String'];
  input: ServiceDurationUpdateInput;
};


export type MutationServiceSubsciptionDeleteArgs = {
  id: Scalars['String'];
};


export type MutationServiceSubsciptionRenewArgs = {
  id: Scalars['String'];
  onlyActivate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationServiceSubscriptionCreateArgs = {
  input: ServiceSubscriptionCreateInput;
};


export type MutationServiceSubscriptionRenewByUserArgs = {
  id: Scalars['String'];
};


export type MutationServiceSubscriptionStopArgs = {
  id: Scalars['String'];
};


export type MutationServiceUpdateArgs = {
  id: Scalars['String'];
  input: ServiceUpdate;
};


export type MutationSetDefaultTenantBookieArgs = {
  id: Scalars['ID'];
};


export type MutationSetFavoriteBookieArgs = {
  tenantBookieId: Scalars['ID'];
};


export type MutationSetPaidArgs = {
  channelId: Scalars['Float'];
  lastPayment: Scalars['String'];
  tipsterId: Scalars['String'];
};


export type MutationSsoLoginArgs = {
  input: SsoLoginInput;
};


export type MutationSubscriptionCreateArgs = {
  input: SubscriptionCreateInput;
};


export type MutationSubscriptionDeleteArgs = {
  id: Scalars['String'];
};


export type MutationSubscriptionUpdateArgs = {
  id: Scalars['String'];
  input: SubscriptionUpdateInput;
};


export type MutationSupportChatCreateArgs = {
  input: SupportChatCreate;
};


export type MutationTipAddToMultitipArgs = {
  multitipId: Scalars['ID'];
  tip: TipCreateMultitip;
};


export type MutationTipCreateArgs = {
  input: TipCreate;
};


export type MutationTipDeleteArgs = {
  channelId: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationTipUpdateArgs = {
  id: Scalars['ID'];
  input: TipUpdate;
};


export type MutationTipsterStatusChangeArgs = {
  status: TipsterStatus;
  tipsterId: Scalars['ID'];
};


export type MutationTrackSignupStartArgs = {
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['Float']>;
  role: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
};


export type MutationTrackUserMagicLinkArgs = {
  email: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
};


export type MutationUndoPaidArgs = {
  channelId: Scalars['Float'];
  tipsterId: Scalars['String'];
};


export type MutationUnfollowChannelArgs = {
  channelId: Scalars['String'];
};


export type MutationUnpinContentArgs = {
  channelId: Scalars['String'];
};


export type MutationUnsaveTipArgs = {
  contentId: Scalars['String'];
  contentType: TipsTypes;
};


export type MutationUpdateServiceSubscriptionArgs = {
  input: ServiceSubscriptionUpdateInput;
  subscriptionId: Scalars['String'];
};


export type MutationUpdateTipRoomArgs = {
  input: UpdateTipRoomInput;
};


export type MutationUpdateTipsterChannelsArgs = {
  channelIds: Array<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type MutationUploadStatImageArgs = {
  input: Scalars['String'];
};


export type MutationUpsertRgBannerArgs = {
  input: RgBannerInput;
};


export type MutationUpsertTenantBookieArgs = {
  input: UpsertTenantBookieInput;
};


export type MutationUpvoteArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<FeedCursorInput>;
  id: Scalars['ID'];
  type: TypesOfContent;
};


export type MutationUserAddBookieArgs = {
  bookieId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserAddCompetitionArgs = {
  competitionId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserAddMarketArgs = {
  marketId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserAddSportArgs = {
  sportId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserCreateArgs = {
  input: UserCreate;
  inviteToken?: InputMaybe<Scalars['String']>;
};


export type MutationUserDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationUserDeleteBookieArgs = {
  bookieId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserDeleteCompetitionArgs = {
  competitionId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserDeleteMarketArgs = {
  marketId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserDeleteSportArgs = {
  sportId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUserFollowTipsterArgs = {
  tipsterId: Scalars['ID'];
};


export type MutationUserPermissionsUpdateArgs = {
  permissions: Array<UserPermission>;
  userId: Scalars['ID'];
};


export type MutationUserStatusChangeArgs = {
  status: UserStatus;
  userId: Scalars['ID'];
};


export type MutationUserSubscribeToContentArgs = {
  input: UserContentSubCreate;
};


export type MutationUserSubscribeToTipsterArgs = {
  tipsterId: Scalars['ID'];
};


export type MutationUserUnfollowFromTipsterArgs = {
  tipsterId: Scalars['ID'];
};


export type MutationUserUnsubscribeFromContentArgs = {
  userContentId: Scalars['ID'];
};


export type MutationUserUnsubscribeToTipArgs = {
  userContentId: Scalars['ID'];
};


export type MutationUserUpdateArgs = {
  id: Scalars['ID'];
  input: UserUpdate;
};


export type MutationUserUpdateBookiesArgs = {
  bookieIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationUserUpdateCompetitionsArgs = {
  competitionIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationUserUpdateMarketsArgs = {
  marketsIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationUserUpdateProfileArgs = {
  input: UserUpdate;
};


export type MutationUserUpdateSportsArgs = {
  sportsIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationVideoUploadArgs = {
  video: Scalars['Upload'];
};


export type MutationVipInviteCreateArgs = {
  planId: Scalars['String'];
};


export type MutationVipInviteRedeemArgs = {
  token: Scalars['String'];
};


export type MutationVipInviteRevokeArgs = {
  id: Scalars['String'];
};


export type MutationVoteArgs = {
  eventOutcomeId: Scalars['ID'];
};

export type MyAccessGrantNode = {
  __typename?: 'MyAccessGrantNode';
  channelId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  expiration?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  planCurrencyCode?: Maybe<Scalars['String']>;
  planDurationDays?: Maybe<Scalars['Int']>;
  planFreeTrialDays?: Maybe<Scalars['Int']>;
  planId?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['Float']>;
  scope: Scalars['String'];
  startedAt: Scalars['DateTime'];
  status: Scalars['String'];
  tipsterId?: Maybe<Scalars['String']>;
};

export type MyLeaderboardPosition = {
  __typename?: 'MyLeaderboardPosition';
  entry?: Maybe<LeaderboardEntry>;
  minTipsThreshold: Scalars['Int'];
  previousRank?: Maybe<Scalars['Int']>;
  qualifies: Scalars['Boolean'];
  /** Null when the user does not currently qualify */
  rank?: Maybe<Scalars['Int']>;
  rankChange?: Maybe<Scalars['Int']>;
  totalTips: Scalars['Int'];
};

/** An object with an ID field to support global identification, in accordance with the Relay specification. This interface is used by the node and nodes queries. */
export type Node = {
  /** A globally-unique identifier. */
  id: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  contentId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUser?: Maybe<User>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  info?: Maybe<Scalars['JSON']>;
  isNew: Scalars['Boolean'];
  type: TypesOfNotifications;
  userId: Scalars['ID'];
};

export enum NotificationSettingScope {
  Channel = 'CHANNEL',
  Global = 'GLOBAL',
  User = 'USER'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  category: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Notifications = {
  __typename?: 'Notifications';
  count: Scalars['Float'];
  notifications: Array<Notification>;
};

export type OddType = {
  __typename?: 'OddType';
  externalId?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sportId?: Maybe<Scalars['Float']>;
};

/** Preferred odds display format */
export enum OddsFormat {
  American = 'AMERICAN',
  Decimal = 'DECIMAL',
  Fractional = 'FRACTIONAL'
}

export type OnboardingProgress = {
  __typename?: 'OnboardingProgress';
  ContentDataTip?: Maybe<Scalars['Boolean']>;
  ContentImageTip?: Maybe<Scalars['Boolean']>;
  basicVideoExplainer?: Maybe<Scalars['Boolean']>;
  basicWelcome?: Maybe<Scalars['Boolean']>;
  contentTipComparison?: Maybe<Scalars['Boolean']>;
  contentTipMenu?: Maybe<Scalars['Boolean']>;
  contentVideoExplainer?: Maybe<Scalars['Boolean']>;
  contentWelcome?: Maybe<Scalars['Boolean']>;
  startAppBanner?: Maybe<Scalars['Boolean']>;
  subcriptionServiceMenu?: Maybe<Scalars['Boolean']>;
  subscriptionFeatureBanner?: Maybe<Scalars['Boolean']>;
  subscriptionMenu?: Maybe<Scalars['Boolean']>;
  subscriptionVideoExplainer?: Maybe<Scalars['Boolean']>;
  subscriptionWelcome?: Maybe<Scalars['Boolean']>;
  userInviteMenu?: Maybe<Scalars['Boolean']>;
  userInviteWelcome?: Maybe<Scalars['Boolean']>;
};

export type OnboardingProgressInput = {
  ContentDataTip?: InputMaybe<Scalars['Boolean']>;
  ContentImageTip?: InputMaybe<Scalars['Boolean']>;
  basicVideoExplainer?: InputMaybe<Scalars['Boolean']>;
  basicWelcome?: InputMaybe<Scalars['Boolean']>;
  contentTipComparison?: InputMaybe<Scalars['Boolean']>;
  contentTipMenu?: InputMaybe<Scalars['Boolean']>;
  contentVideoExplainer?: InputMaybe<Scalars['Boolean']>;
  contentWelcome?: InputMaybe<Scalars['Boolean']>;
  startAppBanner?: InputMaybe<Scalars['Boolean']>;
  subcriptionServiceMenu?: InputMaybe<Scalars['Boolean']>;
  subscriptionFeatureBanner?: InputMaybe<Scalars['Boolean']>;
  subscriptionMenu?: InputMaybe<Scalars['Boolean']>;
  subscriptionVideoExplainer?: InputMaybe<Scalars['Boolean']>;
  subscriptionWelcome?: InputMaybe<Scalars['Boolean']>;
  userCompletedOnboarding?: InputMaybe<Scalars['Boolean']>;
  userInviteMenu?: InputMaybe<Scalars['Boolean']>;
  userInviteWelcome?: InputMaybe<Scalars['Boolean']>;
};

/** option input parameters object for creating a new options */
export type OptionModel = {
  __typename?: 'OptionModel';
  count?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Float'];
  option: Scalars['String'];
  pollId: Scalars['Float'];
  position: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

/** option input parameters object for creating a new ptions */
export type OptionsCreateModel = {
  option: Scalars['String'];
  pollId: Scalars['Float'];
  position: Scalars['Float'];
};

/** option input parameters object for creating a new ptions */
export type OptionsCreatePoll = {
  option: Scalars['String'];
  position: Scalars['Float'];
};

/** option input parameters object for creating a new ptions */
export type OptionsUpdateModel = {
  id?: InputMaybe<Scalars['Float']>;
  option?: InputMaybe<Scalars['String']>;
  pollId?: InputMaybe<Scalars['Float']>;
  position?: InputMaybe<Scalars['Float']>;
};

export type Outcome = {
  __typename?: 'Outcome';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OutcomeEvent = {
  __typename?: 'OutcomeEvent';
  id: Scalars['ID'];
  outcomeName: Scalars['String'];
  specialBetValue?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
  votes: Scalars['Float'];
};

export type OutcomesList = {
  __typename?: 'OutcomesList';
  eventOutcomeId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  oddType?: Maybe<Scalars['String']>;
  outcomeName?: Maybe<Scalars['String']>;
  specialBetValue?: Maybe<Scalars['Float']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** Edges count in the current page */
  count: Scalars['Int'];
  /** Whether connection has the next page */
  hasNextPage: Scalars['Boolean'];
  /** Whether connection has the previous page */
  hasPreviousPage: Scalars['Boolean'];
  /** Total edges found count */
  totalCount: Scalars['Int'];
};

/** The type represents input parameters required for initiating the payment */
export type PaymentInitInput = {
  paymentMethodId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type PaymentInitResult = {
  payment: PaymentNode;
  status: Scalars['Boolean'];
};

/** Service payment methods. */
export type PaymentMethods = {
  __typename?: 'PaymentMethods';
  id: Scalars['String'];
  paymentComment?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<Scalars['String']>;
  paymentType?: Maybe<PaymentType>;
};

/** Service payment methods. */
export type PaymentMethodsInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentComment?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<Scalars['String']>;
  paymentTypeId: Scalars['ID'];
};

/** The type represents a payment transaction */
export type PaymentNode = {
  __typename?: 'PaymentNode';
  /** A globally-unique identifier. */
  id: Scalars['ID'];
};

export type PaymentStripeInitResult = PaymentInitResult & {
  __typename?: 'PaymentStripeInitResult';
  clientSecret: Scalars['String'];
  payment: PaymentNode;
  status: Scalars['Boolean'];
};

/** Service payment type. */
export type PaymentType = {
  __typename?: 'PaymentType';
  category: Scalars['String'];
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  isAutoActivated: Scalars['Boolean'];
  paymentName: Scalars['String'];
};

export type PeriodDates = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type PinnedContent = {
  __typename?: 'PinnedContent';
  contentType: TypesOfContent;
  description?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum Placement {
  Channel = 'CHANNEL',
  Competition = 'COMPETITION',
  Feed = 'FEED',
  Inbox = 'INBOX',
  MatchAmination = 'MATCH_AMINATION'
}

export type PlanCreateInput = {
  channelId: Scalars['Int'];
  currencyCode: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  durationDays: Scalars['Int'];
  freeTrialDays?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  paymentMethods?: InputMaybe<Array<PlanPaymentMethodInput>>;
  price: Scalars['Float'];
  scope: Scalars['String'];
};

export type PlanNode = {
  __typename?: 'PlanNode';
  activeSubscriberCount: Scalars['Int'];
  channelId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  durationDays: Scalars['Int'];
  freeTrialDays?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isLocked: Scalars['Boolean'];
  name: Scalars['String'];
  paymentMethods?: Maybe<Array<PlanPaymentMethod>>;
  price: Scalars['Float'];
  scope: Scalars['String'];
  status: Scalars['String'];
  tenantId: Scalars['String'];
  tipsterId?: Maybe<Scalars['String']>;
};

/** Payment method accepted by a plan. */
export type PlanPaymentMethod = {
  __typename?: 'PlanPaymentMethod';
  id: Scalars['Int'];
  paymentComment?: Maybe<Scalars['String']>;
  paymentInfo?: Maybe<Scalars['String']>;
  paymentType: PlanPaymentType;
  paymentTypeId: Scalars['Int'];
};

/** Payment method accepted by a plan. */
export type PlanPaymentMethodInput = {
  paymentComment?: InputMaybe<Scalars['String']>;
  paymentInfo?: InputMaybe<Scalars['String']>;
  paymentTypeId: Scalars['Int'];
};

/** Payment type accepted by a plan. */
export type PlanPaymentType = {
  __typename?: 'PlanPaymentType';
  category: Scalars['String'];
  id: Scalars['Int'];
  imageUrl: Scalars['String'];
  isAutoActivated: Scalars['Boolean'];
  paymentName: Scalars['String'];
};

export type PlanPurchaseInput = {
  paymentMethodId?: InputMaybe<Scalars['Int']>;
  planId: Scalars['String'];
  receiptEmail?: InputMaybe<Scalars['String']>;
};

export type PlanPurchaseResult = {
  __typename?: 'PlanPurchaseResult';
  clientSecret: Scalars['String'];
  purchase: PurchaseNode;
};

export type PlanUpdateInput = {
  currencyCode?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  durationDays?: InputMaybe<Scalars['Int']>;
  freeTrialDays?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<PlanPaymentMethodInput>>;
  price?: InputMaybe<Scalars['Float']>;
};

export enum PlatformLinkStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
  Verified = 'VERIFIED'
}

export enum PollCategory {
  Event = 'EVENT',
  Fun = 'FUN',
  Other = 'OTHER',
  Quiz = 'QUIZ',
  Trivia = 'TRIVIA'
}

/** poll input parameters object for creating a new poll */
export type PollCreate = {
  category: PollCategory;
  expirationDate: Scalars['String'];
  isCommentsAllow: Scalars['Boolean'];
  options: Array<OptionsCreatePoll>;
  question: Scalars['String'];
};

/** poll output parameters object */
export type PollDetailed = {
  __typename?: 'PollDetailed';
  category: Scalars['String'];
  channelContentId?: Maybe<Scalars['Float']>;
  commentsCount?: Maybe<Scalars['Float']>;
  contentType?: Maybe<TypesOfContent>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate: Scalars['String'];
  id: Scalars['ID'];
  isCommentsAllow: Scalars['Boolean'];
  options: Array<OptionModel>;
  question: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
  userSelectedOptionId?: Maybe<Scalars['Float']>;
  votes?: Maybe<Vote>;
};

/** poll input parameters object for creating a new poll */
export type PollModel = {
  __typename?: 'PollModel';
  category: PollCategory;
  checkResult?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  downvoted?: Maybe<Scalars['Float']>;
  expirationDate: Scalars['String'];
  id: Scalars['ID'];
  isCommentsAllow: Scalars['Boolean'];
  options: Array<OptionModel>;
  question: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  upvoted?: Maybe<Scalars['Float']>;
  upvotedStatus?: Maybe<PollVote>;
  userId: Scalars['ID'];
  votes?: Maybe<Votes>;
};

/** poll input parameters object for creating a new poll */
export type PollUpdate = {
  category: PollCategory;
  expirationDate: Scalars['String'];
  isCommentsAllow: Scalars['Boolean'];
  question: Scalars['String'];
};

/** vote */
export type PollVote = {
  __typename?: 'PollVote';
  downvoted?: Maybe<Scalars['Boolean']>;
  upvoted?: Maybe<Scalars['Boolean']>;
};

/** post input parameters object for creating a new Post */
export type Post = {
  __typename?: 'Post';
  category?: Maybe<CategoryEnum>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  downvoted?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isCommentsAllow: Scalars['Boolean'];
  mediaLink?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<TypeEnum>;
  updatedAt: Scalars['DateTime'];
  upvoted?: Maybe<Scalars['Float']>;
  userId: Scalars['ID'];
};

/** post input parameters object for creating a new Post */
export type PostCreateInput = {
  /** Audio file URL from S3 */
  audioUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryEnum>;
  content?: InputMaybe<Scalars['String']>;
  includeInStat: Scalars['Boolean'];
  isCommentsAllow: Scalars['Boolean'];
  mediaLink?: InputMaybe<Scalars['String']>;
  odds?: InputMaybe<Scalars['Float']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['String']>;
  stake?: InputMaybe<Scalars['Float']>;
  /** Live stream URL (Watchers, YouTube Live, etc.) */
  streamUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: TypeEnum;
  /** External video URL (YouTube) */
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type PostDetailed = {
  __typename?: 'PostDetailed';
  category: Scalars['String'];
  channelContentId?: Maybe<Scalars['Float']>;
  commentsCount?: Maybe<Scalars['Float']>;
  content?: Maybe<Scalars['String']>;
  contentType?: Maybe<TypesOfContent>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isCommentsAllow: Scalars['Boolean'];
  mediaLink?: Maybe<Scalars['String']>;
  ogImageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: TypeEnum;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
  votes?: Maybe<Vote>;
};

/** post input parameters object for updating a Post */
export type PostUpdateInput = {
  /** Audio file URL from S3 */
  audioUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryEnum>;
  content?: InputMaybe<Scalars['String']>;
  includeInStat?: InputMaybe<Scalars['Boolean']>;
  isCommentsAllow?: InputMaybe<Scalars['Boolean']>;
  mediaLink?: InputMaybe<Scalars['String']>;
  odds?: InputMaybe<Scalars['Float']>;
  ogImageUrl?: InputMaybe<Scalars['String']>;
  profit?: InputMaybe<Scalars['String']>;
  stake?: InputMaybe<Scalars['Float']>;
  /** Live stream URL (Watchers, YouTube Live, etc.) */
  streamUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TypeEnum>;
  /** External video URL (YouTube) */
  videoUrl?: InputMaybe<Scalars['String']>;
};

/** post input parameters object for creating a new Post */
export type PostWithVotes = {
  __typename?: 'PostWithVotes';
  category?: Maybe<CategoryEnum>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  downvoted?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isCommentsAllow: Scalars['Boolean'];
  mediaLink?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<TypeEnum>;
  updatedAt: Scalars['DateTime'];
  upvoted?: Maybe<Scalars['Float']>;
  upvotedStatus?: Maybe<Vote>;
  userId: Scalars['ID'];
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  subTotal: Scalars['Float'];
  taxRate: Scalars['Float'];
  total: Scalars['Float'];
  vat: Scalars['Float'];
};

/** Connection type for pagination of Currencies */
export type PriceConnection = {
  __typename?: 'PriceConnection';
  edges: Array<PriceNodeEdge>;
  pageInfo: PageInfo;
};

export type PriceCreateInput = {
  currencyId: Scalars['String'];
  price: Scalars['Float'];
};

export type PriceNode = Node & {
  __typename?: 'PriceNode';
  currency: CurrencyNode;
  currencyId: Scalars['Float'];
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  price: Scalars['Float'];
  priceBreakdown?: Maybe<PriceBreakdown>;
};

export type PriceNodeEdge = {
  __typename?: 'PriceNodeEdge';
  /** PriceNode node */
  node: PriceNode;
};

export type PriceUpdateInput = {
  currencyId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

export enum PublishingPlatform {
  Discord = 'DISCORD',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Pinterest = 'PINTEREST',
  Reddit = 'REDDIT',
  Telegram = 'TELEGRAM',
  Tiktok = 'TIKTOK',
  X = 'X',
  Youtube = 'YOUTUBE'
}

export type PurchaseNode = {
  __typename?: 'PurchaseNode';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  externalReference?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoiceUrl?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PlanPaymentMethod>;
  paymentProvider: Scalars['String'];
  planId: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  adStats: AdStats;
  ads: AllAds;
  adsById: Ads;
  adsByPlacement?: Maybe<Array<Ads>>;
  adsMiniStats: Array<AdMiniStat>;
  affilateLink: AffilateLinkModel;
  affiliateLinkUsers: AllAffilateLinkUsers;
  affiliateLinks: AllAffilateLinks;
  /** Generate AI copy for one tip or a multi-leg parlay slip. Pass a single-element array for a standard post, or multiple elements for a parlay/accumulator post. */
  aiTipAnalysis: Scalars['String'];
  analyticsReport?: Maybe<AnalyticsReports>;
  availablePayments: AvailablePaymentConnection;
  bonus: BonusModel;
  bonuses: AllBonuses;
  bookies: Array<Bookies>;
  bookiesByEventIdAndMarketId: Array<BookieOdd>;
  bookiesByEventOutcomeId: Array<Bookies>;
  bookiesByMultitipContentId: Array<BookieOdd>;
  categoriesBySportIdAndEventDate: Array<Category>;
  categoryById: Category;
  channel: ChannelModel;
  channelDetailed?: Maybe<ChannelDetailed>;
  channelListStatByCategoryies?: Maybe<Array<ChannelListCategory>>;
  channelUsers?: Maybe<ChannelUsersList>;
  channelUsersCount: Scalars['Int'];
  channelUsersWithChannelIds?: Maybe<ChannelUsersList>;
  channels: Channels;
  chat: Chat;
  chatByTipsterId?: Maybe<Chat>;
  chats: Chats;
  checkCurrentUserHasPendingSubscription?: Maybe<Scalars['Boolean']>;
  checkIfUserVotedPoll: Scalars['Boolean'];
  /** Get Comment by ID */
  comment: CommentModel;
  /** Get Comments by Content type */
  commentsByContent: CommentsReturnType;
  competitionEvents?: Maybe<ContentCompetitionEvent>;
  /** Tipster ranking scoped to a specific TIPSTER_PERFORMANCE competition — uses the competition's date range, sport filter, ranking metric, and minimum tips threshold. */
  competitionTipsterLeaderboard: LeaderboardPage;
  competitions: Array<ContentCompetitions>;
  competitionsCount: Scalars['Int'];
  /** Get current total active tips */
  countActiveTips: Scalars['Float'];
  /** Get all Countries */
  countries: Array<CountryModel>;
  /** Get one Country by ID */
  country: CountryModel;
  /** Get user country through ip address */
  countryByIp: CountryModel;
  /** Returns connection of the currencies */
  currencies: CurrencyConnection;
  /** get all detailed tips with filters */
  detailedTipsAndMultitips: Array<DetailedTipAndMultitip>;
  entityNotificationSettingsByEntityId: Array<EntityNotificationSetting>;
  eventOddTypeOutcomeValue: EventOddTypeOutcomeMarket;
  fetchServiceSubscriptions: ServiceSubscriptionConnection;
  financials: FinancialPayConnection;
  freeTrialByCondition: ServiceSubscriptionConnection;
  generateDashboardToken: Scalars['String'];
  generateInviteLink?: Maybe<Scalars['String']>;
  /** Generate telegram bot invite link */
  generateTelegramBotLink: Scalars['String'];
  getEngagementSubscribersMetrics: EngagementSubscribersMetrics;
  getFinancials: Financials;
  getOutcomeNamesByEventIdAndOutcomeId: Array<EventOutcomeResult>;
  getRevenueByDate: Array<RevenueByDate>;
  /** Get a User by external ID */
  getSignupEmailFromToken?: Maybe<UserTokenIdentity>;
  getSubscriptionMetrics: Array<SubscriptionMetrics>;
  getTeamsByExtIds: Array<Team>;
  /** Get stream room info (streamUrl, coverImageUrl) for a tip */
  getTipRoom?: Maybe<TipRoomOutput>;
  /** Get a User by external ID */
  getTipsterChannelsByDisplayName?: Maybe<UserModel>;
  getTipsterFollowersBySource: Array<FollowersBySourceCount>;
  getTipsterStatImages: Array<TipsterStatImageModel>;
  getTipsterSubscribers: SubscribersListConnection;
  getTipsterUsersSignupMethods: Array<SignupMethodCount>;
  getTotalChannelUsers: Array<TotalChannelUsers>;
  getTrialMetrics: TrialMetrics;
  grantsByTipster: Array<TipsterGrantNode>;
  hasAccess: Scalars['Boolean'];
  /** Improve grammar and sentence structure of provided text */
  improveContent: Scalars['String'];
  inviteLink: AffilateLinkModel;
  listTelegramShareSync: Array<SocialPlatformLink>;
  /** Get list of tipster invitees */
  listTipsterInvitees: ManyTipsterInviteeModel;
  markets: Array<Market>;
  marketsByEventId: Array<Market>;
  messagesByChat: Array<Message>;
  /** Get one MultiTip */
  multitip: Multitip;
  /** Get one MultiTip detailed */
  multitipDetailed?: Maybe<MultitipDetailed>;
  myAccessGrants: Array<MyAccessGrantNode>;
  myFavoriteBookie?: Maybe<FavoriteBookie>;
  /** Current user's own leaderboard rank/position, even if outside the currently loaded page range. */
  myLeaderboardPosition: MyLeaderboardPosition;
  notificationSettingsByUserId: Array<EntityNotificationSetting>;
  notifications: Notifications;
  oddByEventIdAndMarketId: Array<OutcomesList>;
  oddVoted: EventOddTypeOutcomeMarketVoteds;
  plans: Array<PlanNode>;
  plansByChannel: Array<PlanNode>;
  plansByTipsterId: Array<PlanNode>;
  poll: PollModel;
  pollDetailed?: Maybe<PollDetailed>;
  pollsByUserId: Array<PollModel>;
  post: PostWithVotes;
  postDetailed?: Maybe<PostDetailed>;
  price: PriceNode;
  prices: PriceConnection;
  /** Get content for public channel */
  privateChannelContent: ChannelFeedResponse;
  publicChannelContent: ChannelFeedResponse;
  recommendedChannels: Channels;
  rewardTypes: Array<RewardType>;
  rgBanner?: Maybe<RgBanner>;
  rgBanners: Array<RgBanner>;
  savedTips: SavedTipsList;
  searchBookmakers: SearchBookmakersResult;
  service: ServiceNode;
  serviceByChannelIdAndTipsterId: ServiceNode;
  serviceDuration: ServiceDurationNode;
  serviceDurations: ServiceDurationConnection;
  serviceSubscription?: Maybe<ServiceSubscriptionNode>;
  serviceSubscriptionByUserIdAndSubscriptionId?: Maybe<ServiceSubscriptionNode>;
  serviceSubscriptions: ServiceSubscriptionConnection;
  serviceSubscriptionsByChannelIdAndTipserId?: Maybe<ServiceSubscriptionConnection>;
  serviceSubscriptionsByUserId?: Maybe<ServiceSubscriptionConnection>;
  services: ServiceConnection;
  servicesByTipsterId: Array<ServiceNode>;
  sportEventByCompetitorName: Array<SportEvent>;
  sportEventByEventId: SportEventDetailed;
  sportEventVoted: SportEventDetailed;
  sportEventsByBetslipTips: Array<BetslipMatchedEvent>;
  sportEventsByTournamentIdAndDate: Array<SportEventType>;
  sportWithoutCategories: Array<Sports>;
  sports: Array<Sports>;
  sportsByEventDate: Array<Sports>;
  ssoSecrets?: Maybe<SsoSecretConfigType>;
  stats: TipsterStatistics;
  subscription: SubscriptionNode;
  subscriptionByChannelIdAndTipsterId: SubscriptionConnection;
  subscriptionWithFreeTrial: SubscriptionNode;
  subscriptions: SubscriptionConnection;
  tenantBookieStats: TenantBookieStats;
  tenantBookies: Array<TenantBookie>;
  tenantBookiesForMultitip: Array<TenantBookieForOutcome>;
  tenantBookiesForOutcome: Array<TenantBookieForOutcome>;
  tenantConfig: TenantConfig;
  /** Get one Tip */
  tip: Tip;
  tipDetailed?: Maybe<TipDetailed>;
  /** Get all Tips. Default limit: 10, skip: 0 */
  tips: Array<Tip>;
  /** Get tips sport distribution with counts */
  tipsSportDistribution: TipsSportDistribution;
  /** Get all tips with outcome names from sports-center service */
  tipsWithOutcomeNames: Array<TipWithOutcomeName>;
  tipsterAvailablePayments: AvailablePaymentConnection;
  tipsterAvailablePaymentsWithPaymentType: AvailablePaymentConnection;
  /** Returns connection of the currencies */
  tipsterCurrencies: CurrencyConnection;
  /** Get the number of followers for a tipster */
  tipsterFollowers: Scalars['Int'];
  tipsterFollowersCount: Scalars['Float'];
  /** Paginated tipster ranking for the current brand/tenant. Pass back snapshotId from a previous response to keep ranks stable across page loads. */
  tipsterLeaderboard: LeaderboardPage;
  tipsterOwnedChannels: Array<TipsterChannel>;
  /** Get a tipster profile by ID */
  tipsterProfile: TipsterProfile;
  /** Get tipster profile stats for header display (win rate, total tips, avg/month) */
  tipsterProfileStats: TipsterProfileStats;
  tournamentsAndcategoryByIds: Array<Tournament>;
  tournamentsByCategoryIdAndEventsDate: Array<Tournament>;
  tournamentsByIds: Array<Tournament>;
  tournamentsBySportIds: Tournaments;
  tournamentsBySportIdsAndEventDate: TournamentList;
  /** Translate Countries */
  translateCountries: Array<CountryModel>;
  unreadChatsCount: Scalars['Float'];
  /** Get a User by ID */
  user: UserModel;
  /** Check users display name */
  userByDisplayname: Scalars['Boolean'];
  /** Get a User by external ID */
  userByExternalId?: Maybe<UserModel>;
  userChannels: Array<ChannelDetailed>;
  /** Get current user */
  userCurrent: UserModel;
  userStats: UserStatistics;
  /** Get all Users. Default limit: 10, skip: 0 */
  users: AllUsersModel;
  usersByIds: Array<UserModel>;
  usersLeaderboard: Array<UserLeaderboardEntry>;
  verifyEmailToken: Scalars['String'];
  vipInvites: Array<VipInviteNode>;
  voterRanking: VoterRanking;
};


export type QueryAdStatsArgs = {
  id: Scalars['ID'];
};


export type QueryAdsArgs = {
  filter?: InputMaybe<AdsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AdsSort>;
};


export type QueryAdsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryAdsByPlacementArgs = {
  channelId?: InputMaybe<Scalars['ID']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<AdsFilter>;
  placement: Placement;
};


export type QueryAdsMiniStatsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryAffilateLinkArgs = {
  id: Scalars['String'];
};


export type QueryAffiliateLinkUsersArgs = {
  filter?: InputMaybe<AffiliateLinkUsersFilter>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
  sort?: InputMaybe<AffiliateLinkUsersSort>;
};


export type QueryAffiliateLinksArgs = {
  filter?: InputMaybe<AffilateLinkFilters>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
  sort?: InputMaybe<AffilateLinkSort>;
};


export type QueryAiTipAnalysisArgs = {
  betType?: InputMaybe<BetType>;
  confidence?: InputMaybe<Scalars['Float']>;
  input: Array<TipAnalysisInput>;
  odds?: InputMaybe<Scalars['Float']>;
};


export type QueryAnalyticsReportArgs = {
  filter?: InputMaybe<AnalyticsReportInput>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
};


export type QueryAvailablePaymentsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryBonusArgs = {
  id: Scalars['String'];
};


export type QueryBonusesArgs = {
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
};


export type QueryBookiesByEventIdAndMarketIdArgs = {
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
  outcomeId?: InputMaybe<Scalars['ID']>;
};


export type QueryBookiesByEventOutcomeIdArgs = {
  eventOutcomeId: Scalars['ID'];
};


export type QueryBookiesByMultitipContentIdArgs = {
  contentId: Scalars['ID'];
};


export type QueryCategoriesBySportIdAndEventDateArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  eventsDate: Scalars['DateTime'];
  sportId: Scalars['ID'];
};


export type QueryCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryChannelArgs = {
  channelId: Scalars['String'];
};


export type QueryChannelDetailedArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryChannelListStatByCategoryiesArgs = {
  filter?: InputMaybe<ChannelListFilterInput>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryChannelUsersArgs = {
  channelId: Scalars['String'];
  channelRole?: InputMaybe<ChannelRole>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryChannelUsersWithChannelIdsArgs = {
  channelIds: Array<Scalars['String']>;
  channelRole?: InputMaybe<ChannelRole>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryChannelsArgs = {
  filter?: InputMaybe<ChannelFilterInput>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ChannelSortInput>;
};


export type QueryChatArgs = {
  id: Scalars['Float'];
};


export type QueryChatByTipsterIdArgs = {
  tipsterId: Scalars['ID'];
};


export type QueryChatsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryCheckIfUserVotedPollArgs = {
  pollId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryCommentArgs = {
  id: Scalars['ID'];
};


export type QueryCommentsByContentArgs = {
  body: CommentsByType;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
};


export type QueryCompetitionEventsArgs = {
  competitionId: Scalars['ID'];
};


export type QueryCompetitionTipsterLeaderboardArgs = {
  competitionId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  snapshotId?: InputMaybe<Scalars['String']>;
};


export type QueryCompetitionsArgs = {
  filter?: InputMaybe<ContentCompetitionFIlter>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
};


export type QueryCompetitionsCountArgs = {
  filter?: InputMaybe<ContentCompetitionFIlter>;
};


export type QueryCountryArgs = {
  id: Scalars['ID'];
};


export type QueryCurrenciesArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryDetailedTipsAndMultitipsArgs = {
  input: TipsFilterInput;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryEntityNotificationSettingsByEntityIdArgs = {
  entityId?: InputMaybe<Scalars['ID']>;
  scope: NotificationSettingScope;
};


export type QueryEventOddTypeOutcomeValueArgs = {
  bookmakerId: Scalars['ID'];
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
  outcomeId: Scalars['ID'];
};


export type QueryFetchServiceSubscriptionsArgs = {
  filter?: InputMaybe<FinancialFilterInputs>;
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryFinancialsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryFreeTrialByConditionArgs = {
  status: ServiceSubscriptionStatus;
};


export type QueryGenerateInviteLinkArgs = {
  channelId: Scalars['String'];
};


export type QueryGenerateTelegramBotLinkArgs = {
  shareType: AutoShareContentTypeInput;
};


export type QueryGetEngagementSubscribersMetricsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryGetFinancialsArgs = {
  filter?: InputMaybe<FinancialFilterInput>;
  limit?: Scalars['Float'];
  skip?: Scalars['Float'];
  sort?: InputMaybe<FinancialSortInput>;
};


export type QueryGetOutcomeNamesByEventIdAndOutcomeIdArgs = {
  items: Array<EventOutcomeInput>;
};


export type QueryGetRevenueByDateArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryGetSignupEmailFromTokenArgs = {
  token: Scalars['String'];
};


export type QueryGetSubscriptionMetricsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryGetTeamsByExtIdsArgs = {
  extIds: Array<Scalars['ID']>;
  sportId: Array<Scalars['ID']>;
};


export type QueryGetTipRoomArgs = {
  tipId: Scalars['ID'];
};


export type QueryGetTipsterChannelsByDisplayNameArgs = {
  displayName: Scalars['String'];
};


export type QueryGetTipsterFollowersBySourceArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryGetTipsterSubscribersArgs = {
  filter?: InputMaybe<ServiceSubscriberFilterInput>;
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGetTipsterUsersSignupMethodsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryGetTotalChannelUsersArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type QueryGetTrialMetricsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryHasAccessArgs = {
  channelId: Scalars['Int'];
  tipsterId?: InputMaybe<Scalars['String']>;
};


export type QueryImproveContentArgs = {
  text: Scalars['String'];
};


export type QueryInviteLinkArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryListTelegramShareSyncArgs = {
  channelId?: InputMaybe<Scalars['String']>;
};


export type QueryListTipsterInviteesArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
};


export type QueryMarketsByEventIdArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
};


export type QueryMessagesByChatArgs = {
  chatId: Scalars['Float'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};


export type QueryMultitipArgs = {
  id: Scalars['ID'];
};


export type QueryMultitipDetailedArgs = {
  id: Scalars['ID'];
};


export type QueryMyLeaderboardPositionArgs = {
  filter?: InputMaybe<LeaderboardFilterInput>;
};


export type QueryNotificationsArgs = {
  channelIds: Array<Scalars['String']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
};


export type QueryOddByEventIdAndMarketIdArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
};


export type QueryOddVotedArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Float']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  skip?: InputMaybe<Scalars['Float']>;
  sportId?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPlansByChannelArgs = {
  channelId: Scalars['Float'];
};


export type QueryPlansByTipsterIdArgs = {
  tipsterId: Scalars['String'];
};


export type QueryPollArgs = {
  id: Scalars['ID'];
};


export type QueryPollDetailedArgs = {
  id: Scalars['ID'];
};


export type QueryPollsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryPostArgs = {
  id: Scalars['ID'];
};


export type QueryPostDetailedArgs = {
  id: Scalars['ID'];
};


export type QueryPriceArgs = {
  id: Scalars['String'];
};


export type QueryPricesArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryPrivateChannelContentArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<FeedCursorInput>;
  filter?: InputMaybe<ChannelFeedFilter>;
  limit?: Scalars['Int'];
};


export type QueryPublicChannelContentArgs = {
  cursor?: InputMaybe<FeedCursorInput>;
  filter?: InputMaybe<ChannelFeedFilter>;
  limit?: Scalars['Int'];
};


export type QueryRecommendedChannelsArgs = {
  filter?: InputMaybe<ChannelFilterInput>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ChannelSortInput>;
};


export type QueryRgBannerArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};


export type QuerySavedTipsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  sportIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QuerySearchBookmakersArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryServiceArgs = {
  id: Scalars['String'];
};


export type QueryServiceByChannelIdAndTipsterIdArgs = {
  channelId: Scalars['String'];
  tipsterId: Scalars['String'];
};


export type QueryServiceDurationArgs = {
  id: Scalars['String'];
};


export type QueryServiceDurationsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryServiceSubscriptionArgs = {
  id: Scalars['String'];
};


export type QueryServiceSubscriptionByUserIdAndSubscriptionIdArgs = {
  subscriptionId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryServiceSubscriptionsArgs = {
  filter?: InputMaybe<ServiceSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryServiceSubscriptionsByChannelIdAndTipserIdArgs = {
  channelId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statuses: Array<ServiceSubscriptionStatus>;
  tipsterId: Scalars['String'];
};


export type QueryServiceSubscriptionsByUserIdArgs = {
  includeExpired: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryServicesArgs = {
  filter?: InputMaybe<ServiceFilterInput>;
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryServicesByTipsterIdArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QuerySportEventByCompetitorNameArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  competitorName: Scalars['String'];
  from?: InputMaybe<Scalars['DateTime']>;
  marketId?: InputMaybe<Scalars['String']>;
  sportId: Array<Scalars['ID']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QuerySportEventByEventIdArgs = {
  eventId: Scalars['ID'];
};


export type QuerySportEventVotedArgs = {
  eventId: Scalars['ID'];
};


export type QuerySportEventsByBetslipTipsArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  tips: Array<BetslipTipInput>;
};


export type QuerySportEventsByTournamentIdAndDateArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  eventsDate: Scalars['DateTime'];
  forDefaultBookie?: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  sportId?: InputMaybe<Scalars['String']>;
  tournamentId?: InputMaybe<Scalars['ID']>;
};


export type QuerySportsByEventDateArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  eventsDate: Scalars['DateTime'];
};


export type QuerySsoSecretsArgs = {
  provider: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  sportId?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tipsterId: Scalars['ID'];
};


export type QuerySubscriptionArgs = {
  id: Scalars['String'];
};


export type QuerySubscriptionByChannelIdAndTipsterIdArgs = {
  channelId?: InputMaybe<Scalars['String']>;
  countryId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QuerySubscriptionWithFreeTrialArgs = {
  serviceId: Scalars['String'];
};


export type QuerySubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryTenantBookieStatsArgs = {
  id: Scalars['ID'];
};


export type QueryTenantBookiesArgs = {
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryTenantBookiesForMultitipArgs = {
  contentId: Scalars['ID'];
  sortByHighOdds?: Scalars['Boolean'];
  userCountryId?: InputMaybe<Scalars['ID']>;
};


export type QueryTenantBookiesForOutcomeArgs = {
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
  outcomeId?: InputMaybe<Scalars['ID']>;
  sortByHighOdds?: Scalars['Boolean'];
  userCountryId?: InputMaybe<Scalars['ID']>;
};


export type QueryTipArgs = {
  id: Scalars['ID'];
};


export type QueryTipDetailedArgs = {
  id: Scalars['ID'];
};


export type QueryTipsArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
};


export type QueryTipsSportDistributionArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  sportIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryTipsWithOutcomeNamesArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  sportIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryTipsterAvailablePaymentsArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryTipsterAvailablePaymentsWithPaymentTypeArgs = {
  isAutoActivated: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryTipsterCurrenciesArgs = {
  limit?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Float']>;
  sortKey?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
};


export type QueryTipsterFollowersArgs = {
  tipsterId: Scalars['ID'];
};


export type QueryTipsterFollowersCountArgs = {
  filter?: InputMaybe<TipsterFollowersCountFIlter>;
  tipsterId: Scalars['String'];
};


export type QueryTipsterLeaderboardArgs = {
  filter?: InputMaybe<LeaderboardFilterInput>;
};


export type QueryTipsterProfileArgs = {
  id: Scalars['ID'];
};


export type QueryTipsterProfileStatsArgs = {
  tipsterId: Scalars['ID'];
};


export type QueryTournamentsAndcategoryByIdsArgs = {
  catids?: Array<Scalars['ID']>;
  ids: Array<Scalars['ID']>;
};


export type QueryTournamentsByCategoryIdAndEventsDateArgs = {
  bookmakerId?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  eventsDate: Scalars['DateTime'];
};


export type QueryTournamentsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryTournamentsBySportIdsArgs = {
  ids: Array<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
};


export type QueryTournamentsBySportIdsAndEventDateArgs = {
  eventsDate: Scalars['DateTime'];
  ids: Array<Scalars['ID']>;
};


export type QueryTranslateCountriesArgs = {
  country_name: Scalars['String'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserByDisplaynameArgs = {
  name: Scalars['String'];
};


export type QueryUserByExternalIdArgs = {
  id: Scalars['ID'];
};


export type QueryUserChannelsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryUserStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  sportId?: InputMaybe<Array<Scalars['ID']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  sort?: InputMaybe<UserSort>;
};


export type QueryUsersByIdsArgs = {
  userIds: Array<Scalars['String']>;
};


export type QueryUsersLeaderboardArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryVerifyEmailTokenArgs = {
  token: Scalars['String'];
};


export type QueryVoterRankingArgs = {
  competitionId: Scalars['ID'];
  limit: Scalars['Float'];
  skip: Scalars['Float'];
};

export type Result = {
  __typename?: 'Result';
  channelId: Scalars['Float'];
  result: Scalars['Boolean'];
};

export enum ResultType {
  Lost = 'LOST',
  Void = 'VOID',
  Won = 'WON'
}

export type RevenueByDate = {
  __typename?: 'RevenueByDate';
  date: Scalars['String'];
  totalAmount: Scalars['Float'];
};

/** Competition reward input */
export type RewardInput = {
  /** Optional reward description */
  description?: InputMaybe<Scalars['String']>;
  /** Optional reward value */
  reward?: InputMaybe<Scalars['String']>;
  /** Reward title, e.g., "First Prize" */
  title: Scalars['String'];
};

export type RewardItem = {
  __typename?: 'RewardItem';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  reward?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type RewardType = {
  __typename?: 'RewardType';
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type RgBanner = {
  __typename?: 'RgBanner';
  ageLabel: Scalars['String'];
  countryCode: Scalars['String'];
  enabled: Scalars['Boolean'];
  footer?: Maybe<Scalars['String']>;
  helpPhone?: Maybe<Scalars['String']>;
  helpPhoneLabel?: Maybe<Scalars['String']>;
  helpUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isTenantOverride: Scalars['Boolean'];
  messages: Array<Scalars['String']>;
  regulatorUrl?: Maybe<Scalars['String']>;
  rotateMessages: Scalars['Boolean'];
  shortMessage?: Maybe<Scalars['String']>;
  variant: RgBannerVariant;
};

export type RgBannerInput = {
  ageLabel: Scalars['String'];
  countryCode: Scalars['String'];
  enabled?: Scalars['Boolean'];
  footer?: InputMaybe<Scalars['String']>;
  helpPhone?: InputMaybe<Scalars['String']>;
  helpPhoneLabel?: InputMaybe<Scalars['String']>;
  helpUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  messages: Array<Scalars['String']>;
  regulatorUrl?: InputMaybe<Scalars['String']>;
  rotateMessages?: Scalars['Boolean'];
  shortMessage?: InputMaybe<Scalars['String']>;
  variant: RgBannerVariant;
};

export enum RgBannerVariant {
  Dgoj = 'DGOJ',
  Image = 'IMAGE',
  Standard = 'STANDARD'
}

export type SavedTips = MultitipDetailed | TipDetailed;

export type SavedTipsList = {
  __typename?: 'SavedTipsList';
  savedTips: Array<SavedTips>;
  totalCount: Scalars['Float'];
};

export type SearchBookmakersResult = {
  __typename?: 'SearchBookmakersResult';
  bookmakers: Array<BookmakerOption>;
  total: Scalars['Int'];
};

export type SendMagicLinkInput = {
  email: Scalars['String'];
  redirectUrl: Scalars['String'];
};

/** Connection type for pagination of Services */
export type ServiceConnection = {
  __typename?: 'ServiceConnection';
  edges: Array<ServiceNodeEdge>;
  pageInfo: PageInfo;
};

export type ServiceCreate = {
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  channelId: Scalars['ID'];
  ctaSubTitle?: InputMaybe<Scalars['String']>;
  ctaTitle?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  expirationAlert?: InputMaybe<Scalars['Boolean']>;
  imageLink?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Scalars['String']>;
  paymentMethods: Array<PaymentMethodsInput>;
  serviceName?: InputMaybe<Scalars['String']>;
  status: ServiceStatus;
  subTitle?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

/** Connection type for pagination of Service durations */
export type ServiceDurationConnection = {
  __typename?: 'ServiceDurationConnection';
  edges: Array<ServiceDurationNodeEdge>;
  pageInfo: PageInfo;
};

export type ServiceDurationCreateInput = {
  duration: Scalars['Float'];
};

export type ServiceDurationNode = {
  __typename?: 'ServiceDurationNode';
  duration: Scalars['Float'];
  /** A globally-unique identifier. */
  id: Scalars['ID'];
};

export type ServiceDurationNodeEdge = {
  __typename?: 'ServiceDurationNodeEdge';
  /** ServiceDurationNode node */
  node: ServiceDurationNode;
};

export type ServiceDurationUpdateInput = {
  duration?: InputMaybe<Scalars['Float']>;
};

export type ServiceFilterInput = {
  channelName?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<PeriodDates>;
  id?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceStatus>;
  tipsterId?: InputMaybe<Scalars['String']>;
};

/** Service object. */
export type ServiceNode = {
  __typename?: 'ServiceNode';
  autoRenewal: Scalars['Boolean'];
  avatarUrl?: Maybe<Scalars['String']>;
  channelId: Scalars['String'];
  channelName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ctaSubTitle?: Maybe<Scalars['String']>;
  ctaTitle?: Maybe<Scalars['String']>;
  dateStart?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  expirationAlert: Scalars['Boolean'];
  hasFreeTrial: Scalars['Boolean'];
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  imageLink?: Maybe<Scalars['String']>;
  info?: Maybe<Scalars['String']>;
  paymentMethods?: Maybe<Array<PaymentMethods>>;
  serviceName?: Maybe<Scalars['String']>;
  status: ServiceStatus;
  subTitle?: Maybe<Scalars['String']>;
  subscribers?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<SubscriptionNode>>;
  tipsterId: Scalars['String'];
  tipsterName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


/** Service object. */
export type ServiceNodeSubscriptionsArgs = {
  countryId?: InputMaybe<Scalars['String']>;
};

export type ServiceNodeEdge = {
  __typename?: 'ServiceNodeEdge';
  /** ServiceNode node */
  node: ServiceNode;
};

export type ServiceSubscriberFilterInput = {
  currencyId?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRange>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceSubscriptionStatus>;
};

export type ServiceSubscriptionConnection = {
  __typename?: 'ServiceSubscriptionConnection';
  edges: Array<ServiceSubscriptionNodeEdge>;
  pageInfo: PageInfo;
};

export type ServiceSubscriptionCreateInput = {
  paymentMethodId?: InputMaybe<Scalars['Float']>;
  subscriptionId: Scalars['String'];
};

export type ServiceSubscriptionFilterInput = {
  status?: InputMaybe<ServiceSubscriptionStatus>;
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type ServiceSubscriptionNode = {
  __typename?: 'ServiceSubscriptionNode';
  channelId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expiration?: Maybe<Scalars['DateTime']>;
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  isTrialUsed: Scalars['Boolean'];
  paymentMethodId?: Maybe<Scalars['Float']>;
  serviceName?: Maybe<Scalars['String']>;
  status: ServiceSubscriptionStatus;
  subscription?: Maybe<SubscriptionNode>;
  subscriptionCurrencyCode?: Maybe<Scalars['String']>;
  subscriptionCurrencySymbol?: Maybe<Scalars['String']>;
  subscriptionDuration?: Maybe<Scalars['Float']>;
  subscriptionId: Scalars['String'];
  subscriptionPrice?: Maybe<Scalars['Float']>;
  tipsterId?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  userDisplayName: Scalars['String'];
  userId: Scalars['String'];
};

export type ServiceSubscriptionNodeEdge = {
  __typename?: 'ServiceSubscriptionNodeEdge';
  /** ServiceSubscriptionNode node */
  node: ServiceSubscriptionNode;
};

export enum ServiceSubscriptionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Onhold = 'ONHOLD'
}

export type ServiceSubscriptionUpdateInput = {
  expiration?: InputMaybe<Scalars['DateTime']>;
  freeTrialPeriod?: InputMaybe<Scalars['Float']>;
  isTrialUsed?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ServiceSubscriptionStatus>;
};

export type ServiceUpdate = {
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  channelId?: InputMaybe<Scalars['ID']>;
  ctaSubTitle?: InputMaybe<Scalars['String']>;
  ctaTitle?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  expirationAlert?: InputMaybe<Scalars['Boolean']>;
  imageLink?: InputMaybe<Scalars['String']>;
  info?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<PaymentMethodsInput>>;
  serviceName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceStatus>;
  subTitle?: InputMaybe<Scalars['String']>;
  tipsterId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Input parameters for updating channel setting */
export type SettingsUpdate = {
  id: Scalars['ID'];
  scope: ChannelSettingsScope;
  value: Scalars['String'];
};

export type SignupMethodCount = {
  __typename?: 'SignupMethodCount';
  pool: Scalars['String'];
  userCount: Scalars['Int'];
};

export type SocialPlatformLink = {
  __typename?: 'SocialPlatformLink';
  channelId: Scalars['Float'];
  contentTypes: Array<AutoShareContentTypes>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  displayType: SocialShareDisplayType;
  id: Scalars['ID'];
  linkVerificationToken: Scalars['String'];
  platformLink: Scalars['String'];
  platformName: PublishingPlatform;
  shouldUpdateMessage: Scalars['Boolean'];
  status: PlatformLinkStatus;
  tokenExpireAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export enum SocialShareDisplayType {
  Image = 'IMAGE',
  Text = 'TEXT'
}

/** ASC or DESC sorting */
export enum SortMethod {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SportDistribution = {
  __typename?: 'SportDistribution';
  count: Scalars['Int'];
  sportId: Scalars['ID'];
  sportName: Scalars['String'];
};

export type SportEvent = {
  __typename?: 'SportEvent';
  bookmakerId?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['ID']>;
  competitors: Array<Competitor>;
  eventDate?: Maybe<Scalars['DateTime']>;
  eventStatus?: Maybe<Scalars['String']>;
  eventType: Scalars['String'];
  externalId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  numberOfTips?: Maybe<Scalars['Float']>;
  sport?: Maybe<Sports>;
  sportId?: Maybe<Scalars['ID']>;
  tournament?: Maybe<Tournament>;
  tournamentId?: Maybe<Scalars['ID']>;
  votes: Scalars['Float'];
};

export type SportEventDetailed = {
  __typename?: 'SportEventDetailed';
  bookmakerId: Scalars['String'];
  bookmakerName: Scalars['String'];
  categoryId?: Maybe<Scalars['ID']>;
  competitors: Array<Competitor>;
  eventDate?: Maybe<Scalars['DateTime']>;
  eventOutcome: Array<MarketForEventList>;
  eventStatus?: Maybe<Scalars['String']>;
  eventType: Scalars['String'];
  externalId?: Maybe<Scalars['ID']>;
  hasLiveOdds: Scalars['Boolean'];
  id: Scalars['ID'];
  liveMatchId?: Maybe<Scalars['String']>;
  numberOfTips?: Maybe<Scalars['Float']>;
  sportId?: Maybe<Scalars['ID']>;
  tournament?: Maybe<Tournament>;
  tournamentId?: Maybe<Scalars['ID']>;
};

export type SportEventType = {
  __typename?: 'SportEventType';
  categoryId?: Maybe<Scalars['ID']>;
  competitors: Array<Competitor>;
  eventDate?: Maybe<Scalars['DateTime']>;
  eventStatus?: Maybe<Scalars['String']>;
  eventType: Scalars['String'];
  externalId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  numberOfTips?: Maybe<Scalars['Float']>;
  sportId?: Maybe<Scalars['ID']>;
  tournament?: Maybe<Tournament>;
  tournamentId?: Maybe<Scalars['ID']>;
  votes?: Maybe<Scalars['Float']>;
};

export type Sports = {
  __typename?: 'Sports';
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SsoLoginInput = {
  payload: Scalars['JSON'];
  provider: Scalars['String'];
};

export type SsoProviderConfig = {
  __typename?: 'SsoProviderConfig';
  allowedOrigins: Array<Scalars['String']>;
  provider: Scalars['String'];
};

export type SsoResult = {
  __typename?: 'SsoResult';
  firebaseToken: Scalars['String'];
};

export type SsoSecretConfigType = {
  __typename?: 'SsoSecretConfigType';
  apiKey?: Maybe<Scalars['String']>;
  apiUrl?: Maybe<Scalars['String']>;
};

export type SubscribersListConnection = {
  __typename?: 'SubscribersListConnection';
  edges: Array<SubscribersListNodeEdge>;
  pageInfo: PageInfo;
};

export type SubscribersListNode = {
  __typename?: 'SubscribersListNode';
  createdAt: Scalars['DateTime'];
  currencyCode: Scalars['String'];
  currencySymbol: Scalars['String'];
  expiration?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isAutoActivated?: Maybe<Scalars['Boolean']>;
  isPaid: Scalars['Boolean'];
  isTrialUsed?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['Float']>;
  paymentName?: Maybe<Scalars['String']>;
  price: Scalars['String'];
  status: ServiceSubscriptionStatus;
  subscriptionId: Scalars['String'];
  tipsterId: Scalars['Float'];
  user?: Maybe<User>;
  userId: Scalars['Float'];
};

export type SubscribersListNodeEdge = {
  __typename?: 'SubscribersListNodeEdge';
  /** SubscribersListNode node */
  node: SubscribersListNode;
};

export type Subscription = {
  __typename?: 'Subscription';
  chatAccepted: Chat;
  chatCreated: Chat;
  eventResult: Scalars['String'];
  messageAdded: Message;
  multitipNew: Scalars['String'];
  multitipResult: Scalars['String'];
  notifications: Scalars['String'];
  pollResult: Scalars['String'];
  subscription: Scalars['String'];
  tipResult: Scalars['String'];
  tipsterStatusChange: Scalars['String'];
  userStatusChange: Scalars['String'];
};


export type SubscriptionMessageAddedArgs = {
  userId: Scalars['ID'];
};


export type SubscriptionNotificationsArgs = {
  userId: Scalars['ID'];
};

export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  edges: Array<SubscriptionNodeEdge>;
  pageInfo: PageInfo;
};

export type SubscriptionCreateInput = {
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  freeTrialPeriod?: InputMaybe<Scalars['Float']>;
  priceId: Scalars['String'];
  serviceDurationId: Scalars['String'];
  serviceId: Scalars['String'];
};

export type SubscriptionMetrics = {
  __typename?: 'SubscriptionMetrics';
  cumulativeActiveSubscriptions: Scalars['Int'];
  date: Scalars['String'];
  newSubscriptions: Scalars['Int'];
};

export type SubscriptionNode = {
  __typename?: 'SubscriptionNode';
  countryIds?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  freeTrialPeriod?: Maybe<Scalars['Float']>;
  /** A globally-unique identifier. */
  id: Scalars['ID'];
  price: PriceNode;
  priceId: Scalars['String'];
  service: ServiceNode;
  serviceDuration: ServiceDurationNode;
  serviceDurationId: Scalars['String'];
  serviceId: Scalars['String'];
  totalActiveSubs?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export type SubscriptionNodeEdge = {
  __typename?: 'SubscriptionNodeEdge';
  /** SubscriptionNode node */
  node: SubscriptionNode;
};

export type SubscriptionUpdateInput = {
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  freeTrialPeriod?: InputMaybe<Scalars['Float']>;
  priceId?: InputMaybe<Scalars['String']>;
  serviceDurationId?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
};

/** input parameters for creating a new chat with support user */
export type SupportChatCreate = {
  email?: InputMaybe<Scalars['String']>;
  initialMessage: InitialMessage;
  subject?: InputMaybe<Scalars['String']>;
};

export type Team = {
  __typename?: 'Team';
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sportId: Scalars['ID'];
};

export type TenantBookie = {
  __typename?: 'TenantBookie';
  affiliateLink?: Maybe<Scalars['String']>;
  allowedCountryIds: Array<Scalars['ID']>;
  bonusLink?: Maybe<Scalars['String']>;
  bookieId?: Maybe<Scalars['Int']>;
  buttonText?: Maybe<Scalars['String']>;
  customName?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isMandatory: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  rewardDescription?: Maybe<Scalars['String']>;
  rewardType?: Maybe<RewardType>;
  sortOrder: Scalars['Int'];
  title: Scalars['String'];
};

export type TenantBookieForOutcome = {
  __typename?: 'TenantBookieForOutcome';
  bonusLink?: Maybe<Scalars['String']>;
  bookieId?: Maybe<Scalars['Int']>;
  buttonText?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  isFavorite: Scalars['Boolean'];
  name: Scalars['String'];
  odd?: Maybe<Scalars['Float']>;
  rewardDescription?: Maybe<Scalars['String']>;
  rewardTypeName?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
};

export type TenantBookieOrderItem = {
  externalId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type TenantBookieStats = {
  __typename?: 'TenantBookieStats';
  clicks: Scalars['Int'];
  timeSeries: Array<BookieDayStat>;
  totalCtr: Scalars['Float'];
  totalViews: Scalars['Int'];
  uniqueCtr: Scalars['Float'];
  uniqueViews: Scalars['Int'];
  viewFrequency: Scalars['Float'];
};

export type TenantBranding = {
  __typename?: 'TenantBranding';
  appName: Scalars['String'];
  emailSettings?: Maybe<TenantEmailSettings>;
  faviconUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  primaryColor: Scalars['String'];
  privacyContent?: Maybe<Scalars['String']>;
  rulesContent?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  termsContent?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['JSON']>;
};

export type TenantConfig = {
  __typename?: 'TenantConfig';
  branding?: Maybe<TenantBranding>;
  demoProfileId?: Maybe<Scalars['String']>;
  featureFlags: Array<FeatureFlag>;
  integrationConfig?: Maybe<TenantIntegrationConfig>;
  integrationSecrets?: Maybe<IntegrationSecrets>;
  tenantId: Scalars['String'];
};

export type TenantEmailSettings = {
  __typename?: 'TenantEmailSettings';
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
};

export type TenantIntegrationConfig = {
  __typename?: 'TenantIntegrationConfig';
  ssoProviders?: Maybe<Array<SsoProviderConfig>>;
  stripePublishableKey?: Maybe<Scalars['String']>;
  watchersApiKey?: Maybe<Scalars['String']>;
  watchersToken?: Maybe<Scalars['String']>;
};

/** Tip object parameters */
export type Tip = {
  __typename?: 'Tip';
  analysis?: Maybe<Scalars['String']>;
  bookieId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<TypesOfContent>;
  createdAt: Scalars['DateTime'];
  customBookieName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  includeInStat?: Maybe<Scalars['Boolean']>;
  isCommentsAllow: Scalars['Boolean'];
  isMultitip: Scalars['Boolean'];
  multitip?: Maybe<Scalars['ID']>;
  odds?: Maybe<Scalars['Float']>;
  outcomeId?: Maybe<Scalars['ID']>;
  partials?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['String']>;
  result?: Maybe<TipResult>;
  resultCreatedAt?: Maybe<Scalars['DateTime']>;
  sportId?: Maybe<Scalars['String']>;
  stake?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
  vip: Scalars['Boolean'];
};

/** Input parameters for generating AI tip analysis */
export type TipAnalysisInput = {
  /** First competitor/team name (home/local) */
  competitor1Name?: InputMaybe<Scalars['String']>;
  /** Second competitor/team name (away/visitor) */
  competitor2Name?: InputMaybe<Scalars['String']>;
  /** Additional context about the match or teams */
  context?: InputMaybe<Scalars['String']>;
  /** Event date (ISO format or readable date string) */
  eventDate: Scalars['String'];
  /** Event name (e.g., "Team A vs Team B") */
  eventName: Scalars['String'];
  /** Betting market type (e.g., Match Winner, Over/Under, BTTS) */
  marketType?: InputMaybe<Scalars['String']>;
  /** Decimal odds (optional - will search for current odds if not provided) */
  odds?: InputMaybe<Scalars['String']>;
};

/** tip input parameters object for creating a new Tip */
export type TipCreate = {
  analysis?: InputMaybe<Scalars['String']>;
  /** Audio file URL from S3 */
  audioUrl?: InputMaybe<Scalars['String']>;
  bookieId?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  customBookieName?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeInStat?: InputMaybe<Scalars['Boolean']>;
  isCommentsAllow?: Scalars['Boolean'];
  isMultiPostTip?: InputMaybe<Scalars['Boolean']>;
  isPostTip?: InputMaybe<Scalars['Boolean']>;
  oddTypeId?: InputMaybe<Scalars['String']>;
  odds?: InputMaybe<Scalars['Float']>;
  outcomeId?: InputMaybe<Scalars['ID']>;
  profit?: InputMaybe<Scalars['String']>;
  sportId?: InputMaybe<Scalars['String']>;
  stake?: InputMaybe<Scalars['Float']>;
  /** Live stream URL (Watchers, YouTube Live, etc.) */
  streamUrl?: InputMaybe<Scalars['String']>;
  /** External video URL (YouTube) */
  videoUrl?: InputMaybe<Scalars['String']>;
  vip: Scalars['Boolean'];
};

/** tip input parameters object for creating a new Tip */
export type TipCreateMultitip = {
  eventId: Scalars['ID'];
  includeInStat?: InputMaybe<Scalars['Boolean']>;
  /** no effect */
  isMultitip?: InputMaybe<Scalars['Boolean']>;
  /** no effect */
  multitip?: InputMaybe<Scalars['ID']>;
  oddTypeId: Scalars['String'];
  odds?: InputMaybe<Scalars['Float']>;
  outcomeId?: InputMaybe<Scalars['ID']>;
  partials?: InputMaybe<Scalars['String']>;
  sportId: Scalars['String'];
  vip?: InputMaybe<Scalars['Boolean']>;
};

/** Tip object parameters */
export type TipDetailed = {
  __typename?: 'TipDetailed';
  analysis?: Maybe<Scalars['String']>;
  anonymized?: Maybe<Scalars['Boolean']>;
  /** Audio file URL from S3 */
  audioUrl?: Maybe<Scalars['String']>;
  blocked: Scalars['Boolean'];
  bonusLink?: Maybe<Scalars['String']>;
  bookieId?: Maybe<Scalars['ID']>;
  bookieImageUrl?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  channelContentId?: Maybe<Scalars['Float']>;
  commentsCount?: Maybe<Scalars['Float']>;
  contentType?: Maybe<TypesOfContent>;
  /** Cover image URL for the stream room */
  coverImageUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customBookieName?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  event?: Maybe<TipSportEventType>;
  eventId?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  includeInStat?: Maybe<Scalars['Boolean']>;
  isCommentsAllow: Scalars['Boolean'];
  isMultiPostTip?: Maybe<Scalars['Boolean']>;
  isMultitip: Scalars['Boolean'];
  isPostTip?: Maybe<Scalars['Boolean']>;
  isSaved?: Maybe<Scalars['Boolean']>;
  /** Video, audio, and stream media files */
  media?: Maybe<Array<TipMediaOutput>>;
  multitip?: Maybe<Scalars['ID']>;
  odds?: Maybe<Scalars['Float']>;
  ogImageUrl?: Maybe<Scalars['String']>;
  outcomeId?: Maybe<Scalars['ID']>;
  partials?: Maybe<Scalars['String']>;
  profit?: Maybe<Scalars['String']>;
  result?: Maybe<TipResult>;
  resultCreatedAt?: Maybe<Scalars['DateTime']>;
  score?: Maybe<GameScore>;
  sportId?: Maybe<Scalars['String']>;
  stake?: Maybe<Scalars['Float']>;
  /** Live stream URL (Watchers, YouTube Live, etc.) */
  streamUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
  /** External video URL (YouTube) */
  videoUrl?: Maybe<Scalars['String']>;
  vip: Scalars['Boolean'];
  votes?: Maybe<Vote>;
};

/** Tip media (video/audio/stream) details */
export type TipMediaOutput = {
  __typename?: 'TipMediaOutput';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Type of media: video, audio, or stream */
  mediaType: Scalars['String'];
  /** URL - External for video/stream (YouTube/Watchers), S3 for audio */
  url: Scalars['String'];
};

export type TipOutcome = {
  __typename?: 'TipOutcome';
  bookmakerName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  specialBetValue?: Maybe<Scalars['String']>;
};

/** Stream room info from Watchers */
export type TipRoomOutput = {
  __typename?: 'TipRoomOutput';
  coverImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  streamEndTime?: Maybe<Scalars['String']>;
  streamStartTime?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  tipId: Scalars['ID'];
};

/** Tip object parameters */
export type TipSportEventType = {
  __typename?: 'TipSportEventType';
  categoryId?: Maybe<Scalars['String']>;
  competitors?: Maybe<Array<Competitor>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  eventDate?: Maybe<Scalars['DateTime']>;
  eventStatus?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  externalCategoryId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSportId?: Maybe<Scalars['String']>;
  externalTournamentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  oddType?: Maybe<OddType>;
  outcome?: Maybe<TipOutcome>;
  sportId?: Maybe<Scalars['String']>;
  tournament?: Maybe<TournamentModel>;
  tournamentId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Tip input parameters for updating an existing Tip */
export type TipUpdate = {
  analysis?: InputMaybe<Scalars['String']>;
  /** Audio file URL from S3 */
  audioUrl?: InputMaybe<Scalars['String']>;
  bookieId?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  customBookieName?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeInStat?: InputMaybe<Scalars['Boolean']>;
  isCommentsAllow?: InputMaybe<Scalars['Boolean']>;
  isMultiPostTip?: InputMaybe<Scalars['Boolean']>;
  isPostTip?: InputMaybe<Scalars['Boolean']>;
  oddTypeId?: InputMaybe<Scalars['String']>;
  odds?: InputMaybe<Scalars['Float']>;
  outcomeId?: InputMaybe<Scalars['ID']>;
  profit?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<TipResult>;
  sportId?: InputMaybe<Scalars['String']>;
  stake?: InputMaybe<Scalars['Float']>;
  /** Live stream URL (Watchers, YouTube Live, etc.) */
  streamUrl?: InputMaybe<Scalars['String']>;
  /** External video URL (YouTube) */
  videoUrl?: InputMaybe<Scalars['String']>;
  vip?: InputMaybe<Scalars['Boolean']>;
};

export type TipWithOutcomeName = {
  __typename?: 'TipWithOutcomeName';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventId?: Maybe<Scalars['ID']>;
  outcomeId?: Maybe<Scalars['ID']>;
  outcomeName?: Maybe<Scalars['String']>;
  result?: Maybe<TipResult>;
  tipId: Scalars['ID'];
};

export type TipsFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['String']>;
  oddTypeId?: InputMaybe<Scalars['String']>;
  sportIds?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type TipsSportDistribution = {
  __typename?: 'TipsSportDistribution';
  sports: Array<SportDistribution>;
  totalCount: Scalars['Int'];
};

export type TipsterChannel = {
  __typename?: 'TipsterChannel';
  channelName: Scalars['String'];
  id: Scalars['ID'];
};

export type TipsterFollowersCountFIlter = {
  channelId?: InputMaybe<Scalars['ID']>;
};

export type TipsterGrantNode = {
  __typename?: 'TipsterGrantNode';
  channelId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  planCurrencyCode?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planPrice?: Maybe<Scalars['Float']>;
  scope: Scalars['String'];
  startedAt: Scalars['DateTime'];
  status: Scalars['String'];
  userId: Scalars['String'];
};

export type TipsterInviteeModel = {
  __typename?: 'TipsterInviteeModel';
  id: Scalars['ID'];
  instagramFollowers?: Maybe<Scalars['String']>;
  instagramName?: Maybe<Scalars['String']>;
  instagramURL?: Maybe<Scalars['String']>;
  telegramURL?: Maybe<Scalars['String']>;
  tipsterId?: Maybe<Scalars['ID']>;
  tipsterInviteLink?: Maybe<Scalars['String']>;
};

/** Tipster profile data */
export type TipsterProfile = {
  __typename?: 'TipsterProfile';
  avarageMonthFreeTips?: Maybe<Scalars['Float']>;
  avarageMonthVipTips?: Maybe<Scalars['Float']>;
  followers: Scalars['Float'];
  isFollowing: Scalars['Boolean'];
  subscribers: Scalars['Float'];
  totalTips: Scalars['Float'];
  user: UserModel;
  winRate?: Maybe<Scalars['Float']>;
};

/** Tipster profile statistics for header display */
export type TipsterProfileStats = {
  __typename?: 'TipsterProfileStats';
  /** Average free tips per month */
  avgFreeTipsPerMonth: Scalars['Float'];
  /** Average VIP tips per month */
  avgVipTipsPerMonth: Scalars['Float'];
  /** Total number of tips */
  totalTips: Scalars['Float'];
  /** Win rate percentage */
  winRate: Scalars['Float'];
};

/** Tipster stat images */
export type TipsterStatImageModel = {
  __typename?: 'TipsterStatImageModel';
  id: Scalars['String'];
  image: Scalars['String'];
  tipsterId: Scalars['String'];
};

/** Tipster statistic */
export type TipsterStatistics = {
  __typename?: 'TipsterStatistics';
  /** average free tips per month */
  avgFreeTipsPerMonth: Scalars['Float'];
  avgOdds: Scalars['Float'];
  avgStake: Scalars['Float'];
  /** average tips per month */
  avgTipsPerMonth: Scalars['Float'];
  /** average VIP tips per month */
  avgVipTipsPerMonth: Scalars['Float'];
  lost: Scalars['Float'];
  pending: Scalars['Float'];
  /** avg profit */
  profit: Scalars['Float'];
  roi: Scalars['Float'];
  totalTips: Scalars['Float'];
  void: Scalars['Float'];
  winRate: Scalars['Float'];
  won: Scalars['Float'];
};

/** Status of the tipster */
export enum TipsterStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type TotalChannelUsers = {
  __typename?: 'TotalChannelUsers';
  date: Scalars['String'];
  totalUsers: Scalars['Int'];
};

export type Tournament = {
  __typename?: 'Tournament';
  category?: Maybe<Category>;
  categoryId: Scalars['ID'];
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  scope?: Maybe<TournamentScope>;
};

export type TournamentList = {
  __typename?: 'TournamentList';
  all: Array<Tournament>;
  popular: Array<Tournament>;
  userFav: Array<Tournament>;
};

export type TournamentModel = {
  __typename?: 'TournamentModel';
  categoryId: Scalars['ID'];
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** The scope of the tournament */
export enum TournamentScope {
  Favorite = 'FAVORITE',
  Popular = 'POPULAR',
  Regular = 'REGULAR'
}

export type Tournaments = {
  __typename?: 'Tournaments';
  totalCount: Scalars['Float'];
  tournaments: Array<Tournament>;
};

export type TrialMetrics = {
  __typename?: 'TrialMetrics';
  percentageTrialUsedAndPaid: Scalars['Float'];
  trialUsedCount: Scalars['Int'];
};

export enum TypeEnum {
  Announcement = 'Announcement',
  BestOf = 'Best_Of',
  News = 'News',
  Post = 'Post',
  PostTip = 'Post_Tip',
  Promo = 'Promo',
  SinglePostTip = 'Single_PostTip'
}

export type UpdateResult = {
  __typename?: 'UpdateResult';
  updated: Scalars['Boolean'];
};

/** Input for updating a Watchers room status for a tip */
export type UpdateTipRoomInput = {
  /** Cover image URL for the stream room */
  coverImageUrl?: InputMaybe<Scalars['String']>;
  /** Planned stream end time in UTC (ISO 8601) */
  endTime?: InputMaybe<Scalars['String']>;
  /** Updated room name */
  name?: InputMaybe<Scalars['String']>;
  /** Planned stream start time in UTC (ISO 8601) */
  startTime?: InputMaybe<Scalars['String']>;
  /** New room status (e.g. LIVE, ENDED) */
  status?: InputMaybe<Scalars['String']>;
  /** Updated stream URL for the room */
  streamUrl?: InputMaybe<Scalars['String']>;
  /** The tip ID whose room to update */
  tipId: Scalars['ID'];
};

export type Updated = {
  __typename?: 'Updated';
  updated: Scalars['Boolean'];
};

export type UpsertTenantBookieInput = {
  affiliateLink?: InputMaybe<Scalars['String']>;
  allowedCountryIds?: InputMaybe<Array<Scalars['ID']>>;
  bonusLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  logoUrlOverride?: InputMaybe<Scalars['String']>;
  rewardDescription?: InputMaybe<Scalars['String']>;
  rewardTypeId?: InputMaybe<Scalars['ID']>;
};

/** user */
export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

/** User favourite Bookies parameters */
export type UserBookies = {
  __typename?: 'UserBookies';
  bookieId: Scalars['Float'];
  userId: Scalars['String'];
};

/** User favourite Competitions parameters */
export type UserCompetitions = {
  __typename?: 'UserCompetitions';
  competitionId: Scalars['Float'];
  userId: Scalars['String'];
};

/** User subscribing to contents */
export type UserContentSubCreate = {
  contentId: Scalars['ID'];
  contentType: Content_Type_Enum;
  paid?: Scalars['Boolean'];
  userId: Scalars['ID'];
};

/** User subscribed contents */
export type UserContentSubscription = {
  __typename?: 'UserContentSubscription';
  contentId: Scalars['ID'];
  contentType: Content_Type_Enum;
  id: Scalars['ID'];
  paid: Scalars['Boolean'];
  userId: Scalars['ID'];
};

/** user input parameters for creating a new User or Admin or Tipster */
export type UserCreate = {
  affiliateId?: InputMaybe<Scalars['String']>;
  alternativeAvatarUrl?: InputMaybe<Scalars['String']>;
  alternativeName?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  dateOfBirth: Scalars['DateTime'];
  displayName: Scalars['String'];
  emailAddress?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<UserGender>;
  lastName?: InputMaybe<Scalars['String']>;
  minTipsNumber?: InputMaybe<Scalars['Float']>;
  oddsFormat?: InputMaybe<OddsFormat>;
  onboardingProgress?: InputMaybe<OnboardingProgressInput>;
  onboardingStage?: InputMaybe<UserOnboardingStages>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pool?: UserPool;
  posthogSessionId?: InputMaybe<Scalars['String']>;
  role: UserRoles;
  signupMethod?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<UserSource>;
  suggestedBank?: InputMaybe<Scalars['Float']>;
  tipsterStatus?: InputMaybe<TipsterStatus>;
  unitShare?: InputMaybe<Scalars['Float']>;
  unitValue?: InputMaybe<Scalars['Float']>;
  userStatus?: InputMaybe<UserStatus>;
};

export type UserFilter = {
  channelIds?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Array<Scalars['ID']>>;
  createdAt?: InputMaybe<BetweenDates>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  followedTipster?: InputMaybe<Scalars['Float']>;
  freeTrial?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<UserGender>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRoles>;
  searchQuery?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  subscriptionStatus?: InputMaybe<Scalars['String']>;
  subscriptionToTipster?: InputMaybe<Scalars['String']>;
  tipsterStatus?: InputMaybe<TipsterStatus>;
  userStatus?: InputMaybe<UserStatus>;
};

/** Gender of the user */
export enum UserGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

/** User leaderboard entry */
export type UserLeaderboardEntry = {
  __typename?: 'UserLeaderboardEntry';
  /** User avatar url */
  avatarUrl?: Maybe<Scalars['String']>;
  /** User first name */
  displayName?: Maybe<Scalars['String']>;
  /** Whether this entry represents top 10 ranking or user position */
  resultType: EntryType;
  /** Total profit amount */
  totalProfit: Scalars['Float'];
  /** User ID */
  userId: Scalars['Int'];
  /** User rank position */
  userRank: Scalars['Int'];
};

/** User favourite Markets parameters */
export type UserMarkets = {
  __typename?: 'UserMarkets';
  marketId: Scalars['Float'];
  userId: Scalars['String'];
};

export type UserModel = {
  __typename?: 'UserModel';
  affiliateId?: Maybe<Scalars['String']>;
  alternativeAvatarUrl?: Maybe<Scalars['String']>;
  alternativeName?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  bookies?: Maybe<Array<UserBookies>>;
  /** Returns whether current user can edit permissions for subject user. (For now implemented only for Tipsters) */
  canEditPermissions: Scalars['Boolean'];
  channelsWhereUserIsTipster?: Maybe<Array<UsersChannelModel>>;
  competitions?: Maybe<Array<UserCompetitions>>;
  country?: Maybe<CountryModel>;
  countryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  dateOfBirth: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  emailAddress?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  favoriteTenantBookieId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  followedChannels?: Maybe<Array<UsersChannelModel>>;
  gender?: Maybe<UserGender>;
  id: Scalars['ID'];
  isTipsterAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<UserMarkets>>;
  minTipsNumber?: Maybe<Scalars['Float']>;
  oddsFormat?: Maybe<OddsFormat>;
  onboardingProgress?: Maybe<OnboardingProgress>;
  onboardingStage?: Maybe<UserOnboardingStages>;
  permissions: Array<UserPermission>;
  phoneNumber?: Maybe<Scalars['String']>;
  pool?: Maybe<UserPool>;
  role: UserRoles;
  source?: Maybe<UserSource>;
  sports?: Maybe<Array<UserSports>>;
  subscriptionDate?: Maybe<Scalars['DateTime']>;
  subscriptionToContents?: Maybe<Array<UserContentSubscription>>;
  subscriptionToTipster?: Maybe<Scalars['String']>;
  suggestedBank?: Maybe<Scalars['Float']>;
  tipsterStatus?: Maybe<TipsterStatus>;
  tipsters?: Maybe<Array<Scalars['String']>>;
  unitShare?: Maybe<Scalars['Float']>;
  unitValue?: Maybe<Scalars['Float']>;
  userStatus?: Maybe<UserStatus>;
};

/** Track last completed onboarding step */
export enum UserOnboardingStages {
  ChoosingFavoriteBookies = 'CHOOSING_FAVORITE_BOOKIES',
  ChoosingFavoriteLeagues = 'CHOOSING_FAVORITE_LEAGUES',
  ChoosingFavoriteMarkets = 'CHOOSING_FAVORITE_MARKETS',
  ChoosingFavoriteSports = 'CHOOSING_FAVORITE_SPORTS',
  CreatingAccount = 'CREATING_ACCOUNT',
  CreatingChannel = 'CREATING_CHANNEL',
  CreatingService = 'CREATING_SERVICE',
  CreatingSubscription = 'CREATING_SUBSCRIPTION',
  Onboarded = 'ONBOARDED',
  UpdatingPersonalInfo = 'UPDATING_PERSONAL_INFO',
  UpdatingPersonalProfile = 'UPDATING_PERSONAL_PROFILE'
}

/** User (tipster) permissions */
export enum UserPermission {
  AddPost = 'ADD_POST',
  AddPromo = 'ADD_PROMO',
  AddSubs = 'ADD_SUBS',
  ChangeUserStatus = 'CHANGE_USER_STATUS',
  CreateInvite = 'CREATE_INVITE',
  CreateTipster = 'CREATE_TIPSTER',
  EditPost = 'EDIT_POST',
  EditSubs = 'EDIT_SUBS',
  EditTipster = 'EDIT_TIPSTER',
  LimitInvites = 'LIMIT_INVITES',
  TipsterMessaging = 'TIPSTER_MESSAGING'
}

export enum UserPool {
  Cognito = 'COGNITO',
  MagicLink = 'MAGIC_LINK',
  Telegram = 'TELEGRAM'
}

/** Roles of the user */
export enum UserRoles {
  Admin = 'ADMIN',
  Agent = 'AGENT',
  Guest = 'GUEST',
  Tipster = 'TIPSTER',
  User = 'USER'
}

export type UserSort = {
  country?: InputMaybe<SortMethod>;
  createdAt?: InputMaybe<SortMethod>;
  dateOfBirth?: InputMaybe<SortMethod>;
  displayName?: InputMaybe<SortMethod>;
  emailAddress?: InputMaybe<SortMethod>;
  firstName?: InputMaybe<SortMethod>;
  gender?: InputMaybe<SortMethod>;
  id?: InputMaybe<SortMethod>;
  lastName?: InputMaybe<SortMethod>;
  phoneNumber?: InputMaybe<SortMethod>;
  tipsterStatus?: InputMaybe<SortMethod>;
  userStatus?: InputMaybe<SortMethod>;
};

export enum UserSource {
  Affiliate = 'AFFILIATE',
  Direct = 'DIRECT',
  Invite = 'INVITE',
  Other = 'OTHER'
}

/** User Sports parameters */
export type UserSports = {
  __typename?: 'UserSports';
  sportId: Scalars['Float'];
  userId?: Maybe<Scalars['String']>;
};

/** User statistic */
export type UserStatistics = {
  __typename?: 'UserStatistics';
  avgMonthVotes: Scalars['Float'];
  avgOdds: Scalars['Float'];
  avgStake: Scalars['Float'];
  lost: Scalars['Float'];
  pending: Scalars['Float'];
  /** avg profit */
  profit: Scalars['Float'];
  roi: Scalars['Float'];
  totalVotes: Scalars['Float'];
  void: Scalars['Float'];
  winRate: Scalars['Float'];
  won: Scalars['Float'];
};

/** Status of the user */
export enum UserStatus {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  Muted = 'MUTED'
}

export type UserTokenIdentity = {
  __typename?: 'UserTokenIdentity';
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  pool?: Maybe<Scalars['String']>;
};

/** user input parameters for updating an existing User */
export type UserUpdate = {
  affiliateId?: InputMaybe<Scalars['String']>;
  alternativeAvatarUrl?: InputMaybe<Scalars['String']>;
  alternativeName?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<UserGender>;
  lastName?: InputMaybe<Scalars['String']>;
  minTipsNumber?: InputMaybe<Scalars['Float']>;
  oddsFormat?: InputMaybe<OddsFormat>;
  onboardingProgress?: InputMaybe<OnboardingProgressInput>;
  onboardingStage?: InputMaybe<UserOnboardingStages>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  posthogSessionId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRoles>;
  signupMethod?: InputMaybe<Scalars['String']>;
  suggestedBank?: InputMaybe<Scalars['Float']>;
  tipsterStatus?: InputMaybe<TipsterStatus>;
  unitShare?: InputMaybe<Scalars['Float']>;
  unitValue?: InputMaybe<Scalars['Float']>;
  userStatus?: InputMaybe<UserStatus>;
};

export type UsersChannelModel = {
  __typename?: 'UsersChannelModel';
  channelName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  settings?: Maybe<Array<UsersChannelSetting>>;
};

export type UsersChannelSetting = {
  __typename?: 'UsersChannelSetting';
  category?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type VipInviteNode = {
  __typename?: 'VipInviteNode';
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isValid: Scalars['Boolean'];
  maxUses: Scalars['Int'];
  planId: Scalars['String'];
  redeemedByUserId?: Maybe<Scalars['String']>;
  shareUrl: Scalars['String'];
  tenantId: Scalars['String'];
  tipsterId: Scalars['String'];
  token: Scalars['String'];
  usedCount: Scalars['Int'];
};

export type VipInviteRedeemResult = {
  __typename?: 'VipInviteRedeemResult';
  grant: AccessGrantNode;
  invite: VipInviteNode;
};

/** vote */
export type Vote = {
  __typename?: 'Vote';
  downvoteCount: Scalars['Float'];
  downvoted?: Maybe<Scalars['Boolean']>;
  upvoteCount: Scalars['Float'];
  upvoted?: Maybe<Scalars['Boolean']>;
};

export type VoterRanking = {
  __typename?: 'VoterRanking';
  competition: ContentCompetitions;
  users: Array<VoterUser>;
};

export type VoterUser = {
  __typename?: 'VoterUser';
  avatarUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  losses: Scalars['String'];
  ranking: Scalars['String'];
  userId: Scalars['ID'];
  userName: Scalars['String'];
  wins: Scalars['String'];
};

/** votes */
export type Votes = {
  __typename?: 'Votes';
  id: Scalars['Float'];
  selectedOptionId: Scalars['Float'];
  userId: Scalars['ID'];
};

/** waitlist attributes */
export type Waitlist = {
  __typename?: 'Waitlist';
  continent: WaitlistContinentsEnum;
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
};

export enum WaitlistContinentsEnum {
  Africa = 'Africa',
  Asia = 'Asia',
  Europe = 'Europe',
  NorthAmerica = 'NorthAmerica',
  Oceania = 'Oceania',
  SouthAmerica = 'SouthAmerica'
}

export enum AffilateLinkStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export enum ChannelCategory {
  BestWinrate = 'BEST_WINRATE',
  Featured = 'FEATURED',
  Hot = 'HOT',
  MostProfit = 'MOST_PROFIT',
  New = 'NEW',
  TopFootball = 'TOP_FOOTBALL',
  TopTennis = 'TOP_TENNIS',
  Trend = 'TREND'
}

export enum ChannelRole {
  Admin = 'ADMIN',
  Agent = 'AGENT',
  Tipster = 'TIPSTER',
  User = 'USER'
}

export enum ChannelSettingsCategory {
  Channel = 'CHANNEL'
}

export enum ChannelSettingsName {
  AllowedPaymentType = 'ALLOWED_PAYMENT_TYPE',
  ChannelDefaultFollowers = 'CHANNEL_DEFAULT_FOLLOWERS',
  ChannelFollowersDailyLimit = 'CHANNEL_FOLLOWERS_DAILY_LIMIT',
  ChannelMaxFollowers = 'CHANNEL_MAX_FOLLOWERS',
  VoteBotLimit = 'VOTE_BOT_LIMIT',
  VoteMultiplierBotTrigger = 'VOTE_MULTIPLIER_BOT_TRIGGER'
}

export enum ChannelSettingsScope {
  Global = 'GLOBAL',
  VipTip = 'VIP_TIP'
}

export enum ChannelStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ChannelType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ContentCompetitionStatusFilter {
  Active = 'ACTIVE',
  Finished = 'FINISHED',
  Starting = 'STARTING'
}

/** Content type */
export enum Content_Type_Enum {
  Event = 'EVENT',
  Multitip = 'MULTITIP',
  Poll = 'POLL',
  Post = 'POST',
  Tip = 'TIP'
}

/** Continents */
export enum ContinentsEnum {
  Africa = 'Africa',
  Asia = 'Asia',
  Europe = 'Europe',
  NorthAmerica = 'NorthAmerica',
  Oceania = 'Oceania',
  SouthAmerica = 'SouthAmerica'
}

export enum PaymentOptions {
  CreditCard = 'CREDIT_CARD',
  EWallet = 'E_WALLET',
  Stripe = 'STRIPE'
}

export enum Payments {
  Manual = 'MANUAL',
  Skrill = 'SKRILL',
  Stripe = 'STRIPE'
}

export enum ServiceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Onhold = 'ONHOLD',
  Private = 'PRIVATE'
}

export enum SubsType {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  FreeTrialNoCc = 'FREE_TRIAL_NO_CC',
  FreeTrialWithCc = 'FREE_TRIAL_WITH_CC'
}

/** result/status of the tip */
export enum TipResult {
  HalfLost = 'HALF_LOST',
  HalfWon = 'HALF_WON',
  Lost = 'LOST',
  Push = 'PUSH',
  Void = 'VOID',
  Won = 'WON'
}

export enum TipsTypes {
  Multitip = 'MULTITIP',
  Tip = 'TIP'
}

export enum TypesOfContent {
  Multitip = 'MULTITIP',
  Poll = 'POLL',
  Post = 'POST',
  PostTip = 'PostTip',
  Tip = 'TIP'
}

export enum TypesOfNotifications {
  AppUpdate = 'APP_UPDATE',
  CompetitionEnded = 'COMPETITION_ENDED',
  CompetitionRanking = 'COMPETITION_RANKING',
  CompetitionStarted = 'COMPETITION_STARTED',
  EventResult = 'EVENT_RESULT',
  FreeTrialActivated = 'FREE_TRIAL_ACTIVATED',
  FreeTrialExpired = 'FREE_TRIAL_EXPIRED',
  FreeTrialExpiring = 'FREE_TRIAL_EXPIRING',
  MessageAdded = 'MESSAGE_ADDED',
  MultiposttipResult = 'MULTIPOSTTIP_RESULT',
  MultitipResult = 'MULTITIP_RESULT',
  NewFreeMultiposttip = 'NEW_FREE_MULTIPOSTTIP',
  NewFreeMultitip = 'NEW_FREE_MULTITIP',
  NewFreePosttip = 'NEW_FREE_POSTTIP',
  NewFreeTip = 'NEW_FREE_TIP',
  NewManualSubscriber = 'NEW_MANUAL_SUBSCRIBER',
  NewPost = 'NEW_POST',
  NewVipMultiposttip = 'NEW_VIP_MULTIPOSTTIP',
  NewVipMultitip = 'NEW_VIP_MULTITIP',
  NewVipPosttip = 'NEW_VIP_POSTTIP',
  NewVipTip = 'NEW_VIP_TIP',
  PinnedContent = 'PINNED_CONTENT',
  Poll = 'POLL',
  PollResult = 'POLL_RESULT',
  PosttipResult = 'POSTTIP_RESULT',
  ReferralJoined = 'REFERRAL_JOINED',
  ServiceExpired = 'SERVICE_EXPIRED',
  ServiceExpiring = 'SERVICE_EXPIRING',
  SubscriptionActivated = 'SUBSCRIPTION_ACTIVATED',
  TipResult = 'TIP_RESULT',
  UserBanned = 'USER_BANNED',
  UserComment = 'USER_COMMENT',
  UserMuted = 'USER_MUTED',
  UserReply = 'USER_REPLY',
  UserWarning = 'USER_WARNING'
}

export type TipDetailedFieldsFragment = { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null };

export type PostDetailedFieldsFragment = { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null };

export type PollDetailedFieldsFragment = { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null };

export type MultitipDetailedFieldsFragment = { __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null };

export type ChannelDetailedFieldsFragment = { __typename?: 'ChannelDetailed', anonymized: boolean, background?: string | null, channelDeal: number, channelName: string, channelStatus: ChannelStatus, channelType: ChannelType, countryId?: string | null, createdAt: any, deletedAt?: any | null, feeForPayment: number, id: string, inviteLink?: string | null, logo?: string | null, paymentOptions?: PaymentOptions | null, pinnedContentId?: number | null, pinnedContentType?: string | null, tipsterCount?: number | null, trialSubscription: number, updatedAt?: any | null, usersCount?: number | null, usersLimit: number, isUserFollowing: boolean, settings?: Array<{ __typename?: 'ChannelSetting', name: ChannelSettingsName, value: string, category: ChannelSettingsCategory, id: string, scope: ChannelSettingsScope }> | null, channelUsers: Array<{ __typename?: 'ChannelUserModel', channelId: string, channelRole: ChannelRole, createdAt: any, id: string, userId: string }>, pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null };

export type PinnedContentFieldsFragment = { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string };

export type GrantExtendMutationVariables = Exact<{
  grantId: Scalars['String'];
  additionalDays: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type GrantExtendMutation = { __typename?: 'Mutation', grantExtend: { __typename?: 'AccessGrantNode', id: string, status: string, expiration?: any | null, updatedAt: any } };

export type GrantActivateMutationVariables = Exact<{
  grantId: Scalars['String'];
}>;


export type GrantActivateMutation = { __typename?: 'Mutation', grantActivate: { __typename?: 'AccessGrantNode', id: string, status: string, expiration?: any | null, updatedAt: any } };

export type GrantRevokeMutationVariables = Exact<{
  grantId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type GrantRevokeMutation = { __typename?: 'Mutation', grantRevoke: { __typename?: 'AccessGrantNode', id: string, status: string, revokedBy?: string | null, revokedReason?: string | null, updatedAt: any } };

export type VipInviteCreateMutationVariables = Exact<{
  planId: Scalars['String'];
}>;


export type VipInviteCreateMutation = { __typename?: 'Mutation', vipInviteCreate: { __typename?: 'VipInviteNode', id: string, token: string, shareUrl: string, expiresAt?: any | null, isValid: boolean, usedCount: number } };

export type VipInviteRevokeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type VipInviteRevokeMutation = { __typename?: 'Mutation', vipInviteRevoke: { __typename?: 'VipInviteNode', id: string, isValid: boolean } };

export type VipInviteRedeemMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VipInviteRedeemMutation = { __typename?: 'Mutation', vipInviteRedeem: { __typename?: 'VipInviteRedeemResult', invite: { __typename?: 'VipInviteNode', id: string, isValid: boolean, usedCount: number }, grant: { __typename?: 'AccessGrantNode', id: string, status: string, startedAt: any, expiration?: any | null } } };

export type CreateAdvertMutationVariables = Exact<{
  input: AdsCreationInput;
}>;


export type CreateAdvertMutation = { __typename?: 'Mutation', adsCreate: { __typename?: 'Ads', id: string } };

export type UpdateAdvertMutationVariables = Exact<{
  id: Scalars['ID'];
  input: AdsUpdate;
}>;


export type UpdateAdvertMutation = { __typename?: 'Mutation', adsUpdate: { __typename?: 'Ads', id: string } };

export type DeleteAdvertMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdvertMutation = { __typename?: 'Mutation', adsDelete: string };

export type UploadAdvertImageMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadAdvertImageMutation = { __typename?: 'Mutation', adsImageUpload: string };

export type CreateBonusMutationVariables = Exact<{
  input: BonusCreate;
}>;


export type CreateBonusMutation = { __typename?: 'Mutation', bonusCreate: { __typename?: 'BonusModel', id: string } };

export type UpdateBonusMutationVariables = Exact<{
  id: Scalars['String'];
  input: BonusUpdate;
}>;


export type UpdateBonusMutation = { __typename?: 'Mutation', bonusUpdate: { __typename?: 'Result', result: boolean } };

export type DeleteBonusMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBonusMutation = { __typename?: 'Mutation', bonusDelete: { __typename?: 'Result', result: boolean } };

export type ReorderBonusesMutationVariables = Exact<{
  orderedIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ReorderBonusesMutation = { __typename?: 'Mutation', bonusReorder: { __typename?: 'Result', result: boolean } };

export type UpsertTenantBookieMutationVariables = Exact<{
  input: UpsertTenantBookieInput;
}>;


export type UpsertTenantBookieMutation = { __typename?: 'Mutation', upsertTenantBookie: { __typename?: 'TenantBookie', id?: string | null, bookieId?: number | null, externalId?: number | null, customName?: string | null, name: string, title: string, imageUrl?: string | null, bonusLink?: string | null, affiliateLink?: string | null, buttonText?: string | null, rewardDescription?: string | null, isVisible: boolean, isDefault: boolean, isMandatory: boolean, sortOrder: number, allowedCountryIds: Array<string>, rewardType?: { __typename?: 'RewardType', id: string, name: string, iconName?: string | null } | null } };

export type DeleteTenantBookieMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTenantBookieMutation = { __typename?: 'Mutation', deleteTenantBookie: { __typename?: 'Result', result: boolean } };

export type SetDefaultTenantBookieMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetDefaultTenantBookieMutation = { __typename?: 'Mutation', setDefaultTenantBookie: { __typename?: 'Result', result: boolean } };

export type ReorderTenantBookiesMutationVariables = Exact<{
  items: Array<TenantBookieOrderItem> | TenantBookieOrderItem;
}>;


export type ReorderTenantBookiesMutation = { __typename?: 'Mutation', reorderTenantBookies: { __typename?: 'Result', result: boolean } };

export type SetFavoriteBookieMutationVariables = Exact<{
  tenantBookieId: Scalars['ID'];
}>;


export type SetFavoriteBookieMutation = { __typename?: 'Mutation', setFavoriteBookie: { __typename?: 'FavoriteBookie', id: string, tenantBookieId: string } };

export type FollowChannelMutationVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type FollowChannelMutation = { __typename?: 'Mutation', followChannel: { __typename?: 'Result', result: boolean } };

export type UnfollowChannelMutationVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type UnfollowChannelMutation = { __typename?: 'Mutation', unfollowChannel: { __typename?: 'Result', result: boolean } };

export type PinContentMutationVariables = Exact<{
  channelId: Scalars['String'];
  contentId: Scalars['String'];
  contentType: TypesOfContent;
}>;


export type PinContentMutation = { __typename?: 'Mutation', pinContent: { __typename?: 'UpdateResult', updated: boolean } };

export type UnpinContentMutationVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type UnpinContentMutation = { __typename?: 'Mutation', unpinContent: { __typename?: 'UpdateResult', updated: boolean } };

export type ChannelUpdateMutationVariables = Exact<{
  channelId: Scalars['String'];
  input: ChannelUpdate;
}>;


export type ChannelUpdateMutation = { __typename?: 'Mutation', channelUpdate: { __typename?: 'UpdateResult', updated: boolean } };

export type FollowChannelByInviteLinkMutationVariables = Exact<{
  inviteLink: Scalars['String'];
}>;


export type FollowChannelByInviteLinkMutation = { __typename?: 'Mutation', followChannelByInviteLink: { __typename?: 'Result', result: boolean } };

export type CreateChannelMutationVariables = Exact<{
  input: ChannelCreate;
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', channelCreate: { __typename?: 'ChannelModel', id: string } };

export type AssignTipsterChannelMutationVariables = Exact<{
  channelId: Scalars['String'];
  tipsterId: Scalars['String'];
}>;


export type AssignTipsterChannelMutation = { __typename?: 'Mutation', addTipsterToChannel: { __typename?: 'Result', result: boolean } };

export type RemoveTipsterFromChannelMutationVariables = Exact<{
  channelId: Scalars['String'];
  tipsterId: Scalars['String'];
}>;


export type RemoveTipsterFromChannelMutation = { __typename?: 'Mutation', deleteTipsterFromChannel: { __typename?: 'Result', result: boolean } };

export type ChatAcceptMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type ChatAcceptMutation = { __typename?: 'Mutation', chatAccept: { __typename?: 'Chat', accepted: boolean, createdAt: any, email?: string | null, id: string, receiverId: string, senderId: string, subject?: string | null } };

export type ChatCreateMutationVariables = Exact<{
  input: ChatCreate;
}>;


export type ChatCreateMutation = { __typename?: 'Mutation', chatCreate: { __typename?: 'Chat', accepted: boolean, createdAt: any, email?: string | null, id: string, receiverId: string, senderId: string, subject?: string | null } };

export type ChatReadMessagesMutationVariables = Exact<{
  chatId: Scalars['ID'];
}>;


export type ChatReadMessagesMutation = { __typename?: 'Mutation', chatReadMessages: { __typename?: 'Chat', id: string } };

export type MessageCreateMutationVariables = Exact<{
  input: MessageCreate;
}>;


export type MessageCreateMutation = { __typename?: 'Mutation', messageCreate: { __typename?: 'Message', chatId?: string | null, createdAt: any, id: string, imageUrl?: string | null, senderId: string, text: string } };

export type CreateSupportChatMutationVariables = Exact<{
  input: SupportChatCreate;
}>;


export type CreateSupportChatMutation = { __typename?: 'Mutation', supportChatCreate: { __typename?: 'Chat', id: string } };

export type ReadManyMessagesMutationVariables = Exact<{
  chatId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReadManyMessagesMutation = { __typename?: 'Mutation', chatReadManyMessages: boolean };

export type CommentCreateMutationVariables = Exact<{
  input: CommentCreateInput;
}>;


export type CommentCreateMutation = { __typename?: 'Mutation', commentCreate: { __typename?: 'CommentModel', contentId: string, contentType: TypesOfContent, createdAt: any, deletedAt?: any | null, id: string, text: string, updatedAt: any, userId: string, imageLink?: string | null } };

export type CommentUpdateMutationVariables = Exact<{
  commentUpdateId: Scalars['ID'];
  input: CommentUpdateInput;
}>;


export type CommentUpdateMutation = { __typename?: 'Mutation', commentUpdate: { __typename?: 'CommentModel', contentId: string, contentType: TypesOfContent, createdAt: any, deletedAt?: any | null, id: string, text: string, updatedAt: any, userId: string, imageLink?: string | null } };

export type CommentDeleteMutationVariables = Exact<{
  commentDeleteId: Scalars['ID'];
}>;


export type CommentDeleteMutation = { __typename?: 'Mutation', commentDelete: string };

export type CompetitionVoteMutationVariables = Exact<{
  competitionId: Scalars['ID'];
  outcomeId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type CompetitionVoteMutation = { __typename?: 'Mutation', competitionVote: { __typename?: 'ContentCompetitionEvent', id: string } };

export type CreateCompetitionMutationVariables = Exact<{
  competition: CompetitionCreate;
}>;


export type CreateCompetitionMutation = { __typename?: 'Mutation', createCompetition: { __typename?: 'ContentCompetitionEvent', id: string, competitionType: CompetitionType, rankingMetric?: string | null, minimumSettledTips?: number | null, rankingSportIds?: Array<string> | null, termsAndconditions?: string | null, termsAndconditionsLink?: string | null, vip?: boolean | null, blocked?: boolean | null, name?: string | null, description?: string | null, maxParticipants: number, startAt: any, endAt: any, cta?: string | null, status: ContentCompetitionStatusFilter, rewards?: Array<{ __typename?: 'RewardItem', title: string, position: string }> | null } };

export type DeleteCompetitionMutationVariables = Exact<{
  competitionId: Scalars['ID'];
}>;


export type DeleteCompetitionMutation = { __typename?: 'Mutation', deleteCompetition: boolean };

export type EditCompetitionMutationVariables = Exact<{
  competitionId: Scalars['ID'];
  update: CompetitionUpdate;
}>;


export type EditCompetitionMutation = { __typename?: 'Mutation', editCompetition: { __typename?: 'ContentCompetitionEvent', id: string, competitionType: CompetitionType, rankingMetric?: string | null, minimumSettledTips?: number | null, rankingSportIds?: Array<string> | null, name?: string | null, description?: string | null, imageUrl?: string | null, maxParticipants: number, startAt: any, endAt: any, cta?: string | null, vip?: boolean | null, termsAndconditions?: string | null, termsAndconditionsLink?: string | null, eligibleCountries?: Array<string> | null, rewards?: Array<{ __typename?: 'RewardItem', id: string, title: string, description?: string | null, reward?: string | null }> | null } };

export type VoteOutcomeMutationVariables = Exact<{
  eventOutcomeId: Scalars['ID'];
}>;


export type VoteOutcomeMutation = { __typename?: 'Mutation', vote: string };

export type PollCreateMutationVariables = Exact<{
  input: PollCreate;
  channelIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PollCreateMutation = { __typename?: 'Mutation', pollCreate: { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } };

export type PollVoteMutationVariables = Exact<{
  pollId: Scalars['ID'];
  selectedOptionId: Scalars['ID'];
}>;


export type PollVoteMutation = { __typename?: 'Mutation', pollVote: { __typename?: 'PollModel', votes?: { __typename?: 'Votes', id: number, selectedOptionId: number, userId: string } | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, option: string, id: number, pollId: number, position: number, updatedAt: any }> } };

export type PollDeleteMutationVariables = Exact<{
  channelId: Scalars['String'];
  pollDeleteId: Scalars['ID'];
}>;


export type PollDeleteMutation = { __typename?: 'Mutation', pollDelete: string };

export type PollUpdateMutationVariables = Exact<{
  pollUpdateId: Scalars['ID'];
  input: PollUpdate;
}>;


export type PollUpdateMutation = { __typename?: 'Mutation', pollUpdate: { __typename?: 'PollModel', category: PollCategory, createdAt: any, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, upvoted?: number | null, userId: string, downvoted?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }> } };

export type PostCreateMutationVariables = Exact<{
  input: PostCreateInput;
  channelIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PostCreateMutation = { __typename?: 'Mutation', postCreate: { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } };

export type PostUpdateMutationVariables = Exact<{
  postUpdateId: Scalars['ID'];
  input: PostUpdateInput;
}>;


export type PostUpdateMutation = { __typename?: 'Mutation', postUpdate: { __typename?: 'Post', category?: CategoryEnum | null, content?: string | null, createdAt: any, deletedAt?: any | null, downvoted?: number | null, id: string, mediaLink?: string | null, title: string, type?: TypeEnum | null, updatedAt: any, upvoted?: number | null, userId: string } };

export type PostDeleteMutationVariables = Exact<{
  postDeleteId: Scalars['ID'];
  channelId: Scalars['String'];
}>;


export type PostDeleteMutation = { __typename?: 'Mutation', postDelete: string };

export type TipDeleteMutationVariables = Exact<{
  tipDeleteId: Scalars['ID'];
  channelId: Scalars['String'];
}>;


export type TipDeleteMutation = { __typename?: 'Mutation', tipDelete: string };

export type MultitipDeleteMutationVariables = Exact<{
  multitipDeleteId: Scalars['ID'];
  channelId: Scalars['String'];
}>;


export type MultitipDeleteMutation = { __typename?: 'Mutation', multitipDelete: string };

export type UpvoteMutationVariables = Exact<{
  id: Scalars['ID'];
  type: TypesOfContent;
  channelId: Scalars['String'];
  cursor?: InputMaybe<FeedCursorInput>;
}>;


export type UpvoteMutation = { __typename?: 'Mutation', upvote: { __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null } };

export type DownvoteMutationVariables = Exact<{
  id: Scalars['ID'];
  type: TypesOfContent;
  channelId: Scalars['String'];
  cursor?: InputMaybe<FeedCursorInput>;
}>;


export type DownvoteMutation = { __typename?: 'Mutation', downvote: { __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null } };

export type ImageUploadMutationVariables = Exact<{
  image: Scalars['Upload'];
}>;


export type ImageUploadMutation = { __typename?: 'Mutation', imageUpload: string };

export type AudioUploadMutationVariables = Exact<{
  audio: Scalars['Upload'];
}>;


export type AudioUploadMutation = { __typename?: 'Mutation', audioUpload: string };

export type VideoUploadMutationVariables = Exact<{
  video: Scalars['Upload'];
}>;


export type VideoUploadMutation = { __typename?: 'Mutation', videoUpload: string };

export type ImageDeleteMutationVariables = Exact<{
  imageUrl: Scalars['String'];
}>;


export type ImageDeleteMutation = { __typename?: 'Mutation', imageDelete: boolean };

export type CreateSingleTipMutationVariables = Exact<{
  input: TipCreate;
}>;


export type CreateSingleTipMutation = { __typename?: 'Mutation', tipCreate: { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null } };

export type CreateMultiTipMutationVariables = Exact<{
  input: MultitipCreate;
}>;


export type CreateMultiTipMutation = { __typename?: 'Mutation', multitipCreate: { __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } };

export type FollowTipsterMutationVariables = Exact<{
  tipsterId: Scalars['ID'];
}>;


export type FollowTipsterMutation = { __typename?: 'Mutation', userFollowTipster: { __typename?: 'UserModel', id: string } };

export type UnFollowTipsterMutationVariables = Exact<{
  tipsterId: Scalars['ID'];
}>;


export type UnFollowTipsterMutation = { __typename?: 'Mutation', userUnfollowFromTipster: { __typename?: 'UserModel', id: string } };

export type UpdateSingleTipMutationVariables = Exact<{
  id: Scalars['ID'];
  input: TipUpdate;
}>;


export type UpdateSingleTipMutation = { __typename?: 'Mutation', tipUpdate: { __typename?: 'Tip', id: string } };

export type UpdateMultiTipMutationVariables = Exact<{
  id: Scalars['ID'];
  input: MultitipUpdate;
}>;


export type UpdateMultiTipMutation = { __typename?: 'Mutation', multitipUpdate: { __typename?: 'Multitip', id: string } };

export type SaveTipMutationVariables = Exact<{
  contentId: Scalars['String'];
  contentType: TipsTypes;
  addedFromChannelId?: InputMaybe<Scalars['String']>;
  tipCreatedAt?: InputMaybe<Scalars['DateTime']>;
  tipSportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SaveTipMutation = { __typename?: 'Mutation', saveTip: { __typename?: 'Result', result: boolean } };

export type UnsaveTipMutationVariables = Exact<{
  contentId: Scalars['String'];
  contentType: TipsTypes;
}>;


export type UnsaveTipMutation = { __typename?: 'Mutation', unsaveTip: { __typename?: 'Result', result: boolean } };

export type CreateTipRoomMutationVariables = Exact<{
  input: CreateTipRoomInput;
}>;


export type CreateTipRoomMutation = { __typename?: 'Mutation', createTipRoom: boolean };

export type ParseBetslipMutationVariables = Exact<{
  imageBase64: Scalars['String'];
  mimeType: Scalars['String'];
}>;


export type ParseBetslipMutation = { __typename?: 'Mutation', parseBetslip: { __typename?: 'BetslipParseResult', bookmakerName?: string | null, totalOdds?: number | null, confidence: number, tips: Array<{ __typename?: 'BetslipTipItem', homeTeam?: string | null, awayTeam?: string | null, eventDate?: string | null, market?: string | null, odds?: number | null }> } };

export type UpdateTipRoomMutationVariables = Exact<{
  input: UpdateTipRoomInput;
}>;


export type UpdateTipRoomMutation = { __typename?: 'Mutation', updateTipRoom: boolean };

export type UploadImageMutationVariables = Exact<{
  image: Scalars['Upload'];
}>;


export type UploadImageMutation = { __typename?: 'Mutation', imageUpload: string };

export type JoinTipsterCompetitionMutationVariables = Exact<{
  competitionId: Scalars['ID'];
}>;


export type JoinTipsterCompetitionMutation = { __typename?: 'Mutation', joinTipsterCompetition: { __typename?: 'ContentCompetitionEvent', id: string, takenSlots?: string | null, remainingSlots?: string | null, isOpen: boolean } };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  scope: NotificationSettingScope;
  value: Scalars['Boolean'];
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', entityNotificationSettingsUpdate: { __typename?: 'EntityNotificationSetting', id: string } };

export type ReadNotificationMutationVariables = Exact<{
  readNotificationId: Scalars['ID'];
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', readNotification: { __typename?: 'Notification', createdAt: any, iconUrl?: string | null, id: string, info?: any | null, isNew: boolean, type: TypesOfNotifications, userId: string } };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID'];
}>;


export type DeleteNotificationMutation = { __typename?: 'Mutation', deleteNotification: boolean };

export type SendFirebaseTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type SendFirebaseTokenMutation = { __typename?: 'Mutation', addFCMToken: boolean };

export type DeleteFirebaseTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type DeleteFirebaseTokenMutation = { __typename?: 'Mutation', deleteFCMToken: boolean };

export type ReadNotificationsMutationVariables = Exact<{
  readNotificationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReadNotificationsMutation = { __typename?: 'Mutation', readNotifications: boolean };

export type MarkAllChannelMessageAsReadMutationVariables = Exact<{
  channelIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkAllChannelMessageAsReadMutation = { __typename?: 'Mutation', markAllChannelMessageAsRead: boolean };

export type CreateUserMutationVariables = Exact<{
  input: UserCreate;
  inviteToken?: InputMaybe<Scalars['String']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'UserModel', dateOfBirth: any, displayName: string, emailAddress?: string | null, firstName?: string | null, gender?: UserGender | null, id: string, lastName?: string | null, phoneNumber?: string | null, role: UserRoles, countryId?: string | null, onboardingStage?: UserOnboardingStages | null } };

export type CheckUniqueDisplayNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CheckUniqueDisplayNameQuery = { __typename?: 'Query', userByDisplayname: boolean };

export type CreatePaymentIntentMutationVariables = Exact<{
  input: PaymentInitInput;
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', paymentCreateIntent: { __typename?: 'PaymentStripeInitResult', clientSecret: string, status: boolean, payment: { __typename?: 'PaymentNode', id: string } } };

export type UpdatePaymentAndSubscriptionUpdateMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type UpdatePaymentAndSubscriptionUpdateMutation = { __typename?: 'Mutation', paymentAndSubscriptionUpdate: boolean };

export type PlanCreateMutationVariables = Exact<{
  input: PlanCreateInput;
}>;


export type PlanCreateMutation = { __typename?: 'Mutation', planCreate: { __typename?: 'PlanNode', id: string, channelId: number, tipsterId?: string | null, scope: string, name: string, description?: string | null, price: number, currencyCode: string, durationDays: number, freeTrialDays?: number | null, status: string, createdAt: any, isLocked: boolean, activeSubscriberCount: number, paymentMethods?: Array<{ __typename?: 'PlanPaymentMethod', id: number, paymentType: { __typename?: 'PlanPaymentType', id: number, paymentName: string, isAutoActivated: boolean, category: string, imageUrl: string } }> | null } };

export type PlanUpdateMutationVariables = Exact<{
  input: PlanUpdateInput;
}>;


export type PlanUpdateMutation = { __typename?: 'Mutation', planUpdate: { __typename?: 'PlanNode', id: string, name: string, description?: string | null, price: number, currencyCode: string, durationDays: number, freeTrialDays?: number | null, isLocked: boolean, activeSubscriberCount: number, paymentMethods?: Array<{ __typename?: 'PlanPaymentMethod', id: number, paymentType: { __typename?: 'PlanPaymentType', id: number, paymentName: string, isAutoActivated: boolean, category: string, imageUrl: string } }> | null } };

export type PlanDiscontinueMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlanDiscontinueMutation = { __typename?: 'Mutation', planDiscontinue: { __typename?: 'PlanNode', id: string, status: string, deletedAt?: any | null } };

export type OptionRearrangeMutationVariables = Exact<{
  options: Array<OptionsUpdateModel> | OptionsUpdateModel;
}>;


export type OptionRearrangeMutation = { __typename?: 'Mutation', optionRearrange: string };

export type OptionCreateMutationVariables = Exact<{
  input: OptionsCreateModel;
}>;


export type OptionCreateMutation = { __typename?: 'Mutation', optionCreate: { __typename?: 'OptionModel', option: string, id: number, pollId: number, position: number } };

export type OptionUpdateMutationVariables = Exact<{
  optionUpdateId: Scalars['ID'];
  input: OptionsUpdateModel;
}>;


export type OptionUpdateMutation = { __typename?: 'Mutation', optionUpdate: string };

export type OptionDeleteMutationVariables = Exact<{
  optionDeleteId: Scalars['ID'];
}>;


export type OptionDeleteMutation = { __typename?: 'Mutation', optionDelete: string };

export type PlanPurchaseCreateMutationVariables = Exact<{
  input: PlanPurchaseInput;
}>;


export type PlanPurchaseCreateMutation = { __typename?: 'Mutation', planPurchaseCreate: { __typename?: 'PlanPurchaseResult', clientSecret: string, purchase: { __typename?: 'PurchaseNode', id: string, planId: string, userId: string, paymentProvider: string, externalReference?: string | null, amount: number, currencyCode: string, status: string, createdAt: any, paymentMethod?: { __typename?: 'PlanPaymentMethod', id: number, paymentType: { __typename?: 'PlanPaymentType', id: number, paymentName: string, isAutoActivated: boolean, category: string, imageUrl: string } } | null } } };

export type CreateServiceMutationVariables = Exact<{
  input: ServiceCreate;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', serviceCreate: { __typename?: 'ServiceNode', id: string } };

export type CreateServiceDurationMutationVariables = Exact<{
  input: ServiceDurationCreateInput;
}>;


export type CreateServiceDurationMutation = { __typename?: 'Mutation', serviceDurationCreate: { __typename?: 'ServiceDurationNode', id: string } };

export type UpdateServiceMutationVariables = Exact<{
  input: ServiceUpdate;
  id: Scalars['String'];
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', serviceUpdate: boolean };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', serviceDelete: boolean };

export type UpdateServiceDetailsMutationVariables = Exact<{
  input: ServiceUpdate;
  id: Scalars['String'];
}>;


export type UpdateServiceDetailsMutation = { __typename?: 'Mutation', serviceDetailsUpdate: boolean };

export type CreateManualSubscriptionMutationVariables = Exact<{
  input: ServiceSubscriptionCreateInput;
}>;


export type CreateManualSubscriptionMutation = { __typename?: 'Mutation', serviceSubscriptionCreate: { __typename?: 'ServiceSubscriptionNode', id: string } };

export type ActivateFreeTrialMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type ActivateFreeTrialMutation = { __typename?: 'Mutation', activeFreeTrial?: boolean | null };

export type RenewSubscriptionMutationVariables = Exact<{
  id: Scalars['String'];
  onlyActivate?: InputMaybe<Scalars['Boolean']>;
}>;


export type RenewSubscriptionMutation = { __typename?: 'Mutation', serviceSubsciptionRenew: { __typename?: 'ServiceSubscriptionNode', id: string } };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: SubscriptionUpdateInput;
  id: Scalars['String'];
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', subscriptionUpdate: boolean };

export type DeleteSubscriptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSubscriptionMutation = { __typename?: 'Mutation', subscriptionDelete: boolean };

export type StopUserSubscriptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type StopUserSubscriptionMutation = { __typename?: 'Mutation', serviceSubscriptionStop: boolean };

export type RenewUserSubscriptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RenewUserSubscriptionMutation = { __typename?: 'Mutation', serviceSubscriptionRenewByUser: { __typename?: 'ServiceSubscriptionNode', id: string, status: ServiceSubscriptionStatus, expiration?: any | null } };

export type TrackSignupStartMutationVariables = Exact<{
  role: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['Float']>;
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type TrackSignupStartMutation = { __typename?: 'Mutation', trackSignupStart: boolean };

export type TrackUserMagicLinkMutationVariables = Exact<{
  email: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
}>;


export type TrackUserMagicLinkMutation = { __typename?: 'Mutation', trackUserMagicLink: boolean };

export type GlobalUpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UserUpdate;
}>;


export type GlobalUpdateUserMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'UserModel', id: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UserUpdate;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', userUpdateProfile: { __typename?: 'UserModel', id: string, avatarUrl?: string | null, background?: string | null, bio?: string | null, dateOfBirth: any, displayName: string, firstName?: string | null, lastName?: string | null, onboardingStage?: UserOnboardingStages | null, unitValue?: number | null, unitShare?: number | null, oddsFormat?: OddsFormat | null, country?: { __typename?: 'CountryModel', code: string, continent: ContinentsEnum, id: string, name: string } | null } };

export type UpdateCurrentUserBookiesMutationVariables = Exact<{
  bookieIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UpdateCurrentUserBookiesMutation = { __typename?: 'Mutation', userUpdateBookies: { __typename?: 'Updated', updated: boolean } };

export type UpdateCurrentUserCompetitionsMutationVariables = Exact<{
  competitionIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UpdateCurrentUserCompetitionsMutation = { __typename?: 'Mutation', userUpdateCompetitions: { __typename?: 'Updated', updated: boolean } };

export type UpdateCurrentUserSportsMutationVariables = Exact<{
  sportsIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UpdateCurrentUserSportsMutation = { __typename?: 'Mutation', userUpdateSports: { __typename?: 'Updated', updated: boolean } };

export type UpdateCurrentUserMarketsMutationVariables = Exact<{
  marketsIds: Array<Scalars['ID']> | Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UpdateCurrentUserMarketsMutation = { __typename?: 'Mutation', userUpdateMarkets: { __typename?: 'Updated', updated: boolean } };

export type UserCreateMutationVariables = Exact<{
  input: UserCreate;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'UserModel', id: string, onboardingStage?: UserOnboardingStages | null, country?: { __typename?: 'CountryModel', id: string } | null } };

export type FollowChannelByLinkNameMutationVariables = Exact<{
  internalName: Scalars['String'];
}>;


export type FollowChannelByLinkNameMutation = { __typename?: 'Mutation', followChannelByLinkName: { __typename?: 'Result', result: boolean, channelId: number } };

export type ClickAnonymousMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type ClickAnonymousMutation = { __typename?: 'Mutation', clickAnonymous: { __typename?: 'AnonymousModel', tipsterId: string } };

export type GenerateTipsterInviteLinkMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GenerateTipsterInviteLinkMutation = { __typename?: 'Mutation', generateTipsterInviteLink: { __typename?: 'UserModel', affiliateId?: string | null } };

export type FollowUserByLinkNameMutationVariables = Exact<{
  linkName: Scalars['String'];
}>;


export type FollowUserByLinkNameMutation = { __typename?: 'Mutation', followUserByLinkName: { __typename?: 'UserModel', id: string } };

export type UploadTipsterStatMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type UploadTipsterStatMutation = { __typename?: 'Mutation', uploadStatImage: { __typename?: 'TipsterStatImageModel', image: string } };

export type DeleteTipsterStatImageMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteTipsterStatImageMutation = { __typename?: 'Mutation', deleteStatImage: { __typename?: 'TipsterStatImageModel', id: string, image: string, tipsterId: string } };

export type JoinWaitListMutationVariables = Exact<{
  input: JoinWaitlistCreateInput;
}>;


export type JoinWaitListMutation = { __typename?: 'Mutation', joinWaitlist: { __typename?: 'Waitlist', id: string, email: string } };

export type GetAdvertisementQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['ID']>;
  placement: Placement;
  filter?: InputMaybe<AdsFilter>;
  excludeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetAdvertisementQuery = { __typename?: 'Query', adsByPlacement?: Array<{ __typename?: 'Ads', id: string, imageUrl: string, referral?: string | null, title: string, description?: string | null, ctaText?: string | null, ctaLink?: string | null, variant?: AdVariant | null, frequencyCapImpressions?: number | null, frequencyCapWindow?: FrequencyCapWindow | null, rotationWeight?: number | null }> | null };

export type GetAdvertsQueryVariables = Exact<{
  filter?: InputMaybe<AdsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<AdsSort>;
}>;


export type GetAdvertsQuery = { __typename?: 'Query', ads: { __typename?: 'AllAds', count: number, ads: Array<{ __typename?: 'Ads', id: string, title: string, imageUrl: string, referral?: string | null, isActive: boolean, visible: boolean, startDate: any, expirationDate: any, placement?: Array<Placement> | null, updatedAt: any, createdAt: any }> } };

export type GetAdStatsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdStatsQuery = { __typename?: 'Query', adStats: { __typename?: 'AdStats', totalViews: number, uniqueViews: number, clicks: number, viewFrequency: number, uniqueCtr: number, totalCtr: number, timeSeries: Array<{ __typename?: 'AdDayStat', date: string, impressions: number, uniqueViews: number, clicks: number }> } };

export type GetAdsMiniStatsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetAdsMiniStatsQuery = { __typename?: 'Query', adsMiniStats: Array<{ __typename?: 'AdMiniStat', adId: string, views: number, clicks: number }> };

export type GetAdvertByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdvertByIdQuery = { __typename?: 'Query', adsById: { __typename?: 'Ads', id: string, title: string, imageUrl: string, referral?: string | null, isActive: boolean, visible: boolean, startDate: any, expirationDate: any, placement?: Array<Placement> | null, description?: string | null, ctaText?: string | null, ctaLink?: string | null, variant?: AdVariant | null, frequencyCapImpressions?: number | null, frequencyCapWindow?: FrequencyCapWindow | null, rotationWeight?: number | null, targets?: Array<{ __typename?: 'AdsTarget', channelId: string, countryIds?: Array<string> | null }> | null } };

export type GenerateAiTipAnalysisQueryVariables = Exact<{
  input: Array<TipAnalysisInput> | TipAnalysisInput;
  betType?: InputMaybe<BetType>;
  confidence?: InputMaybe<Scalars['Float']>;
  odds?: InputMaybe<Scalars['Float']>;
}>;


export type GenerateAiTipAnalysisQuery = { __typename?: 'Query', aiTipAnalysis: string };

export type ImproveContentQueryVariables = Exact<{
  text: Scalars['String'];
}>;


export type ImproveContentQuery = { __typename?: 'Query', improveContent: string };

export type GetListTelegramShareSyncQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type GetListTelegramShareSyncQuery = { __typename?: 'Query', listTelegramShareSync: Array<{ __typename?: 'SocialPlatformLink', id: string, userId: string, channelId: number, linkVerificationToken: string, status: PlatformLinkStatus, displayType: SocialShareDisplayType, contentTypes: Array<AutoShareContentTypes> }> };

export type GetgenerateTelegramBotLinkQueryVariables = Exact<{
  payload: AutoShareContentTypeInput;
}>;


export type GetgenerateTelegramBotLinkQuery = { __typename?: 'Query', generateTelegramBotLink: string };

export type GetBonusesQueryVariables = Exact<{
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  countryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetBonusesQuery = { __typename?: 'Query', bonuses: { __typename?: 'AllBonuses', count: number, bonuses?: Array<{ __typename?: 'BonusModel', id: string, title?: string | null, description?: string | null, imageUrl?: string | null, buttonName?: string | null, buttonUrl?: string | null, rewardType?: string | null, socialRating?: number | null, features?: Array<string> | null, termsAndConditions?: string | null, allowedCountryIds: Array<string>, order: number, createdAt: any, updatedAt: any }> | null } };

export type GetBonusByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBonusByIdQuery = { __typename?: 'Query', bonus: { __typename?: 'BonusModel', id: string, title?: string | null, description?: string | null, imageUrl?: string | null, buttonName?: string | null, buttonUrl?: string | null, rewardType?: string | null, socialRating?: number | null, features?: Array<string> | null, termsAndConditions?: string | null, allowedCountryIds: Array<string>, createdAt: any, updatedAt: any } };

export type BookiesQueryVariables = Exact<{ [key: string]: never; }>;


export type BookiesQuery = { __typename?: 'Query', bookies: Array<{ __typename?: 'Bookies', id: string, name: string }> };

export type GetTenantBookiesQueryVariables = Exact<{
  countryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetTenantBookiesQuery = { __typename?: 'Query', tenantBookies: Array<{ __typename?: 'TenantBookie', id?: string | null, bookieId?: number | null, externalId?: number | null, customName?: string | null, name: string, title: string, imageUrl?: string | null, bonusLink?: string | null, affiliateLink?: string | null, buttonText?: string | null, rewardDescription?: string | null, isVisible: boolean, isDefault: boolean, isMandatory: boolean, sortOrder: number, allowedCountryIds: Array<string>, rewardType?: { __typename?: 'RewardType', id: string, name: string, iconName?: string | null } | null }> };

export type SearchBookmakersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchBookmakersQuery = { __typename?: 'Query', searchBookmakers: { __typename?: 'SearchBookmakersResult', total: number, bookmakers: Array<{ __typename?: 'BookmakerOption', id: number, name: string, imageUrl?: string | null }> } };

export type GetTenantBookieStatsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTenantBookieStatsQuery = { __typename?: 'Query', tenantBookieStats: { __typename?: 'TenantBookieStats', totalViews: number, uniqueViews: number, clicks: number, viewFrequency: number, uniqueCtr: number, totalCtr: number, timeSeries: Array<{ __typename?: 'BookieDayStat', date: string, impressions: number, uniqueViews: number, clicks: number }> } };

export type GetRewardTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRewardTypesQuery = { __typename?: 'Query', rewardTypes: Array<{ __typename?: 'RewardType', id: string, name: string, iconName?: string | null, sortOrder: number }> };

export type TenantBookiesForOutcomeQueryVariables = Exact<{
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
  outcomeId?: InputMaybe<Scalars['ID']>;
  sortByHighOdds?: InputMaybe<Scalars['Boolean']>;
  userCountryId?: InputMaybe<Scalars['ID']>;
}>;


export type TenantBookiesForOutcomeQuery = { __typename?: 'Query', tenantBookiesForOutcome: Array<{ __typename?: 'TenantBookieForOutcome', id?: string | null, bookieId?: number | null, externalId?: number | null, name: string, imageUrl?: string | null, bonusLink?: string | null, buttonText?: string | null, rewardTypeName?: string | null, rewardDescription?: string | null, odd?: number | null, sortOrder: number, isDefault: boolean, isFavorite: boolean }> };

export type TenantBookiesForMultitipQueryVariables = Exact<{
  contentId: Scalars['ID'];
  sortByHighOdds?: InputMaybe<Scalars['Boolean']>;
  userCountryId?: InputMaybe<Scalars['ID']>;
}>;


export type TenantBookiesForMultitipQuery = { __typename?: 'Query', tenantBookiesForMultitip: Array<{ __typename?: 'TenantBookieForOutcome', id?: string | null, bookieId?: number | null, externalId?: number | null, name: string, imageUrl?: string | null, bonusLink?: string | null, buttonText?: string | null, rewardTypeName?: string | null, rewardDescription?: string | null, odd?: number | null, sortOrder: number, isDefault: boolean, isFavorite: boolean }> };

export type GetMyFavoriteBookieQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFavoriteBookieQuery = { __typename?: 'Query', myFavoriteBookie?: { __typename?: 'FavoriteBookie', id: string, tenantBookieId: string } | null };

export type ChannelUsersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ChannelUsersCountQuery = { __typename?: 'Query', channelUsersCount: number };

export type PrivateChannelContentQueryVariables = Exact<{
  channelId: Scalars['String'];
  limit?: Scalars['Int'];
  cursor?: InputMaybe<FeedCursorInput>;
  filter?: InputMaybe<ChannelFeedFilter>;
}>;


export type PrivateChannelContentQuery = { __typename?: 'Query', privateChannelContent: { __typename?: 'ChannelFeedResponse', nextCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, previousCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, feed?: Array<{ __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null } };

export type PublicChannelContentQueryVariables = Exact<{
  limit?: Scalars['Int'];
  cursor?: InputMaybe<FeedCursorInput>;
  filter?: InputMaybe<ChannelFeedFilter>;
}>;


export type PublicChannelContentQuery = { __typename?: 'Query', publicChannelContent: { __typename?: 'ChannelFeedResponse', nextCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, previousCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, feed?: Array<{ __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null } };

export type ChannelPinnedContentQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type ChannelPinnedContentQuery = { __typename?: 'Query', channelDetailed?: { __typename?: 'ChannelDetailed', pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null } | null };

export type ChannelDetailedQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type ChannelDetailedQuery = { __typename?: 'Query', channelDetailed?: { __typename?: 'ChannelDetailed', anonymized: boolean, background?: string | null, channelDeal: number, channelName: string, channelStatus: ChannelStatus, channelType: ChannelType, countryId?: string | null, createdAt: any, deletedAt?: any | null, feeForPayment: number, id: string, inviteLink?: string | null, logo?: string | null, paymentOptions?: PaymentOptions | null, pinnedContentId?: number | null, pinnedContentType?: string | null, tipsterCount?: number | null, trialSubscription: number, updatedAt?: any | null, usersCount?: number | null, usersLimit: number, isUserFollowing: boolean, settings?: Array<{ __typename?: 'ChannelSetting', name: ChannelSettingsName, value: string, category: ChannelSettingsCategory, id: string, scope: ChannelSettingsScope }> | null, channelUsers: Array<{ __typename?: 'ChannelUserModel', channelId: string, channelRole: ChannelRole, createdAt: any, id: string, userId: string }>, pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null } | null };

export type ChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type ChannelQuery = { __typename?: 'Query', channel: { __typename?: 'ChannelModel', anonymized: boolean, channelDeal: number, channelName: string, channelStatus: ChannelStatus, channelType: ChannelType, countryId?: string | null, createdAt: any, deletedAt?: any | null, feeForPayment: number, id: string, logo?: string | null, paymentOptions?: PaymentOptions | null, pinnedContentId?: number | null, pinnedContentType?: string | null, trialSubscription: number, updatedAt?: any | null, settings?: Array<{ __typename?: 'ChannelSetting', name: ChannelSettingsName, value: string }> | null } };

export type UserChannelsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type UserChannelsQuery = { __typename?: 'Query', userChannels: Array<{ __typename?: 'ChannelDetailed', anonymized: boolean, background?: string | null, channelDeal: number, channelName: string, channelStatus: ChannelStatus, channelType: ChannelType, countryId?: string | null, createdAt: any, deletedAt?: any | null, feeForPayment: number, id: string, inviteLink?: string | null, logo?: string | null, paymentOptions?: PaymentOptions | null, pinnedContentId?: number | null, pinnedContentType?: string | null, tipsterCount?: number | null, trialSubscription: number, updatedAt?: any | null, usersCount?: number | null, usersLimit: number, isUserFollowing: boolean, settings?: Array<{ __typename?: 'ChannelSetting', name: ChannelSettingsName, value: string, category: ChannelSettingsCategory, id: string, scope: ChannelSettingsScope }> | null, channelUsers: Array<{ __typename?: 'ChannelUserModel', channelId: string, channelRole: ChannelRole, createdAt: any, id: string, userId: string }>, pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null }> };

export type GetChannelIdsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type GetChannelIdsQuery = { __typename?: 'Query', userChannels: Array<{ __typename?: 'ChannelDetailed', id: string }> };

export type GenerateInviteLinkQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateInviteLinkQuery = { __typename?: 'Query', inviteLink: { __typename?: 'AffilateLinkModel', id: string, internalName: string, channel?: { __typename?: 'ChannelModel', channelName: string } | null } };

export type GetChannelPinnedContentQueryVariables = Exact<{
  channelId: Scalars['String'];
}>;


export type GetChannelPinnedContentQuery = { __typename?: 'Query', channelDetailed?: { __typename?: 'ChannelDetailed', pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null } | null };

export type SuggestedChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestedChannelsQuery = { __typename?: 'Query', recommendedChannels: { __typename?: 'Channels', channels: Array<{ __typename?: 'ChannelModel', id: string, channelName: string, logo?: string | null, channelStatus: ChannelStatus }> } };

export type GetTipsterChannelsQueryVariables = Exact<{
  tipster: Scalars['String'];
}>;


export type GetTipsterChannelsQuery = { __typename?: 'Query', channels: { __typename?: 'Channels', channels: Array<{ __typename?: 'ChannelModel', channelName: string, id: string, settings?: Array<{ __typename?: 'ChannelSetting', name: ChannelSettingsName, value: string }> | null }> } };

export type GetchannelListStatByCategoryiesQueryVariables = Exact<{
  filter?: InputMaybe<ChannelListFilterInput>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
}>;


export type GetchannelListStatByCategoryiesQuery = { __typename?: 'Query', channelListStatByCategoryies?: Array<{ __typename?: 'ChannelListCategory', id: string, channelName?: string | null, logo?: string | null, background?: string | null, members?: number | null, category?: string | null, trialSubscription?: number | null, tipsters?: Array<{ __typename?: 'ChannelListCategoryUser', id: string, bio?: string | null, lastName?: string | null, firstName?: string | null, displayName?: string | null, avatarUrl?: string | null, sports?: Array<{ __typename?: 'UserSports', sportId: number }> | null }> | null, stat?: { __typename?: 'TipsterStatistics', winRate: number } | null }> | null };

export type GetTipsterFollowersCountQueryVariables = Exact<{
  tipsterId: Scalars['String'];
  filter?: InputMaybe<TipsterFollowersCountFIlter>;
}>;


export type GetTipsterFollowersCountQuery = { __typename?: 'Query', tipsterFollowersCount: number };

export type GetChatListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
}>;


export type GetChatListQuery = { __typename?: 'Query', chats: { __typename?: 'Chats', totalCount: number, chats: Array<{ __typename?: 'ChatList', accepted: boolean, createdAt: any, email?: string | null, hasNewMessage: boolean, id: string, receiverId: string, senderId: string, subject?: string | null, lastMessage?: { __typename?: 'Message', chatId?: string | null, createdAt: any, id: string, imageUrl?: string | null, senderId: string, text: string } | null }> } };

export type GetMessagesByChatQueryVariables = Exact<{
  chatId: Scalars['Float'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
}>;


export type GetMessagesByChatQuery = { __typename?: 'Query', messagesByChat: Array<{ __typename?: 'Message', chatId?: string | null, createdAt: any, id: string, imageUrl?: string | null, senderId: string, text: string }> };

export type GetChatQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type GetChatQuery = { __typename?: 'Query', chat: { __typename?: 'Chat', accepted: boolean, createdAt: any, email?: string | null, id: string, receiverId: string, senderId: string, subject?: string | null } };

export type GetChatReceiverAndSenderQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type GetChatReceiverAndSenderQuery = { __typename?: 'Query', chat: { __typename?: 'Chat', id: string, receiverId: string, senderId: string } };

export type CommentsByContentQueryVariables = Exact<{
  body: CommentsByType;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
}>;


export type CommentsByContentQuery = { __typename?: 'Query', commentsByContent: { __typename?: 'CommentsReturnType', totalCount: number, comments: Array<{ __typename?: 'CommentDetailed', contentId: string, contentType: TypesOfContent, createdAt: any, deletedAt?: any | null, id: string, imageLink?: string | null, text: string, updatedAt: any, userId: string, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null }> } };

export type GetCompetitionEventsQueryVariables = Exact<{
  competitionId: Scalars['ID'];
}>;


export type GetCompetitionEventsQuery = { __typename?: 'Query', competitionEvents?: { __typename: 'ContentCompetitionEvent', id: string, name?: string | null, competitionType: CompetitionType, imageUrl?: string | null, cta?: string | null, termsAndconditions?: string | null, termsAndconditionsLink?: string | null, vip?: boolean | null, blocked?: boolean | null, events: Array<{ __typename: 'CompetitionEventData', id: number, userCanVote: boolean, eventDate?: any | null, oddType?: { __typename: 'OddType', id: string, name?: string | null } | null, outcomeValue?: Array<{ __typename: 'EventOutcomevalue', id?: number | null, name?: string | null, value?: number | null }> | null, competitors?: Array<{ __typename: 'Competitor', id: string, name: string, imageUrl?: string | null }> | null }> } | null };

export type GetCompetitionTipsterLeaderboardQueryVariables = Exact<{
  competitionId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  snapshotId?: InputMaybe<Scalars['String']>;
}>;


export type GetCompetitionTipsterLeaderboardQuery = { __typename?: 'Query', competitionTipsterLeaderboard: { __typename?: 'LeaderboardPage', totalCount: number, hasNextPage: boolean, snapshotId: string, minTipsThreshold: number, top: Array<{ __typename?: 'LeaderboardEntry', rank: number, tipsterId: string, displayName?: string | null, avatarUrl?: string | null, profit: number, winRate: number, roi: number, totalTips: number, won: number, lost: number }>, entries: Array<{ __typename?: 'LeaderboardEntry', rank: number, tipsterId: string, displayName?: string | null, avatarUrl?: string | null, profit: number, winRate: number, roi: number, totalTips: number, won: number, lost: number }> } };

export type GetCompetitionsVotesQueryVariables = Exact<{
  limit: Scalars['Float'];
  skip: Scalars['Float'];
  competitionId: Scalars['ID'];
}>;


export type GetCompetitionsVotesQuery = { __typename?: 'Query', voterRanking: { __typename?: 'VoterRanking', competition: { __typename?: 'ContentCompetitions', id: string, name?: string | null, cta?: string | null, imageUrl?: string | null, status: ContentCompetitionStatusFilter }, users: Array<{ __typename?: 'VoterUser', userName: string, ranking: string, userId: string, avatarUrl?: string | null, wins: string, losses: string }> } };

export type GetCompetitionsDataQueryVariables = Exact<{
  limit: Scalars['Float'];
  skip: Scalars['Float'];
  filter?: InputMaybe<ContentCompetitionFIlter>;
}>;


export type GetCompetitionsDataQuery = { __typename?: 'Query', competitions: Array<{ __typename?: 'ContentCompetitions', id: string, marketIds?: Array<string> | null, createdBy?: string | null, competitionType: CompetitionType, rankingMetric?: string | null, minimumSettledTips?: number | null, rankingSportIds?: Array<string> | null, imageUrl?: string | null, name?: string | null, startAt: any, endAt: any, userCanVote?: boolean | null, userJoined?: boolean | null, remainingSlots?: string | null, takenSlots?: string | null, cta?: string | null, isOpen: boolean, maxParticipants: number, description?: string | null, termsAndconditions?: string | null, termsAndconditionsLink?: string | null, vip?: boolean | null, blocked?: boolean | null, eligibleCountries?: Array<string> | null, createdByType: CompetitionCreatedByType, rewards?: Array<{ __typename?: 'RewardItem', title: string, id: string, description?: string | null, reward?: string | null }> | null }> };

export type GetCompetitionsCountQueryVariables = Exact<{
  filter?: InputMaybe<ContentCompetitionFIlter>;
}>;


export type GetCompetitionsCountQuery = { __typename?: 'Query', competitionsCount: number };

export type GetCurrenciesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
}>;


export type GetCurrenciesQuery = { __typename?: 'Query', currencies: { __typename?: 'CurrencyConnection', edges: Array<{ __typename?: 'CurrencyNodeEdge', node: { __typename?: 'CurrencyNode', code: string, id: string, name: string } }> } };

export type GenerateDashboardTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateDashboardTokenQuery = { __typename?: 'Query', generateDashboardToken: string };

export type GetEngagementSubscribersMetricsQueryVariables = Exact<{
  tipsterId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetEngagementSubscribersMetricsQuery = { __typename?: 'Query', getEngagementSubscribersMetrics: { __typename?: 'EngagementSubscribersMetrics', activeAndOnholdSubscriptions: number, activeSubscriptionsOnly: number, isTrialUsed: number, percentageActiveTrialUsed: number, unsubscribed: number, unfollowed: number } };

export type GetTournamentsBySportAndDateQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  eventsDate: Scalars['DateTime'];
}>;


export type GetTournamentsBySportAndDateQuery = { __typename?: 'Query', tournamentsBySportIdsAndEventDate: { __typename?: 'TournamentList', all: Array<{ __typename?: 'Tournament', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string, code?: string | null } | null }>, popular: Array<{ __typename?: 'Tournament', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string, code?: string | null } | null }>, userFav: Array<{ __typename?: 'Tournament', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string, code?: string | null } | null }> } };

export type GetEventsByTournamentAndDateQueryVariables = Exact<{
  eventsDate: Scalars['DateTime'];
  forDefaultBookie: Scalars['Boolean'];
  tournamentId?: InputMaybe<Scalars['ID']>;
  bookmakerId?: InputMaybe<Scalars['String']>;
  sportId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
}>;


export type GetEventsByTournamentAndDateQuery = { __typename?: 'Query', sportEventsByTournamentIdAndDate: Array<{ __typename?: 'SportEventType', categoryId?: string | null, eventDate?: any | null, id: string, numberOfTips?: number | null, votes?: number | null, competitors: Array<{ __typename?: 'Competitor', name: string, id: string, type: CompetitorType, imageUrl?: string | null }>, tournament?: { __typename?: 'Tournament', id: string, name: string, scope?: TournamentScope | null, category?: { __typename?: 'Category', id: string, name: string, code?: string | null } | null } | null }> };

export type GetEventByIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventByIdQuery = { __typename?: 'Query', sportEventByEventId: { __typename?: 'SportEventDetailed', bookmakerId: string, bookmakerName: string, hasLiveOdds: boolean, liveMatchId?: string | null, eventDate?: any | null, eventType: string, id: string, sportId?: string | null, categoryId?: string | null, competitors: Array<{ __typename?: 'Competitor', id: string, type: CompetitorType, name: string, imageUrl?: string | null }>, eventOutcome: Array<{ __typename?: 'MarketForEventList', id?: string | null, votes: number, userVoted?: number | null, name: string, withSpecialBetValue: boolean, numberOfTips: number, outcomeEvent: Array<{ __typename?: 'OutcomeEvent', id: string, value: number, votes: number, specialBetValue?: number | null, outcomeName: string }> }>, tournament?: { __typename?: 'Tournament', id: string, name: string } | null } };

export type GetEventByIdWithoutOddsQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type GetEventByIdWithoutOddsQuery = { __typename?: 'Query', sportEventByEventId: { __typename?: 'SportEventDetailed', eventDate?: any | null, eventType: string, id: string, sportId?: string | null, categoryId?: string | null, competitors: Array<{ __typename?: 'Competitor', id: string, type: CompetitorType, name: string, imageUrl?: string | null }>, eventOutcome: Array<{ __typename?: 'MarketForEventList', id?: string | null, votes: number, userVoted?: number | null, name: string, withSpecialBetValue: boolean, numberOfTips: number, outcomeEvent: Array<{ __typename?: 'OutcomeEvent', id: string, votes: number, specialBetValue?: number | null, outcomeName: string }> }>, tournament?: { __typename?: 'Tournament', id: string, name: string } | null } };

export type GetSportsByDateQueryVariables = Exact<{
  eventsDate: Scalars['DateTime'];
  bookmakerId?: InputMaybe<Scalars['String']>;
}>;


export type GetSportsByDateQuery = { __typename?: 'Query', sportsByEventDate: Array<{ __typename?: 'Sports', id: string, name: string }> };

export type GetCountriesBySportAndDateQueryVariables = Exact<{
  sportId: Scalars['ID'];
  eventsDate: Scalars['DateTime'];
  bookmakerId?: InputMaybe<Scalars['String']>;
}>;


export type GetCountriesBySportAndDateQuery = { __typename?: 'Query', categoriesBySportIdAndEventDate: Array<{ __typename?: 'Category', id: string, name: string, code?: string | null }> };

export type GetCompetitionsByCountryAndDateQueryVariables = Exact<{
  categoryId: Scalars['ID'];
  eventsDate: Scalars['DateTime'];
  bookmakerId?: InputMaybe<Scalars['String']>;
}>;


export type GetCompetitionsByCountryAndDateQuery = { __typename?: 'Query', tournamentsByCategoryIdAndEventsDate: Array<{ __typename?: 'Tournament', id: string, name: string }> };

export type GetMarketsByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
  bookmakerId?: InputMaybe<Scalars['String']>;
}>;


export type GetMarketsByEventIdQuery = { __typename?: 'Query', marketsByEventId: Array<{ __typename?: 'Market', id: string, name: string }> };

export type GetOutcomesByMarketAndEventQueryVariables = Exact<{
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
  bookmakerId?: InputMaybe<Scalars['String']>;
}>;


export type GetOutcomesByMarketAndEventQuery = { __typename?: 'Query', oddByEventIdAndMarketId: Array<{ __typename?: 'OutcomesList', name?: string | null, id: string }> };

export type GetCurrentUserFavouriteSportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserFavouriteSportsQuery = { __typename?: 'Query', userCurrent: { __typename?: 'UserModel', sports?: Array<{ __typename?: 'UserSports', sportId: number }> | null } };

export type GetBookiesByOutcomeIdQueryVariables = Exact<{
  eventOutcomeId: Scalars['ID'];
}>;


export type GetBookiesByOutcomeIdQuery = { __typename?: 'Query', bookiesByEventOutcomeId: Array<{ __typename?: 'Bookies', id: string, name: string, odd?: number | null }> };

export type GetBookiesByEventIdAndMarketIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
  marketId: Scalars['ID'];
  outcomeId?: InputMaybe<Scalars['ID']>;
}>;


export type GetBookiesByEventIdAndMarketIdQuery = { __typename?: 'Query', bookiesByEventIdAndMarketId: Array<{ __typename?: 'BookieOdd', bookieId: string, bookieName: string, bookieImageUrl?: string | null, odd: number, outcomeId: string, outcomeName: string, specialBetValue?: number | null }> };

export type GetEventsVotedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  sportId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  status?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  marketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetEventsVotedQuery = { __typename?: 'Query', oddVoted: { __typename?: 'EventOddTypeOutcomeMarketVoteds', totalCount: number, avgProfit: number, eventOddTypeOutcomeMarketVoteds: Array<{ __typename?: 'EventOddTypeOutcomeMarketVoted', id: string, result?: ResultType | null, numberOfTips?: number | null, profit: string, event?: { __typename?: 'SportEventType', id: string, competitors: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType }> } | null, market?: { __typename?: 'Market', id: string, name: string } | null, outcome?: { __typename?: 'Outcome', id: string, name: string } | null }> } };

export type SearchEventsByNameQueryVariables = Exact<{
  competitorName: Scalars['String'];
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  bookmakerId?: InputMaybe<Scalars['String']>;
  marketId?: InputMaybe<Scalars['String']>;
  sportId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SearchEventsByNameQuery = { __typename?: 'Query', sportEventByCompetitorName: Array<{ __typename?: 'SportEvent', id: string, bookmakerId?: string | null, eventDate?: any | null, votes: number, numberOfTips?: number | null, competitors: Array<{ __typename?: 'Competitor', id: string, type: CompetitorType, name: string }>, tournament?: { __typename?: 'Tournament', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string, code?: string | null } | null } | null }> };

export type GetCategoryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCategoryByIdQuery = { __typename?: 'Query', categoryById: { __typename?: 'Category', id: string, name: string, code?: string | null } };

export type GetCompetitorsByExternalIdsQueryVariables = Exact<{
  extIds: Array<Scalars['ID']> | Scalars['ID'];
  sportId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCompetitorsByExternalIdsQuery = { __typename?: 'Query', getTeamsByExtIds: Array<{ __typename?: 'Team', id: string, imageUrl?: string | null, externalId: string }> };

export type GetTournamentsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTournamentsByIdsQuery = { __typename?: 'Query', tournamentsByIds: Array<{ __typename?: 'Tournament', id: string, name: string }> };

export type PollQueryVariables = Exact<{
  pollId: Scalars['ID'];
}>;


export type PollQuery = { __typename?: 'Query', poll: { __typename?: 'PollModel', category: PollCategory, createdAt: any, deletedAt?: any | null, downvoted?: number | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, upvoted?: number | null, userId: string, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, votes?: { __typename?: 'Votes', id: number, selectedOptionId: number, userId: string } | null, upvotedStatus?: { __typename?: 'PollVote', downvoted?: boolean | null, upvoted?: boolean | null } | null } };

export type PollDetailedQueryVariables = Exact<{
  pollDetailedId: Scalars['ID'];
}>;


export type PollDetailedQuery = { __typename?: 'Query', pollDetailed?: { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | null };

export type PollsByUserIdQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type PollsByUserIdQuery = { __typename?: 'Query', pollsByUserId: Array<{ __typename?: 'PollModel', category: PollCategory, createdAt: any, deletedAt?: any | null, downvoted?: number | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, upvoted?: number | null, userId: string, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, position: number, updatedAt: any }>, votes?: { __typename?: 'Votes', id: number, selectedOptionId: number, userId: string } | null }> };

export type PostQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;


export type PostQuery = { __typename?: 'Query', post: { __typename?: 'PostWithVotes', category?: CategoryEnum | null, content?: string | null, createdAt: any, deletedAt?: any | null, downvoted?: number | null, isCommentsAllow: boolean, id: string, mediaLink?: string | null, title: string, type?: TypeEnum | null, updatedAt: any, upvoted?: number | null, userId: string, upvotedStatus?: { __typename?: 'Vote', downvoted?: boolean | null, upvoted?: boolean | null } | null } };

export type PostDetailedQueryVariables = Exact<{
  postDetailedId: Scalars['ID'];
}>;


export type PostDetailedQuery = { __typename?: 'Query', postDetailed?: { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | null };

export type TipDetailedQueryVariables = Exact<{
  tipDetailedId: Scalars['ID'];
}>;


export type TipDetailedQuery = { __typename?: 'Query', tipDetailed?: { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null } | null };

export type GetTipRoomQueryVariables = Exact<{
  tipId: Scalars['ID'];
}>;


export type GetTipRoomQuery = { __typename?: 'Query', getTipRoom?: { __typename?: 'TipRoomOutput', tipId: string, name?: string | null, streamUrl?: string | null, coverImageUrl?: string | null, streamStartTime?: string | null, streamEndTime?: string | null } | null };

export type MultitipDetailedQueryVariables = Exact<{
  multitipDetailedId: Scalars['ID'];
}>;


export type MultitipDetailedQuery = { __typename?: 'Query', multitipDetailed?: { __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | null };

export type GetTipListQueryVariables = Exact<{
  input: TipsFilterInput;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
}>;


export type GetTipListQuery = { __typename?: 'Query', detailedTipsAndMultitips: Array<{ __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> };

export type SavedTipsQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  sportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type SavedTipsQuery = { __typename?: 'Query', savedTips: { __typename?: 'SavedTipsList', totalCount: number, savedTips: Array<{ __typename?: 'MultitipDetailed', anonymized?: boolean | null, contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', anonymized?: boolean | null, contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> } };

export type GetPublicChannelDataQueryVariables = Exact<{
  channelId?: Scalars['String'];
  limit?: Scalars['Int'];
  cursor?: InputMaybe<FeedCursorInput>;
  filter?: InputMaybe<ChannelFeedFilter>;
}>;


export type GetPublicChannelDataQuery = { __typename?: 'Query', publicChannelContent: { __typename?: 'ChannelFeedResponse', nextCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, previousCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, feed?: Array<{ __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null }, channelDetailed?: { __typename?: 'ChannelDetailed', pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null } | null };

export type GetPrivateChannelDataQueryVariables = Exact<{
  channelId: Scalars['String'];
  limit?: Scalars['Int'];
  cursor?: InputMaybe<FeedCursorInput>;
  filter?: InputMaybe<ChannelFeedFilter>;
}>;


export type GetPrivateChannelDataQuery = { __typename?: 'Query', privateChannelContent: { __typename?: 'ChannelFeedResponse', nextCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, previousCursor?: { __typename?: 'FeedCursor', id: number, createdAt: any } | null, feed?: Array<{ __typename?: 'MultitipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, id: string, title?: string | null, isCommentsAllow: boolean, isSaved?: boolean | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, userId: string, vip: boolean, streamUrl?: string | null, videoUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, tips?: Array<{ __typename?: 'TipDetailed', analysis?: string | null, blocked: boolean, bookieId?: string | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PollDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, createdAt: any, deletedAt?: any | null, expirationDate: string, id: string, isCommentsAllow: boolean, question: string, updatedAt: any, userSelectedOptionId?: number | null, options: Array<{ __typename?: 'OptionModel', count?: number | null, createdAt: any, deletedAt?: any | null, id: number, option: string, pollId: number, position: number, updatedAt: any }>, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'PostDetailed', contentType?: TypesOfContent | null, category: string, commentsCount?: number | null, content?: string | null, createdAt: any, deletedAt?: any | null, id: string, mediaLink?: string | null, isCommentsAllow: boolean, title?: string | null, type: TypeEnum, updatedAt: any, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null } | { __typename?: 'TipDetailed', contentType?: TypesOfContent | null, analysis?: string | null, blocked: boolean, bookieId?: string | null, bookieImageUrl?: string | null, buttonText?: string | null, bonusLink?: string | null, channelContentId?: number | null, commentsCount?: number | null, createdAt: any, customBookieName?: string | null, deletedAt?: any | null, eventId?: number | null, id: string, title?: string | null, isCommentsAllow: boolean, isMultitip: boolean, isSaved?: boolean | null, multitip?: string | null, odds?: number | null, outcomeId?: string | null, profit?: string | null, result?: TipResult | null, stake?: number | null, updatedAt: any, vip: boolean, sportId?: string | null, imageUrl?: string | null, videoUrl?: string | null, streamUrl?: string | null, audioUrl?: string | null, coverImageUrl?: string | null, isMultiPostTip?: boolean | null, isPostTip?: boolean | null, event?: { __typename?: 'TipSportEventType', categoryId?: string | null, createdAt?: any | null, deletedAt?: any | null, eventDate?: any | null, eventStatus?: string | null, eventType?: string | null, externalCategoryId?: string | null, externalId?: string | null, externalSportId?: string | null, externalTournamentId?: string | null, id: string, sportId?: string | null, tournamentId?: string | null, updatedAt?: any | null, competitors?: Array<{ __typename?: 'Competitor', id: string, name: string, type: CompetitorType, imageUrl?: string | null }> | null, oddType?: { __typename?: 'OddType', externalId?: number | null, id: string, name?: string | null, sportId?: number | null } | null, outcome?: { __typename?: 'TipOutcome', id: string, name: string, specialBetValue?: string | null, bookmakerName?: string | null } | null, tournament?: { __typename?: 'TournamentModel', categoryId: string, externalId: string, id: string, name: string, imageUrl?: string | null } | null } | null, user?: { __typename?: 'User', avatarUrl?: string | null, displayName?: string | null, id: string } | null, votes?: { __typename?: 'Vote', downvoteCount: number, downvoted?: boolean | null, upvoteCount: number, upvoted?: boolean | null } | null, score?: { __typename?: 'GameScore', ft?: string | null, penalty?: string | null, sport?: string | null, total?: string | null } | null }> | null }, channelDetailed?: { __typename?: 'ChannelDetailed', pinnedContent?: { __typename?: 'PinnedContent', contentType: TypesOfContent, description?: string | null, header?: string | null, id: string } | null } | null };

export type GetTipsterFollowersBySourceQueryVariables = Exact<{
  userId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetTipsterFollowersBySourceQuery = { __typename?: 'Query', getTipsterFollowersBySource: Array<{ __typename?: 'FollowersBySourceCount', source: string, userCount: number }> };

export type GetTipsterUsersSignupMethodsQueryVariables = Exact<{
  userId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetTipsterUsersSignupMethodsQuery = { __typename?: 'Query', getTipsterUsersSignupMethods: Array<{ __typename?: 'SignupMethodCount', pool: string, userCount: number }> };

export type GetActiveTipsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveTipsCountQuery = { __typename?: 'Query', countActiveTips: number };

export type LeaderboardEntryFieldsFragment = { __typename?: 'LeaderboardEntry', rank: number, previousRank?: number | null, rankChange?: number | null, tipsterId: string, displayName?: string | null, avatarUrl?: string | null, profit: number, winRate: number, roi: number, totalTips: number, won: number, lost: number, void: number };

export type GetTipsterLeaderboardQueryVariables = Exact<{
  filter?: InputMaybe<LeaderboardFilterInput>;
}>;


export type GetTipsterLeaderboardQuery = { __typename?: 'Query', tipsterLeaderboard: { __typename?: 'LeaderboardPage', offset: number, limit: number, totalCount: number, hasNextPage: boolean, snapshotId: string, minTipsThreshold: number, top: Array<{ __typename?: 'LeaderboardEntry', rank: number, previousRank?: number | null, rankChange?: number | null, tipsterId: string, displayName?: string | null, avatarUrl?: string | null, profit: number, winRate: number, roi: number, totalTips: number, won: number, lost: number, void: number }>, entries: Array<{ __typename?: 'LeaderboardEntry', rank: number, previousRank?: number | null, rankChange?: number | null, tipsterId: string, displayName?: string | null, avatarUrl?: string | null, profit: number, winRate: number, roi: number, totalTips: number, won: number, lost: number, void: number }> } };

export type GetMyLeaderboardPositionQueryVariables = Exact<{
  filter?: InputMaybe<LeaderboardFilterInput>;
}>;


export type GetMyLeaderboardPositionQuery = { __typename?: 'Query', myLeaderboardPosition: { __typename?: 'MyLeaderboardPosition', rank?: number | null, previousRank?: number | null, rankChange?: number | null, qualifies: boolean, totalTips: number, minTipsThreshold: number, entry?: { __typename?: 'LeaderboardEntry', rank: number, previousRank?: number | null, rankChange?: number | null, tipsterId: string, displayName?: string | null, avatarUrl?: string | null, profit: number, winRate: number, roi: number, totalTips: number, won: number, lost: number, void: number } | null } };

export type MarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type GetNotificationsQueryVariables = Exact<{
  channelIds: Array<Scalars['String']> | Scalars['String'];
  isNew?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'Notifications', count: number, notifications: Array<{ __typename?: 'Notification', createdAt: any, iconUrl?: string | null, id: string, info?: any | null, isNew: boolean, type: TypesOfNotifications, userId: string, createdByUser?: { __typename?: 'User', id: string, displayName?: string | null, firstName?: string | null, avatarUrl?: string | null, lastName?: string | null } | null }> } };

export type GetNotificationsCountQueryVariables = Exact<{
  channelIds: Array<Scalars['String']> | Scalars['String'];
  isNew?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
}>;


export type GetNotificationsCountQuery = { __typename?: 'Query', notifications: { __typename?: 'Notifications', count: number } };

export type GetNotificationSettingsQueryVariables = Exact<{
  entityId?: InputMaybe<Scalars['ID']>;
  scope: NotificationSettingScope;
}>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', entityNotificationSettingsByEntityId: Array<{ __typename?: 'EntityNotificationSetting', id: string, isEditable: boolean, value: boolean, notificationSetting: { __typename?: 'NotificationSettings', id: string, name: string, category: string } }> };

export type GetNotificationsAndMessagesCountQueryVariables = Exact<{
  channelIds: Array<Scalars['String']> | Scalars['String'];
  isNew?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
}>;


export type GetNotificationsAndMessagesCountQuery = { __typename?: 'Query', unreadChatsCount: number, notifications: { __typename?: 'Notifications', count: number } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'CountryModel', id: string, name: string, code: string }> };

export type GetSportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSportsQuery = { __typename?: 'Query', sports: Array<{ __typename?: 'Sports', id: string, name: string }> };

export type GetTournamentsBySportIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTournamentsBySportIdsQuery = { __typename?: 'Query', tournamentsBySportIds: { __typename?: 'Tournaments', totalCount: number, tournaments: Array<{ __typename?: 'Tournament', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string, externalId: string, sportId: string } | null }> } };

export type GetCountryByIpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryByIpQuery = { __typename?: 'Query', countryByIp: { __typename?: 'CountryModel', id: string, isBlacklisted?: boolean | null, code: string, name: string, continent: ContinentsEnum } };

export type GetBookiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookiesQuery = { __typename?: 'Query', bookies: Array<{ __typename?: 'Bookies', id: string, name: string }> };

export type GetFavouriteListForProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavouriteListForProfileQuery = { __typename?: 'Query', sports: Array<{ __typename?: 'Sports', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string, sportId: string }> };

export type GetTranslatedCountriesQueryVariables = Exact<{
  country_name: Scalars['String'];
}>;


export type GetTranslatedCountriesQuery = { __typename?: 'Query', translateCountries: Array<{ __typename?: 'CountryModel', id: string, name: string, code: string }> };

export type GetSportsWithoutCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSportsWithoutCategoriesQuery = { __typename?: 'Query', sportWithoutCategories: Array<{ __typename?: 'Sports', id: string, name: string }> };

export type GetPlansByChannelQueryVariables = Exact<{
  channelId: Scalars['Float'];
}>;


export type GetPlansByChannelQuery = { __typename?: 'Query', plansByChannel: Array<{ __typename?: 'PlanNode', id: string, channelId: number, tipsterId?: string | null, scope: string, name: string, description?: string | null, price: number, currencyCode: string, durationDays: number, freeTrialDays?: number | null, status: string, createdAt: any, isLocked: boolean, activeSubscriberCount: number, paymentMethods?: Array<{ __typename?: 'PlanPaymentMethod', id: number, paymentType: { __typename?: 'PlanPaymentType', id: number, paymentName: string, isAutoActivated: boolean, category: string, imageUrl: string } }> | null }> };

export type GetPlansByTipsterIdQueryVariables = Exact<{
  tipsterId: Scalars['String'];
}>;


export type GetPlansByTipsterIdQuery = { __typename?: 'Query', plansByTipsterId: Array<{ __typename?: 'PlanNode', id: string, channelId: number, tipsterId?: string | null, scope: string, name: string, description?: string | null, price: number, currencyCode: string, durationDays: number, freeTrialDays?: number | null, status: string, createdAt: any, isLocked: boolean, activeSubscriberCount: number, paymentMethods?: Array<{ __typename?: 'PlanPaymentMethod', id: number, paymentType: { __typename?: 'PlanPaymentType', id: number, paymentName: string, isAutoActivated: boolean, category: string, imageUrl: string } }> | null }> };

export type GetPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlansQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'PlanNode', id: string, channelId: number, tipsterId?: string | null, scope: string, name: string, description?: string | null, price: number, currencyCode: string, durationDays: number, freeTrialDays?: number | null, status: string, createdAt: any, isLocked: boolean, activeSubscriberCount: number, paymentMethods?: Array<{ __typename?: 'PlanPaymentMethod', id: number, paymentType: { __typename?: 'PlanPaymentType', id: number, paymentName: string, isAutoActivated: boolean, category: string, imageUrl: string } }> | null }> };

export type HasAccessQueryVariables = Exact<{
  channelId: Scalars['Int'];
  tipsterId?: InputMaybe<Scalars['String']>;
}>;


export type HasAccessQuery = { __typename?: 'Query', hasAccess: boolean };

export type GetMyAccessGrantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAccessGrantsQuery = { __typename?: 'Query', myAccessGrants: Array<{ __typename?: 'MyAccessGrantNode', id: string, channelId: number, tipsterId?: string | null, scope: string, status: string, startedAt: any, expiration?: any | null, createdAt: any, planId?: string | null, planName?: string | null, planPrice?: number | null, planCurrencyCode?: string | null, planDurationDays?: number | null, planFreeTrialDays?: number | null }> };

export type GetGrantsByTipsterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGrantsByTipsterQuery = { __typename?: 'Query', grantsByTipster: Array<{ __typename?: 'TipsterGrantNode', id: string, userId: string, displayName?: string | null, channelId: number, scope: string, status: string, startedAt: any, expiration?: any | null, createdAt: any, planId?: string | null, planName?: string | null, planPrice?: number | null, planCurrencyCode?: string | null }> };

export type GetVipInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVipInvitesQuery = { __typename?: 'Query', vipInvites: Array<{ __typename?: 'VipInviteNode', id: string, token: string, shareUrl: string, isValid: boolean, usedCount: number, expiresAt?: any | null, createdAt: any }> };

export type GetRevenueByDateQueryVariables = Exact<{
  tipsterId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetRevenueByDateQuery = { __typename?: 'Query', getRevenueByDate: Array<{ __typename?: 'RevenueByDate', date: string, totalAmount: number }> };

export type GetServiceByTipsterAndChannelQueryVariables = Exact<{
  channelId: Scalars['String'];
  tipsterId: Scalars['String'];
}>;


export type GetServiceByTipsterAndChannelQuery = { __typename?: 'Query', serviceByChannelIdAndTipsterId: { __typename?: 'ServiceNode', id: string, title?: string | null, subTitle?: string | null, ctaTitle?: string | null, ctaSubTitle?: string | null, imageLink?: string | null } };

export type GetServicesByTipsterIdQueryVariables = Exact<{
  tipsterId: Scalars['String'];
}>;


export type GetServicesByTipsterIdQuery = { __typename?: 'Query', services: { __typename?: 'ServiceConnection', edges: Array<{ __typename?: 'ServiceNodeEdge', node: { __typename?: 'ServiceNode', id: string, serviceName?: string | null, channelId: string, channelName?: string | null } }> } };

export type GetAvailablePaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailablePaymentMethodsQuery = { __typename?: 'Query', availablePayments: { __typename?: 'AvailablePaymentConnection', edges: Array<{ __typename?: 'AvailablePaymentNodeEdge', node: { __typename?: 'AvailablePaymentNode', id: string, paymentName: string, imageUrl: string, isAutoActivated: boolean } }> } };

export type CurrentUserHasPendingSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserHasPendingSubscriptionQuery = { __typename?: 'Query', checkCurrentUserHasPendingSubscription?: boolean | null };

export type GetSubscriptionsByTipsterAndChannelQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']>;
  tipsterId: Scalars['String'];
  countryId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type GetSubscriptionsByTipsterAndChannelQuery = { __typename?: 'Query', subscriptionByChannelIdAndTipsterId: { __typename?: 'SubscriptionConnection', edges: Array<{ __typename?: 'SubscriptionNodeEdge', node: { __typename?: 'SubscriptionNode', id: string, freeTrialPeriod?: number | null, price: { __typename?: 'PriceNode', id: string, price: number, currency: { __typename?: 'CurrencyNode', id: string, name: string, symbol: string }, priceBreakdown?: { __typename?: 'PriceBreakdown', taxRate: number, subTotal: number, total: number, vat: number } | null }, serviceDuration: { __typename?: 'ServiceDurationNode', id: string, duration: number }, service: { __typename?: 'ServiceNode', id: string, tipsterId: string, tipsterName?: string | null, imageLink?: string | null, info?: string | null, status: ServiceStatus, title?: string | null, subTitle?: string | null, ctaTitle?: string | null, ctaSubTitle?: string | null, serviceName?: string | null, channelId: string, channelName?: string | null, email?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethods', id: string, paymentInfo?: string | null, paymentComment?: string | null, paymentType?: { __typename?: 'PaymentType', paymentName: string, id: string, imageUrl: string, isAutoActivated: boolean, category: string } | null }> | null } } }> } };

export type GetServicesWithSubscriptionsQueryVariables = Exact<{
  tipsterId: Scalars['String'];
  channelId?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
}>;


export type GetServicesWithSubscriptionsQuery = { __typename?: 'Query', servicesByTipsterId: Array<{ __typename?: 'ServiceNode', id: string, tipsterId: string, tipsterName?: string | null, imageLink?: string | null, info?: string | null, status: ServiceStatus, title?: string | null, subTitle?: string | null, ctaTitle?: string | null, ctaSubTitle?: string | null, serviceName?: string | null, channelId: string, channelName?: string | null, email?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethods', id: string, paymentInfo?: string | null, paymentComment?: string | null, paymentType?: { __typename?: 'PaymentType', paymentName: string, id: string, imageUrl: string, isAutoActivated: boolean, category: string } | null }> | null, subscriptions?: Array<{ __typename?: 'SubscriptionNode', id: string, freeTrialPeriod?: number | null, price: { __typename?: 'PriceNode', id: string, price: number, currency: { __typename?: 'CurrencyNode', id: string, name: string, symbol: string }, priceBreakdown?: { __typename?: 'PriceBreakdown', taxRate: number, subTotal: number, total: number, vat: number } | null }, serviceDuration: { __typename?: 'ServiceDurationNode', id: string, duration: number } }> | null }> };

export type GetServiceSubByUserAndSubQueryVariables = Exact<{
  subscriptionId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type GetServiceSubByUserAndSubQuery = { __typename?: 'Query', serviceSubscriptionByUserIdAndSubscriptionId?: { __typename?: 'ServiceSubscriptionNode', id: string, isTrialUsed: boolean, status: ServiceSubscriptionStatus } | null };

export type GetServiceSubscriptionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetServiceSubscriptionQuery = { __typename?: 'Query', serviceSubscription?: { __typename?: 'ServiceSubscriptionNode', id: string, status: ServiceSubscriptionStatus } | null };

export type CreatePriceMutationVariables = Exact<{
  input: PriceCreateInput;
}>;


export type CreatePriceMutation = { __typename?: 'Mutation', priceCreate: { __typename?: 'PriceNode', id: string } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: SubscriptionCreateInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', subscriptionCreate: { __typename?: 'SubscriptionNode', id: string } };

export type GetSubscriptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<Scalars['String']>;
}>;


export type GetSubscriptionsQuery = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number }, edges: Array<{ __typename?: 'SubscriptionNodeEdge', node: { __typename?: 'SubscriptionNode', id: string, countryIds?: Array<string> | null, serviceId: string, freeTrialPeriod?: number | null, totalActiveSubs?: number | null, price: { __typename?: 'PriceNode', price: number, id: string, currency: { __typename?: 'CurrencyNode', code: string, name: string, id: string, symbol: string }, priceBreakdown?: { __typename?: 'PriceBreakdown', taxRate: number, subTotal: number, total: number, vat: number } | null }, service: { __typename?: 'ServiceNode', tipsterId: string, channelId: string, channelName?: string | null, serviceName?: string | null, id: string, status: ServiceStatus, autoRenewal: boolean, info?: string | null, imageLink?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethods', id: string, paymentInfo?: string | null, paymentComment?: string | null, paymentType?: { __typename?: 'PaymentType', paymentName: string, id: string, imageUrl: string, isAutoActivated: boolean } | null }> | null }, serviceDuration: { __typename?: 'ServiceDurationNode', id: string, duration: number } } }> } };

export type GetSubscribersListByTipsterQueryVariables = Exact<{
  filter?: InputMaybe<ServiceSubscriberFilterInput>;
}>;


export type GetSubscribersListByTipsterQuery = { __typename?: 'Query', getTipsterSubscribers: { __typename?: 'SubscribersListConnection', edges: Array<{ __typename?: 'SubscribersListNodeEdge', node: { __typename?: 'SubscribersListNode', id: string, name: string, price: string, status: ServiceSubscriptionStatus, isPaid: boolean, expiration?: any | null, isAutoActivated?: boolean | null, currencyCode: string, currencySymbol: string, paymentName?: string | null, subscriptionId: string, createdAt: any, paymentMethodId?: number | null, isTrialUsed?: boolean | null, user?: { __typename?: 'User', id: string, displayName?: string | null } | null } }> } };

export type GetUserPendingSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPendingSubscriptionQuery = { __typename?: 'Query', serviceSubscriptionsByUserId?: { __typename?: 'ServiceSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number }, edges: Array<{ __typename?: 'ServiceSubscriptionNodeEdge', node: { __typename?: 'ServiceSubscriptionNode', id: string, expiration?: any | null, status: ServiceSubscriptionStatus, userId: string, createdAt: any, paymentMethodId?: number | null, subscription?: { __typename?: 'SubscriptionNode', id: string, freeTrialPeriod?: number | null, price: { __typename?: 'PriceNode', id: string, price: number, currency: { __typename?: 'CurrencyNode', id: string, name: string }, priceBreakdown?: { __typename?: 'PriceBreakdown', taxRate: number, subTotal: number, total: number, vat: number } | null }, serviceDuration: { __typename?: 'ServiceDurationNode', id: string, duration: number }, service: { __typename?: 'ServiceNode', id: string, tipsterId: string, tipsterName?: string | null, imageLink?: string | null, info?: string | null, title?: string | null, subTitle?: string | null, ctaTitle?: string | null, ctaSubTitle?: string | null, serviceName?: string | null, email?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethods', id: string, paymentInfo?: string | null, paymentComment?: string | null, paymentType?: { __typename?: 'PaymentType', paymentName: string, id: string, imageUrl: string, isAutoActivated: boolean } | null }> | null } } | null } }> } | null };

export type GetSubscriptionMetricsQueryVariables = Exact<{
  tipsterId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetSubscriptionMetricsQuery = { __typename?: 'Query', getSubscriptionMetrics: Array<{ __typename?: 'SubscriptionMetrics', date: string, newSubscriptions: number, cumulativeActiveSubscriptions: number }> };

export type GetTenantConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantConfigQuery = { __typename?: 'Query', tenantConfig: { __typename?: 'TenantConfig', tenantId: string, demoProfileId?: string | null, featureFlags: Array<{ __typename?: 'FeatureFlag', key: string, enabled: boolean, metadata?: any | null }>, branding?: { __typename?: 'TenantBranding', appName: string, primaryColor: string, secondaryColor?: string | null, logoUrl?: string | null, faviconUrl?: string | null, termsContent?: string | null, privacyContent?: string | null, rulesContent?: string | null } | null, integrationConfig?: { __typename?: 'TenantIntegrationConfig', stripePublishableKey?: string | null, watchersApiKey?: string | null, watchersToken?: string | null, ssoProviders?: Array<{ __typename?: 'SsoProviderConfig', provider: string, allowedOrigins: Array<string> }> | null } | null } };

export type GetTipsSportDistributionQueryVariables = Exact<{
  userId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  sportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTipsSportDistributionQuery = { __typename?: 'Query', tipsSportDistribution: { __typename?: 'TipsSportDistribution', totalCount: number, sports: Array<{ __typename?: 'SportDistribution', sportId: string, sportName: string, count: number }> } };

export type GetTipsWithOutcomeNamesQueryVariables = Exact<{
  userId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  sportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTipsWithOutcomeNamesQuery = { __typename?: 'Query', tipsWithOutcomeNames: Array<{ __typename?: 'TipWithOutcomeName', tipId: string, eventId?: string | null, outcomeId?: string | null, result?: TipResult | null, outcomeName?: string | null, createdAt?: any | null }> };

export type GetTipsterProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTipsterProfileQuery = { __typename?: 'Query', tipsterProfile: { __typename?: 'TipsterProfile', avarageMonthFreeTips?: number | null, avarageMonthVipTips?: number | null, followers: number, isFollowing: boolean, subscribers: number, totalTips: number, winRate?: number | null, user: { __typename?: 'UserModel', avatarUrl?: string | null, background?: string | null, bio?: string | null, canEditPermissions: boolean, displayName: string, firstName?: string | null, id: string, lastName?: string | null, role: UserRoles, subscriptionToTipster?: string | null, suggestedBank?: number | null, bookies?: Array<{ __typename?: 'UserBookies', bookieId: number }> | null, competitions?: Array<{ __typename?: 'UserCompetitions', competitionId: number }> | null, markets?: Array<{ __typename?: 'UserMarkets', marketId: number }> | null, sports?: Array<{ __typename?: 'UserSports', sportId: number }> | null } } };

export type GetTipsterStatsQueryVariables = Exact<{
  tipsterId: Scalars['ID'];
  sportId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetTipsterStatsQuery = { __typename?: 'Query', stats: { __typename?: 'TipsterStatistics', avgOdds: number, avgStake: number, lost: number, pending: number, profit: number, roi: number, totalTips: number, void: number, winRate: number, won: number } };

export type GetChatByTipsterIdQueryVariables = Exact<{
  tipsterId: Scalars['ID'];
}>;


export type GetChatByTipsterIdQuery = { __typename?: 'Query', chatByTipsterId?: { __typename?: 'Chat', id: string } | null };

export type GetTipsterStatImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipsterStatImagesQuery = { __typename?: 'Query', getTipsterStatImages: Array<{ __typename?: 'TipsterStatImageModel', id: string, image: string }> };

export type FindTipsterChannelsByDisplayNameQueryVariables = Exact<{
  displayName: Scalars['String'];
}>;


export type FindTipsterChannelsByDisplayNameQuery = { __typename?: 'Query', getTipsterChannelsByDisplayName?: { __typename?: 'UserModel', displayName: string, id: string, channelsWhereUserIsTipster?: Array<{ __typename?: 'UsersChannelModel', id: string, channelName?: string | null, logo?: string | null }> | null } | null };

export type GetTipsterCurrenciesQueryVariables = Exact<{
  tipsterId: Scalars['String'];
}>;


export type GetTipsterCurrenciesQuery = { __typename?: 'Query', tipsterCurrencies: { __typename?: 'CurrencyConnection', edges: Array<{ __typename?: 'CurrencyNodeEdge', node: { __typename?: 'CurrencyNode', id: string, code: string, name: string, symbol: string } }> } };

export type GetTipsterAvailablePaymentsQueryVariables = Exact<{
  tipsterId: Scalars['String'];
}>;


export type GetTipsterAvailablePaymentsQuery = { __typename?: 'Query', tipsterAvailablePayments: { __typename?: 'AvailablePaymentConnection', edges: Array<{ __typename?: 'AvailablePaymentNodeEdge', node: { __typename?: 'AvailablePaymentNode', id: string, imageUrl: string, paymentName: string, isAutoActivated: boolean } }> } };

export type GetTipsterProfileStatsQueryVariables = Exact<{
  tipsterId: Scalars['ID'];
}>;


export type GetTipsterProfileStatsQuery = { __typename?: 'Query', tipsterProfileStats: { __typename?: 'TipsterProfileStats', winRate: number, totalTips: number, avgFreeTipsPerMonth: number, avgVipTipsPerMonth: number } };

export type GetTipstersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetTipstersQuery = { __typename?: 'Query', tipsters: { __typename?: 'AllUsersModel', count: number, tipsterList: Array<{ __typename?: 'UserModel', createdAt: any, displayName: string, emailAddress?: string | null, id: string, lastName?: string | null, firstName?: string | null, onboardingStage?: UserOnboardingStages | null }> } };

export type GetTipsterOwnedChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTipsterOwnedChannelsQuery = { __typename?: 'Query', tipsterOwnedChannels: Array<{ __typename?: 'TipsterChannel', id: string, channelName: string }> };

export type GetTotalChannelUsersQueryVariables = Exact<{
  userId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetTotalChannelUsersQuery = { __typename?: 'Query', getTotalChannelUsers: Array<{ __typename?: 'TotalChannelUsers', date: string, totalUsers: number }> };

export type GetTrialMetricsQueryVariables = Exact<{
  tipsterId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}>;


export type GetTrialMetricsQuery = { __typename?: 'Query', getTrialMetrics: { __typename?: 'TrialMetrics', trialUsedCount: number, percentageTrialUsedAndPaid: number } };

export type GetUserStatsQueryVariables = Exact<{
  sportId?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetUserStatsQuery = { __typename?: 'Query', userStats: { __typename?: 'UserStatistics', avgOdds: number, avgStake: number, lost: number, pending: number, profit: number, roi: number, totalVotes: number, void: number, winRate: number, won: number, avgMonthVotes: number } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', hasPendingSubscription?: boolean | null, userCurrent: { __typename?: 'UserModel', isTipsterAdmin?: boolean | null, countryId?: string | null, dateOfBirth: any, displayName: string, emailAddress?: string | null, firstName?: string | null, gender?: UserGender | null, id: string, lastName?: string | null, phoneNumber?: string | null, role: UserRoles, avatarUrl?: string | null, background?: string | null, bio?: string | null, tipsterStatus?: TipsterStatus | null, userStatus?: UserStatus | null, permissions: Array<UserPermission>, onboardingStage?: UserOnboardingStages | null, unitValue?: number | null, unitShare?: number | null, oddsFormat?: OddsFormat | null, favoriteTenantBookieId?: string | null, channelsWhereUserIsTipster?: Array<{ __typename?: 'UsersChannelModel', id: string, channelName?: string | null, logo?: string | null }> | null, followedChannels?: Array<{ __typename?: 'UsersChannelModel', id: string, channelName?: string | null, logo?: string | null, settings?: Array<{ __typename?: 'UsersChannelSetting', id: string, value?: string | null, name?: string | null, scope?: string | null, category?: string | null, externalId?: string | null }> | null }> | null, onboardingProgress?: { __typename?: 'OnboardingProgress', basicWelcome?: boolean | null, basicVideoExplainer?: boolean | null, contentWelcome?: boolean | null, contentVideoExplainer?: boolean | null, contentTipComparison?: boolean | null, contentTipMenu?: boolean | null, ContentDataTip?: boolean | null, ContentImageTip?: boolean | null, subscriptionMenu?: boolean | null, subscriptionWelcome?: boolean | null, subscriptionVideoExplainer?: boolean | null, subcriptionServiceMenu?: boolean | null, subscriptionFeatureBanner?: boolean | null, userInviteWelcome?: boolean | null, userInviteMenu?: boolean | null, startAppBanner?: boolean | null } | null } };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'UserModel', alternativeAvatarUrl?: string | null, alternativeName?: string | null, avatarUrl?: string | null, background?: string | null, bio?: string | null, countryId?: string | null, createdAt: any, dateOfBirth: any, deletedAt?: any | null, displayName: string, emailAddress?: string | null, externalId: string, firstName?: string | null, gender?: UserGender | null, id: string, lastName?: string | null, minTipsNumber?: number | null, phoneNumber?: string | null, role: UserRoles, subscriptionDate?: any | null, subscriptionToTipster?: string | null, tipsterStatus?: TipsterStatus | null, userStatus?: UserStatus | null, unitValue?: number | null, unitShare?: number | null, oddsFormat?: OddsFormat | null, bookies?: Array<{ __typename?: 'UserBookies', bookieId: number, userId: string }> | null, competitions?: Array<{ __typename?: 'UserCompetitions', competitionId: number, userId: string }> | null, country?: { __typename?: 'CountryModel', code: string, continent: ContinentsEnum, id: string, name: string } | null, markets?: Array<{ __typename?: 'UserMarkets', marketId: number, userId: string }> | null, sports?: Array<{ __typename?: 'UserSports', sportId: number, userId?: string | null }> | null, subscriptionToContents?: Array<{ __typename?: 'UserContentSubscription', contentId: string, contentType: Content_Type_Enum, id: string, paid: boolean, userId: string }> | null } };

export type GetCurrentUserFavouritesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserFavouritesQuery = { __typename?: 'Query', userCurrent: { __typename?: 'UserModel', bookies?: Array<{ __typename?: 'UserBookies', bookieId: number, userId: string }> | null, competitions?: Array<{ __typename?: 'UserCompetitions', competitionId: number, userId: string }> | null, markets?: Array<{ __typename?: 'UserMarkets', marketId: number, userId: string }> | null, sports?: Array<{ __typename?: 'UserSports', sportId: number, userId?: string | null }> | null } };

export type GetUserRoleQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetUserRoleQuery = { __typename?: 'Query', user: { __typename?: 'UserModel', role: UserRoles } };

export type UsersByIdsQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UsersByIdsQuery = { __typename?: 'Query', usersByIds: Array<{ __typename?: 'UserModel', displayName: string, avatarUrl?: string | null, id: string, role: UserRoles }> };

export type GetCurrentUserSubsQueryVariables = Exact<{
  includeExpired: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
}>;


export type GetCurrentUserSubsQuery = { __typename?: 'Query', serviceSubscriptionsByUserId?: { __typename?: 'ServiceSubscriptionConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean }, edges: Array<{ __typename?: 'ServiceSubscriptionNodeEdge', node: { __typename?: 'ServiceSubscriptionNode', expiration?: any | null, id: string, status: ServiceSubscriptionStatus, serviceName?: string | null, subscriptionDuration?: number | null, subscriptionPrice?: number | null, subscriptionCurrencyCode?: string | null, subscriptionCurrencySymbol?: string | null, channelId?: number | null, paymentMethodId?: number | null, isTrialUsed: boolean, createdAt: any, subscription?: { __typename?: 'SubscriptionNode', freeTrialPeriod?: number | null, service: { __typename?: 'ServiceNode', avatarUrl?: string | null, tipsterName?: string | null, status: ServiceStatus, paymentMethods?: Array<{ __typename?: 'PaymentMethods', id: string, paymentType?: { __typename?: 'PaymentType', id: string, paymentName: string, imageUrl: string, isAutoActivated: boolean } | null }> | null } } | null } }> } | null };

export type GetUserDataForChatQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetUserDataForChatQuery = { __typename?: 'Query', user: { __typename?: 'UserModel', avatarUrl?: string | null, displayName: string, id: string, role: UserRoles } };

export type GetTipsterFollowersQueryVariables = Exact<{
  tipsterId: Scalars['ID'];
}>;


export type GetTipsterFollowersQuery = { __typename?: 'Query', tipsterFollowers: number };

export type GetVerifiedEmailFromTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetVerifiedEmailFromTokenQuery = { __typename?: 'Query', verifyEmailToken: string };

export type GetSignupEmailFromTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetSignupEmailFromTokenQuery = { __typename?: 'Query', getSignupEmailFromToken?: { __typename?: 'UserTokenIdentity', email?: string | null } | null };

export type PollResultSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PollResultSubscriptionSubscription = { __typename?: 'Subscription', pollResult: string };

export const TipDetailedFieldsFragmentDoc = gql`
    fragment TipDetailedFields on TipDetailed {
  contentType
  analysis
  blocked
  bookieId
  bookieImageUrl
  buttonText
  bonusLink
  channelContentId
  commentsCount
  createdAt
  customBookieName
  deletedAt
  event {
    categoryId
    competitors {
      id
      name
      type
      imageUrl
    }
    createdAt
    deletedAt
    eventDate
    eventStatus
    eventType
    externalCategoryId
    externalId
    externalSportId
    externalTournamentId
    id
    oddType {
      externalId
      id
      name
      sportId
    }
    outcome {
      id
      name
      specialBetValue
      bookmakerName
    }
    sportId
    tournament {
      categoryId
      externalId
      id
      name
      imageUrl
    }
    tournamentId
    updatedAt
  }
  eventId
  id
  title
  isCommentsAllow
  isMultitip
  isSaved
  multitip
  odds
  outcomeId
  profit
  result
  stake
  updatedAt
  user {
    avatarUrl
    displayName
    id
  }
  vip
  votes {
    downvoteCount
    downvoted
    upvoteCount
    upvoted
  }
  sportId
  imageUrl
  videoUrl
  streamUrl
  audioUrl
  coverImageUrl
  isMultiPostTip
  isPostTip
  score {
    ft
    penalty
    sport
    total
  }
}
    `;
export const PostDetailedFieldsFragmentDoc = gql`
    fragment PostDetailedFields on PostDetailed {
  contentType
  category
  commentsCount
  content
  createdAt
  deletedAt
  id
  mediaLink
  isCommentsAllow
  title
  type
  updatedAt
  user {
    avatarUrl
    displayName
    id
  }
  votes {
    downvoteCount
    downvoted
    upvoteCount
    upvoted
  }
}
    `;
export const PollDetailedFieldsFragmentDoc = gql`
    fragment PollDetailedFields on PollDetailed {
  contentType
  category
  commentsCount
  createdAt
  deletedAt
  expirationDate
  id
  isCommentsAllow
  options {
    count
    createdAt
    deletedAt
    id
    option
    pollId
    position
    updatedAt
  }
  question
  updatedAt
  user {
    avatarUrl
    displayName
    id
  }
  userSelectedOptionId
  votes {
    downvoteCount
    downvoted
    upvoteCount
    upvoted
  }
}
    `;
export const MultitipDetailedFieldsFragmentDoc = gql`
    fragment MultitipDetailedFields on MultitipDetailed {
  contentType
  analysis
  blocked
  bookieId
  bookieImageUrl
  buttonText
  bonusLink
  channelContentId
  commentsCount
  createdAt
  customBookieName
  deletedAt
  id
  title
  isCommentsAllow
  isSaved
  odds
  outcomeId
  profit
  result
  stake
  tips {
    analysis
    blocked
    bookieId
    commentsCount
    createdAt
    customBookieName
    deletedAt
    event {
      categoryId
      competitors {
        id
        name
        type
        imageUrl
      }
      createdAt
      deletedAt
      eventDate
      eventStatus
      eventType
      externalCategoryId
      externalId
      externalSportId
      externalTournamentId
      id
      oddType {
        externalId
        id
        name
        sportId
      }
      outcome {
        id
        name
        specialBetValue
        bookmakerName
      }
      sportId
      tournament {
        categoryId
        externalId
        id
        name
        imageUrl
      }
      tournamentId
      updatedAt
    }
    eventId
    id
    title
    isCommentsAllow
    isMultitip
    multitip
    odds
    outcomeId
    profit
    result
    stake
    updatedAt
    user {
      avatarUrl
      displayName
      id
    }
    vip
    votes {
      downvoteCount
      downvoted
      upvoteCount
      upvoted
    }
    score {
      ft
      penalty
      sport
      total
    }
  }
  updatedAt
  userId
  vip
  streamUrl
  videoUrl
  audioUrl
  coverImageUrl
  votes {
    downvoteCount
    downvoted
    upvoteCount
    upvoted
  }
}
    `;
export const PinnedContentFieldsFragmentDoc = gql`
    fragment PinnedContentFields on PinnedContent {
  contentType
  description
  header
  id
}
    `;
export const ChannelDetailedFieldsFragmentDoc = gql`
    fragment ChannelDetailedFields on ChannelDetailed {
  anonymized
  background
  channelDeal
  channelName
  channelStatus
  channelType
  settings {
    name
    value
    category
    id
    scope
  }
  channelUsers {
    channelId
    channelRole
    createdAt
    id
    userId
  }
  countryId
  createdAt
  deletedAt
  feeForPayment
  id
  inviteLink
  logo
  paymentOptions
  pinnedContent {
    ...PinnedContentFields
  }
  pinnedContentId
  pinnedContentType
  tipsterCount
  trialSubscription
  updatedAt
  usersCount
  usersLimit
  isUserFollowing
}
    ${PinnedContentFieldsFragmentDoc}`;
export const LeaderboardEntryFieldsFragmentDoc = gql`
    fragment LeaderboardEntryFields on LeaderboardEntry {
  rank
  previousRank
  rankChange
  tipsterId
  displayName
  avatarUrl
  profit
  winRate
  roi
  totalTips
  won
  lost
  void
}
    `;
export const GrantExtendDocument = gql`
    mutation GrantExtend($grantId: String!, $additionalDays: Int!, $reason: String) {
  grantExtend(grantId: $grantId, additionalDays: $additionalDays, reason: $reason) {
    id
    status
    expiration
    updatedAt
  }
}
    `;
export type GrantExtendMutationFn = Apollo.MutationFunction<GrantExtendMutation, GrantExtendMutationVariables>;

/**
 * __useGrantExtendMutation__
 *
 * To run a mutation, you first call `useGrantExtendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantExtendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantExtendMutation, { data, loading, error }] = useGrantExtendMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *      additionalDays: // value for 'additionalDays'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useGrantExtendMutation(baseOptions?: Apollo.MutationHookOptions<GrantExtendMutation, GrantExtendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantExtendMutation, GrantExtendMutationVariables>(GrantExtendDocument, options);
      }
export type GrantExtendMutationHookResult = ReturnType<typeof useGrantExtendMutation>;
export type GrantExtendMutationResult = Apollo.MutationResult<GrantExtendMutation>;
export type GrantExtendMutationOptions = Apollo.BaseMutationOptions<GrantExtendMutation, GrantExtendMutationVariables>;
export const GrantActivateDocument = gql`
    mutation GrantActivate($grantId: String!) {
  grantActivate(grantId: $grantId) {
    id
    status
    expiration
    updatedAt
  }
}
    `;
export type GrantActivateMutationFn = Apollo.MutationFunction<GrantActivateMutation, GrantActivateMutationVariables>;

/**
 * __useGrantActivateMutation__
 *
 * To run a mutation, you first call `useGrantActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantActivateMutation, { data, loading, error }] = useGrantActivateMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *   },
 * });
 */
export function useGrantActivateMutation(baseOptions?: Apollo.MutationHookOptions<GrantActivateMutation, GrantActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantActivateMutation, GrantActivateMutationVariables>(GrantActivateDocument, options);
      }
export type GrantActivateMutationHookResult = ReturnType<typeof useGrantActivateMutation>;
export type GrantActivateMutationResult = Apollo.MutationResult<GrantActivateMutation>;
export type GrantActivateMutationOptions = Apollo.BaseMutationOptions<GrantActivateMutation, GrantActivateMutationVariables>;
export const GrantRevokeDocument = gql`
    mutation GrantRevoke($grantId: String!, $reason: String) {
  grantRevoke(grantId: $grantId, reason: $reason) {
    id
    status
    revokedBy
    revokedReason
    updatedAt
  }
}
    `;
export type GrantRevokeMutationFn = Apollo.MutationFunction<GrantRevokeMutation, GrantRevokeMutationVariables>;

/**
 * __useGrantRevokeMutation__
 *
 * To run a mutation, you first call `useGrantRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantRevokeMutation, { data, loading, error }] = useGrantRevokeMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useGrantRevokeMutation(baseOptions?: Apollo.MutationHookOptions<GrantRevokeMutation, GrantRevokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantRevokeMutation, GrantRevokeMutationVariables>(GrantRevokeDocument, options);
      }
export type GrantRevokeMutationHookResult = ReturnType<typeof useGrantRevokeMutation>;
export type GrantRevokeMutationResult = Apollo.MutationResult<GrantRevokeMutation>;
export type GrantRevokeMutationOptions = Apollo.BaseMutationOptions<GrantRevokeMutation, GrantRevokeMutationVariables>;
export const VipInviteCreateDocument = gql`
    mutation VipInviteCreate($planId: String!) {
  vipInviteCreate(planId: $planId) {
    id
    token
    shareUrl
    expiresAt
    isValid
    usedCount
  }
}
    `;
export type VipInviteCreateMutationFn = Apollo.MutationFunction<VipInviteCreateMutation, VipInviteCreateMutationVariables>;

/**
 * __useVipInviteCreateMutation__
 *
 * To run a mutation, you first call `useVipInviteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVipInviteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vipInviteCreateMutation, { data, loading, error }] = useVipInviteCreateMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useVipInviteCreateMutation(baseOptions?: Apollo.MutationHookOptions<VipInviteCreateMutation, VipInviteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VipInviteCreateMutation, VipInviteCreateMutationVariables>(VipInviteCreateDocument, options);
      }
export type VipInviteCreateMutationHookResult = ReturnType<typeof useVipInviteCreateMutation>;
export type VipInviteCreateMutationResult = Apollo.MutationResult<VipInviteCreateMutation>;
export type VipInviteCreateMutationOptions = Apollo.BaseMutationOptions<VipInviteCreateMutation, VipInviteCreateMutationVariables>;
export const VipInviteRevokeDocument = gql`
    mutation VipInviteRevoke($id: String!) {
  vipInviteRevoke(id: $id) {
    id
    isValid
  }
}
    `;
export type VipInviteRevokeMutationFn = Apollo.MutationFunction<VipInviteRevokeMutation, VipInviteRevokeMutationVariables>;

/**
 * __useVipInviteRevokeMutation__
 *
 * To run a mutation, you first call `useVipInviteRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVipInviteRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vipInviteRevokeMutation, { data, loading, error }] = useVipInviteRevokeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVipInviteRevokeMutation(baseOptions?: Apollo.MutationHookOptions<VipInviteRevokeMutation, VipInviteRevokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VipInviteRevokeMutation, VipInviteRevokeMutationVariables>(VipInviteRevokeDocument, options);
      }
export type VipInviteRevokeMutationHookResult = ReturnType<typeof useVipInviteRevokeMutation>;
export type VipInviteRevokeMutationResult = Apollo.MutationResult<VipInviteRevokeMutation>;
export type VipInviteRevokeMutationOptions = Apollo.BaseMutationOptions<VipInviteRevokeMutation, VipInviteRevokeMutationVariables>;
export const VipInviteRedeemDocument = gql`
    mutation VipInviteRedeem($token: String!) {
  vipInviteRedeem(token: $token) {
    invite {
      id
      isValid
      usedCount
    }
    grant {
      id
      status
      startedAt
      expiration
    }
  }
}
    `;
export type VipInviteRedeemMutationFn = Apollo.MutationFunction<VipInviteRedeemMutation, VipInviteRedeemMutationVariables>;

/**
 * __useVipInviteRedeemMutation__
 *
 * To run a mutation, you first call `useVipInviteRedeemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVipInviteRedeemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vipInviteRedeemMutation, { data, loading, error }] = useVipInviteRedeemMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVipInviteRedeemMutation(baseOptions?: Apollo.MutationHookOptions<VipInviteRedeemMutation, VipInviteRedeemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VipInviteRedeemMutation, VipInviteRedeemMutationVariables>(VipInviteRedeemDocument, options);
      }
export type VipInviteRedeemMutationHookResult = ReturnType<typeof useVipInviteRedeemMutation>;
export type VipInviteRedeemMutationResult = Apollo.MutationResult<VipInviteRedeemMutation>;
export type VipInviteRedeemMutationOptions = Apollo.BaseMutationOptions<VipInviteRedeemMutation, VipInviteRedeemMutationVariables>;
export const CreateAdvertDocument = gql`
    mutation CreateAdvert($input: AdsCreationInput!) {
  adsCreate(input: $input) {
    id
  }
}
    `;
export type CreateAdvertMutationFn = Apollo.MutationFunction<CreateAdvertMutation, CreateAdvertMutationVariables>;

/**
 * __useCreateAdvertMutation__
 *
 * To run a mutation, you first call `useCreateAdvertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdvertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdvertMutation, { data, loading, error }] = useCreateAdvertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdvertMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdvertMutation, CreateAdvertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdvertMutation, CreateAdvertMutationVariables>(CreateAdvertDocument, options);
      }
export type CreateAdvertMutationHookResult = ReturnType<typeof useCreateAdvertMutation>;
export type CreateAdvertMutationResult = Apollo.MutationResult<CreateAdvertMutation>;
export type CreateAdvertMutationOptions = Apollo.BaseMutationOptions<CreateAdvertMutation, CreateAdvertMutationVariables>;
export const UpdateAdvertDocument = gql`
    mutation UpdateAdvert($id: ID!, $input: AdsUpdate!) {
  adsUpdate(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateAdvertMutationFn = Apollo.MutationFunction<UpdateAdvertMutation, UpdateAdvertMutationVariables>;

/**
 * __useUpdateAdvertMutation__
 *
 * To run a mutation, you first call `useUpdateAdvertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvertMutation, { data, loading, error }] = useUpdateAdvertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdvertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdvertMutation, UpdateAdvertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdvertMutation, UpdateAdvertMutationVariables>(UpdateAdvertDocument, options);
      }
export type UpdateAdvertMutationHookResult = ReturnType<typeof useUpdateAdvertMutation>;
export type UpdateAdvertMutationResult = Apollo.MutationResult<UpdateAdvertMutation>;
export type UpdateAdvertMutationOptions = Apollo.BaseMutationOptions<UpdateAdvertMutation, UpdateAdvertMutationVariables>;
export const DeleteAdvertDocument = gql`
    mutation DeleteAdvert($id: ID!) {
  adsDelete(id: $id)
}
    `;
export type DeleteAdvertMutationFn = Apollo.MutationFunction<DeleteAdvertMutation, DeleteAdvertMutationVariables>;

/**
 * __useDeleteAdvertMutation__
 *
 * To run a mutation, you first call `useDeleteAdvertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdvertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdvertMutation, { data, loading, error }] = useDeleteAdvertMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdvertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdvertMutation, DeleteAdvertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdvertMutation, DeleteAdvertMutationVariables>(DeleteAdvertDocument, options);
      }
export type DeleteAdvertMutationHookResult = ReturnType<typeof useDeleteAdvertMutation>;
export type DeleteAdvertMutationResult = Apollo.MutationResult<DeleteAdvertMutation>;
export type DeleteAdvertMutationOptions = Apollo.BaseMutationOptions<DeleteAdvertMutation, DeleteAdvertMutationVariables>;
export const UploadAdvertImageDocument = gql`
    mutation UploadAdvertImage($file: Upload!) {
  adsImageUpload(file: $file)
}
    `;
export type UploadAdvertImageMutationFn = Apollo.MutationFunction<UploadAdvertImageMutation, UploadAdvertImageMutationVariables>;

/**
 * __useUploadAdvertImageMutation__
 *
 * To run a mutation, you first call `useUploadAdvertImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdvertImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAdvertImageMutation, { data, loading, error }] = useUploadAdvertImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAdvertImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadAdvertImageMutation, UploadAdvertImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAdvertImageMutation, UploadAdvertImageMutationVariables>(UploadAdvertImageDocument, options);
      }
export type UploadAdvertImageMutationHookResult = ReturnType<typeof useUploadAdvertImageMutation>;
export type UploadAdvertImageMutationResult = Apollo.MutationResult<UploadAdvertImageMutation>;
export type UploadAdvertImageMutationOptions = Apollo.BaseMutationOptions<UploadAdvertImageMutation, UploadAdvertImageMutationVariables>;
export const CreateBonusDocument = gql`
    mutation CreateBonus($input: BonusCreate!) {
  bonusCreate(input: $input) {
    id
  }
}
    `;
export type CreateBonusMutationFn = Apollo.MutationFunction<CreateBonusMutation, CreateBonusMutationVariables>;

/**
 * __useCreateBonusMutation__
 *
 * To run a mutation, you first call `useCreateBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBonusMutation, { data, loading, error }] = useCreateBonusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBonusMutation(baseOptions?: Apollo.MutationHookOptions<CreateBonusMutation, CreateBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBonusMutation, CreateBonusMutationVariables>(CreateBonusDocument, options);
      }
export type CreateBonusMutationHookResult = ReturnType<typeof useCreateBonusMutation>;
export type CreateBonusMutationResult = Apollo.MutationResult<CreateBonusMutation>;
export type CreateBonusMutationOptions = Apollo.BaseMutationOptions<CreateBonusMutation, CreateBonusMutationVariables>;
export const UpdateBonusDocument = gql`
    mutation UpdateBonus($id: String!, $input: BonusUpdate!) {
  bonusUpdate(id: $id, input: $input) {
    result
  }
}
    `;
export type UpdateBonusMutationFn = Apollo.MutationFunction<UpdateBonusMutation, UpdateBonusMutationVariables>;

/**
 * __useUpdateBonusMutation__
 *
 * To run a mutation, you first call `useUpdateBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBonusMutation, { data, loading, error }] = useUpdateBonusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBonusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBonusMutation, UpdateBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBonusMutation, UpdateBonusMutationVariables>(UpdateBonusDocument, options);
      }
export type UpdateBonusMutationHookResult = ReturnType<typeof useUpdateBonusMutation>;
export type UpdateBonusMutationResult = Apollo.MutationResult<UpdateBonusMutation>;
export type UpdateBonusMutationOptions = Apollo.BaseMutationOptions<UpdateBonusMutation, UpdateBonusMutationVariables>;
export const DeleteBonusDocument = gql`
    mutation DeleteBonus($id: String!) {
  bonusDelete(id: $id) {
    result
  }
}
    `;
export type DeleteBonusMutationFn = Apollo.MutationFunction<DeleteBonusMutation, DeleteBonusMutationVariables>;

/**
 * __useDeleteBonusMutation__
 *
 * To run a mutation, you first call `useDeleteBonusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBonusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBonusMutation, { data, loading, error }] = useDeleteBonusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBonusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBonusMutation, DeleteBonusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBonusMutation, DeleteBonusMutationVariables>(DeleteBonusDocument, options);
      }
export type DeleteBonusMutationHookResult = ReturnType<typeof useDeleteBonusMutation>;
export type DeleteBonusMutationResult = Apollo.MutationResult<DeleteBonusMutation>;
export type DeleteBonusMutationOptions = Apollo.BaseMutationOptions<DeleteBonusMutation, DeleteBonusMutationVariables>;
export const ReorderBonusesDocument = gql`
    mutation ReorderBonuses($orderedIds: [String!]!) {
  bonusReorder(orderedIds: $orderedIds) {
    result
  }
}
    `;
export type ReorderBonusesMutationFn = Apollo.MutationFunction<ReorderBonusesMutation, ReorderBonusesMutationVariables>;

/**
 * __useReorderBonusesMutation__
 *
 * To run a mutation, you first call `useReorderBonusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderBonusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderBonusesMutation, { data, loading, error }] = useReorderBonusesMutation({
 *   variables: {
 *      orderedIds: // value for 'orderedIds'
 *   },
 * });
 */
export function useReorderBonusesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderBonusesMutation, ReorderBonusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderBonusesMutation, ReorderBonusesMutationVariables>(ReorderBonusesDocument, options);
      }
export type ReorderBonusesMutationHookResult = ReturnType<typeof useReorderBonusesMutation>;
export type ReorderBonusesMutationResult = Apollo.MutationResult<ReorderBonusesMutation>;
export type ReorderBonusesMutationOptions = Apollo.BaseMutationOptions<ReorderBonusesMutation, ReorderBonusesMutationVariables>;
export const UpsertTenantBookieDocument = gql`
    mutation UpsertTenantBookie($input: UpsertTenantBookieInput!) {
  upsertTenantBookie(input: $input) {
    id
    bookieId
    externalId
    customName
    name
    title
    imageUrl
    bonusLink
    affiliateLink
    buttonText
    rewardType {
      id
      name
      iconName
    }
    rewardDescription
    isVisible
    isDefault
    isMandatory
    sortOrder
    allowedCountryIds
  }
}
    `;
export type UpsertTenantBookieMutationFn = Apollo.MutationFunction<UpsertTenantBookieMutation, UpsertTenantBookieMutationVariables>;

/**
 * __useUpsertTenantBookieMutation__
 *
 * To run a mutation, you first call `useUpsertTenantBookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTenantBookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTenantBookieMutation, { data, loading, error }] = useUpsertTenantBookieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTenantBookieMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTenantBookieMutation, UpsertTenantBookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTenantBookieMutation, UpsertTenantBookieMutationVariables>(UpsertTenantBookieDocument, options);
      }
export type UpsertTenantBookieMutationHookResult = ReturnType<typeof useUpsertTenantBookieMutation>;
export type UpsertTenantBookieMutationResult = Apollo.MutationResult<UpsertTenantBookieMutation>;
export type UpsertTenantBookieMutationOptions = Apollo.BaseMutationOptions<UpsertTenantBookieMutation, UpsertTenantBookieMutationVariables>;
export const DeleteTenantBookieDocument = gql`
    mutation DeleteTenantBookie($id: ID!) {
  deleteTenantBookie(id: $id) {
    result
  }
}
    `;
export type DeleteTenantBookieMutationFn = Apollo.MutationFunction<DeleteTenantBookieMutation, DeleteTenantBookieMutationVariables>;

/**
 * __useDeleteTenantBookieMutation__
 *
 * To run a mutation, you first call `useDeleteTenantBookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantBookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantBookieMutation, { data, loading, error }] = useDeleteTenantBookieMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTenantBookieMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantBookieMutation, DeleteTenantBookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantBookieMutation, DeleteTenantBookieMutationVariables>(DeleteTenantBookieDocument, options);
      }
export type DeleteTenantBookieMutationHookResult = ReturnType<typeof useDeleteTenantBookieMutation>;
export type DeleteTenantBookieMutationResult = Apollo.MutationResult<DeleteTenantBookieMutation>;
export type DeleteTenantBookieMutationOptions = Apollo.BaseMutationOptions<DeleteTenantBookieMutation, DeleteTenantBookieMutationVariables>;
export const SetDefaultTenantBookieDocument = gql`
    mutation SetDefaultTenantBookie($id: ID!) {
  setDefaultTenantBookie(id: $id) {
    result
  }
}
    `;
export type SetDefaultTenantBookieMutationFn = Apollo.MutationFunction<SetDefaultTenantBookieMutation, SetDefaultTenantBookieMutationVariables>;

/**
 * __useSetDefaultTenantBookieMutation__
 *
 * To run a mutation, you first call `useSetDefaultTenantBookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultTenantBookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultTenantBookieMutation, { data, loading, error }] = useSetDefaultTenantBookieMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultTenantBookieMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultTenantBookieMutation, SetDefaultTenantBookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultTenantBookieMutation, SetDefaultTenantBookieMutationVariables>(SetDefaultTenantBookieDocument, options);
      }
export type SetDefaultTenantBookieMutationHookResult = ReturnType<typeof useSetDefaultTenantBookieMutation>;
export type SetDefaultTenantBookieMutationResult = Apollo.MutationResult<SetDefaultTenantBookieMutation>;
export type SetDefaultTenantBookieMutationOptions = Apollo.BaseMutationOptions<SetDefaultTenantBookieMutation, SetDefaultTenantBookieMutationVariables>;
export const ReorderTenantBookiesDocument = gql`
    mutation ReorderTenantBookies($items: [TenantBookieOrderItem!]!) {
  reorderTenantBookies(items: $items) {
    result
  }
}
    `;
export type ReorderTenantBookiesMutationFn = Apollo.MutationFunction<ReorderTenantBookiesMutation, ReorderTenantBookiesMutationVariables>;

/**
 * __useReorderTenantBookiesMutation__
 *
 * To run a mutation, you first call `useReorderTenantBookiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTenantBookiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTenantBookiesMutation, { data, loading, error }] = useReorderTenantBookiesMutation({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useReorderTenantBookiesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderTenantBookiesMutation, ReorderTenantBookiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderTenantBookiesMutation, ReorderTenantBookiesMutationVariables>(ReorderTenantBookiesDocument, options);
      }
export type ReorderTenantBookiesMutationHookResult = ReturnType<typeof useReorderTenantBookiesMutation>;
export type ReorderTenantBookiesMutationResult = Apollo.MutationResult<ReorderTenantBookiesMutation>;
export type ReorderTenantBookiesMutationOptions = Apollo.BaseMutationOptions<ReorderTenantBookiesMutation, ReorderTenantBookiesMutationVariables>;
export const SetFavoriteBookieDocument = gql`
    mutation SetFavoriteBookie($tenantBookieId: ID!) {
  setFavoriteBookie(tenantBookieId: $tenantBookieId) {
    id
    tenantBookieId
  }
}
    `;
export type SetFavoriteBookieMutationFn = Apollo.MutationFunction<SetFavoriteBookieMutation, SetFavoriteBookieMutationVariables>;

/**
 * __useSetFavoriteBookieMutation__
 *
 * To run a mutation, you first call `useSetFavoriteBookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFavoriteBookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFavoriteBookieMutation, { data, loading, error }] = useSetFavoriteBookieMutation({
 *   variables: {
 *      tenantBookieId: // value for 'tenantBookieId'
 *   },
 * });
 */
export function useSetFavoriteBookieMutation(baseOptions?: Apollo.MutationHookOptions<SetFavoriteBookieMutation, SetFavoriteBookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFavoriteBookieMutation, SetFavoriteBookieMutationVariables>(SetFavoriteBookieDocument, options);
      }
export type SetFavoriteBookieMutationHookResult = ReturnType<typeof useSetFavoriteBookieMutation>;
export type SetFavoriteBookieMutationResult = Apollo.MutationResult<SetFavoriteBookieMutation>;
export type SetFavoriteBookieMutationOptions = Apollo.BaseMutationOptions<SetFavoriteBookieMutation, SetFavoriteBookieMutationVariables>;
export const FollowChannelDocument = gql`
    mutation FollowChannel($channelId: String!) {
  followChannel(channelId: $channelId) {
    result
  }
}
    `;
export type FollowChannelMutationFn = Apollo.MutationFunction<FollowChannelMutation, FollowChannelMutationVariables>;

/**
 * __useFollowChannelMutation__
 *
 * To run a mutation, you first call `useFollowChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followChannelMutation, { data, loading, error }] = useFollowChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useFollowChannelMutation(baseOptions?: Apollo.MutationHookOptions<FollowChannelMutation, FollowChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowChannelMutation, FollowChannelMutationVariables>(FollowChannelDocument, options);
      }
export type FollowChannelMutationHookResult = ReturnType<typeof useFollowChannelMutation>;
export type FollowChannelMutationResult = Apollo.MutationResult<FollowChannelMutation>;
export type FollowChannelMutationOptions = Apollo.BaseMutationOptions<FollowChannelMutation, FollowChannelMutationVariables>;
export const UnfollowChannelDocument = gql`
    mutation UnfollowChannel($channelId: String!) {
  unfollowChannel(channelId: $channelId) {
    result
  }
}
    `;
export type UnfollowChannelMutationFn = Apollo.MutationFunction<UnfollowChannelMutation, UnfollowChannelMutationVariables>;

/**
 * __useUnfollowChannelMutation__
 *
 * To run a mutation, you first call `useUnfollowChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowChannelMutation, { data, loading, error }] = useUnfollowChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useUnfollowChannelMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowChannelMutation, UnfollowChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowChannelMutation, UnfollowChannelMutationVariables>(UnfollowChannelDocument, options);
      }
export type UnfollowChannelMutationHookResult = ReturnType<typeof useUnfollowChannelMutation>;
export type UnfollowChannelMutationResult = Apollo.MutationResult<UnfollowChannelMutation>;
export type UnfollowChannelMutationOptions = Apollo.BaseMutationOptions<UnfollowChannelMutation, UnfollowChannelMutationVariables>;
export const PinContentDocument = gql`
    mutation PinContent($channelId: String!, $contentId: String!, $contentType: typesOfContent!) {
  pinContent(
    channelId: $channelId
    contentId: $contentId
    contentType: $contentType
  ) {
    updated
  }
}
    `;
export type PinContentMutationFn = Apollo.MutationFunction<PinContentMutation, PinContentMutationVariables>;

/**
 * __usePinContentMutation__
 *
 * To run a mutation, you first call `usePinContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinContentMutation, { data, loading, error }] = usePinContentMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      contentId: // value for 'contentId'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function usePinContentMutation(baseOptions?: Apollo.MutationHookOptions<PinContentMutation, PinContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PinContentMutation, PinContentMutationVariables>(PinContentDocument, options);
      }
export type PinContentMutationHookResult = ReturnType<typeof usePinContentMutation>;
export type PinContentMutationResult = Apollo.MutationResult<PinContentMutation>;
export type PinContentMutationOptions = Apollo.BaseMutationOptions<PinContentMutation, PinContentMutationVariables>;
export const UnpinContentDocument = gql`
    mutation UnpinContent($channelId: String!) {
  unpinContent(channelId: $channelId) {
    updated
  }
}
    `;
export type UnpinContentMutationFn = Apollo.MutationFunction<UnpinContentMutation, UnpinContentMutationVariables>;

/**
 * __useUnpinContentMutation__
 *
 * To run a mutation, you first call `useUnpinContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinContentMutation, { data, loading, error }] = useUnpinContentMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useUnpinContentMutation(baseOptions?: Apollo.MutationHookOptions<UnpinContentMutation, UnpinContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinContentMutation, UnpinContentMutationVariables>(UnpinContentDocument, options);
      }
export type UnpinContentMutationHookResult = ReturnType<typeof useUnpinContentMutation>;
export type UnpinContentMutationResult = Apollo.MutationResult<UnpinContentMutation>;
export type UnpinContentMutationOptions = Apollo.BaseMutationOptions<UnpinContentMutation, UnpinContentMutationVariables>;
export const ChannelUpdateDocument = gql`
    mutation ChannelUpdate($channelId: String!, $input: ChannelUpdate!) {
  channelUpdate(channelId: $channelId, input: $input) {
    updated
  }
}
    `;
export type ChannelUpdateMutationFn = Apollo.MutationFunction<ChannelUpdateMutation, ChannelUpdateMutationVariables>;

/**
 * __useChannelUpdateMutation__
 *
 * To run a mutation, you first call `useChannelUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChannelUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [channelUpdateMutation, { data, loading, error }] = useChannelUpdateMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChannelUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ChannelUpdateMutation, ChannelUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChannelUpdateMutation, ChannelUpdateMutationVariables>(ChannelUpdateDocument, options);
      }
export type ChannelUpdateMutationHookResult = ReturnType<typeof useChannelUpdateMutation>;
export type ChannelUpdateMutationResult = Apollo.MutationResult<ChannelUpdateMutation>;
export type ChannelUpdateMutationOptions = Apollo.BaseMutationOptions<ChannelUpdateMutation, ChannelUpdateMutationVariables>;
export const FollowChannelByInviteLinkDocument = gql`
    mutation FollowChannelByInviteLink($inviteLink: String!) {
  followChannelByInviteLink(inviteLink: $inviteLink) {
    result
  }
}
    `;
export type FollowChannelByInviteLinkMutationFn = Apollo.MutationFunction<FollowChannelByInviteLinkMutation, FollowChannelByInviteLinkMutationVariables>;

/**
 * __useFollowChannelByInviteLinkMutation__
 *
 * To run a mutation, you first call `useFollowChannelByInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowChannelByInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followChannelByInviteLinkMutation, { data, loading, error }] = useFollowChannelByInviteLinkMutation({
 *   variables: {
 *      inviteLink: // value for 'inviteLink'
 *   },
 * });
 */
export function useFollowChannelByInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<FollowChannelByInviteLinkMutation, FollowChannelByInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowChannelByInviteLinkMutation, FollowChannelByInviteLinkMutationVariables>(FollowChannelByInviteLinkDocument, options);
      }
export type FollowChannelByInviteLinkMutationHookResult = ReturnType<typeof useFollowChannelByInviteLinkMutation>;
export type FollowChannelByInviteLinkMutationResult = Apollo.MutationResult<FollowChannelByInviteLinkMutation>;
export type FollowChannelByInviteLinkMutationOptions = Apollo.BaseMutationOptions<FollowChannelByInviteLinkMutation, FollowChannelByInviteLinkMutationVariables>;
export const CreateChannelDocument = gql`
    mutation CreateChannel($input: ChannelCreate!) {
  channelCreate(input: $input) {
    id
  }
}
    `;
export type CreateChannelMutationFn = Apollo.MutationFunction<CreateChannelMutation, CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMutation, CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<CreateChannelMutation, CreateChannelMutationVariables>;
export const AssignTipsterChannelDocument = gql`
    mutation AssignTipsterChannel($channelId: String!, $tipsterId: String!) {
  addTipsterToChannel(channelId: $channelId, tipsterId: $tipsterId) {
    result
  }
}
    `;
export type AssignTipsterChannelMutationFn = Apollo.MutationFunction<AssignTipsterChannelMutation, AssignTipsterChannelMutationVariables>;

/**
 * __useAssignTipsterChannelMutation__
 *
 * To run a mutation, you first call `useAssignTipsterChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTipsterChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTipsterChannelMutation, { data, loading, error }] = useAssignTipsterChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useAssignTipsterChannelMutation(baseOptions?: Apollo.MutationHookOptions<AssignTipsterChannelMutation, AssignTipsterChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTipsterChannelMutation, AssignTipsterChannelMutationVariables>(AssignTipsterChannelDocument, options);
      }
export type AssignTipsterChannelMutationHookResult = ReturnType<typeof useAssignTipsterChannelMutation>;
export type AssignTipsterChannelMutationResult = Apollo.MutationResult<AssignTipsterChannelMutation>;
export type AssignTipsterChannelMutationOptions = Apollo.BaseMutationOptions<AssignTipsterChannelMutation, AssignTipsterChannelMutationVariables>;
export const RemoveTipsterFromChannelDocument = gql`
    mutation RemoveTipsterFromChannel($channelId: String!, $tipsterId: String!) {
  deleteTipsterFromChannel(channelId: $channelId, tipsterId: $tipsterId) {
    result
  }
}
    `;
export type RemoveTipsterFromChannelMutationFn = Apollo.MutationFunction<RemoveTipsterFromChannelMutation, RemoveTipsterFromChannelMutationVariables>;

/**
 * __useRemoveTipsterFromChannelMutation__
 *
 * To run a mutation, you first call `useRemoveTipsterFromChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTipsterFromChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTipsterFromChannelMutation, { data, loading, error }] = useRemoveTipsterFromChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useRemoveTipsterFromChannelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTipsterFromChannelMutation, RemoveTipsterFromChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTipsterFromChannelMutation, RemoveTipsterFromChannelMutationVariables>(RemoveTipsterFromChannelDocument, options);
      }
export type RemoveTipsterFromChannelMutationHookResult = ReturnType<typeof useRemoveTipsterFromChannelMutation>;
export type RemoveTipsterFromChannelMutationResult = Apollo.MutationResult<RemoveTipsterFromChannelMutation>;
export type RemoveTipsterFromChannelMutationOptions = Apollo.BaseMutationOptions<RemoveTipsterFromChannelMutation, RemoveTipsterFromChannelMutationVariables>;
export const ChatAcceptDocument = gql`
    mutation ChatAccept($id: Float!) {
  chatAccept(id: $id) {
    accepted
    createdAt
    email
    id
    receiverId
    senderId
    subject
  }
}
    `;
export type ChatAcceptMutationFn = Apollo.MutationFunction<ChatAcceptMutation, ChatAcceptMutationVariables>;

/**
 * __useChatAcceptMutation__
 *
 * To run a mutation, you first call `useChatAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatAcceptMutation, { data, loading, error }] = useChatAcceptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatAcceptMutation(baseOptions?: Apollo.MutationHookOptions<ChatAcceptMutation, ChatAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatAcceptMutation, ChatAcceptMutationVariables>(ChatAcceptDocument, options);
      }
export type ChatAcceptMutationHookResult = ReturnType<typeof useChatAcceptMutation>;
export type ChatAcceptMutationResult = Apollo.MutationResult<ChatAcceptMutation>;
export type ChatAcceptMutationOptions = Apollo.BaseMutationOptions<ChatAcceptMutation, ChatAcceptMutationVariables>;
export const ChatCreateDocument = gql`
    mutation ChatCreate($input: ChatCreate!) {
  chatCreate(input: $input) {
    accepted
    createdAt
    email
    id
    receiverId
    senderId
    subject
  }
}
    `;
export type ChatCreateMutationFn = Apollo.MutationFunction<ChatCreateMutation, ChatCreateMutationVariables>;

/**
 * __useChatCreateMutation__
 *
 * To run a mutation, you first call `useChatCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatCreateMutation, { data, loading, error }] = useChatCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatCreateMutation(baseOptions?: Apollo.MutationHookOptions<ChatCreateMutation, ChatCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatCreateMutation, ChatCreateMutationVariables>(ChatCreateDocument, options);
      }
export type ChatCreateMutationHookResult = ReturnType<typeof useChatCreateMutation>;
export type ChatCreateMutationResult = Apollo.MutationResult<ChatCreateMutation>;
export type ChatCreateMutationOptions = Apollo.BaseMutationOptions<ChatCreateMutation, ChatCreateMutationVariables>;
export const ChatReadMessagesDocument = gql`
    mutation ChatReadMessages($chatId: ID!) {
  chatReadMessages(chatId: $chatId) {
    id
  }
}
    `;
export type ChatReadMessagesMutationFn = Apollo.MutationFunction<ChatReadMessagesMutation, ChatReadMessagesMutationVariables>;

/**
 * __useChatReadMessagesMutation__
 *
 * To run a mutation, you first call `useChatReadMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatReadMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatReadMessagesMutation, { data, loading, error }] = useChatReadMessagesMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatReadMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ChatReadMessagesMutation, ChatReadMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatReadMessagesMutation, ChatReadMessagesMutationVariables>(ChatReadMessagesDocument, options);
      }
export type ChatReadMessagesMutationHookResult = ReturnType<typeof useChatReadMessagesMutation>;
export type ChatReadMessagesMutationResult = Apollo.MutationResult<ChatReadMessagesMutation>;
export type ChatReadMessagesMutationOptions = Apollo.BaseMutationOptions<ChatReadMessagesMutation, ChatReadMessagesMutationVariables>;
export const MessageCreateDocument = gql`
    mutation MessageCreate($input: MessageCreate!) {
  messageCreate(input: $input) {
    chatId
    createdAt
    id
    imageUrl
    senderId
    text
  }
}
    `;
export type MessageCreateMutationFn = Apollo.MutationFunction<MessageCreateMutation, MessageCreateMutationVariables>;

/**
 * __useMessageCreateMutation__
 *
 * To run a mutation, you first call `useMessageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageCreateMutation, { data, loading, error }] = useMessageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageCreateMutation(baseOptions?: Apollo.MutationHookOptions<MessageCreateMutation, MessageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MessageCreateMutation, MessageCreateMutationVariables>(MessageCreateDocument, options);
      }
export type MessageCreateMutationHookResult = ReturnType<typeof useMessageCreateMutation>;
export type MessageCreateMutationResult = Apollo.MutationResult<MessageCreateMutation>;
export type MessageCreateMutationOptions = Apollo.BaseMutationOptions<MessageCreateMutation, MessageCreateMutationVariables>;
export const CreateSupportChatDocument = gql`
    mutation CreateSupportChat($input: SupportChatCreate!) {
  supportChatCreate(input: $input) {
    id
  }
}
    `;
export type CreateSupportChatMutationFn = Apollo.MutationFunction<CreateSupportChatMutation, CreateSupportChatMutationVariables>;

/**
 * __useCreateSupportChatMutation__
 *
 * To run a mutation, you first call `useCreateSupportChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportChatMutation, { data, loading, error }] = useCreateSupportChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupportChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportChatMutation, CreateSupportChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportChatMutation, CreateSupportChatMutationVariables>(CreateSupportChatDocument, options);
      }
export type CreateSupportChatMutationHookResult = ReturnType<typeof useCreateSupportChatMutation>;
export type CreateSupportChatMutationResult = Apollo.MutationResult<CreateSupportChatMutation>;
export type CreateSupportChatMutationOptions = Apollo.BaseMutationOptions<CreateSupportChatMutation, CreateSupportChatMutationVariables>;
export const ReadManyMessagesDocument = gql`
    mutation ReadManyMessages($chatId: [ID!]!) {
  chatReadManyMessages(chatId: $chatId)
}
    `;
export type ReadManyMessagesMutationFn = Apollo.MutationFunction<ReadManyMessagesMutation, ReadManyMessagesMutationVariables>;

/**
 * __useReadManyMessagesMutation__
 *
 * To run a mutation, you first call `useReadManyMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadManyMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readManyMessagesMutation, { data, loading, error }] = useReadManyMessagesMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useReadManyMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ReadManyMessagesMutation, ReadManyMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadManyMessagesMutation, ReadManyMessagesMutationVariables>(ReadManyMessagesDocument, options);
      }
export type ReadManyMessagesMutationHookResult = ReturnType<typeof useReadManyMessagesMutation>;
export type ReadManyMessagesMutationResult = Apollo.MutationResult<ReadManyMessagesMutation>;
export type ReadManyMessagesMutationOptions = Apollo.BaseMutationOptions<ReadManyMessagesMutation, ReadManyMessagesMutationVariables>;
export const CommentCreateDocument = gql`
    mutation CommentCreate($input: CommentCreateInput!) {
  commentCreate(input: $input) {
    contentId
    contentType
    createdAt
    deletedAt
    id
    text
    updatedAt
    userId
    imageLink
  }
}
    `;
export type CommentCreateMutationFn = Apollo.MutationFunction<CommentCreateMutation, CommentCreateMutationVariables>;

/**
 * __useCommentCreateMutation__
 *
 * To run a mutation, you first call `useCommentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentCreateMutation, { data, loading, error }] = useCommentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentCreateMutation(baseOptions?: Apollo.MutationHookOptions<CommentCreateMutation, CommentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentCreateMutation, CommentCreateMutationVariables>(CommentCreateDocument, options);
      }
export type CommentCreateMutationHookResult = ReturnType<typeof useCommentCreateMutation>;
export type CommentCreateMutationResult = Apollo.MutationResult<CommentCreateMutation>;
export type CommentCreateMutationOptions = Apollo.BaseMutationOptions<CommentCreateMutation, CommentCreateMutationVariables>;
export const CommentUpdateDocument = gql`
    mutation CommentUpdate($commentUpdateId: ID!, $input: CommentUpdateInput!) {
  commentUpdate(id: $commentUpdateId, input: $input) {
    contentId
    contentType
    createdAt
    deletedAt
    id
    text
    updatedAt
    userId
    imageLink
  }
}
    `;
export type CommentUpdateMutationFn = Apollo.MutationFunction<CommentUpdateMutation, CommentUpdateMutationVariables>;

/**
 * __useCommentUpdateMutation__
 *
 * To run a mutation, you first call `useCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentUpdateMutation, { data, loading, error }] = useCommentUpdateMutation({
 *   variables: {
 *      commentUpdateId: // value for 'commentUpdateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CommentUpdateMutation, CommentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentUpdateMutation, CommentUpdateMutationVariables>(CommentUpdateDocument, options);
      }
export type CommentUpdateMutationHookResult = ReturnType<typeof useCommentUpdateMutation>;
export type CommentUpdateMutationResult = Apollo.MutationResult<CommentUpdateMutation>;
export type CommentUpdateMutationOptions = Apollo.BaseMutationOptions<CommentUpdateMutation, CommentUpdateMutationVariables>;
export const CommentDeleteDocument = gql`
    mutation CommentDelete($commentDeleteId: ID!) {
  commentDelete(id: $commentDeleteId)
}
    `;
export type CommentDeleteMutationFn = Apollo.MutationFunction<CommentDeleteMutation, CommentDeleteMutationVariables>;

/**
 * __useCommentDeleteMutation__
 *
 * To run a mutation, you first call `useCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentDeleteMutation, { data, loading, error }] = useCommentDeleteMutation({
 *   variables: {
 *      commentDeleteId: // value for 'commentDeleteId'
 *   },
 * });
 */
export function useCommentDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CommentDeleteMutation, CommentDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentDeleteMutation, CommentDeleteMutationVariables>(CommentDeleteDocument, options);
      }
export type CommentDeleteMutationHookResult = ReturnType<typeof useCommentDeleteMutation>;
export type CommentDeleteMutationResult = Apollo.MutationResult<CommentDeleteMutation>;
export type CommentDeleteMutationOptions = Apollo.BaseMutationOptions<CommentDeleteMutation, CommentDeleteMutationVariables>;
export const CompetitionVoteDocument = gql`
    mutation CompetitionVote($competitionId: ID!, $outcomeId: ID!, $eventId: ID!) {
  competitionVote(
    competitionId: $competitionId
    outcomeId: $outcomeId
    eventId: $eventId
  ) {
    id
  }
}
    `;
export type CompetitionVoteMutationFn = Apollo.MutationFunction<CompetitionVoteMutation, CompetitionVoteMutationVariables>;

/**
 * __useCompetitionVoteMutation__
 *
 * To run a mutation, you first call `useCompetitionVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompetitionVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [competitionVoteMutation, { data, loading, error }] = useCompetitionVoteMutation({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *      outcomeId: // value for 'outcomeId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCompetitionVoteMutation(baseOptions?: Apollo.MutationHookOptions<CompetitionVoteMutation, CompetitionVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompetitionVoteMutation, CompetitionVoteMutationVariables>(CompetitionVoteDocument, options);
      }
export type CompetitionVoteMutationHookResult = ReturnType<typeof useCompetitionVoteMutation>;
export type CompetitionVoteMutationResult = Apollo.MutationResult<CompetitionVoteMutation>;
export type CompetitionVoteMutationOptions = Apollo.BaseMutationOptions<CompetitionVoteMutation, CompetitionVoteMutationVariables>;
export const CreateCompetitionDocument = gql`
    mutation CreateCompetition($competition: CompetitionCreate!) {
  createCompetition(competition: $competition) {
    id
    competitionType
    rankingMetric
    minimumSettledTips
    rankingSportIds
    termsAndconditions
    termsAndconditionsLink
    vip
    blocked
    name
    description
    maxParticipants
    startAt
    endAt
    cta
    status
    rewards {
      title
      position: id
    }
  }
}
    `;
export type CreateCompetitionMutationFn = Apollo.MutationFunction<CreateCompetitionMutation, CreateCompetitionMutationVariables>;

/**
 * __useCreateCompetitionMutation__
 *
 * To run a mutation, you first call `useCreateCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetitionMutation, { data, loading, error }] = useCreateCompetitionMutation({
 *   variables: {
 *      competition: // value for 'competition'
 *   },
 * });
 */
export function useCreateCompetitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetitionMutation, CreateCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetitionMutation, CreateCompetitionMutationVariables>(CreateCompetitionDocument, options);
      }
export type CreateCompetitionMutationHookResult = ReturnType<typeof useCreateCompetitionMutation>;
export type CreateCompetitionMutationResult = Apollo.MutationResult<CreateCompetitionMutation>;
export type CreateCompetitionMutationOptions = Apollo.BaseMutationOptions<CreateCompetitionMutation, CreateCompetitionMutationVariables>;
export const DeleteCompetitionDocument = gql`
    mutation DeleteCompetition($competitionId: ID!) {
  deleteCompetition(competitionId: $competitionId)
}
    `;
export type DeleteCompetitionMutationFn = Apollo.MutationFunction<DeleteCompetitionMutation, DeleteCompetitionMutationVariables>;

/**
 * __useDeleteCompetitionMutation__
 *
 * To run a mutation, you first call `useDeleteCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompetitionMutation, { data, loading, error }] = useDeleteCompetitionMutation({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *   },
 * });
 */
export function useDeleteCompetitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompetitionMutation, DeleteCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompetitionMutation, DeleteCompetitionMutationVariables>(DeleteCompetitionDocument, options);
      }
export type DeleteCompetitionMutationHookResult = ReturnType<typeof useDeleteCompetitionMutation>;
export type DeleteCompetitionMutationResult = Apollo.MutationResult<DeleteCompetitionMutation>;
export type DeleteCompetitionMutationOptions = Apollo.BaseMutationOptions<DeleteCompetitionMutation, DeleteCompetitionMutationVariables>;
export const EditCompetitionDocument = gql`
    mutation EditCompetition($competitionId: ID!, $update: CompetitionUpdate!) {
  editCompetition(competitionId: $competitionId, update: $update) {
    id
    competitionType
    rankingMetric
    minimumSettledTips
    rankingSportIds
    name
    description
    imageUrl
    maxParticipants
    startAt
    endAt
    cta
    vip
    termsAndconditions
    termsAndconditionsLink
    eligibleCountries
    rewards {
      id
      title
      description
      reward
    }
  }
}
    `;
export type EditCompetitionMutationFn = Apollo.MutationFunction<EditCompetitionMutation, EditCompetitionMutationVariables>;

/**
 * __useEditCompetitionMutation__
 *
 * To run a mutation, you first call `useEditCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompetitionMutation, { data, loading, error }] = useEditCompetitionMutation({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useEditCompetitionMutation(baseOptions?: Apollo.MutationHookOptions<EditCompetitionMutation, EditCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompetitionMutation, EditCompetitionMutationVariables>(EditCompetitionDocument, options);
      }
export type EditCompetitionMutationHookResult = ReturnType<typeof useEditCompetitionMutation>;
export type EditCompetitionMutationResult = Apollo.MutationResult<EditCompetitionMutation>;
export type EditCompetitionMutationOptions = Apollo.BaseMutationOptions<EditCompetitionMutation, EditCompetitionMutationVariables>;
export const VoteOutcomeDocument = gql`
    mutation VoteOutcome($eventOutcomeId: ID!) {
  vote(eventOutcomeId: $eventOutcomeId)
}
    `;
export type VoteOutcomeMutationFn = Apollo.MutationFunction<VoteOutcomeMutation, VoteOutcomeMutationVariables>;

/**
 * __useVoteOutcomeMutation__
 *
 * To run a mutation, you first call `useVoteOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteOutcomeMutation, { data, loading, error }] = useVoteOutcomeMutation({
 *   variables: {
 *      eventOutcomeId: // value for 'eventOutcomeId'
 *   },
 * });
 */
export function useVoteOutcomeMutation(baseOptions?: Apollo.MutationHookOptions<VoteOutcomeMutation, VoteOutcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteOutcomeMutation, VoteOutcomeMutationVariables>(VoteOutcomeDocument, options);
      }
export type VoteOutcomeMutationHookResult = ReturnType<typeof useVoteOutcomeMutation>;
export type VoteOutcomeMutationResult = Apollo.MutationResult<VoteOutcomeMutation>;
export type VoteOutcomeMutationOptions = Apollo.BaseMutationOptions<VoteOutcomeMutation, VoteOutcomeMutationVariables>;
export const PollCreateDocument = gql`
    mutation PollCreate($input: PollCreate!, $channelIds: [ID!]!) {
  pollCreate(input: $input, channelIds: $channelIds) {
    ...PollDetailedFields
  }
}
    ${PollDetailedFieldsFragmentDoc}`;
export type PollCreateMutationFn = Apollo.MutationFunction<PollCreateMutation, PollCreateMutationVariables>;

/**
 * __usePollCreateMutation__
 *
 * To run a mutation, you first call `usePollCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollCreateMutation, { data, loading, error }] = usePollCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function usePollCreateMutation(baseOptions?: Apollo.MutationHookOptions<PollCreateMutation, PollCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollCreateMutation, PollCreateMutationVariables>(PollCreateDocument, options);
      }
export type PollCreateMutationHookResult = ReturnType<typeof usePollCreateMutation>;
export type PollCreateMutationResult = Apollo.MutationResult<PollCreateMutation>;
export type PollCreateMutationOptions = Apollo.BaseMutationOptions<PollCreateMutation, PollCreateMutationVariables>;
export const PollVoteDocument = gql`
    mutation PollVote($pollId: ID!, $selectedOptionId: ID!) {
  pollVote(pollId: $pollId, selectedOptionId: $selectedOptionId) {
    votes {
      id
      selectedOptionId
      userId
    }
    options {
      count
      createdAt
      deletedAt
      option
      id
      pollId
      position
      updatedAt
    }
  }
}
    `;
export type PollVoteMutationFn = Apollo.MutationFunction<PollVoteMutation, PollVoteMutationVariables>;

/**
 * __usePollVoteMutation__
 *
 * To run a mutation, you first call `usePollVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollVoteMutation, { data, loading, error }] = usePollVoteMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      selectedOptionId: // value for 'selectedOptionId'
 *   },
 * });
 */
export function usePollVoteMutation(baseOptions?: Apollo.MutationHookOptions<PollVoteMutation, PollVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollVoteMutation, PollVoteMutationVariables>(PollVoteDocument, options);
      }
export type PollVoteMutationHookResult = ReturnType<typeof usePollVoteMutation>;
export type PollVoteMutationResult = Apollo.MutationResult<PollVoteMutation>;
export type PollVoteMutationOptions = Apollo.BaseMutationOptions<PollVoteMutation, PollVoteMutationVariables>;
export const PollDeleteDocument = gql`
    mutation PollDelete($channelId: String!, $pollDeleteId: ID!) {
  pollDelete(id: $pollDeleteId, channelId: $channelId)
}
    `;
export type PollDeleteMutationFn = Apollo.MutationFunction<PollDeleteMutation, PollDeleteMutationVariables>;

/**
 * __usePollDeleteMutation__
 *
 * To run a mutation, you first call `usePollDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollDeleteMutation, { data, loading, error }] = usePollDeleteMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      pollDeleteId: // value for 'pollDeleteId'
 *   },
 * });
 */
export function usePollDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PollDeleteMutation, PollDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollDeleteMutation, PollDeleteMutationVariables>(PollDeleteDocument, options);
      }
export type PollDeleteMutationHookResult = ReturnType<typeof usePollDeleteMutation>;
export type PollDeleteMutationResult = Apollo.MutationResult<PollDeleteMutation>;
export type PollDeleteMutationOptions = Apollo.BaseMutationOptions<PollDeleteMutation, PollDeleteMutationVariables>;
export const PollUpdateDocument = gql`
    mutation PollUpdate($pollUpdateId: ID!, $input: PollUpdate!) {
  pollUpdate(id: $pollUpdateId, input: $input) {
    category
    createdAt
    expirationDate
    id
    isCommentsAllow
    options {
      count
      createdAt
      deletedAt
      id
      option
      pollId
      position
      updatedAt
    }
    question
    updatedAt
    upvoted
    userId
    downvoted
  }
}
    `;
export type PollUpdateMutationFn = Apollo.MutationFunction<PollUpdateMutation, PollUpdateMutationVariables>;

/**
 * __usePollUpdateMutation__
 *
 * To run a mutation, you first call `usePollUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePollUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pollUpdateMutation, { data, loading, error }] = usePollUpdateMutation({
 *   variables: {
 *      pollUpdateId: // value for 'pollUpdateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePollUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PollUpdateMutation, PollUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PollUpdateMutation, PollUpdateMutationVariables>(PollUpdateDocument, options);
      }
export type PollUpdateMutationHookResult = ReturnType<typeof usePollUpdateMutation>;
export type PollUpdateMutationResult = Apollo.MutationResult<PollUpdateMutation>;
export type PollUpdateMutationOptions = Apollo.BaseMutationOptions<PollUpdateMutation, PollUpdateMutationVariables>;
export const PostCreateDocument = gql`
    mutation PostCreate($input: PostCreateInput!, $channelIds: [ID!]!) {
  postCreate(input: $input, channelIds: $channelIds) {
    ...PostDetailedFields
  }
}
    ${PostDetailedFieldsFragmentDoc}`;
export type PostCreateMutationFn = Apollo.MutationFunction<PostCreateMutation, PostCreateMutationVariables>;

/**
 * __usePostCreateMutation__
 *
 * To run a mutation, you first call `usePostCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCreateMutation, { data, loading, error }] = usePostCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function usePostCreateMutation(baseOptions?: Apollo.MutationHookOptions<PostCreateMutation, PostCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCreateMutation, PostCreateMutationVariables>(PostCreateDocument, options);
      }
export type PostCreateMutationHookResult = ReturnType<typeof usePostCreateMutation>;
export type PostCreateMutationResult = Apollo.MutationResult<PostCreateMutation>;
export type PostCreateMutationOptions = Apollo.BaseMutationOptions<PostCreateMutation, PostCreateMutationVariables>;
export const PostUpdateDocument = gql`
    mutation PostUpdate($postUpdateId: ID!, $input: PostUpdateInput!) {
  postUpdate(id: $postUpdateId, input: $input) {
    category
    content
    createdAt
    deletedAt
    downvoted
    id
    mediaLink
    title
    type
    updatedAt
    upvoted
    userId
  }
}
    `;
export type PostUpdateMutationFn = Apollo.MutationFunction<PostUpdateMutation, PostUpdateMutationVariables>;

/**
 * __usePostUpdateMutation__
 *
 * To run a mutation, you first call `usePostUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUpdateMutation, { data, loading, error }] = usePostUpdateMutation({
 *   variables: {
 *      postUpdateId: // value for 'postUpdateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PostUpdateMutation, PostUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostUpdateMutation, PostUpdateMutationVariables>(PostUpdateDocument, options);
      }
export type PostUpdateMutationHookResult = ReturnType<typeof usePostUpdateMutation>;
export type PostUpdateMutationResult = Apollo.MutationResult<PostUpdateMutation>;
export type PostUpdateMutationOptions = Apollo.BaseMutationOptions<PostUpdateMutation, PostUpdateMutationVariables>;
export const PostDeleteDocument = gql`
    mutation PostDelete($postDeleteId: ID!, $channelId: String!) {
  postDelete(id: $postDeleteId, channelId: $channelId)
}
    `;
export type PostDeleteMutationFn = Apollo.MutationFunction<PostDeleteMutation, PostDeleteMutationVariables>;

/**
 * __usePostDeleteMutation__
 *
 * To run a mutation, you first call `usePostDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postDeleteMutation, { data, loading, error }] = usePostDeleteMutation({
 *   variables: {
 *      postDeleteId: // value for 'postDeleteId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePostDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PostDeleteMutation, PostDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostDeleteMutation, PostDeleteMutationVariables>(PostDeleteDocument, options);
      }
export type PostDeleteMutationHookResult = ReturnType<typeof usePostDeleteMutation>;
export type PostDeleteMutationResult = Apollo.MutationResult<PostDeleteMutation>;
export type PostDeleteMutationOptions = Apollo.BaseMutationOptions<PostDeleteMutation, PostDeleteMutationVariables>;
export const TipDeleteDocument = gql`
    mutation TipDelete($tipDeleteId: ID!, $channelId: String!) {
  tipDelete(id: $tipDeleteId, channelId: $channelId)
}
    `;
export type TipDeleteMutationFn = Apollo.MutationFunction<TipDeleteMutation, TipDeleteMutationVariables>;

/**
 * __useTipDeleteMutation__
 *
 * To run a mutation, you first call `useTipDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTipDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tipDeleteMutation, { data, loading, error }] = useTipDeleteMutation({
 *   variables: {
 *      tipDeleteId: // value for 'tipDeleteId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useTipDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TipDeleteMutation, TipDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TipDeleteMutation, TipDeleteMutationVariables>(TipDeleteDocument, options);
      }
export type TipDeleteMutationHookResult = ReturnType<typeof useTipDeleteMutation>;
export type TipDeleteMutationResult = Apollo.MutationResult<TipDeleteMutation>;
export type TipDeleteMutationOptions = Apollo.BaseMutationOptions<TipDeleteMutation, TipDeleteMutationVariables>;
export const MultitipDeleteDocument = gql`
    mutation MultitipDelete($multitipDeleteId: ID!, $channelId: String!) {
  multitipDelete(id: $multitipDeleteId, channelId: $channelId)
}
    `;
export type MultitipDeleteMutationFn = Apollo.MutationFunction<MultitipDeleteMutation, MultitipDeleteMutationVariables>;

/**
 * __useMultitipDeleteMutation__
 *
 * To run a mutation, you first call `useMultitipDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultitipDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multitipDeleteMutation, { data, loading, error }] = useMultitipDeleteMutation({
 *   variables: {
 *      multitipDeleteId: // value for 'multitipDeleteId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useMultitipDeleteMutation(baseOptions?: Apollo.MutationHookOptions<MultitipDeleteMutation, MultitipDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MultitipDeleteMutation, MultitipDeleteMutationVariables>(MultitipDeleteDocument, options);
      }
export type MultitipDeleteMutationHookResult = ReturnType<typeof useMultitipDeleteMutation>;
export type MultitipDeleteMutationResult = Apollo.MutationResult<MultitipDeleteMutation>;
export type MultitipDeleteMutationOptions = Apollo.BaseMutationOptions<MultitipDeleteMutation, MultitipDeleteMutationVariables>;
export const UpvoteDocument = gql`
    mutation Upvote($id: ID!, $type: typesOfContent!, $channelId: String!, $cursor: FeedCursorInput) {
  upvote(id: $id, type: $type, channelId: $channelId, cursor: $cursor) {
    ... on MultitipDetailed {
      ...MultitipDetailedFields
    }
    ... on PollDetailed {
      ...PollDetailedFields
    }
    ... on PostDetailed {
      ...PostDetailedFields
    }
    ... on TipDetailed {
      ...TipDetailedFields
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${PollDetailedFieldsFragmentDoc}
${PostDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}`;
export type UpvoteMutationFn = Apollo.MutationFunction<UpvoteMutation, UpvoteMutationVariables>;

/**
 * __useUpvoteMutation__
 *
 * To run a mutation, you first call `useUpvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upvoteMutation, { data, loading, error }] = useUpvoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useUpvoteMutation(baseOptions?: Apollo.MutationHookOptions<UpvoteMutation, UpvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpvoteMutation, UpvoteMutationVariables>(UpvoteDocument, options);
      }
export type UpvoteMutationHookResult = ReturnType<typeof useUpvoteMutation>;
export type UpvoteMutationResult = Apollo.MutationResult<UpvoteMutation>;
export type UpvoteMutationOptions = Apollo.BaseMutationOptions<UpvoteMutation, UpvoteMutationVariables>;
export const DownvoteDocument = gql`
    mutation Downvote($id: ID!, $type: typesOfContent!, $channelId: String!, $cursor: FeedCursorInput) {
  downvote(id: $id, type: $type, channelId: $channelId, cursor: $cursor) {
    ... on MultitipDetailed {
      ...MultitipDetailedFields
    }
    ... on PollDetailed {
      ...PollDetailedFields
    }
    ... on PostDetailed {
      ...PostDetailedFields
    }
    ... on TipDetailed {
      ...TipDetailedFields
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${PollDetailedFieldsFragmentDoc}
${PostDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}`;
export type DownvoteMutationFn = Apollo.MutationFunction<DownvoteMutation, DownvoteMutationVariables>;

/**
 * __useDownvoteMutation__
 *
 * To run a mutation, you first call `useDownvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downvoteMutation, { data, loading, error }] = useDownvoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useDownvoteMutation(baseOptions?: Apollo.MutationHookOptions<DownvoteMutation, DownvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownvoteMutation, DownvoteMutationVariables>(DownvoteDocument, options);
      }
export type DownvoteMutationHookResult = ReturnType<typeof useDownvoteMutation>;
export type DownvoteMutationResult = Apollo.MutationResult<DownvoteMutation>;
export type DownvoteMutationOptions = Apollo.BaseMutationOptions<DownvoteMutation, DownvoteMutationVariables>;
export const ImageUploadDocument = gql`
    mutation ImageUpload($image: Upload!) {
  imageUpload(image: $image)
}
    `;
export type ImageUploadMutationFn = Apollo.MutationFunction<ImageUploadMutation, ImageUploadMutationVariables>;

/**
 * __useImageUploadMutation__
 *
 * To run a mutation, you first call `useImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageUploadMutation, { data, loading, error }] = useImageUploadMutation({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useImageUploadMutation(baseOptions?: Apollo.MutationHookOptions<ImageUploadMutation, ImageUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageUploadMutation, ImageUploadMutationVariables>(ImageUploadDocument, options);
      }
export type ImageUploadMutationHookResult = ReturnType<typeof useImageUploadMutation>;
export type ImageUploadMutationResult = Apollo.MutationResult<ImageUploadMutation>;
export type ImageUploadMutationOptions = Apollo.BaseMutationOptions<ImageUploadMutation, ImageUploadMutationVariables>;
export const AudioUploadDocument = gql`
    mutation AudioUpload($audio: Upload!) {
  audioUpload(audio: $audio)
}
    `;
export type AudioUploadMutationFn = Apollo.MutationFunction<AudioUploadMutation, AudioUploadMutationVariables>;

/**
 * __useAudioUploadMutation__
 *
 * To run a mutation, you first call `useAudioUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudioUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audioUploadMutation, { data, loading, error }] = useAudioUploadMutation({
 *   variables: {
 *      audio: // value for 'audio'
 *   },
 * });
 */
export function useAudioUploadMutation(baseOptions?: Apollo.MutationHookOptions<AudioUploadMutation, AudioUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudioUploadMutation, AudioUploadMutationVariables>(AudioUploadDocument, options);
      }
export type AudioUploadMutationHookResult = ReturnType<typeof useAudioUploadMutation>;
export type AudioUploadMutationResult = Apollo.MutationResult<AudioUploadMutation>;
export type AudioUploadMutationOptions = Apollo.BaseMutationOptions<AudioUploadMutation, AudioUploadMutationVariables>;
export const VideoUploadDocument = gql`
    mutation VideoUpload($video: Upload!) {
  videoUpload(video: $video)
}
    `;
export type VideoUploadMutationFn = Apollo.MutationFunction<VideoUploadMutation, VideoUploadMutationVariables>;

/**
 * __useVideoUploadMutation__
 *
 * To run a mutation, you first call `useVideoUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoUploadMutation, { data, loading, error }] = useVideoUploadMutation({
 *   variables: {
 *      video: // value for 'video'
 *   },
 * });
 */
export function useVideoUploadMutation(baseOptions?: Apollo.MutationHookOptions<VideoUploadMutation, VideoUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoUploadMutation, VideoUploadMutationVariables>(VideoUploadDocument, options);
      }
export type VideoUploadMutationHookResult = ReturnType<typeof useVideoUploadMutation>;
export type VideoUploadMutationResult = Apollo.MutationResult<VideoUploadMutation>;
export type VideoUploadMutationOptions = Apollo.BaseMutationOptions<VideoUploadMutation, VideoUploadMutationVariables>;
export const ImageDeleteDocument = gql`
    mutation ImageDelete($imageUrl: String!) {
  imageDelete(imageURL: $imageUrl)
}
    `;
export type ImageDeleteMutationFn = Apollo.MutationFunction<ImageDeleteMutation, ImageDeleteMutationVariables>;

/**
 * __useImageDeleteMutation__
 *
 * To run a mutation, you first call `useImageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [imageDeleteMutation, { data, loading, error }] = useImageDeleteMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useImageDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ImageDeleteMutation, ImageDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImageDeleteMutation, ImageDeleteMutationVariables>(ImageDeleteDocument, options);
      }
export type ImageDeleteMutationHookResult = ReturnType<typeof useImageDeleteMutation>;
export type ImageDeleteMutationResult = Apollo.MutationResult<ImageDeleteMutation>;
export type ImageDeleteMutationOptions = Apollo.BaseMutationOptions<ImageDeleteMutation, ImageDeleteMutationVariables>;
export const CreateSingleTipDocument = gql`
    mutation CreateSingleTip($input: TipCreate!) {
  tipCreate(input: $input) {
    ...TipDetailedFields
  }
}
    ${TipDetailedFieldsFragmentDoc}`;
export type CreateSingleTipMutationFn = Apollo.MutationFunction<CreateSingleTipMutation, CreateSingleTipMutationVariables>;

/**
 * __useCreateSingleTipMutation__
 *
 * To run a mutation, you first call `useCreateSingleTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSingleTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSingleTipMutation, { data, loading, error }] = useCreateSingleTipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSingleTipMutation(baseOptions?: Apollo.MutationHookOptions<CreateSingleTipMutation, CreateSingleTipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSingleTipMutation, CreateSingleTipMutationVariables>(CreateSingleTipDocument, options);
      }
export type CreateSingleTipMutationHookResult = ReturnType<typeof useCreateSingleTipMutation>;
export type CreateSingleTipMutationResult = Apollo.MutationResult<CreateSingleTipMutation>;
export type CreateSingleTipMutationOptions = Apollo.BaseMutationOptions<CreateSingleTipMutation, CreateSingleTipMutationVariables>;
export const CreateMultiTipDocument = gql`
    mutation CreateMultiTip($input: MultitipCreate!) {
  multitipCreate(input: $input) {
    ...MultitipDetailedFields
  }
}
    ${MultitipDetailedFieldsFragmentDoc}`;
export type CreateMultiTipMutationFn = Apollo.MutationFunction<CreateMultiTipMutation, CreateMultiTipMutationVariables>;

/**
 * __useCreateMultiTipMutation__
 *
 * To run a mutation, you first call `useCreateMultiTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiTipMutation, { data, loading, error }] = useCreateMultiTipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMultiTipMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiTipMutation, CreateMultiTipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiTipMutation, CreateMultiTipMutationVariables>(CreateMultiTipDocument, options);
      }
export type CreateMultiTipMutationHookResult = ReturnType<typeof useCreateMultiTipMutation>;
export type CreateMultiTipMutationResult = Apollo.MutationResult<CreateMultiTipMutation>;
export type CreateMultiTipMutationOptions = Apollo.BaseMutationOptions<CreateMultiTipMutation, CreateMultiTipMutationVariables>;
export const FollowTipsterDocument = gql`
    mutation FollowTipster($tipsterId: ID!) {
  userFollowTipster(tipsterId: $tipsterId) {
    id
  }
}
    `;
export type FollowTipsterMutationFn = Apollo.MutationFunction<FollowTipsterMutation, FollowTipsterMutationVariables>;

/**
 * __useFollowTipsterMutation__
 *
 * To run a mutation, you first call `useFollowTipsterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowTipsterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followTipsterMutation, { data, loading, error }] = useFollowTipsterMutation({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useFollowTipsterMutation(baseOptions?: Apollo.MutationHookOptions<FollowTipsterMutation, FollowTipsterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowTipsterMutation, FollowTipsterMutationVariables>(FollowTipsterDocument, options);
      }
export type FollowTipsterMutationHookResult = ReturnType<typeof useFollowTipsterMutation>;
export type FollowTipsterMutationResult = Apollo.MutationResult<FollowTipsterMutation>;
export type FollowTipsterMutationOptions = Apollo.BaseMutationOptions<FollowTipsterMutation, FollowTipsterMutationVariables>;
export const UnFollowTipsterDocument = gql`
    mutation UnFollowTipster($tipsterId: ID!) {
  userUnfollowFromTipster(tipsterId: $tipsterId) {
    id
  }
}
    `;
export type UnFollowTipsterMutationFn = Apollo.MutationFunction<UnFollowTipsterMutation, UnFollowTipsterMutationVariables>;

/**
 * __useUnFollowTipsterMutation__
 *
 * To run a mutation, you first call `useUnFollowTipsterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnFollowTipsterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unFollowTipsterMutation, { data, loading, error }] = useUnFollowTipsterMutation({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useUnFollowTipsterMutation(baseOptions?: Apollo.MutationHookOptions<UnFollowTipsterMutation, UnFollowTipsterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnFollowTipsterMutation, UnFollowTipsterMutationVariables>(UnFollowTipsterDocument, options);
      }
export type UnFollowTipsterMutationHookResult = ReturnType<typeof useUnFollowTipsterMutation>;
export type UnFollowTipsterMutationResult = Apollo.MutationResult<UnFollowTipsterMutation>;
export type UnFollowTipsterMutationOptions = Apollo.BaseMutationOptions<UnFollowTipsterMutation, UnFollowTipsterMutationVariables>;
export const UpdateSingleTipDocument = gql`
    mutation UpdateSingleTip($id: ID!, $input: TipUpdate!) {
  tipUpdate(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateSingleTipMutationFn = Apollo.MutationFunction<UpdateSingleTipMutation, UpdateSingleTipMutationVariables>;

/**
 * __useUpdateSingleTipMutation__
 *
 * To run a mutation, you first call `useUpdateSingleTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleTipMutation, { data, loading, error }] = useUpdateSingleTipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSingleTipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSingleTipMutation, UpdateSingleTipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSingleTipMutation, UpdateSingleTipMutationVariables>(UpdateSingleTipDocument, options);
      }
export type UpdateSingleTipMutationHookResult = ReturnType<typeof useUpdateSingleTipMutation>;
export type UpdateSingleTipMutationResult = Apollo.MutationResult<UpdateSingleTipMutation>;
export type UpdateSingleTipMutationOptions = Apollo.BaseMutationOptions<UpdateSingleTipMutation, UpdateSingleTipMutationVariables>;
export const UpdateMultiTipDocument = gql`
    mutation UpdateMultiTip($id: ID!, $input: MultitipUpdate!) {
  multitipUpdate(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateMultiTipMutationFn = Apollo.MutationFunction<UpdateMultiTipMutation, UpdateMultiTipMutationVariables>;

/**
 * __useUpdateMultiTipMutation__
 *
 * To run a mutation, you first call `useUpdateMultiTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultiTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultiTipMutation, { data, loading, error }] = useUpdateMultiTipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMultiTipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMultiTipMutation, UpdateMultiTipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMultiTipMutation, UpdateMultiTipMutationVariables>(UpdateMultiTipDocument, options);
      }
export type UpdateMultiTipMutationHookResult = ReturnType<typeof useUpdateMultiTipMutation>;
export type UpdateMultiTipMutationResult = Apollo.MutationResult<UpdateMultiTipMutation>;
export type UpdateMultiTipMutationOptions = Apollo.BaseMutationOptions<UpdateMultiTipMutation, UpdateMultiTipMutationVariables>;
export const SaveTipDocument = gql`
    mutation SaveTip($contentId: String!, $contentType: tipsTypes!, $addedFromChannelId: String, $tipCreatedAt: DateTime, $tipSportIds: [String!]) {
  saveTip(
    contentId: $contentId
    contentType: $contentType
    addedFromChannelId: $addedFromChannelId
    tipCreatedAt: $tipCreatedAt
    tipSportIds: $tipSportIds
  ) {
    result
  }
}
    `;
export type SaveTipMutationFn = Apollo.MutationFunction<SaveTipMutation, SaveTipMutationVariables>;

/**
 * __useSaveTipMutation__
 *
 * To run a mutation, you first call `useSaveTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTipMutation, { data, loading, error }] = useSaveTipMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      contentType: // value for 'contentType'
 *      addedFromChannelId: // value for 'addedFromChannelId'
 *      tipCreatedAt: // value for 'tipCreatedAt'
 *      tipSportIds: // value for 'tipSportIds'
 *   },
 * });
 */
export function useSaveTipMutation(baseOptions?: Apollo.MutationHookOptions<SaveTipMutation, SaveTipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTipMutation, SaveTipMutationVariables>(SaveTipDocument, options);
      }
export type SaveTipMutationHookResult = ReturnType<typeof useSaveTipMutation>;
export type SaveTipMutationResult = Apollo.MutationResult<SaveTipMutation>;
export type SaveTipMutationOptions = Apollo.BaseMutationOptions<SaveTipMutation, SaveTipMutationVariables>;
export const UnsaveTipDocument = gql`
    mutation UnsaveTip($contentId: String!, $contentType: tipsTypes!) {
  unsaveTip(contentId: $contentId, contentType: $contentType) {
    result
  }
}
    `;
export type UnsaveTipMutationFn = Apollo.MutationFunction<UnsaveTipMutation, UnsaveTipMutationVariables>;

/**
 * __useUnsaveTipMutation__
 *
 * To run a mutation, you first call `useUnsaveTipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsaveTipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsaveTipMutation, { data, loading, error }] = useUnsaveTipMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useUnsaveTipMutation(baseOptions?: Apollo.MutationHookOptions<UnsaveTipMutation, UnsaveTipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsaveTipMutation, UnsaveTipMutationVariables>(UnsaveTipDocument, options);
      }
export type UnsaveTipMutationHookResult = ReturnType<typeof useUnsaveTipMutation>;
export type UnsaveTipMutationResult = Apollo.MutationResult<UnsaveTipMutation>;
export type UnsaveTipMutationOptions = Apollo.BaseMutationOptions<UnsaveTipMutation, UnsaveTipMutationVariables>;
export const CreateTipRoomDocument = gql`
    mutation CreateTipRoom($input: CreateTipRoomInput!) {
  createTipRoom(input: $input)
}
    `;
export type CreateTipRoomMutationFn = Apollo.MutationFunction<CreateTipRoomMutation, CreateTipRoomMutationVariables>;

/**
 * __useCreateTipRoomMutation__
 *
 * To run a mutation, you first call `useCreateTipRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTipRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTipRoomMutation, { data, loading, error }] = useCreateTipRoomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTipRoomMutation(baseOptions?: Apollo.MutationHookOptions<CreateTipRoomMutation, CreateTipRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTipRoomMutation, CreateTipRoomMutationVariables>(CreateTipRoomDocument, options);
      }
export type CreateTipRoomMutationHookResult = ReturnType<typeof useCreateTipRoomMutation>;
export type CreateTipRoomMutationResult = Apollo.MutationResult<CreateTipRoomMutation>;
export type CreateTipRoomMutationOptions = Apollo.BaseMutationOptions<CreateTipRoomMutation, CreateTipRoomMutationVariables>;
export const ParseBetslipDocument = gql`
    mutation ParseBetslip($imageBase64: String!, $mimeType: String!) {
  parseBetslip(imageBase64: $imageBase64, mimeType: $mimeType) {
    tips {
      homeTeam
      awayTeam
      eventDate
      market
      odds
    }
    bookmakerName
    totalOdds
    confidence
  }
}
    `;
export type ParseBetslipMutationFn = Apollo.MutationFunction<ParseBetslipMutation, ParseBetslipMutationVariables>;

/**
 * __useParseBetslipMutation__
 *
 * To run a mutation, you first call `useParseBetslipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseBetslipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseBetslipMutation, { data, loading, error }] = useParseBetslipMutation({
 *   variables: {
 *      imageBase64: // value for 'imageBase64'
 *      mimeType: // value for 'mimeType'
 *   },
 * });
 */
export function useParseBetslipMutation(baseOptions?: Apollo.MutationHookOptions<ParseBetslipMutation, ParseBetslipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseBetslipMutation, ParseBetslipMutationVariables>(ParseBetslipDocument, options);
      }
export type ParseBetslipMutationHookResult = ReturnType<typeof useParseBetslipMutation>;
export type ParseBetslipMutationResult = Apollo.MutationResult<ParseBetslipMutation>;
export type ParseBetslipMutationOptions = Apollo.BaseMutationOptions<ParseBetslipMutation, ParseBetslipMutationVariables>;
export const UpdateTipRoomDocument = gql`
    mutation UpdateTipRoom($input: UpdateTipRoomInput!) {
  updateTipRoom(input: $input)
}
    `;
export type UpdateTipRoomMutationFn = Apollo.MutationFunction<UpdateTipRoomMutation, UpdateTipRoomMutationVariables>;

/**
 * __useUpdateTipRoomMutation__
 *
 * To run a mutation, you first call `useUpdateTipRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTipRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTipRoomMutation, { data, loading, error }] = useUpdateTipRoomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTipRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTipRoomMutation, UpdateTipRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTipRoomMutation, UpdateTipRoomMutationVariables>(UpdateTipRoomDocument, options);
      }
export type UpdateTipRoomMutationHookResult = ReturnType<typeof useUpdateTipRoomMutation>;
export type UpdateTipRoomMutationResult = Apollo.MutationResult<UpdateTipRoomMutation>;
export type UpdateTipRoomMutationOptions = Apollo.BaseMutationOptions<UpdateTipRoomMutation, UpdateTipRoomMutationVariables>;
export const UploadImageDocument = gql`
    mutation UploadImage($image: Upload!) {
  imageUpload(image: $image)
}
    `;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const JoinTipsterCompetitionDocument = gql`
    mutation JoinTipsterCompetition($competitionId: ID!) {
  joinTipsterCompetition(competitionId: $competitionId) {
    id
    takenSlots
    remainingSlots
    isOpen
  }
}
    `;
export type JoinTipsterCompetitionMutationFn = Apollo.MutationFunction<JoinTipsterCompetitionMutation, JoinTipsterCompetitionMutationVariables>;

/**
 * __useJoinTipsterCompetitionMutation__
 *
 * To run a mutation, you first call `useJoinTipsterCompetitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTipsterCompetitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTipsterCompetitionMutation, { data, loading, error }] = useJoinTipsterCompetitionMutation({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *   },
 * });
 */
export function useJoinTipsterCompetitionMutation(baseOptions?: Apollo.MutationHookOptions<JoinTipsterCompetitionMutation, JoinTipsterCompetitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinTipsterCompetitionMutation, JoinTipsterCompetitionMutationVariables>(JoinTipsterCompetitionDocument, options);
      }
export type JoinTipsterCompetitionMutationHookResult = ReturnType<typeof useJoinTipsterCompetitionMutation>;
export type JoinTipsterCompetitionMutationResult = Apollo.MutationResult<JoinTipsterCompetitionMutation>;
export type JoinTipsterCompetitionMutationOptions = Apollo.BaseMutationOptions<JoinTipsterCompetitionMutation, JoinTipsterCompetitionMutationVariables>;
export const UpdateNotificationSettingsDocument = gql`
    mutation UpdateNotificationSettings($id: ID!, $scope: NotificationSettingScope!, $value: Boolean!) {
  entityNotificationSettingsUpdate(id: $id, scope: $scope, value: $value) {
    id
  }
}
    `;
export type UpdateNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;

/**
 * __useUpdateNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsMutation, { data, loading, error }] = useUpdateNotificationSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scope: // value for 'scope'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>(UpdateNotificationSettingsDocument, options);
      }
export type UpdateNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationResult = Apollo.MutationResult<UpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($readNotificationId: ID!) {
  readNotification(id: $readNotificationId) {
    createdAt
    iconUrl
    id
    info
    isNew
    type
    userId
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      readNotificationId: // value for 'readNotificationId'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($notificationId: ID!) {
  deleteNotification(id: $notificationId)
}
    `;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<DeleteNotificationMutation, DeleteNotificationMutationVariables>;

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationMutation, DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
export const SendFirebaseTokenDocument = gql`
    mutation SendFirebaseToken($token: String!) {
  addFCMToken(token: $token)
}
    `;
export type SendFirebaseTokenMutationFn = Apollo.MutationFunction<SendFirebaseTokenMutation, SendFirebaseTokenMutationVariables>;

/**
 * __useSendFirebaseTokenMutation__
 *
 * To run a mutation, you first call `useSendFirebaseTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFirebaseTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFirebaseTokenMutation, { data, loading, error }] = useSendFirebaseTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSendFirebaseTokenMutation(baseOptions?: Apollo.MutationHookOptions<SendFirebaseTokenMutation, SendFirebaseTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFirebaseTokenMutation, SendFirebaseTokenMutationVariables>(SendFirebaseTokenDocument, options);
      }
export type SendFirebaseTokenMutationHookResult = ReturnType<typeof useSendFirebaseTokenMutation>;
export type SendFirebaseTokenMutationResult = Apollo.MutationResult<SendFirebaseTokenMutation>;
export type SendFirebaseTokenMutationOptions = Apollo.BaseMutationOptions<SendFirebaseTokenMutation, SendFirebaseTokenMutationVariables>;
export const DeleteFirebaseTokenDocument = gql`
    mutation DeleteFirebaseToken($token: String!) {
  deleteFCMToken(token: $token)
}
    `;
export type DeleteFirebaseTokenMutationFn = Apollo.MutationFunction<DeleteFirebaseTokenMutation, DeleteFirebaseTokenMutationVariables>;

/**
 * __useDeleteFirebaseTokenMutation__
 *
 * To run a mutation, you first call `useDeleteFirebaseTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFirebaseTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFirebaseTokenMutation, { data, loading, error }] = useDeleteFirebaseTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useDeleteFirebaseTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFirebaseTokenMutation, DeleteFirebaseTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFirebaseTokenMutation, DeleteFirebaseTokenMutationVariables>(DeleteFirebaseTokenDocument, options);
      }
export type DeleteFirebaseTokenMutationHookResult = ReturnType<typeof useDeleteFirebaseTokenMutation>;
export type DeleteFirebaseTokenMutationResult = Apollo.MutationResult<DeleteFirebaseTokenMutation>;
export type DeleteFirebaseTokenMutationOptions = Apollo.BaseMutationOptions<DeleteFirebaseTokenMutation, DeleteFirebaseTokenMutationVariables>;
export const ReadNotificationsDocument = gql`
    mutation ReadNotifications($readNotificationIds: [ID!]!) {
  readNotifications(id: $readNotificationIds)
}
    `;
export type ReadNotificationsMutationFn = Apollo.MutationFunction<ReadNotificationsMutation, ReadNotificationsMutationVariables>;

/**
 * __useReadNotificationsMutation__
 *
 * To run a mutation, you first call `useReadNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationsMutation, { data, loading, error }] = useReadNotificationsMutation({
 *   variables: {
 *      readNotificationIds: // value for 'readNotificationIds'
 *   },
 * });
 */
export function useReadNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationsMutation, ReadNotificationsMutationVariables>(ReadNotificationsDocument, options);
      }
export type ReadNotificationsMutationHookResult = ReturnType<typeof useReadNotificationsMutation>;
export type ReadNotificationsMutationResult = Apollo.MutationResult<ReadNotificationsMutation>;
export type ReadNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const MarkAllChannelMessageAsReadDocument = gql`
    mutation MarkAllChannelMessageAsRead($channelIds: [ID!]!) {
  markAllChannelMessageAsRead(channelIds: $channelIds)
}
    `;
export type MarkAllChannelMessageAsReadMutationFn = Apollo.MutationFunction<MarkAllChannelMessageAsReadMutation, MarkAllChannelMessageAsReadMutationVariables>;

/**
 * __useMarkAllChannelMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllChannelMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllChannelMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllChannelMessageAsReadMutation, { data, loading, error }] = useMarkAllChannelMessageAsReadMutation({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *   },
 * });
 */
export function useMarkAllChannelMessageAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllChannelMessageAsReadMutation, MarkAllChannelMessageAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllChannelMessageAsReadMutation, MarkAllChannelMessageAsReadMutationVariables>(MarkAllChannelMessageAsReadDocument, options);
      }
export type MarkAllChannelMessageAsReadMutationHookResult = ReturnType<typeof useMarkAllChannelMessageAsReadMutation>;
export type MarkAllChannelMessageAsReadMutationResult = Apollo.MutationResult<MarkAllChannelMessageAsReadMutation>;
export type MarkAllChannelMessageAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllChannelMessageAsReadMutation, MarkAllChannelMessageAsReadMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: UserCreate!, $inviteToken: String) {
  userCreate(input: $input, inviteToken: $inviteToken) {
    dateOfBirth
    displayName
    emailAddress
    firstName
    gender
    id
    lastName
    phoneNumber
    role
    countryId
    onboardingStage
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CheckUniqueDisplayNameDocument = gql`
    query CheckUniqueDisplayName($name: String!) {
  userByDisplayname(name: $name)
}
    `;

/**
 * __useCheckUniqueDisplayNameQuery__
 *
 * To run a query within a React component, call `useCheckUniqueDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUniqueDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUniqueDisplayNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckUniqueDisplayNameQuery(baseOptions: Apollo.QueryHookOptions<CheckUniqueDisplayNameQuery, CheckUniqueDisplayNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUniqueDisplayNameQuery, CheckUniqueDisplayNameQueryVariables>(CheckUniqueDisplayNameDocument, options);
      }
export function useCheckUniqueDisplayNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUniqueDisplayNameQuery, CheckUniqueDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUniqueDisplayNameQuery, CheckUniqueDisplayNameQueryVariables>(CheckUniqueDisplayNameDocument, options);
        }
export type CheckUniqueDisplayNameQueryHookResult = ReturnType<typeof useCheckUniqueDisplayNameQuery>;
export type CheckUniqueDisplayNameLazyQueryHookResult = ReturnType<typeof useCheckUniqueDisplayNameLazyQuery>;
export type CheckUniqueDisplayNameQueryResult = Apollo.QueryResult<CheckUniqueDisplayNameQuery, CheckUniqueDisplayNameQueryVariables>;
export const CreatePaymentIntentDocument = gql`
    mutation CreatePaymentIntent($input: PaymentInitInput!) {
  paymentCreateIntent(input: $input) {
    payment {
      id
    }
    status
    ... on PaymentStripeInitResult {
      clientSecret
    }
  }
}
    `;
export type CreatePaymentIntentMutationFn = Apollo.MutationFunction<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;

/**
 * __useCreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = useCreatePaymentIntentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, options);
      }
export type CreatePaymentIntentMutationHookResult = ReturnType<typeof useCreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationResult = Apollo.MutationResult<CreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;
export const UpdatePaymentAndSubscriptionUpdateDocument = gql`
    mutation UpdatePaymentAndSubscriptionUpdate($input: String!) {
  paymentAndSubscriptionUpdate(input: $input)
}
    `;
export type UpdatePaymentAndSubscriptionUpdateMutationFn = Apollo.MutationFunction<UpdatePaymentAndSubscriptionUpdateMutation, UpdatePaymentAndSubscriptionUpdateMutationVariables>;

/**
 * __useUpdatePaymentAndSubscriptionUpdateMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentAndSubscriptionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentAndSubscriptionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentAndSubscriptionUpdateMutation, { data, loading, error }] = useUpdatePaymentAndSubscriptionUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentAndSubscriptionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentAndSubscriptionUpdateMutation, UpdatePaymentAndSubscriptionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentAndSubscriptionUpdateMutation, UpdatePaymentAndSubscriptionUpdateMutationVariables>(UpdatePaymentAndSubscriptionUpdateDocument, options);
      }
export type UpdatePaymentAndSubscriptionUpdateMutationHookResult = ReturnType<typeof useUpdatePaymentAndSubscriptionUpdateMutation>;
export type UpdatePaymentAndSubscriptionUpdateMutationResult = Apollo.MutationResult<UpdatePaymentAndSubscriptionUpdateMutation>;
export type UpdatePaymentAndSubscriptionUpdateMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentAndSubscriptionUpdateMutation, UpdatePaymentAndSubscriptionUpdateMutationVariables>;
export const PlanCreateDocument = gql`
    mutation PlanCreate($input: PlanCreateInput!) {
  planCreate(input: $input) {
    id
    channelId
    tipsterId
    scope
    name
    description
    price
    currencyCode
    durationDays
    freeTrialDays
    status
    createdAt
    paymentMethods {
      id
      paymentType {
        id
        paymentName
        isAutoActivated
        category
        imageUrl
      }
    }
    isLocked
    activeSubscriberCount
  }
}
    `;
export type PlanCreateMutationFn = Apollo.MutationFunction<PlanCreateMutation, PlanCreateMutationVariables>;

/**
 * __usePlanCreateMutation__
 *
 * To run a mutation, you first call `usePlanCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planCreateMutation, { data, loading, error }] = usePlanCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanCreateMutation(baseOptions?: Apollo.MutationHookOptions<PlanCreateMutation, PlanCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanCreateMutation, PlanCreateMutationVariables>(PlanCreateDocument, options);
      }
export type PlanCreateMutationHookResult = ReturnType<typeof usePlanCreateMutation>;
export type PlanCreateMutationResult = Apollo.MutationResult<PlanCreateMutation>;
export type PlanCreateMutationOptions = Apollo.BaseMutationOptions<PlanCreateMutation, PlanCreateMutationVariables>;
export const PlanUpdateDocument = gql`
    mutation PlanUpdate($input: PlanUpdateInput!) {
  planUpdate(input: $input) {
    id
    name
    description
    price
    currencyCode
    durationDays
    freeTrialDays
    paymentMethods {
      id
      paymentType {
        id
        paymentName
        isAutoActivated
        category
        imageUrl
      }
    }
    isLocked
    activeSubscriberCount
  }
}
    `;
export type PlanUpdateMutationFn = Apollo.MutationFunction<PlanUpdateMutation, PlanUpdateMutationVariables>;

/**
 * __usePlanUpdateMutation__
 *
 * To run a mutation, you first call `usePlanUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planUpdateMutation, { data, loading, error }] = usePlanUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PlanUpdateMutation, PlanUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanUpdateMutation, PlanUpdateMutationVariables>(PlanUpdateDocument, options);
      }
export type PlanUpdateMutationHookResult = ReturnType<typeof usePlanUpdateMutation>;
export type PlanUpdateMutationResult = Apollo.MutationResult<PlanUpdateMutation>;
export type PlanUpdateMutationOptions = Apollo.BaseMutationOptions<PlanUpdateMutation, PlanUpdateMutationVariables>;
export const PlanDiscontinueDocument = gql`
    mutation PlanDiscontinue($id: String!) {
  planDiscontinue(id: $id) {
    id
    status
    deletedAt
  }
}
    `;
export type PlanDiscontinueMutationFn = Apollo.MutationFunction<PlanDiscontinueMutation, PlanDiscontinueMutationVariables>;

/**
 * __usePlanDiscontinueMutation__
 *
 * To run a mutation, you first call `usePlanDiscontinueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanDiscontinueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planDiscontinueMutation, { data, loading, error }] = usePlanDiscontinueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanDiscontinueMutation(baseOptions?: Apollo.MutationHookOptions<PlanDiscontinueMutation, PlanDiscontinueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanDiscontinueMutation, PlanDiscontinueMutationVariables>(PlanDiscontinueDocument, options);
      }
export type PlanDiscontinueMutationHookResult = ReturnType<typeof usePlanDiscontinueMutation>;
export type PlanDiscontinueMutationResult = Apollo.MutationResult<PlanDiscontinueMutation>;
export type PlanDiscontinueMutationOptions = Apollo.BaseMutationOptions<PlanDiscontinueMutation, PlanDiscontinueMutationVariables>;
export const OptionRearrangeDocument = gql`
    mutation OptionRearrange($options: [OptionsUpdateModel!]!) {
  optionRearrange(options: $options)
}
    `;
export type OptionRearrangeMutationFn = Apollo.MutationFunction<OptionRearrangeMutation, OptionRearrangeMutationVariables>;

/**
 * __useOptionRearrangeMutation__
 *
 * To run a mutation, you first call `useOptionRearrangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptionRearrangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optionRearrangeMutation, { data, loading, error }] = useOptionRearrangeMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useOptionRearrangeMutation(baseOptions?: Apollo.MutationHookOptions<OptionRearrangeMutation, OptionRearrangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptionRearrangeMutation, OptionRearrangeMutationVariables>(OptionRearrangeDocument, options);
      }
export type OptionRearrangeMutationHookResult = ReturnType<typeof useOptionRearrangeMutation>;
export type OptionRearrangeMutationResult = Apollo.MutationResult<OptionRearrangeMutation>;
export type OptionRearrangeMutationOptions = Apollo.BaseMutationOptions<OptionRearrangeMutation, OptionRearrangeMutationVariables>;
export const OptionCreateDocument = gql`
    mutation OptionCreate($input: OptionsCreateModel!) {
  optionCreate(input: $input) {
    option
    id
    pollId
    position
  }
}
    `;
export type OptionCreateMutationFn = Apollo.MutationFunction<OptionCreateMutation, OptionCreateMutationVariables>;

/**
 * __useOptionCreateMutation__
 *
 * To run a mutation, you first call `useOptionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optionCreateMutation, { data, loading, error }] = useOptionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOptionCreateMutation(baseOptions?: Apollo.MutationHookOptions<OptionCreateMutation, OptionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptionCreateMutation, OptionCreateMutationVariables>(OptionCreateDocument, options);
      }
export type OptionCreateMutationHookResult = ReturnType<typeof useOptionCreateMutation>;
export type OptionCreateMutationResult = Apollo.MutationResult<OptionCreateMutation>;
export type OptionCreateMutationOptions = Apollo.BaseMutationOptions<OptionCreateMutation, OptionCreateMutationVariables>;
export const OptionUpdateDocument = gql`
    mutation OptionUpdate($optionUpdateId: ID!, $input: OptionsUpdateModel!) {
  optionUpdate(id: $optionUpdateId, input: $input)
}
    `;
export type OptionUpdateMutationFn = Apollo.MutationFunction<OptionUpdateMutation, OptionUpdateMutationVariables>;

/**
 * __useOptionUpdateMutation__
 *
 * To run a mutation, you first call `useOptionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optionUpdateMutation, { data, loading, error }] = useOptionUpdateMutation({
 *   variables: {
 *      optionUpdateId: // value for 'optionUpdateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOptionUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OptionUpdateMutation, OptionUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptionUpdateMutation, OptionUpdateMutationVariables>(OptionUpdateDocument, options);
      }
export type OptionUpdateMutationHookResult = ReturnType<typeof useOptionUpdateMutation>;
export type OptionUpdateMutationResult = Apollo.MutationResult<OptionUpdateMutation>;
export type OptionUpdateMutationOptions = Apollo.BaseMutationOptions<OptionUpdateMutation, OptionUpdateMutationVariables>;
export const OptionDeleteDocument = gql`
    mutation OptionDelete($optionDeleteId: ID!) {
  optionDelete(id: $optionDeleteId)
}
    `;
export type OptionDeleteMutationFn = Apollo.MutationFunction<OptionDeleteMutation, OptionDeleteMutationVariables>;

/**
 * __useOptionDeleteMutation__
 *
 * To run a mutation, you first call `useOptionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optionDeleteMutation, { data, loading, error }] = useOptionDeleteMutation({
 *   variables: {
 *      optionDeleteId: // value for 'optionDeleteId'
 *   },
 * });
 */
export function useOptionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OptionDeleteMutation, OptionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptionDeleteMutation, OptionDeleteMutationVariables>(OptionDeleteDocument, options);
      }
export type OptionDeleteMutationHookResult = ReturnType<typeof useOptionDeleteMutation>;
export type OptionDeleteMutationResult = Apollo.MutationResult<OptionDeleteMutation>;
export type OptionDeleteMutationOptions = Apollo.BaseMutationOptions<OptionDeleteMutation, OptionDeleteMutationVariables>;
export const PlanPurchaseCreateDocument = gql`
    mutation PlanPurchaseCreate($input: PlanPurchaseInput!) {
  planPurchaseCreate(input: $input) {
    clientSecret
    purchase {
      id
      planId
      userId
      paymentProvider
      externalReference
      paymentMethod {
        id
        paymentType {
          id
          paymentName
          isAutoActivated
          category
          imageUrl
        }
      }
      amount
      currencyCode
      status
      createdAt
    }
  }
}
    `;
export type PlanPurchaseCreateMutationFn = Apollo.MutationFunction<PlanPurchaseCreateMutation, PlanPurchaseCreateMutationVariables>;

/**
 * __usePlanPurchaseCreateMutation__
 *
 * To run a mutation, you first call `usePlanPurchaseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanPurchaseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planPurchaseCreateMutation, { data, loading, error }] = usePlanPurchaseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanPurchaseCreateMutation(baseOptions?: Apollo.MutationHookOptions<PlanPurchaseCreateMutation, PlanPurchaseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanPurchaseCreateMutation, PlanPurchaseCreateMutationVariables>(PlanPurchaseCreateDocument, options);
      }
export type PlanPurchaseCreateMutationHookResult = ReturnType<typeof usePlanPurchaseCreateMutation>;
export type PlanPurchaseCreateMutationResult = Apollo.MutationResult<PlanPurchaseCreateMutation>;
export type PlanPurchaseCreateMutationOptions = Apollo.BaseMutationOptions<PlanPurchaseCreateMutation, PlanPurchaseCreateMutationVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($input: ServiceCreate!) {
  serviceCreate(input: $input) {
    id
  }
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const CreateServiceDurationDocument = gql`
    mutation CreateServiceDuration($input: ServiceDurationCreateInput!) {
  serviceDurationCreate(input: $input) {
    id
  }
}
    `;
export type CreateServiceDurationMutationFn = Apollo.MutationFunction<CreateServiceDurationMutation, CreateServiceDurationMutationVariables>;

/**
 * __useCreateServiceDurationMutation__
 *
 * To run a mutation, you first call `useCreateServiceDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceDurationMutation, { data, loading, error }] = useCreateServiceDurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceDurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceDurationMutation, CreateServiceDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceDurationMutation, CreateServiceDurationMutationVariables>(CreateServiceDurationDocument, options);
      }
export type CreateServiceDurationMutationHookResult = ReturnType<typeof useCreateServiceDurationMutation>;
export type CreateServiceDurationMutationResult = Apollo.MutationResult<CreateServiceDurationMutation>;
export type CreateServiceDurationMutationOptions = Apollo.BaseMutationOptions<CreateServiceDurationMutation, CreateServiceDurationMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation UpdateService($input: ServiceUpdate!, $id: String!) {
  serviceUpdate(input: $input, id: $id)
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation DeleteService($id: String!) {
  serviceDelete(id: $id)
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const UpdateServiceDetailsDocument = gql`
    mutation UpdateServiceDetails($input: ServiceUpdate!, $id: String!) {
  serviceDetailsUpdate(input: $input, id: $id)
}
    `;
export type UpdateServiceDetailsMutationFn = Apollo.MutationFunction<UpdateServiceDetailsMutation, UpdateServiceDetailsMutationVariables>;

/**
 * __useUpdateServiceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateServiceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceDetailsMutation, { data, loading, error }] = useUpdateServiceDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateServiceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceDetailsMutation, UpdateServiceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceDetailsMutation, UpdateServiceDetailsMutationVariables>(UpdateServiceDetailsDocument, options);
      }
export type UpdateServiceDetailsMutationHookResult = ReturnType<typeof useUpdateServiceDetailsMutation>;
export type UpdateServiceDetailsMutationResult = Apollo.MutationResult<UpdateServiceDetailsMutation>;
export type UpdateServiceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateServiceDetailsMutation, UpdateServiceDetailsMutationVariables>;
export const CreateManualSubscriptionDocument = gql`
    mutation CreateManualSubscription($input: ServiceSubscriptionCreateInput!) {
  serviceSubscriptionCreate(input: $input) {
    id
  }
}
    `;
export type CreateManualSubscriptionMutationFn = Apollo.MutationFunction<CreateManualSubscriptionMutation, CreateManualSubscriptionMutationVariables>;

/**
 * __useCreateManualSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateManualSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualSubscriptionMutation, { data, loading, error }] = useCreateManualSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualSubscriptionMutation, CreateManualSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualSubscriptionMutation, CreateManualSubscriptionMutationVariables>(CreateManualSubscriptionDocument, options);
      }
export type CreateManualSubscriptionMutationHookResult = ReturnType<typeof useCreateManualSubscriptionMutation>;
export type CreateManualSubscriptionMutationResult = Apollo.MutationResult<CreateManualSubscriptionMutation>;
export type CreateManualSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateManualSubscriptionMutation, CreateManualSubscriptionMutationVariables>;
export const ActivateFreeTrialDocument = gql`
    mutation ActivateFreeTrial($subscriptionId: String!) {
  activeFreeTrial(subscriptionId: $subscriptionId)
}
    `;
export type ActivateFreeTrialMutationFn = Apollo.MutationFunction<ActivateFreeTrialMutation, ActivateFreeTrialMutationVariables>;

/**
 * __useActivateFreeTrialMutation__
 *
 * To run a mutation, you first call `useActivateFreeTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateFreeTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateFreeTrialMutation, { data, loading, error }] = useActivateFreeTrialMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useActivateFreeTrialMutation(baseOptions?: Apollo.MutationHookOptions<ActivateFreeTrialMutation, ActivateFreeTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateFreeTrialMutation, ActivateFreeTrialMutationVariables>(ActivateFreeTrialDocument, options);
      }
export type ActivateFreeTrialMutationHookResult = ReturnType<typeof useActivateFreeTrialMutation>;
export type ActivateFreeTrialMutationResult = Apollo.MutationResult<ActivateFreeTrialMutation>;
export type ActivateFreeTrialMutationOptions = Apollo.BaseMutationOptions<ActivateFreeTrialMutation, ActivateFreeTrialMutationVariables>;
export const RenewSubscriptionDocument = gql`
    mutation RenewSubscription($id: String!, $onlyActivate: Boolean) {
  serviceSubsciptionRenew(id: $id, onlyActivate: $onlyActivate) {
    id
  }
}
    `;
export type RenewSubscriptionMutationFn = Apollo.MutationFunction<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>;

/**
 * __useRenewSubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewSubscriptionMutation, { data, loading, error }] = useRenewSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      onlyActivate: // value for 'onlyActivate'
 *   },
 * });
 */
export function useRenewSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>(RenewSubscriptionDocument, options);
      }
export type RenewSubscriptionMutationHookResult = ReturnType<typeof useRenewSubscriptionMutation>;
export type RenewSubscriptionMutationResult = Apollo.MutationResult<RenewSubscriptionMutation>;
export type RenewSubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: SubscriptionUpdateInput!, $id: String!) {
  subscriptionUpdate(input: $input, id: $id)
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const DeleteSubscriptionDocument = gql`
    mutation DeleteSubscription($id: String!) {
  subscriptionDelete(id: $id)
}
    `;
export type DeleteSubscriptionMutationFn = Apollo.MutationFunction<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;

/**
 * __useDeleteSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionMutation, { data, loading, error }] = useDeleteSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>(DeleteSubscriptionDocument, options);
      }
export type DeleteSubscriptionMutationHookResult = ReturnType<typeof useDeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationResult = Apollo.MutationResult<DeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;
export const StopUserSubscriptionDocument = gql`
    mutation StopUserSubscription($id: String!) {
  serviceSubscriptionStop(id: $id)
}
    `;
export type StopUserSubscriptionMutationFn = Apollo.MutationFunction<StopUserSubscriptionMutation, StopUserSubscriptionMutationVariables>;

/**
 * __useStopUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useStopUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopUserSubscriptionMutation, { data, loading, error }] = useStopUserSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopUserSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<StopUserSubscriptionMutation, StopUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopUserSubscriptionMutation, StopUserSubscriptionMutationVariables>(StopUserSubscriptionDocument, options);
      }
export type StopUserSubscriptionMutationHookResult = ReturnType<typeof useStopUserSubscriptionMutation>;
export type StopUserSubscriptionMutationResult = Apollo.MutationResult<StopUserSubscriptionMutation>;
export type StopUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<StopUserSubscriptionMutation, StopUserSubscriptionMutationVariables>;
export const RenewUserSubscriptionDocument = gql`
    mutation RenewUserSubscription($id: String!) {
  serviceSubscriptionRenewByUser(id: $id) {
    id
    status
    expiration
  }
}
    `;
export type RenewUserSubscriptionMutationFn = Apollo.MutationFunction<RenewUserSubscriptionMutation, RenewUserSubscriptionMutationVariables>;

/**
 * __useRenewUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewUserSubscriptionMutation, { data, loading, error }] = useRenewUserSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenewUserSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewUserSubscriptionMutation, RenewUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewUserSubscriptionMutation, RenewUserSubscriptionMutationVariables>(RenewUserSubscriptionDocument, options);
      }
export type RenewUserSubscriptionMutationHookResult = ReturnType<typeof useRenewUserSubscriptionMutation>;
export type RenewUserSubscriptionMutationResult = Apollo.MutationResult<RenewUserSubscriptionMutation>;
export type RenewUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewUserSubscriptionMutation, RenewUserSubscriptionMutationVariables>;
export const TrackSignupStartDocument = gql`
    mutation TrackSignupStart($role: String!, $email: String, $externalId: Float, $sessionId: String) {
  trackSignupStart(
    role: $role
    email: $email
    externalId: $externalId
    sessionId: $sessionId
  )
}
    `;
export type TrackSignupStartMutationFn = Apollo.MutationFunction<TrackSignupStartMutation, TrackSignupStartMutationVariables>;

/**
 * __useTrackSignupStartMutation__
 *
 * To run a mutation, you first call `useTrackSignupStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackSignupStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackSignupStartMutation, { data, loading, error }] = useTrackSignupStartMutation({
 *   variables: {
 *      role: // value for 'role'
 *      email: // value for 'email'
 *      externalId: // value for 'externalId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useTrackSignupStartMutation(baseOptions?: Apollo.MutationHookOptions<TrackSignupStartMutation, TrackSignupStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackSignupStartMutation, TrackSignupStartMutationVariables>(TrackSignupStartDocument, options);
      }
export type TrackSignupStartMutationHookResult = ReturnType<typeof useTrackSignupStartMutation>;
export type TrackSignupStartMutationResult = Apollo.MutationResult<TrackSignupStartMutation>;
export type TrackSignupStartMutationOptions = Apollo.BaseMutationOptions<TrackSignupStartMutation, TrackSignupStartMutationVariables>;
export const TrackUserMagicLinkDocument = gql`
    mutation TrackUserMagicLink($email: String!, $sessionId: String) {
  trackUserMagicLink(email: $email, sessionId: $sessionId)
}
    `;
export type TrackUserMagicLinkMutationFn = Apollo.MutationFunction<TrackUserMagicLinkMutation, TrackUserMagicLinkMutationVariables>;

/**
 * __useTrackUserMagicLinkMutation__
 *
 * To run a mutation, you first call `useTrackUserMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackUserMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackUserMagicLinkMutation, { data, loading, error }] = useTrackUserMagicLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useTrackUserMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<TrackUserMagicLinkMutation, TrackUserMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackUserMagicLinkMutation, TrackUserMagicLinkMutationVariables>(TrackUserMagicLinkDocument, options);
      }
export type TrackUserMagicLinkMutationHookResult = ReturnType<typeof useTrackUserMagicLinkMutation>;
export type TrackUserMagicLinkMutationResult = Apollo.MutationResult<TrackUserMagicLinkMutation>;
export type TrackUserMagicLinkMutationOptions = Apollo.BaseMutationOptions<TrackUserMagicLinkMutation, TrackUserMagicLinkMutationVariables>;
export const GlobalUpdateUserDocument = gql`
    mutation GlobalUpdateUser($id: ID!, $input: UserUpdate!) {
  userUpdate(id: $id, input: $input) {
    id
  }
}
    `;
export type GlobalUpdateUserMutationFn = Apollo.MutationFunction<GlobalUpdateUserMutation, GlobalUpdateUserMutationVariables>;

/**
 * __useGlobalUpdateUserMutation__
 *
 * To run a mutation, you first call `useGlobalUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGlobalUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [globalUpdateUserMutation, { data, loading, error }] = useGlobalUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGlobalUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<GlobalUpdateUserMutation, GlobalUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GlobalUpdateUserMutation, GlobalUpdateUserMutationVariables>(GlobalUpdateUserDocument, options);
      }
export type GlobalUpdateUserMutationHookResult = ReturnType<typeof useGlobalUpdateUserMutation>;
export type GlobalUpdateUserMutationResult = Apollo.MutationResult<GlobalUpdateUserMutation>;
export type GlobalUpdateUserMutationOptions = Apollo.BaseMutationOptions<GlobalUpdateUserMutation, GlobalUpdateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UserUpdate!) {
  userUpdateProfile(input: $input) {
    id
    avatarUrl
    background
    bio
    dateOfBirth
    displayName
    firstName
    lastName
    onboardingStage
    unitValue
    unitShare
    oddsFormat
    country {
      code
      continent
      id
      name
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateCurrentUserBookiesDocument = gql`
    mutation UpdateCurrentUserBookies($bookieIds: [ID!]!, $userId: ID!) {
  userUpdateBookies(bookieIds: $bookieIds, userId: $userId) {
    updated
  }
}
    `;
export type UpdateCurrentUserBookiesMutationFn = Apollo.MutationFunction<UpdateCurrentUserBookiesMutation, UpdateCurrentUserBookiesMutationVariables>;

/**
 * __useUpdateCurrentUserBookiesMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserBookiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserBookiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserBookiesMutation, { data, loading, error }] = useUpdateCurrentUserBookiesMutation({
 *   variables: {
 *      bookieIds: // value for 'bookieIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateCurrentUserBookiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserBookiesMutation, UpdateCurrentUserBookiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserBookiesMutation, UpdateCurrentUserBookiesMutationVariables>(UpdateCurrentUserBookiesDocument, options);
      }
export type UpdateCurrentUserBookiesMutationHookResult = ReturnType<typeof useUpdateCurrentUserBookiesMutation>;
export type UpdateCurrentUserBookiesMutationResult = Apollo.MutationResult<UpdateCurrentUserBookiesMutation>;
export type UpdateCurrentUserBookiesMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserBookiesMutation, UpdateCurrentUserBookiesMutationVariables>;
export const UpdateCurrentUserCompetitionsDocument = gql`
    mutation UpdateCurrentUserCompetitions($competitionIds: [ID!]!, $userId: ID!) {
  userUpdateCompetitions(competitionIds: $competitionIds, userId: $userId) {
    updated
  }
}
    `;
export type UpdateCurrentUserCompetitionsMutationFn = Apollo.MutationFunction<UpdateCurrentUserCompetitionsMutation, UpdateCurrentUserCompetitionsMutationVariables>;

/**
 * __useUpdateCurrentUserCompetitionsMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserCompetitionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserCompetitionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserCompetitionsMutation, { data, loading, error }] = useUpdateCurrentUserCompetitionsMutation({
 *   variables: {
 *      competitionIds: // value for 'competitionIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateCurrentUserCompetitionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserCompetitionsMutation, UpdateCurrentUserCompetitionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserCompetitionsMutation, UpdateCurrentUserCompetitionsMutationVariables>(UpdateCurrentUserCompetitionsDocument, options);
      }
export type UpdateCurrentUserCompetitionsMutationHookResult = ReturnType<typeof useUpdateCurrentUserCompetitionsMutation>;
export type UpdateCurrentUserCompetitionsMutationResult = Apollo.MutationResult<UpdateCurrentUserCompetitionsMutation>;
export type UpdateCurrentUserCompetitionsMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserCompetitionsMutation, UpdateCurrentUserCompetitionsMutationVariables>;
export const UpdateCurrentUserSportsDocument = gql`
    mutation UpdateCurrentUserSports($sportsIds: [ID!]!, $userId: ID!) {
  userUpdateSports(sportsIds: $sportsIds, userId: $userId) {
    updated
  }
}
    `;
export type UpdateCurrentUserSportsMutationFn = Apollo.MutationFunction<UpdateCurrentUserSportsMutation, UpdateCurrentUserSportsMutationVariables>;

/**
 * __useUpdateCurrentUserSportsMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserSportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserSportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserSportsMutation, { data, loading, error }] = useUpdateCurrentUserSportsMutation({
 *   variables: {
 *      sportsIds: // value for 'sportsIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateCurrentUserSportsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserSportsMutation, UpdateCurrentUserSportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserSportsMutation, UpdateCurrentUserSportsMutationVariables>(UpdateCurrentUserSportsDocument, options);
      }
export type UpdateCurrentUserSportsMutationHookResult = ReturnType<typeof useUpdateCurrentUserSportsMutation>;
export type UpdateCurrentUserSportsMutationResult = Apollo.MutationResult<UpdateCurrentUserSportsMutation>;
export type UpdateCurrentUserSportsMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserSportsMutation, UpdateCurrentUserSportsMutationVariables>;
export const UpdateCurrentUserMarketsDocument = gql`
    mutation UpdateCurrentUserMarkets($marketsIds: [ID!]!, $userId: ID!) {
  userUpdateMarkets(marketsIds: $marketsIds, userId: $userId) {
    updated
  }
}
    `;
export type UpdateCurrentUserMarketsMutationFn = Apollo.MutationFunction<UpdateCurrentUserMarketsMutation, UpdateCurrentUserMarketsMutationVariables>;

/**
 * __useUpdateCurrentUserMarketsMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMarketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMarketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserMarketsMutation, { data, loading, error }] = useUpdateCurrentUserMarketsMutation({
 *   variables: {
 *      marketsIds: // value for 'marketsIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateCurrentUserMarketsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserMarketsMutation, UpdateCurrentUserMarketsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserMarketsMutation, UpdateCurrentUserMarketsMutationVariables>(UpdateCurrentUserMarketsDocument, options);
      }
export type UpdateCurrentUserMarketsMutationHookResult = ReturnType<typeof useUpdateCurrentUserMarketsMutation>;
export type UpdateCurrentUserMarketsMutationResult = Apollo.MutationResult<UpdateCurrentUserMarketsMutation>;
export type UpdateCurrentUserMarketsMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserMarketsMutation, UpdateCurrentUserMarketsMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($input: UserCreate!) {
  userCreate(input: $input) {
    id
    onboardingStage
    country {
      id
    }
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const FollowChannelByLinkNameDocument = gql`
    mutation FollowChannelByLinkName($internalName: String!) {
  followChannelByLinkName(internalName: $internalName) {
    result
    channelId
  }
}
    `;
export type FollowChannelByLinkNameMutationFn = Apollo.MutationFunction<FollowChannelByLinkNameMutation, FollowChannelByLinkNameMutationVariables>;

/**
 * __useFollowChannelByLinkNameMutation__
 *
 * To run a mutation, you first call `useFollowChannelByLinkNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowChannelByLinkNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followChannelByLinkNameMutation, { data, loading, error }] = useFollowChannelByLinkNameMutation({
 *   variables: {
 *      internalName: // value for 'internalName'
 *   },
 * });
 */
export function useFollowChannelByLinkNameMutation(baseOptions?: Apollo.MutationHookOptions<FollowChannelByLinkNameMutation, FollowChannelByLinkNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowChannelByLinkNameMutation, FollowChannelByLinkNameMutationVariables>(FollowChannelByLinkNameDocument, options);
      }
export type FollowChannelByLinkNameMutationHookResult = ReturnType<typeof useFollowChannelByLinkNameMutation>;
export type FollowChannelByLinkNameMutationResult = Apollo.MutationResult<FollowChannelByLinkNameMutation>;
export type FollowChannelByLinkNameMutationOptions = Apollo.BaseMutationOptions<FollowChannelByLinkNameMutation, FollowChannelByLinkNameMutationVariables>;
export const ClickAnonymousDocument = gql`
    mutation ClickAnonymous($input: ID!) {
  clickAnonymous(tipsterId: $input) {
    tipsterId
  }
}
    `;
export type ClickAnonymousMutationFn = Apollo.MutationFunction<ClickAnonymousMutation, ClickAnonymousMutationVariables>;

/**
 * __useClickAnonymousMutation__
 *
 * To run a mutation, you first call `useClickAnonymousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickAnonymousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickAnonymousMutation, { data, loading, error }] = useClickAnonymousMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClickAnonymousMutation(baseOptions?: Apollo.MutationHookOptions<ClickAnonymousMutation, ClickAnonymousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClickAnonymousMutation, ClickAnonymousMutationVariables>(ClickAnonymousDocument, options);
      }
export type ClickAnonymousMutationHookResult = ReturnType<typeof useClickAnonymousMutation>;
export type ClickAnonymousMutationResult = Apollo.MutationResult<ClickAnonymousMutation>;
export type ClickAnonymousMutationOptions = Apollo.BaseMutationOptions<ClickAnonymousMutation, ClickAnonymousMutationVariables>;
export const GenerateTipsterInviteLinkDocument = gql`
    mutation GenerateTipsterInviteLink($userId: ID!) {
  generateTipsterInviteLink(userId: $userId) {
    affiliateId
  }
}
    `;
export type GenerateTipsterInviteLinkMutationFn = Apollo.MutationFunction<GenerateTipsterInviteLinkMutation, GenerateTipsterInviteLinkMutationVariables>;

/**
 * __useGenerateTipsterInviteLinkMutation__
 *
 * To run a mutation, you first call `useGenerateTipsterInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTipsterInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTipsterInviteLinkMutation, { data, loading, error }] = useGenerateTipsterInviteLinkMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateTipsterInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTipsterInviteLinkMutation, GenerateTipsterInviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTipsterInviteLinkMutation, GenerateTipsterInviteLinkMutationVariables>(GenerateTipsterInviteLinkDocument, options);
      }
export type GenerateTipsterInviteLinkMutationHookResult = ReturnType<typeof useGenerateTipsterInviteLinkMutation>;
export type GenerateTipsterInviteLinkMutationResult = Apollo.MutationResult<GenerateTipsterInviteLinkMutation>;
export type GenerateTipsterInviteLinkMutationOptions = Apollo.BaseMutationOptions<GenerateTipsterInviteLinkMutation, GenerateTipsterInviteLinkMutationVariables>;
export const FollowUserByLinkNameDocument = gql`
    mutation FollowUserByLinkName($linkName: String!) {
  followUserByLinkName(linkName: $linkName) {
    id
  }
}
    `;
export type FollowUserByLinkNameMutationFn = Apollo.MutationFunction<FollowUserByLinkNameMutation, FollowUserByLinkNameMutationVariables>;

/**
 * __useFollowUserByLinkNameMutation__
 *
 * To run a mutation, you first call `useFollowUserByLinkNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserByLinkNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserByLinkNameMutation, { data, loading, error }] = useFollowUserByLinkNameMutation({
 *   variables: {
 *      linkName: // value for 'linkName'
 *   },
 * });
 */
export function useFollowUserByLinkNameMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserByLinkNameMutation, FollowUserByLinkNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserByLinkNameMutation, FollowUserByLinkNameMutationVariables>(FollowUserByLinkNameDocument, options);
      }
export type FollowUserByLinkNameMutationHookResult = ReturnType<typeof useFollowUserByLinkNameMutation>;
export type FollowUserByLinkNameMutationResult = Apollo.MutationResult<FollowUserByLinkNameMutation>;
export type FollowUserByLinkNameMutationOptions = Apollo.BaseMutationOptions<FollowUserByLinkNameMutation, FollowUserByLinkNameMutationVariables>;
export const UploadTipsterStatDocument = gql`
    mutation UploadTipsterStat($input: String!) {
  uploadStatImage(input: $input) {
    image
  }
}
    `;
export type UploadTipsterStatMutationFn = Apollo.MutationFunction<UploadTipsterStatMutation, UploadTipsterStatMutationVariables>;

/**
 * __useUploadTipsterStatMutation__
 *
 * To run a mutation, you first call `useUploadTipsterStatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTipsterStatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTipsterStatMutation, { data, loading, error }] = useUploadTipsterStatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadTipsterStatMutation(baseOptions?: Apollo.MutationHookOptions<UploadTipsterStatMutation, UploadTipsterStatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadTipsterStatMutation, UploadTipsterStatMutationVariables>(UploadTipsterStatDocument, options);
      }
export type UploadTipsterStatMutationHookResult = ReturnType<typeof useUploadTipsterStatMutation>;
export type UploadTipsterStatMutationResult = Apollo.MutationResult<UploadTipsterStatMutation>;
export type UploadTipsterStatMutationOptions = Apollo.BaseMutationOptions<UploadTipsterStatMutation, UploadTipsterStatMutationVariables>;
export const DeleteTipsterStatImageDocument = gql`
    mutation DeleteTipsterStatImage($input: String!) {
  deleteStatImage(input: $input) {
    id
    image
    tipsterId
  }
}
    `;
export type DeleteTipsterStatImageMutationFn = Apollo.MutationFunction<DeleteTipsterStatImageMutation, DeleteTipsterStatImageMutationVariables>;

/**
 * __useDeleteTipsterStatImageMutation__
 *
 * To run a mutation, you first call `useDeleteTipsterStatImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTipsterStatImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTipsterStatImageMutation, { data, loading, error }] = useDeleteTipsterStatImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTipsterStatImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTipsterStatImageMutation, DeleteTipsterStatImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTipsterStatImageMutation, DeleteTipsterStatImageMutationVariables>(DeleteTipsterStatImageDocument, options);
      }
export type DeleteTipsterStatImageMutationHookResult = ReturnType<typeof useDeleteTipsterStatImageMutation>;
export type DeleteTipsterStatImageMutationResult = Apollo.MutationResult<DeleteTipsterStatImageMutation>;
export type DeleteTipsterStatImageMutationOptions = Apollo.BaseMutationOptions<DeleteTipsterStatImageMutation, DeleteTipsterStatImageMutationVariables>;
export const JoinWaitListDocument = gql`
    mutation JoinWaitList($input: JoinWaitlistCreateInput!) {
  joinWaitlist(input: $input) {
    id
    email
  }
}
    `;
export type JoinWaitListMutationFn = Apollo.MutationFunction<JoinWaitListMutation, JoinWaitListMutationVariables>;

/**
 * __useJoinWaitListMutation__
 *
 * To run a mutation, you first call `useJoinWaitListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinWaitListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinWaitListMutation, { data, loading, error }] = useJoinWaitListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinWaitListMutation(baseOptions?: Apollo.MutationHookOptions<JoinWaitListMutation, JoinWaitListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinWaitListMutation, JoinWaitListMutationVariables>(JoinWaitListDocument, options);
      }
export type JoinWaitListMutationHookResult = ReturnType<typeof useJoinWaitListMutation>;
export type JoinWaitListMutationResult = Apollo.MutationResult<JoinWaitListMutation>;
export type JoinWaitListMutationOptions = Apollo.BaseMutationOptions<JoinWaitListMutation, JoinWaitListMutationVariables>;
export const GetAdvertisementDocument = gql`
    query GetAdvertisement($channelId: ID, $placement: Placement!, $filter: AdsFilter, $excludeIds: [ID!]) {
  adsByPlacement(
    channelId: $channelId
    placement: $placement
    filter: $filter
    excludeIds: $excludeIds
  ) {
    id
    imageUrl
    referral
    title
    description
    ctaText
    ctaLink
    variant
    frequencyCapImpressions
    frequencyCapWindow
    rotationWeight
  }
}
    `;

/**
 * __useGetAdvertisementQuery__
 *
 * To run a query within a React component, call `useGetAdvertisementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertisementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertisementQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      placement: // value for 'placement'
 *      filter: // value for 'filter'
 *      excludeIds: // value for 'excludeIds'
 *   },
 * });
 */
export function useGetAdvertisementQuery(baseOptions: Apollo.QueryHookOptions<GetAdvertisementQuery, GetAdvertisementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertisementQuery, GetAdvertisementQueryVariables>(GetAdvertisementDocument, options);
      }
export function useGetAdvertisementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertisementQuery, GetAdvertisementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertisementQuery, GetAdvertisementQueryVariables>(GetAdvertisementDocument, options);
        }
export type GetAdvertisementQueryHookResult = ReturnType<typeof useGetAdvertisementQuery>;
export type GetAdvertisementLazyQueryHookResult = ReturnType<typeof useGetAdvertisementLazyQuery>;
export type GetAdvertisementQueryResult = Apollo.QueryResult<GetAdvertisementQuery, GetAdvertisementQueryVariables>;
export const GetAdvertsDocument = gql`
    query GetAdverts($filter: AdsFilter, $limit: Int = 10, $skip: Int = 0, $sort: AdsSort) {
  ads(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    ads {
      id
      title
      imageUrl
      referral
      isActive
      visible
      startDate
      expirationDate
      placement
      updatedAt
      createdAt
    }
    count
  }
}
    `;

/**
 * __useGetAdvertsQuery__
 *
 * To run a query within a React component, call `useGetAdvertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdvertsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvertsQuery, GetAdvertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertsQuery, GetAdvertsQueryVariables>(GetAdvertsDocument, options);
      }
export function useGetAdvertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertsQuery, GetAdvertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertsQuery, GetAdvertsQueryVariables>(GetAdvertsDocument, options);
        }
export type GetAdvertsQueryHookResult = ReturnType<typeof useGetAdvertsQuery>;
export type GetAdvertsLazyQueryHookResult = ReturnType<typeof useGetAdvertsLazyQuery>;
export type GetAdvertsQueryResult = Apollo.QueryResult<GetAdvertsQuery, GetAdvertsQueryVariables>;
export const GetAdStatsDocument = gql`
    query GetAdStats($id: ID!) {
  adStats(id: $id) {
    totalViews
    uniqueViews
    clicks
    viewFrequency
    uniqueCtr
    totalCtr
    timeSeries {
      date
      impressions
      uniqueViews
      clicks
    }
  }
}
    `;

/**
 * __useGetAdStatsQuery__
 *
 * To run a query within a React component, call `useGetAdStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAdStatsQuery, GetAdStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdStatsQuery, GetAdStatsQueryVariables>(GetAdStatsDocument, options);
      }
export function useGetAdStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdStatsQuery, GetAdStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdStatsQuery, GetAdStatsQueryVariables>(GetAdStatsDocument, options);
        }
export type GetAdStatsQueryHookResult = ReturnType<typeof useGetAdStatsQuery>;
export type GetAdStatsLazyQueryHookResult = ReturnType<typeof useGetAdStatsLazyQuery>;
export type GetAdStatsQueryResult = Apollo.QueryResult<GetAdStatsQuery, GetAdStatsQueryVariables>;
export const GetAdsMiniStatsDocument = gql`
    query GetAdsMiniStats($ids: [ID!]!) {
  adsMiniStats(ids: $ids) {
    adId
    views
    clicks
  }
}
    `;

/**
 * __useGetAdsMiniStatsQuery__
 *
 * To run a query within a React component, call `useGetAdsMiniStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdsMiniStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdsMiniStatsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAdsMiniStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAdsMiniStatsQuery, GetAdsMiniStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdsMiniStatsQuery, GetAdsMiniStatsQueryVariables>(GetAdsMiniStatsDocument, options);
      }
export function useGetAdsMiniStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdsMiniStatsQuery, GetAdsMiniStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdsMiniStatsQuery, GetAdsMiniStatsQueryVariables>(GetAdsMiniStatsDocument, options);
        }
export type GetAdsMiniStatsQueryHookResult = ReturnType<typeof useGetAdsMiniStatsQuery>;
export type GetAdsMiniStatsLazyQueryHookResult = ReturnType<typeof useGetAdsMiniStatsLazyQuery>;
export type GetAdsMiniStatsQueryResult = Apollo.QueryResult<GetAdsMiniStatsQuery, GetAdsMiniStatsQueryVariables>;
export const GetAdvertByIdDocument = gql`
    query GetAdvertById($id: ID!) {
  adsById(id: $id) {
    id
    title
    imageUrl
    referral
    isActive
    visible
    startDate
    expirationDate
    placement
    description
    ctaText
    ctaLink
    variant
    frequencyCapImpressions
    frequencyCapWindow
    rotationWeight
    targets {
      channelId
      countryIds
    }
  }
}
    `;

/**
 * __useGetAdvertByIdQuery__
 *
 * To run a query within a React component, call `useGetAdvertByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvertByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvertByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdvertByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAdvertByIdQuery, GetAdvertByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvertByIdQuery, GetAdvertByIdQueryVariables>(GetAdvertByIdDocument, options);
      }
export function useGetAdvertByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvertByIdQuery, GetAdvertByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvertByIdQuery, GetAdvertByIdQueryVariables>(GetAdvertByIdDocument, options);
        }
export type GetAdvertByIdQueryHookResult = ReturnType<typeof useGetAdvertByIdQuery>;
export type GetAdvertByIdLazyQueryHookResult = ReturnType<typeof useGetAdvertByIdLazyQuery>;
export type GetAdvertByIdQueryResult = Apollo.QueryResult<GetAdvertByIdQuery, GetAdvertByIdQueryVariables>;
export const GenerateAiTipAnalysisDocument = gql`
    query GenerateAiTipAnalysis($input: [TipAnalysisInput!]!, $betType: BetType, $confidence: Float, $odds: Float) {
  aiTipAnalysis(
    input: $input
    betType: $betType
    confidence: $confidence
    odds: $odds
  )
}
    `;

/**
 * __useGenerateAiTipAnalysisQuery__
 *
 * To run a query within a React component, call `useGenerateAiTipAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiTipAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateAiTipAnalysisQuery({
 *   variables: {
 *      input: // value for 'input'
 *      betType: // value for 'betType'
 *      confidence: // value for 'confidence'
 *      odds: // value for 'odds'
 *   },
 * });
 */
export function useGenerateAiTipAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GenerateAiTipAnalysisQuery, GenerateAiTipAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateAiTipAnalysisQuery, GenerateAiTipAnalysisQueryVariables>(GenerateAiTipAnalysisDocument, options);
      }
export function useGenerateAiTipAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateAiTipAnalysisQuery, GenerateAiTipAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateAiTipAnalysisQuery, GenerateAiTipAnalysisQueryVariables>(GenerateAiTipAnalysisDocument, options);
        }
export type GenerateAiTipAnalysisQueryHookResult = ReturnType<typeof useGenerateAiTipAnalysisQuery>;
export type GenerateAiTipAnalysisLazyQueryHookResult = ReturnType<typeof useGenerateAiTipAnalysisLazyQuery>;
export type GenerateAiTipAnalysisQueryResult = Apollo.QueryResult<GenerateAiTipAnalysisQuery, GenerateAiTipAnalysisQueryVariables>;
export const ImproveContentDocument = gql`
    query ImproveContent($text: String!) {
  improveContent(text: $text)
}
    `;

/**
 * __useImproveContentQuery__
 *
 * To run a query within a React component, call `useImproveContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useImproveContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImproveContentQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useImproveContentQuery(baseOptions: Apollo.QueryHookOptions<ImproveContentQuery, ImproveContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImproveContentQuery, ImproveContentQueryVariables>(ImproveContentDocument, options);
      }
export function useImproveContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImproveContentQuery, ImproveContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImproveContentQuery, ImproveContentQueryVariables>(ImproveContentDocument, options);
        }
export type ImproveContentQueryHookResult = ReturnType<typeof useImproveContentQuery>;
export type ImproveContentLazyQueryHookResult = ReturnType<typeof useImproveContentLazyQuery>;
export type ImproveContentQueryResult = Apollo.QueryResult<ImproveContentQuery, ImproveContentQueryVariables>;
export const GetListTelegramShareSyncDocument = gql`
    query GetListTelegramShareSync($channelId: String!) {
  listTelegramShareSync(channelId: $channelId) {
    id
    userId
    channelId
    linkVerificationToken
    status
    displayType
    contentTypes
  }
}
    `;

/**
 * __useGetListTelegramShareSyncQuery__
 *
 * To run a query within a React component, call `useGetListTelegramShareSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListTelegramShareSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListTelegramShareSyncQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetListTelegramShareSyncQuery(baseOptions: Apollo.QueryHookOptions<GetListTelegramShareSyncQuery, GetListTelegramShareSyncQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListTelegramShareSyncQuery, GetListTelegramShareSyncQueryVariables>(GetListTelegramShareSyncDocument, options);
      }
export function useGetListTelegramShareSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListTelegramShareSyncQuery, GetListTelegramShareSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListTelegramShareSyncQuery, GetListTelegramShareSyncQueryVariables>(GetListTelegramShareSyncDocument, options);
        }
export type GetListTelegramShareSyncQueryHookResult = ReturnType<typeof useGetListTelegramShareSyncQuery>;
export type GetListTelegramShareSyncLazyQueryHookResult = ReturnType<typeof useGetListTelegramShareSyncLazyQuery>;
export type GetListTelegramShareSyncQueryResult = Apollo.QueryResult<GetListTelegramShareSyncQuery, GetListTelegramShareSyncQueryVariables>;
export const GetgenerateTelegramBotLinkDocument = gql`
    query GetgenerateTelegramBotLink($payload: AutoShareContentTypeInput!) {
  generateTelegramBotLink(shareType: $payload)
}
    `;

/**
 * __useGetgenerateTelegramBotLinkQuery__
 *
 * To run a query within a React component, call `useGetgenerateTelegramBotLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetgenerateTelegramBotLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetgenerateTelegramBotLinkQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetgenerateTelegramBotLinkQuery(baseOptions: Apollo.QueryHookOptions<GetgenerateTelegramBotLinkQuery, GetgenerateTelegramBotLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetgenerateTelegramBotLinkQuery, GetgenerateTelegramBotLinkQueryVariables>(GetgenerateTelegramBotLinkDocument, options);
      }
export function useGetgenerateTelegramBotLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetgenerateTelegramBotLinkQuery, GetgenerateTelegramBotLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetgenerateTelegramBotLinkQuery, GetgenerateTelegramBotLinkQueryVariables>(GetgenerateTelegramBotLinkDocument, options);
        }
export type GetgenerateTelegramBotLinkQueryHookResult = ReturnType<typeof useGetgenerateTelegramBotLinkQuery>;
export type GetgenerateTelegramBotLinkLazyQueryHookResult = ReturnType<typeof useGetgenerateTelegramBotLinkLazyQuery>;
export type GetgenerateTelegramBotLinkQueryResult = Apollo.QueryResult<GetgenerateTelegramBotLinkQuery, GetgenerateTelegramBotLinkQueryVariables>;
export const GetBonusesDocument = gql`
    query GetBonuses($limit: Int!, $skip: Int!, $countryIds: [ID!]) {
  bonuses(limit: $limit, skip: $skip, countryIds: $countryIds) {
    bonuses {
      id
      title
      description
      imageUrl
      buttonName
      buttonUrl
      rewardType
      socialRating
      features
      termsAndConditions
      allowedCountryIds
      order
      createdAt
      updatedAt
    }
    count
  }
}
    `;

/**
 * __useGetBonusesQuery__
 *
 * To run a query within a React component, call `useGetBonusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBonusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBonusesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useGetBonusesQuery(baseOptions: Apollo.QueryHookOptions<GetBonusesQuery, GetBonusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBonusesQuery, GetBonusesQueryVariables>(GetBonusesDocument, options);
      }
export function useGetBonusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBonusesQuery, GetBonusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBonusesQuery, GetBonusesQueryVariables>(GetBonusesDocument, options);
        }
export type GetBonusesQueryHookResult = ReturnType<typeof useGetBonusesQuery>;
export type GetBonusesLazyQueryHookResult = ReturnType<typeof useGetBonusesLazyQuery>;
export type GetBonusesQueryResult = Apollo.QueryResult<GetBonusesQuery, GetBonusesQueryVariables>;
export const GetBonusByIdDocument = gql`
    query GetBonusById($id: String!) {
  bonus(id: $id) {
    id
    title
    description
    imageUrl
    buttonName
    buttonUrl
    rewardType
    socialRating
    features
    termsAndConditions
    allowedCountryIds
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetBonusByIdQuery__
 *
 * To run a query within a React component, call `useGetBonusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBonusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBonusByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBonusByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBonusByIdQuery, GetBonusByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBonusByIdQuery, GetBonusByIdQueryVariables>(GetBonusByIdDocument, options);
      }
export function useGetBonusByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBonusByIdQuery, GetBonusByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBonusByIdQuery, GetBonusByIdQueryVariables>(GetBonusByIdDocument, options);
        }
export type GetBonusByIdQueryHookResult = ReturnType<typeof useGetBonusByIdQuery>;
export type GetBonusByIdLazyQueryHookResult = ReturnType<typeof useGetBonusByIdLazyQuery>;
export type GetBonusByIdQueryResult = Apollo.QueryResult<GetBonusByIdQuery, GetBonusByIdQueryVariables>;
export const BookiesDocument = gql`
    query bookies {
  bookies {
    id
    name
  }
}
    `;

/**
 * __useBookiesQuery__
 *
 * To run a query within a React component, call `useBookiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookiesQuery(baseOptions?: Apollo.QueryHookOptions<BookiesQuery, BookiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookiesQuery, BookiesQueryVariables>(BookiesDocument, options);
      }
export function useBookiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookiesQuery, BookiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookiesQuery, BookiesQueryVariables>(BookiesDocument, options);
        }
export type BookiesQueryHookResult = ReturnType<typeof useBookiesQuery>;
export type BookiesLazyQueryHookResult = ReturnType<typeof useBookiesLazyQuery>;
export type BookiesQueryResult = Apollo.QueryResult<BookiesQuery, BookiesQueryVariables>;
export const GetTenantBookiesDocument = gql`
    query GetTenantBookies($countryIds: [ID!]) {
  tenantBookies(countryIds: $countryIds) {
    id
    bookieId
    externalId
    customName
    name
    title
    imageUrl
    bonusLink
    affiliateLink
    buttonText
    rewardType {
      id
      name
      iconName
    }
    rewardDescription
    isVisible
    isDefault
    isMandatory
    sortOrder
    allowedCountryIds
  }
}
    `;

/**
 * __useGetTenantBookiesQuery__
 *
 * To run a query within a React component, call `useGetTenantBookiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantBookiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantBookiesQuery({
 *   variables: {
 *      countryIds: // value for 'countryIds'
 *   },
 * });
 */
export function useGetTenantBookiesQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantBookiesQuery, GetTenantBookiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantBookiesQuery, GetTenantBookiesQueryVariables>(GetTenantBookiesDocument, options);
      }
export function useGetTenantBookiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantBookiesQuery, GetTenantBookiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantBookiesQuery, GetTenantBookiesQueryVariables>(GetTenantBookiesDocument, options);
        }
export type GetTenantBookiesQueryHookResult = ReturnType<typeof useGetTenantBookiesQuery>;
export type GetTenantBookiesLazyQueryHookResult = ReturnType<typeof useGetTenantBookiesLazyQuery>;
export type GetTenantBookiesQueryResult = Apollo.QueryResult<GetTenantBookiesQuery, GetTenantBookiesQueryVariables>;
export const SearchBookmakersDocument = gql`
    query SearchBookmakers($search: String, $limit: Int = 20, $offset: Int = 0) {
  searchBookmakers(search: $search, limit: $limit, offset: $offset) {
    bookmakers {
      id
      name
      imageUrl
    }
    total
  }
}
    `;

/**
 * __useSearchBookmakersQuery__
 *
 * To run a query within a React component, call `useSearchBookmakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBookmakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBookmakersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchBookmakersQuery(baseOptions?: Apollo.QueryHookOptions<SearchBookmakersQuery, SearchBookmakersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBookmakersQuery, SearchBookmakersQueryVariables>(SearchBookmakersDocument, options);
      }
export function useSearchBookmakersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBookmakersQuery, SearchBookmakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBookmakersQuery, SearchBookmakersQueryVariables>(SearchBookmakersDocument, options);
        }
export type SearchBookmakersQueryHookResult = ReturnType<typeof useSearchBookmakersQuery>;
export type SearchBookmakersLazyQueryHookResult = ReturnType<typeof useSearchBookmakersLazyQuery>;
export type SearchBookmakersQueryResult = Apollo.QueryResult<SearchBookmakersQuery, SearchBookmakersQueryVariables>;
export const GetTenantBookieStatsDocument = gql`
    query GetTenantBookieStats($id: ID!) {
  tenantBookieStats(id: $id) {
    totalViews
    uniqueViews
    clicks
    viewFrequency
    uniqueCtr
    totalCtr
    timeSeries {
      date
      impressions
      uniqueViews
      clicks
    }
  }
}
    `;

/**
 * __useGetTenantBookieStatsQuery__
 *
 * To run a query within a React component, call `useGetTenantBookieStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantBookieStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantBookieStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTenantBookieStatsQuery(baseOptions: Apollo.QueryHookOptions<GetTenantBookieStatsQuery, GetTenantBookieStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantBookieStatsQuery, GetTenantBookieStatsQueryVariables>(GetTenantBookieStatsDocument, options);
      }
export function useGetTenantBookieStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantBookieStatsQuery, GetTenantBookieStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantBookieStatsQuery, GetTenantBookieStatsQueryVariables>(GetTenantBookieStatsDocument, options);
        }
export type GetTenantBookieStatsQueryHookResult = ReturnType<typeof useGetTenantBookieStatsQuery>;
export type GetTenantBookieStatsLazyQueryHookResult = ReturnType<typeof useGetTenantBookieStatsLazyQuery>;
export type GetTenantBookieStatsQueryResult = Apollo.QueryResult<GetTenantBookieStatsQuery, GetTenantBookieStatsQueryVariables>;
export const GetRewardTypesDocument = gql`
    query GetRewardTypes {
  rewardTypes {
    id
    name
    iconName
    sortOrder
  }
}
    `;

/**
 * __useGetRewardTypesQuery__
 *
 * To run a query within a React component, call `useGetRewardTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRewardTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetRewardTypesQuery, GetRewardTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardTypesQuery, GetRewardTypesQueryVariables>(GetRewardTypesDocument, options);
      }
export function useGetRewardTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardTypesQuery, GetRewardTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardTypesQuery, GetRewardTypesQueryVariables>(GetRewardTypesDocument, options);
        }
export type GetRewardTypesQueryHookResult = ReturnType<typeof useGetRewardTypesQuery>;
export type GetRewardTypesLazyQueryHookResult = ReturnType<typeof useGetRewardTypesLazyQuery>;
export type GetRewardTypesQueryResult = Apollo.QueryResult<GetRewardTypesQuery, GetRewardTypesQueryVariables>;
export const TenantBookiesForOutcomeDocument = gql`
    query TenantBookiesForOutcome($eventId: ID!, $marketId: ID!, $outcomeId: ID, $sortByHighOdds: Boolean = false, $userCountryId: ID) {
  tenantBookiesForOutcome(
    eventId: $eventId
    marketId: $marketId
    outcomeId: $outcomeId
    sortByHighOdds: $sortByHighOdds
    userCountryId: $userCountryId
  ) {
    id
    bookieId
    externalId
    name
    imageUrl
    bonusLink
    buttonText
    rewardTypeName
    rewardDescription
    odd
    sortOrder
    isDefault
    isFavorite
  }
}
    `;

/**
 * __useTenantBookiesForOutcomeQuery__
 *
 * To run a query within a React component, call `useTenantBookiesForOutcomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantBookiesForOutcomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantBookiesForOutcomeQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      marketId: // value for 'marketId'
 *      outcomeId: // value for 'outcomeId'
 *      sortByHighOdds: // value for 'sortByHighOdds'
 *      userCountryId: // value for 'userCountryId'
 *   },
 * });
 */
export function useTenantBookiesForOutcomeQuery(baseOptions: Apollo.QueryHookOptions<TenantBookiesForOutcomeQuery, TenantBookiesForOutcomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantBookiesForOutcomeQuery, TenantBookiesForOutcomeQueryVariables>(TenantBookiesForOutcomeDocument, options);
      }
export function useTenantBookiesForOutcomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantBookiesForOutcomeQuery, TenantBookiesForOutcomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantBookiesForOutcomeQuery, TenantBookiesForOutcomeQueryVariables>(TenantBookiesForOutcomeDocument, options);
        }
export type TenantBookiesForOutcomeQueryHookResult = ReturnType<typeof useTenantBookiesForOutcomeQuery>;
export type TenantBookiesForOutcomeLazyQueryHookResult = ReturnType<typeof useTenantBookiesForOutcomeLazyQuery>;
export type TenantBookiesForOutcomeQueryResult = Apollo.QueryResult<TenantBookiesForOutcomeQuery, TenantBookiesForOutcomeQueryVariables>;
export const TenantBookiesForMultitipDocument = gql`
    query TenantBookiesForMultitip($contentId: ID!, $sortByHighOdds: Boolean = false, $userCountryId: ID) {
  tenantBookiesForMultitip(
    contentId: $contentId
    sortByHighOdds: $sortByHighOdds
    userCountryId: $userCountryId
  ) {
    id
    bookieId
    externalId
    name
    imageUrl
    bonusLink
    buttonText
    rewardTypeName
    rewardDescription
    odd
    sortOrder
    isDefault
    isFavorite
  }
}
    `;

/**
 * __useTenantBookiesForMultitipQuery__
 *
 * To run a query within a React component, call `useTenantBookiesForMultitipQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantBookiesForMultitipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantBookiesForMultitipQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      sortByHighOdds: // value for 'sortByHighOdds'
 *      userCountryId: // value for 'userCountryId'
 *   },
 * });
 */
export function useTenantBookiesForMultitipQuery(baseOptions: Apollo.QueryHookOptions<TenantBookiesForMultitipQuery, TenantBookiesForMultitipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantBookiesForMultitipQuery, TenantBookiesForMultitipQueryVariables>(TenantBookiesForMultitipDocument, options);
      }
export function useTenantBookiesForMultitipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantBookiesForMultitipQuery, TenantBookiesForMultitipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantBookiesForMultitipQuery, TenantBookiesForMultitipQueryVariables>(TenantBookiesForMultitipDocument, options);
        }
export type TenantBookiesForMultitipQueryHookResult = ReturnType<typeof useTenantBookiesForMultitipQuery>;
export type TenantBookiesForMultitipLazyQueryHookResult = ReturnType<typeof useTenantBookiesForMultitipLazyQuery>;
export type TenantBookiesForMultitipQueryResult = Apollo.QueryResult<TenantBookiesForMultitipQuery, TenantBookiesForMultitipQueryVariables>;
export const GetMyFavoriteBookieDocument = gql`
    query GetMyFavoriteBookie {
  myFavoriteBookie {
    id
    tenantBookieId
  }
}
    `;

/**
 * __useGetMyFavoriteBookieQuery__
 *
 * To run a query within a React component, call `useGetMyFavoriteBookieQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFavoriteBookieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFavoriteBookieQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFavoriteBookieQuery(baseOptions?: Apollo.QueryHookOptions<GetMyFavoriteBookieQuery, GetMyFavoriteBookieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyFavoriteBookieQuery, GetMyFavoriteBookieQueryVariables>(GetMyFavoriteBookieDocument, options);
      }
export function useGetMyFavoriteBookieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFavoriteBookieQuery, GetMyFavoriteBookieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyFavoriteBookieQuery, GetMyFavoriteBookieQueryVariables>(GetMyFavoriteBookieDocument, options);
        }
export type GetMyFavoriteBookieQueryHookResult = ReturnType<typeof useGetMyFavoriteBookieQuery>;
export type GetMyFavoriteBookieLazyQueryHookResult = ReturnType<typeof useGetMyFavoriteBookieLazyQuery>;
export type GetMyFavoriteBookieQueryResult = Apollo.QueryResult<GetMyFavoriteBookieQuery, GetMyFavoriteBookieQueryVariables>;
export const ChannelUsersCountDocument = gql`
    query channelUsersCount {
  channelUsersCount
}
    `;

/**
 * __useChannelUsersCountQuery__
 *
 * To run a query within a React component, call `useChannelUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelUsersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useChannelUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<ChannelUsersCountQuery, ChannelUsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelUsersCountQuery, ChannelUsersCountQueryVariables>(ChannelUsersCountDocument, options);
      }
export function useChannelUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelUsersCountQuery, ChannelUsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelUsersCountQuery, ChannelUsersCountQueryVariables>(ChannelUsersCountDocument, options);
        }
export type ChannelUsersCountQueryHookResult = ReturnType<typeof useChannelUsersCountQuery>;
export type ChannelUsersCountLazyQueryHookResult = ReturnType<typeof useChannelUsersCountLazyQuery>;
export type ChannelUsersCountQueryResult = Apollo.QueryResult<ChannelUsersCountQuery, ChannelUsersCountQueryVariables>;
export const PrivateChannelContentDocument = gql`
    query PrivateChannelContent($channelId: String!, $limit: Int! = 10, $cursor: FeedCursorInput, $filter: ChannelFeedFilter) {
  privateChannelContent(
    channelId: $channelId
    limit: $limit
    cursor: $cursor
    filter: $filter
  ) {
    nextCursor {
      id
      createdAt
    }
    previousCursor {
      id
      createdAt
    }
    feed {
      ... on MultitipDetailed {
        ...MultitipDetailedFields
      }
      ... on PollDetailed {
        ...PollDetailedFields
      }
      ... on PostDetailed {
        ...PostDetailedFields
      }
      ... on TipDetailed {
        ...TipDetailedFields
      }
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${PollDetailedFieldsFragmentDoc}
${PostDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}`;

/**
 * __usePrivateChannelContentQuery__
 *
 * To run a query within a React component, call `usePrivateChannelContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateChannelContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateChannelContentQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrivateChannelContentQuery(baseOptions: Apollo.QueryHookOptions<PrivateChannelContentQuery, PrivateChannelContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateChannelContentQuery, PrivateChannelContentQueryVariables>(PrivateChannelContentDocument, options);
      }
export function usePrivateChannelContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateChannelContentQuery, PrivateChannelContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateChannelContentQuery, PrivateChannelContentQueryVariables>(PrivateChannelContentDocument, options);
        }
export type PrivateChannelContentQueryHookResult = ReturnType<typeof usePrivateChannelContentQuery>;
export type PrivateChannelContentLazyQueryHookResult = ReturnType<typeof usePrivateChannelContentLazyQuery>;
export type PrivateChannelContentQueryResult = Apollo.QueryResult<PrivateChannelContentQuery, PrivateChannelContentQueryVariables>;
export const PublicChannelContentDocument = gql`
    query PublicChannelContent($limit: Int! = 10, $cursor: FeedCursorInput, $filter: ChannelFeedFilter) {
  publicChannelContent(limit: $limit, cursor: $cursor, filter: $filter) {
    nextCursor {
      id
      createdAt
    }
    previousCursor {
      id
      createdAt
    }
    feed {
      ... on MultitipDetailed {
        ...MultitipDetailedFields
      }
      ... on PollDetailed {
        ...PollDetailedFields
      }
      ... on PostDetailed {
        ...PostDetailedFields
      }
      ... on TipDetailed {
        ...TipDetailedFields
      }
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${PollDetailedFieldsFragmentDoc}
${PostDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}`;

/**
 * __usePublicChannelContentQuery__
 *
 * To run a query within a React component, call `usePublicChannelContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicChannelContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicChannelContentQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePublicChannelContentQuery(baseOptions?: Apollo.QueryHookOptions<PublicChannelContentQuery, PublicChannelContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicChannelContentQuery, PublicChannelContentQueryVariables>(PublicChannelContentDocument, options);
      }
export function usePublicChannelContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicChannelContentQuery, PublicChannelContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicChannelContentQuery, PublicChannelContentQueryVariables>(PublicChannelContentDocument, options);
        }
export type PublicChannelContentQueryHookResult = ReturnType<typeof usePublicChannelContentQuery>;
export type PublicChannelContentLazyQueryHookResult = ReturnType<typeof usePublicChannelContentLazyQuery>;
export type PublicChannelContentQueryResult = Apollo.QueryResult<PublicChannelContentQuery, PublicChannelContentQueryVariables>;
export const ChannelPinnedContentDocument = gql`
    query ChannelPinnedContent($channelId: String!) {
  channelDetailed(channelId: $channelId) {
    pinnedContent {
      ...PinnedContentFields
    }
  }
}
    ${PinnedContentFieldsFragmentDoc}`;

/**
 * __useChannelPinnedContentQuery__
 *
 * To run a query within a React component, call `useChannelPinnedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelPinnedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelPinnedContentQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelPinnedContentQuery(baseOptions: Apollo.QueryHookOptions<ChannelPinnedContentQuery, ChannelPinnedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelPinnedContentQuery, ChannelPinnedContentQueryVariables>(ChannelPinnedContentDocument, options);
      }
export function useChannelPinnedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelPinnedContentQuery, ChannelPinnedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelPinnedContentQuery, ChannelPinnedContentQueryVariables>(ChannelPinnedContentDocument, options);
        }
export type ChannelPinnedContentQueryHookResult = ReturnType<typeof useChannelPinnedContentQuery>;
export type ChannelPinnedContentLazyQueryHookResult = ReturnType<typeof useChannelPinnedContentLazyQuery>;
export type ChannelPinnedContentQueryResult = Apollo.QueryResult<ChannelPinnedContentQuery, ChannelPinnedContentQueryVariables>;
export const ChannelDetailedDocument = gql`
    query ChannelDetailed($channelId: String!) {
  channelDetailed(channelId: $channelId) {
    ...ChannelDetailedFields
  }
}
    ${ChannelDetailedFieldsFragmentDoc}`;

/**
 * __useChannelDetailedQuery__
 *
 * To run a query within a React component, call `useChannelDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDetailedQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelDetailedQuery(baseOptions: Apollo.QueryHookOptions<ChannelDetailedQuery, ChannelDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelDetailedQuery, ChannelDetailedQueryVariables>(ChannelDetailedDocument, options);
      }
export function useChannelDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelDetailedQuery, ChannelDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelDetailedQuery, ChannelDetailedQueryVariables>(ChannelDetailedDocument, options);
        }
export type ChannelDetailedQueryHookResult = ReturnType<typeof useChannelDetailedQuery>;
export type ChannelDetailedLazyQueryHookResult = ReturnType<typeof useChannelDetailedLazyQuery>;
export type ChannelDetailedQueryResult = Apollo.QueryResult<ChannelDetailedQuery, ChannelDetailedQueryVariables>;
export const ChannelDocument = gql`
    query Channel($channelId: String!) {
  channel(channelId: $channelId) {
    anonymized
    channelDeal
    channelName
    channelStatus
    channelType
    countryId
    createdAt
    deletedAt
    feeForPayment
    id
    logo
    paymentOptions
    pinnedContentId
    pinnedContentType
    trialSubscription
    updatedAt
    settings {
      name
      value
    }
  }
}
    `;

/**
 * __useChannelQuery__
 *
 * To run a query within a React component, call `useChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChannelQuery(baseOptions: Apollo.QueryHookOptions<ChannelQuery, ChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelQuery, ChannelQueryVariables>(ChannelDocument, options);
      }
export function useChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelQuery, ChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelQuery, ChannelQueryVariables>(ChannelDocument, options);
        }
export type ChannelQueryHookResult = ReturnType<typeof useChannelQuery>;
export type ChannelLazyQueryHookResult = ReturnType<typeof useChannelLazyQuery>;
export type ChannelQueryResult = Apollo.QueryResult<ChannelQuery, ChannelQueryVariables>;
export const UserChannelsDocument = gql`
    query UserChannels($userId: String) {
  userChannels(userId: $userId) {
    ...ChannelDetailedFields
  }
}
    ${ChannelDetailedFieldsFragmentDoc}`;

/**
 * __useUserChannelsQuery__
 *
 * To run a query within a React component, call `useUserChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserChannelsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserChannelsQuery(baseOptions?: Apollo.QueryHookOptions<UserChannelsQuery, UserChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserChannelsQuery, UserChannelsQueryVariables>(UserChannelsDocument, options);
      }
export function useUserChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserChannelsQuery, UserChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserChannelsQuery, UserChannelsQueryVariables>(UserChannelsDocument, options);
        }
export type UserChannelsQueryHookResult = ReturnType<typeof useUserChannelsQuery>;
export type UserChannelsLazyQueryHookResult = ReturnType<typeof useUserChannelsLazyQuery>;
export type UserChannelsQueryResult = Apollo.QueryResult<UserChannelsQuery, UserChannelsQueryVariables>;
export const GetChannelIdsDocument = gql`
    query GetChannelIds($userId: String) {
  userChannels(userId: $userId) {
    id
  }
}
    `;

/**
 * __useGetChannelIdsQuery__
 *
 * To run a query within a React component, call `useGetChannelIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChannelIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelIdsQuery, GetChannelIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelIdsQuery, GetChannelIdsQueryVariables>(GetChannelIdsDocument, options);
      }
export function useGetChannelIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelIdsQuery, GetChannelIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelIdsQuery, GetChannelIdsQueryVariables>(GetChannelIdsDocument, options);
        }
export type GetChannelIdsQueryHookResult = ReturnType<typeof useGetChannelIdsQuery>;
export type GetChannelIdsLazyQueryHookResult = ReturnType<typeof useGetChannelIdsLazyQuery>;
export type GetChannelIdsQueryResult = Apollo.QueryResult<GetChannelIdsQuery, GetChannelIdsQueryVariables>;
export const GenerateInviteLinkDocument = gql`
    query GenerateInviteLink($channelId: String) {
  inviteLink(channelId: $channelId) {
    id
    internalName
    channel {
      channelName
    }
  }
}
    `;

/**
 * __useGenerateInviteLinkQuery__
 *
 * To run a query within a React component, call `useGenerateInviteLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateInviteLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateInviteLinkQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGenerateInviteLinkQuery(baseOptions?: Apollo.QueryHookOptions<GenerateInviteLinkQuery, GenerateInviteLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateInviteLinkQuery, GenerateInviteLinkQueryVariables>(GenerateInviteLinkDocument, options);
      }
export function useGenerateInviteLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateInviteLinkQuery, GenerateInviteLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateInviteLinkQuery, GenerateInviteLinkQueryVariables>(GenerateInviteLinkDocument, options);
        }
export type GenerateInviteLinkQueryHookResult = ReturnType<typeof useGenerateInviteLinkQuery>;
export type GenerateInviteLinkLazyQueryHookResult = ReturnType<typeof useGenerateInviteLinkLazyQuery>;
export type GenerateInviteLinkQueryResult = Apollo.QueryResult<GenerateInviteLinkQuery, GenerateInviteLinkQueryVariables>;
export const GetChannelPinnedContentDocument = gql`
    query GetChannelPinnedContent($channelId: String!) {
  channelDetailed(channelId: $channelId) {
    pinnedContent {
      ...PinnedContentFields
    }
  }
}
    ${PinnedContentFieldsFragmentDoc}`;

/**
 * __useGetChannelPinnedContentQuery__
 *
 * To run a query within a React component, call `useGetChannelPinnedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelPinnedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelPinnedContentQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelPinnedContentQuery(baseOptions: Apollo.QueryHookOptions<GetChannelPinnedContentQuery, GetChannelPinnedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelPinnedContentQuery, GetChannelPinnedContentQueryVariables>(GetChannelPinnedContentDocument, options);
      }
export function useGetChannelPinnedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelPinnedContentQuery, GetChannelPinnedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelPinnedContentQuery, GetChannelPinnedContentQueryVariables>(GetChannelPinnedContentDocument, options);
        }
export type GetChannelPinnedContentQueryHookResult = ReturnType<typeof useGetChannelPinnedContentQuery>;
export type GetChannelPinnedContentLazyQueryHookResult = ReturnType<typeof useGetChannelPinnedContentLazyQuery>;
export type GetChannelPinnedContentQueryResult = Apollo.QueryResult<GetChannelPinnedContentQuery, GetChannelPinnedContentQueryVariables>;
export const SuggestedChannelsDocument = gql`
    query suggestedChannels {
  recommendedChannels(limit: 10) {
    channels {
      id
      channelName
      logo
      channelStatus
    }
  }
}
    `;

/**
 * __useSuggestedChannelsQuery__
 *
 * To run a query within a React component, call `useSuggestedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestedChannelsQuery(baseOptions?: Apollo.QueryHookOptions<SuggestedChannelsQuery, SuggestedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedChannelsQuery, SuggestedChannelsQueryVariables>(SuggestedChannelsDocument, options);
      }
export function useSuggestedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedChannelsQuery, SuggestedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedChannelsQuery, SuggestedChannelsQueryVariables>(SuggestedChannelsDocument, options);
        }
export type SuggestedChannelsQueryHookResult = ReturnType<typeof useSuggestedChannelsQuery>;
export type SuggestedChannelsLazyQueryHookResult = ReturnType<typeof useSuggestedChannelsLazyQuery>;
export type SuggestedChannelsQueryResult = Apollo.QueryResult<SuggestedChannelsQuery, SuggestedChannelsQueryVariables>;
export const GetTipsterChannelsDocument = gql`
    query getTipsterChannels($tipster: String!) {
  channels(filter: {tipsterId: $tipster}) {
    channels {
      channelName
      id
      settings {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useGetTipsterChannelsQuery__
 *
 * To run a query within a React component, call `useGetTipsterChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterChannelsQuery({
 *   variables: {
 *      tipster: // value for 'tipster'
 *   },
 * });
 */
export function useGetTipsterChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterChannelsQuery, GetTipsterChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterChannelsQuery, GetTipsterChannelsQueryVariables>(GetTipsterChannelsDocument, options);
      }
export function useGetTipsterChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterChannelsQuery, GetTipsterChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterChannelsQuery, GetTipsterChannelsQueryVariables>(GetTipsterChannelsDocument, options);
        }
export type GetTipsterChannelsQueryHookResult = ReturnType<typeof useGetTipsterChannelsQuery>;
export type GetTipsterChannelsLazyQueryHookResult = ReturnType<typeof useGetTipsterChannelsLazyQuery>;
export type GetTipsterChannelsQueryResult = Apollo.QueryResult<GetTipsterChannelsQuery, GetTipsterChannelsQueryVariables>;
export const GetchannelListStatByCategoryiesDocument = gql`
    query GetchannelListStatByCategoryies($filter: ChannelListFilterInput, $limit: Float!, $skip: Float!) {
  channelListStatByCategoryies(filter: $filter, limit: $limit, skip: $skip) {
    id
    channelName
    logo
    background
    members
    category
    trialSubscription
    tipsters {
      id
      bio
      lastName
      firstName
      displayName
      avatarUrl
      sports {
        sportId
      }
    }
    stat {
      winRate
    }
  }
}
    `;

/**
 * __useGetchannelListStatByCategoryiesQuery__
 *
 * To run a query within a React component, call `useGetchannelListStatByCategoryiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetchannelListStatByCategoryiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetchannelListStatByCategoryiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetchannelListStatByCategoryiesQuery(baseOptions: Apollo.QueryHookOptions<GetchannelListStatByCategoryiesQuery, GetchannelListStatByCategoryiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetchannelListStatByCategoryiesQuery, GetchannelListStatByCategoryiesQueryVariables>(GetchannelListStatByCategoryiesDocument, options);
      }
export function useGetchannelListStatByCategoryiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetchannelListStatByCategoryiesQuery, GetchannelListStatByCategoryiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetchannelListStatByCategoryiesQuery, GetchannelListStatByCategoryiesQueryVariables>(GetchannelListStatByCategoryiesDocument, options);
        }
export type GetchannelListStatByCategoryiesQueryHookResult = ReturnType<typeof useGetchannelListStatByCategoryiesQuery>;
export type GetchannelListStatByCategoryiesLazyQueryHookResult = ReturnType<typeof useGetchannelListStatByCategoryiesLazyQuery>;
export type GetchannelListStatByCategoryiesQueryResult = Apollo.QueryResult<GetchannelListStatByCategoryiesQuery, GetchannelListStatByCategoryiesQueryVariables>;
export const GetTipsterFollowersCountDocument = gql`
    query GetTipsterFollowersCount($tipsterId: String!, $filter: TipsterFollowersCountFIlter) {
  tipsterFollowersCount(tipsterId: $tipsterId, filter: $filter)
}
    `;

/**
 * __useGetTipsterFollowersCountQuery__
 *
 * To run a query within a React component, call `useGetTipsterFollowersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterFollowersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterFollowersCountQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTipsterFollowersCountQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterFollowersCountQuery, GetTipsterFollowersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterFollowersCountQuery, GetTipsterFollowersCountQueryVariables>(GetTipsterFollowersCountDocument, options);
      }
export function useGetTipsterFollowersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterFollowersCountQuery, GetTipsterFollowersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterFollowersCountQuery, GetTipsterFollowersCountQueryVariables>(GetTipsterFollowersCountDocument, options);
        }
export type GetTipsterFollowersCountQueryHookResult = ReturnType<typeof useGetTipsterFollowersCountQuery>;
export type GetTipsterFollowersCountLazyQueryHookResult = ReturnType<typeof useGetTipsterFollowersCountLazyQuery>;
export type GetTipsterFollowersCountQueryResult = Apollo.QueryResult<GetTipsterFollowersCountQuery, GetTipsterFollowersCountQueryVariables>;
export const GetChatListDocument = gql`
    query GetChatList($limit: Float, $skip: Float) {
  chats(limit: $limit, skip: $skip) {
    chats {
      accepted
      createdAt
      email
      hasNewMessage
      id
      receiverId
      senderId
      subject
      lastMessage {
        chatId
        createdAt
        id
        imageUrl
        senderId
        text
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetChatListQuery__
 *
 * To run a query within a React component, call `useGetChatListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetChatListQuery(baseOptions?: Apollo.QueryHookOptions<GetChatListQuery, GetChatListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatListQuery, GetChatListQueryVariables>(GetChatListDocument, options);
      }
export function useGetChatListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatListQuery, GetChatListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatListQuery, GetChatListQueryVariables>(GetChatListDocument, options);
        }
export type GetChatListQueryHookResult = ReturnType<typeof useGetChatListQuery>;
export type GetChatListLazyQueryHookResult = ReturnType<typeof useGetChatListLazyQuery>;
export type GetChatListQueryResult = Apollo.QueryResult<GetChatListQuery, GetChatListQueryVariables>;
export const GetMessagesByChatDocument = gql`
    query GetMessagesByChat($chatId: Float!, $limit: Float!, $offset: Float!) {
  messagesByChat(chatId: $chatId, limit: $limit, offset: $offset) {
    chatId
    createdAt
    id
    imageUrl
    senderId
    text
  }
}
    `;

/**
 * __useGetMessagesByChatQuery__
 *
 * To run a query within a React component, call `useGetMessagesByChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMessagesByChatQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesByChatQuery, GetMessagesByChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesByChatQuery, GetMessagesByChatQueryVariables>(GetMessagesByChatDocument, options);
      }
export function useGetMessagesByChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesByChatQuery, GetMessagesByChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesByChatQuery, GetMessagesByChatQueryVariables>(GetMessagesByChatDocument, options);
        }
export type GetMessagesByChatQueryHookResult = ReturnType<typeof useGetMessagesByChatQuery>;
export type GetMessagesByChatLazyQueryHookResult = ReturnType<typeof useGetMessagesByChatLazyQuery>;
export type GetMessagesByChatQueryResult = Apollo.QueryResult<GetMessagesByChatQuery, GetMessagesByChatQueryVariables>;
export const GetChatDocument = gql`
    query GetChat($id: Float!) {
  chat(id: $id) {
    accepted
    createdAt
    email
    id
    receiverId
    senderId
    subject
  }
}
    `;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQuery, GetChatQueryVariables>;
export const GetChatReceiverAndSenderDocument = gql`
    query GetChatReceiverAndSender($id: Float!) {
  chat(id: $id) {
    id
    receiverId
    senderId
  }
}
    `;

/**
 * __useGetChatReceiverAndSenderQuery__
 *
 * To run a query within a React component, call `useGetChatReceiverAndSenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatReceiverAndSenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatReceiverAndSenderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatReceiverAndSenderQuery(baseOptions: Apollo.QueryHookOptions<GetChatReceiverAndSenderQuery, GetChatReceiverAndSenderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatReceiverAndSenderQuery, GetChatReceiverAndSenderQueryVariables>(GetChatReceiverAndSenderDocument, options);
      }
export function useGetChatReceiverAndSenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatReceiverAndSenderQuery, GetChatReceiverAndSenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatReceiverAndSenderQuery, GetChatReceiverAndSenderQueryVariables>(GetChatReceiverAndSenderDocument, options);
        }
export type GetChatReceiverAndSenderQueryHookResult = ReturnType<typeof useGetChatReceiverAndSenderQuery>;
export type GetChatReceiverAndSenderLazyQueryHookResult = ReturnType<typeof useGetChatReceiverAndSenderLazyQuery>;
export type GetChatReceiverAndSenderQueryResult = Apollo.QueryResult<GetChatReceiverAndSenderQuery, GetChatReceiverAndSenderQueryVariables>;
export const CommentsByContentDocument = gql`
    query CommentsByContent($body: CommentsByType!, $limit: Float!, $skip: Float!) {
  commentsByContent(body: $body, limit: $limit, skip: $skip) {
    comments {
      contentId
      contentType
      createdAt
      deletedAt
      id
      imageLink
      text
      updatedAt
      user {
        avatarUrl
        displayName
        id
      }
      userId
    }
    totalCount
  }
}
    `;

/**
 * __useCommentsByContentQuery__
 *
 * To run a query within a React component, call `useCommentsByContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsByContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsByContentQuery({
 *   variables: {
 *      body: // value for 'body'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCommentsByContentQuery(baseOptions: Apollo.QueryHookOptions<CommentsByContentQuery, CommentsByContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsByContentQuery, CommentsByContentQueryVariables>(CommentsByContentDocument, options);
      }
export function useCommentsByContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsByContentQuery, CommentsByContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsByContentQuery, CommentsByContentQueryVariables>(CommentsByContentDocument, options);
        }
export type CommentsByContentQueryHookResult = ReturnType<typeof useCommentsByContentQuery>;
export type CommentsByContentLazyQueryHookResult = ReturnType<typeof useCommentsByContentLazyQuery>;
export type CommentsByContentQueryResult = Apollo.QueryResult<CommentsByContentQuery, CommentsByContentQueryVariables>;
export const GetCompetitionEventsDocument = gql`
    query GetCompetitionEvents($competitionId: ID!) {
  competitionEvents(competitionId: $competitionId) {
    id
    name
    competitionType
    imageUrl
    cta
    termsAndconditions
    termsAndconditionsLink
    vip
    blocked
    events {
      id
      userCanVote
      eventDate
      oddType {
        id
        name
        __typename
      }
      outcomeValue {
        id
        name
        value
        __typename
      }
      competitors {
        id
        name
        imageUrl
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetCompetitionEventsQuery__
 *
 * To run a query within a React component, call `useGetCompetitionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionEventsQuery({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *   },
 * });
 */
export function useGetCompetitionEventsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitionEventsQuery, GetCompetitionEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionEventsQuery, GetCompetitionEventsQueryVariables>(GetCompetitionEventsDocument, options);
      }
export function useGetCompetitionEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionEventsQuery, GetCompetitionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionEventsQuery, GetCompetitionEventsQueryVariables>(GetCompetitionEventsDocument, options);
        }
export type GetCompetitionEventsQueryHookResult = ReturnType<typeof useGetCompetitionEventsQuery>;
export type GetCompetitionEventsLazyQueryHookResult = ReturnType<typeof useGetCompetitionEventsLazyQuery>;
export type GetCompetitionEventsQueryResult = Apollo.QueryResult<GetCompetitionEventsQuery, GetCompetitionEventsQueryVariables>;
export const GetCompetitionTipsterLeaderboardDocument = gql`
    query GetCompetitionTipsterLeaderboard($competitionId: ID!, $limit: Float, $offset: Float, $snapshotId: String) {
  competitionTipsterLeaderboard(
    competitionId: $competitionId
    limit: $limit
    offset: $offset
    snapshotId: $snapshotId
  ) {
    top {
      rank
      tipsterId
      displayName
      avatarUrl
      profit
      winRate
      roi
      totalTips
      won
      lost
    }
    entries {
      rank
      tipsterId
      displayName
      avatarUrl
      profit
      winRate
      roi
      totalTips
      won
      lost
    }
    totalCount
    hasNextPage
    snapshotId
    minTipsThreshold
  }
}
    `;

/**
 * __useGetCompetitionTipsterLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetCompetitionTipsterLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionTipsterLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionTipsterLeaderboardQuery({
 *   variables: {
 *      competitionId: // value for 'competitionId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useGetCompetitionTipsterLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitionTipsterLeaderboardQuery, GetCompetitionTipsterLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionTipsterLeaderboardQuery, GetCompetitionTipsterLeaderboardQueryVariables>(GetCompetitionTipsterLeaderboardDocument, options);
      }
export function useGetCompetitionTipsterLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionTipsterLeaderboardQuery, GetCompetitionTipsterLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionTipsterLeaderboardQuery, GetCompetitionTipsterLeaderboardQueryVariables>(GetCompetitionTipsterLeaderboardDocument, options);
        }
export type GetCompetitionTipsterLeaderboardQueryHookResult = ReturnType<typeof useGetCompetitionTipsterLeaderboardQuery>;
export type GetCompetitionTipsterLeaderboardLazyQueryHookResult = ReturnType<typeof useGetCompetitionTipsterLeaderboardLazyQuery>;
export type GetCompetitionTipsterLeaderboardQueryResult = Apollo.QueryResult<GetCompetitionTipsterLeaderboardQuery, GetCompetitionTipsterLeaderboardQueryVariables>;
export const GetCompetitionsVotesDocument = gql`
    query GetCompetitionsVotes($limit: Float!, $skip: Float!, $competitionId: ID!) {
  voterRanking(limit: $limit, skip: $skip, competitionId: $competitionId) {
    competition {
      id
      name
      cta
      imageUrl
      status
    }
    users {
      userName
      ranking
      userId
      avatarUrl
      wins
      losses
    }
  }
}
    `;

/**
 * __useGetCompetitionsVotesQuery__
 *
 * To run a query within a React component, call `useGetCompetitionsVotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionsVotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionsVotesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      competitionId: // value for 'competitionId'
 *   },
 * });
 */
export function useGetCompetitionsVotesQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitionsVotesQuery, GetCompetitionsVotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionsVotesQuery, GetCompetitionsVotesQueryVariables>(GetCompetitionsVotesDocument, options);
      }
export function useGetCompetitionsVotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionsVotesQuery, GetCompetitionsVotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionsVotesQuery, GetCompetitionsVotesQueryVariables>(GetCompetitionsVotesDocument, options);
        }
export type GetCompetitionsVotesQueryHookResult = ReturnType<typeof useGetCompetitionsVotesQuery>;
export type GetCompetitionsVotesLazyQueryHookResult = ReturnType<typeof useGetCompetitionsVotesLazyQuery>;
export type GetCompetitionsVotesQueryResult = Apollo.QueryResult<GetCompetitionsVotesQuery, GetCompetitionsVotesQueryVariables>;
export const GetCompetitionsDataDocument = gql`
    query GetCompetitionsData($limit: Float!, $skip: Float!, $filter: ContentCompetitionFIlter) {
  competitions(limit: $limit, skip: $skip, filter: $filter) {
    id
    marketIds
    createdBy
    competitionType
    rankingMetric
    minimumSettledTips
    rankingSportIds
    rewards {
      title
      id
      description
      reward
    }
    imageUrl
    name
    startAt
    endAt
    userCanVote
    userJoined
    remainingSlots
    takenSlots
    cta
    isOpen
    maxParticipants
    description
    termsAndconditions
    termsAndconditionsLink
    vip
    blocked
    eligibleCountries
    createdByType
  }
}
    `;

/**
 * __useGetCompetitionsDataQuery__
 *
 * To run a query within a React component, call `useGetCompetitionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionsDataQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCompetitionsDataQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitionsDataQuery, GetCompetitionsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionsDataQuery, GetCompetitionsDataQueryVariables>(GetCompetitionsDataDocument, options);
      }
export function useGetCompetitionsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionsDataQuery, GetCompetitionsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionsDataQuery, GetCompetitionsDataQueryVariables>(GetCompetitionsDataDocument, options);
        }
export type GetCompetitionsDataQueryHookResult = ReturnType<typeof useGetCompetitionsDataQuery>;
export type GetCompetitionsDataLazyQueryHookResult = ReturnType<typeof useGetCompetitionsDataLazyQuery>;
export type GetCompetitionsDataQueryResult = Apollo.QueryResult<GetCompetitionsDataQuery, GetCompetitionsDataQueryVariables>;
export const GetCompetitionsCountDocument = gql`
    query GetCompetitionsCount($filter: ContentCompetitionFIlter) {
  competitionsCount(filter: $filter)
}
    `;

/**
 * __useGetCompetitionsCountQuery__
 *
 * To run a query within a React component, call `useGetCompetitionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCompetitionsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetCompetitionsCountQuery, GetCompetitionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionsCountQuery, GetCompetitionsCountQueryVariables>(GetCompetitionsCountDocument, options);
      }
export function useGetCompetitionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionsCountQuery, GetCompetitionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionsCountQuery, GetCompetitionsCountQueryVariables>(GetCompetitionsCountDocument, options);
        }
export type GetCompetitionsCountQueryHookResult = ReturnType<typeof useGetCompetitionsCountQuery>;
export type GetCompetitionsCountLazyQueryHookResult = ReturnType<typeof useGetCompetitionsCountLazyQuery>;
export type GetCompetitionsCountQueryResult = Apollo.QueryResult<GetCompetitionsCountQuery, GetCompetitionsCountQueryVariables>;
export const GetCurrenciesDocument = gql`
    query GetCurrencies($limit: Float, $skip: Float) {
  currencies(limit: $limit, skip: $skip) {
    edges {
      node {
        code
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
      }
export function useGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export type GetCurrenciesQueryHookResult = ReturnType<typeof useGetCurrenciesQuery>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCurrenciesLazyQuery>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export const GenerateDashboardTokenDocument = gql`
    query GenerateDashboardToken {
  generateDashboardToken
}
    `;

/**
 * __useGenerateDashboardTokenQuery__
 *
 * To run a query within a React component, call `useGenerateDashboardTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateDashboardTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateDashboardTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateDashboardTokenQuery(baseOptions?: Apollo.QueryHookOptions<GenerateDashboardTokenQuery, GenerateDashboardTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateDashboardTokenQuery, GenerateDashboardTokenQueryVariables>(GenerateDashboardTokenDocument, options);
      }
export function useGenerateDashboardTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateDashboardTokenQuery, GenerateDashboardTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateDashboardTokenQuery, GenerateDashboardTokenQueryVariables>(GenerateDashboardTokenDocument, options);
        }
export type GenerateDashboardTokenQueryHookResult = ReturnType<typeof useGenerateDashboardTokenQuery>;
export type GenerateDashboardTokenLazyQueryHookResult = ReturnType<typeof useGenerateDashboardTokenLazyQuery>;
export type GenerateDashboardTokenQueryResult = Apollo.QueryResult<GenerateDashboardTokenQuery, GenerateDashboardTokenQueryVariables>;
export const GetEngagementSubscribersMetricsDocument = gql`
    query GetEngagementSubscribersMetrics($tipsterId: String!, $startDate: String, $endDate: String) {
  getEngagementSubscribersMetrics(
    tipsterId: $tipsterId
    startDate: $startDate
    endDate: $endDate
  ) {
    activeAndOnholdSubscriptions
    activeSubscriptionsOnly
    isTrialUsed
    percentageActiveTrialUsed
    unsubscribed
    unfollowed
  }
}
    `;

/**
 * __useGetEngagementSubscribersMetricsQuery__
 *
 * To run a query within a React component, call `useGetEngagementSubscribersMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngagementSubscribersMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngagementSubscribersMetricsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEngagementSubscribersMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetEngagementSubscribersMetricsQuery, GetEngagementSubscribersMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngagementSubscribersMetricsQuery, GetEngagementSubscribersMetricsQueryVariables>(GetEngagementSubscribersMetricsDocument, options);
      }
export function useGetEngagementSubscribersMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngagementSubscribersMetricsQuery, GetEngagementSubscribersMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngagementSubscribersMetricsQuery, GetEngagementSubscribersMetricsQueryVariables>(GetEngagementSubscribersMetricsDocument, options);
        }
export type GetEngagementSubscribersMetricsQueryHookResult = ReturnType<typeof useGetEngagementSubscribersMetricsQuery>;
export type GetEngagementSubscribersMetricsLazyQueryHookResult = ReturnType<typeof useGetEngagementSubscribersMetricsLazyQuery>;
export type GetEngagementSubscribersMetricsQueryResult = Apollo.QueryResult<GetEngagementSubscribersMetricsQuery, GetEngagementSubscribersMetricsQueryVariables>;
export const GetTournamentsBySportAndDateDocument = gql`
    query GetTournamentsBySportAndDate($ids: [ID!]!, $eventsDate: DateTime!) {
  tournamentsBySportIdsAndEventDate(ids: $ids, eventsDate: $eventsDate) {
    all {
      id
      name
      category {
        id
        name
        code
      }
    }
    popular {
      id
      name
      category {
        id
        name
        code
      }
    }
    userFav {
      id
      name
      category {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetTournamentsBySportAndDateQuery__
 *
 * To run a query within a React component, call `useGetTournamentsBySportAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsBySportAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsBySportAndDateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      eventsDate: // value for 'eventsDate'
 *   },
 * });
 */
export function useGetTournamentsBySportAndDateQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentsBySportAndDateQuery, GetTournamentsBySportAndDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsBySportAndDateQuery, GetTournamentsBySportAndDateQueryVariables>(GetTournamentsBySportAndDateDocument, options);
      }
export function useGetTournamentsBySportAndDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsBySportAndDateQuery, GetTournamentsBySportAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsBySportAndDateQuery, GetTournamentsBySportAndDateQueryVariables>(GetTournamentsBySportAndDateDocument, options);
        }
export type GetTournamentsBySportAndDateQueryHookResult = ReturnType<typeof useGetTournamentsBySportAndDateQuery>;
export type GetTournamentsBySportAndDateLazyQueryHookResult = ReturnType<typeof useGetTournamentsBySportAndDateLazyQuery>;
export type GetTournamentsBySportAndDateQueryResult = Apollo.QueryResult<GetTournamentsBySportAndDateQuery, GetTournamentsBySportAndDateQueryVariables>;
export const GetEventsByTournamentAndDateDocument = gql`
    query GetEventsByTournamentAndDate($eventsDate: DateTime!, $forDefaultBookie: Boolean!, $tournamentId: ID, $bookmakerId: String, $sportId: String, $limit: Float, $skip: Float) {
  sportEventsByTournamentIdAndDate(
    eventsDate: $eventsDate
    forDefaultBookie: $forDefaultBookie
    tournamentId: $tournamentId
    bookmakerId: $bookmakerId
    sportId: $sportId
    limit: $limit
    skip: $skip
  ) {
    categoryId
    competitors {
      name
      id
      type
      imageUrl
    }
    eventDate
    id
    numberOfTips
    votes
    tournament {
      id
      name
      scope
      category {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetEventsByTournamentAndDateQuery__
 *
 * To run a query within a React component, call `useGetEventsByTournamentAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByTournamentAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByTournamentAndDateQuery({
 *   variables: {
 *      eventsDate: // value for 'eventsDate'
 *      forDefaultBookie: // value for 'forDefaultBookie'
 *      tournamentId: // value for 'tournamentId'
 *      bookmakerId: // value for 'bookmakerId'
 *      sportId: // value for 'sportId'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetEventsByTournamentAndDateQuery(baseOptions: Apollo.QueryHookOptions<GetEventsByTournamentAndDateQuery, GetEventsByTournamentAndDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsByTournamentAndDateQuery, GetEventsByTournamentAndDateQueryVariables>(GetEventsByTournamentAndDateDocument, options);
      }
export function useGetEventsByTournamentAndDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsByTournamentAndDateQuery, GetEventsByTournamentAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsByTournamentAndDateQuery, GetEventsByTournamentAndDateQueryVariables>(GetEventsByTournamentAndDateDocument, options);
        }
export type GetEventsByTournamentAndDateQueryHookResult = ReturnType<typeof useGetEventsByTournamentAndDateQuery>;
export type GetEventsByTournamentAndDateLazyQueryHookResult = ReturnType<typeof useGetEventsByTournamentAndDateLazyQuery>;
export type GetEventsByTournamentAndDateQueryResult = Apollo.QueryResult<GetEventsByTournamentAndDateQuery, GetEventsByTournamentAndDateQueryVariables>;
export const GetEventByIdDocument = gql`
    query GetEventById($eventId: ID!) {
  sportEventByEventId(eventId: $eventId) {
    bookmakerId
    bookmakerName
    hasLiveOdds
    liveMatchId
    competitors {
      id
      type
      name
      imageUrl
    }
    eventDate
    eventOutcome {
      id
      votes
      userVoted
      name
      withSpecialBetValue
      numberOfTips
      outcomeEvent {
        id
        value
        votes
        specialBetValue
        outcomeName
      }
    }
    eventType
    id
    tournament {
      id
      name
    }
    sportId
    categoryId
  }
}
    `;

/**
 * __useGetEventByIdQuery__
 *
 * To run a query within a React component, call `useGetEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
      }
export function useGetEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByIdQuery, GetEventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByIdQuery, GetEventByIdQueryVariables>(GetEventByIdDocument, options);
        }
export type GetEventByIdQueryHookResult = ReturnType<typeof useGetEventByIdQuery>;
export type GetEventByIdLazyQueryHookResult = ReturnType<typeof useGetEventByIdLazyQuery>;
export type GetEventByIdQueryResult = Apollo.QueryResult<GetEventByIdQuery, GetEventByIdQueryVariables>;
export const GetEventByIdWithoutOddsDocument = gql`
    query GetEventByIdWithoutOdds($eventId: ID!) {
  sportEventByEventId(eventId: $eventId) {
    competitors {
      id
      type
      name
      imageUrl
    }
    eventDate
    eventOutcome {
      id
      votes
      userVoted
      name
      withSpecialBetValue
      numberOfTips
      outcomeEvent {
        id
        votes
        specialBetValue
        outcomeName
      }
    }
    eventType
    id
    tournament {
      id
      name
    }
    sportId
    categoryId
  }
}
    `;

/**
 * __useGetEventByIdWithoutOddsQuery__
 *
 * To run a query within a React component, call `useGetEventByIdWithoutOddsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByIdWithoutOddsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByIdWithoutOddsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventByIdWithoutOddsQuery(baseOptions: Apollo.QueryHookOptions<GetEventByIdWithoutOddsQuery, GetEventByIdWithoutOddsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByIdWithoutOddsQuery, GetEventByIdWithoutOddsQueryVariables>(GetEventByIdWithoutOddsDocument, options);
      }
export function useGetEventByIdWithoutOddsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByIdWithoutOddsQuery, GetEventByIdWithoutOddsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByIdWithoutOddsQuery, GetEventByIdWithoutOddsQueryVariables>(GetEventByIdWithoutOddsDocument, options);
        }
export type GetEventByIdWithoutOddsQueryHookResult = ReturnType<typeof useGetEventByIdWithoutOddsQuery>;
export type GetEventByIdWithoutOddsLazyQueryHookResult = ReturnType<typeof useGetEventByIdWithoutOddsLazyQuery>;
export type GetEventByIdWithoutOddsQueryResult = Apollo.QueryResult<GetEventByIdWithoutOddsQuery, GetEventByIdWithoutOddsQueryVariables>;
export const GetSportsByDateDocument = gql`
    query GetSportsByDate($eventsDate: DateTime!, $bookmakerId: String) {
  sportsByEventDate(eventsDate: $eventsDate, bookmakerId: $bookmakerId) {
    id
    name
  }
}
    `;

/**
 * __useGetSportsByDateQuery__
 *
 * To run a query within a React component, call `useGetSportsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportsByDateQuery({
 *   variables: {
 *      eventsDate: // value for 'eventsDate'
 *      bookmakerId: // value for 'bookmakerId'
 *   },
 * });
 */
export function useGetSportsByDateQuery(baseOptions: Apollo.QueryHookOptions<GetSportsByDateQuery, GetSportsByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportsByDateQuery, GetSportsByDateQueryVariables>(GetSportsByDateDocument, options);
      }
export function useGetSportsByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportsByDateQuery, GetSportsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportsByDateQuery, GetSportsByDateQueryVariables>(GetSportsByDateDocument, options);
        }
export type GetSportsByDateQueryHookResult = ReturnType<typeof useGetSportsByDateQuery>;
export type GetSportsByDateLazyQueryHookResult = ReturnType<typeof useGetSportsByDateLazyQuery>;
export type GetSportsByDateQueryResult = Apollo.QueryResult<GetSportsByDateQuery, GetSportsByDateQueryVariables>;
export const GetCountriesBySportAndDateDocument = gql`
    query GetCountriesBySportAndDate($sportId: ID!, $eventsDate: DateTime!, $bookmakerId: String) {
  categoriesBySportIdAndEventDate(
    sportId: $sportId
    eventsDate: $eventsDate
    bookmakerId: $bookmakerId
  ) {
    id
    name
    code
  }
}
    `;

/**
 * __useGetCountriesBySportAndDateQuery__
 *
 * To run a query within a React component, call `useGetCountriesBySportAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesBySportAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesBySportAndDateQuery({
 *   variables: {
 *      sportId: // value for 'sportId'
 *      eventsDate: // value for 'eventsDate'
 *      bookmakerId: // value for 'bookmakerId'
 *   },
 * });
 */
export function useGetCountriesBySportAndDateQuery(baseOptions: Apollo.QueryHookOptions<GetCountriesBySportAndDateQuery, GetCountriesBySportAndDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesBySportAndDateQuery, GetCountriesBySportAndDateQueryVariables>(GetCountriesBySportAndDateDocument, options);
      }
export function useGetCountriesBySportAndDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesBySportAndDateQuery, GetCountriesBySportAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesBySportAndDateQuery, GetCountriesBySportAndDateQueryVariables>(GetCountriesBySportAndDateDocument, options);
        }
export type GetCountriesBySportAndDateQueryHookResult = ReturnType<typeof useGetCountriesBySportAndDateQuery>;
export type GetCountriesBySportAndDateLazyQueryHookResult = ReturnType<typeof useGetCountriesBySportAndDateLazyQuery>;
export type GetCountriesBySportAndDateQueryResult = Apollo.QueryResult<GetCountriesBySportAndDateQuery, GetCountriesBySportAndDateQueryVariables>;
export const GetCompetitionsByCountryAndDateDocument = gql`
    query GetCompetitionsByCountryAndDate($categoryId: ID!, $eventsDate: DateTime!, $bookmakerId: String) {
  tournamentsByCategoryIdAndEventsDate(
    categoryId: $categoryId
    eventsDate: $eventsDate
    bookmakerId: $bookmakerId
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetCompetitionsByCountryAndDateQuery__
 *
 * To run a query within a React component, call `useGetCompetitionsByCountryAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionsByCountryAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionsByCountryAndDateQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      eventsDate: // value for 'eventsDate'
 *      bookmakerId: // value for 'bookmakerId'
 *   },
 * });
 */
export function useGetCompetitionsByCountryAndDateQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitionsByCountryAndDateQuery, GetCompetitionsByCountryAndDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionsByCountryAndDateQuery, GetCompetitionsByCountryAndDateQueryVariables>(GetCompetitionsByCountryAndDateDocument, options);
      }
export function useGetCompetitionsByCountryAndDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionsByCountryAndDateQuery, GetCompetitionsByCountryAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionsByCountryAndDateQuery, GetCompetitionsByCountryAndDateQueryVariables>(GetCompetitionsByCountryAndDateDocument, options);
        }
export type GetCompetitionsByCountryAndDateQueryHookResult = ReturnType<typeof useGetCompetitionsByCountryAndDateQuery>;
export type GetCompetitionsByCountryAndDateLazyQueryHookResult = ReturnType<typeof useGetCompetitionsByCountryAndDateLazyQuery>;
export type GetCompetitionsByCountryAndDateQueryResult = Apollo.QueryResult<GetCompetitionsByCountryAndDateQuery, GetCompetitionsByCountryAndDateQueryVariables>;
export const GetMarketsByEventIdDocument = gql`
    query GetMarketsByEventId($eventId: ID!, $bookmakerId: String) {
  marketsByEventId(eventId: $eventId, bookmakerId: $bookmakerId) {
    id
    name
  }
}
    `;

/**
 * __useGetMarketsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetMarketsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      bookmakerId: // value for 'bookmakerId'
 *   },
 * });
 */
export function useGetMarketsByEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetMarketsByEventIdQuery, GetMarketsByEventIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketsByEventIdQuery, GetMarketsByEventIdQueryVariables>(GetMarketsByEventIdDocument, options);
      }
export function useGetMarketsByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketsByEventIdQuery, GetMarketsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketsByEventIdQuery, GetMarketsByEventIdQueryVariables>(GetMarketsByEventIdDocument, options);
        }
export type GetMarketsByEventIdQueryHookResult = ReturnType<typeof useGetMarketsByEventIdQuery>;
export type GetMarketsByEventIdLazyQueryHookResult = ReturnType<typeof useGetMarketsByEventIdLazyQuery>;
export type GetMarketsByEventIdQueryResult = Apollo.QueryResult<GetMarketsByEventIdQuery, GetMarketsByEventIdQueryVariables>;
export const GetOutcomesByMarketAndEventDocument = gql`
    query GetOutcomesByMarketAndEvent($eventId: ID!, $marketId: ID!, $bookmakerId: String) {
  oddByEventIdAndMarketId(
    eventId: $eventId
    marketId: $marketId
    bookmakerId: $bookmakerId
  ) {
    id: eventOutcomeId
    name
  }
}
    `;

/**
 * __useGetOutcomesByMarketAndEventQuery__
 *
 * To run a query within a React component, call `useGetOutcomesByMarketAndEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutcomesByMarketAndEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutcomesByMarketAndEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      marketId: // value for 'marketId'
 *      bookmakerId: // value for 'bookmakerId'
 *   },
 * });
 */
export function useGetOutcomesByMarketAndEventQuery(baseOptions: Apollo.QueryHookOptions<GetOutcomesByMarketAndEventQuery, GetOutcomesByMarketAndEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutcomesByMarketAndEventQuery, GetOutcomesByMarketAndEventQueryVariables>(GetOutcomesByMarketAndEventDocument, options);
      }
export function useGetOutcomesByMarketAndEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutcomesByMarketAndEventQuery, GetOutcomesByMarketAndEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutcomesByMarketAndEventQuery, GetOutcomesByMarketAndEventQueryVariables>(GetOutcomesByMarketAndEventDocument, options);
        }
export type GetOutcomesByMarketAndEventQueryHookResult = ReturnType<typeof useGetOutcomesByMarketAndEventQuery>;
export type GetOutcomesByMarketAndEventLazyQueryHookResult = ReturnType<typeof useGetOutcomesByMarketAndEventLazyQuery>;
export type GetOutcomesByMarketAndEventQueryResult = Apollo.QueryResult<GetOutcomesByMarketAndEventQuery, GetOutcomesByMarketAndEventQueryVariables>;
export const GetCurrentUserFavouriteSportsDocument = gql`
    query GetCurrentUserFavouriteSports {
  userCurrent {
    sports {
      sportId
    }
  }
}
    `;

/**
 * __useGetCurrentUserFavouriteSportsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserFavouriteSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserFavouriteSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserFavouriteSportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserFavouriteSportsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserFavouriteSportsQuery, GetCurrentUserFavouriteSportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserFavouriteSportsQuery, GetCurrentUserFavouriteSportsQueryVariables>(GetCurrentUserFavouriteSportsDocument, options);
      }
export function useGetCurrentUserFavouriteSportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserFavouriteSportsQuery, GetCurrentUserFavouriteSportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserFavouriteSportsQuery, GetCurrentUserFavouriteSportsQueryVariables>(GetCurrentUserFavouriteSportsDocument, options);
        }
export type GetCurrentUserFavouriteSportsQueryHookResult = ReturnType<typeof useGetCurrentUserFavouriteSportsQuery>;
export type GetCurrentUserFavouriteSportsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserFavouriteSportsLazyQuery>;
export type GetCurrentUserFavouriteSportsQueryResult = Apollo.QueryResult<GetCurrentUserFavouriteSportsQuery, GetCurrentUserFavouriteSportsQueryVariables>;
export const GetBookiesByOutcomeIdDocument = gql`
    query GetBookiesByOutcomeId($eventOutcomeId: ID!) {
  bookiesByEventOutcomeId(eventOutcomeId: $eventOutcomeId) {
    id
    name
    odd
  }
}
    `;

/**
 * __useGetBookiesByOutcomeIdQuery__
 *
 * To run a query within a React component, call `useGetBookiesByOutcomeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookiesByOutcomeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookiesByOutcomeIdQuery({
 *   variables: {
 *      eventOutcomeId: // value for 'eventOutcomeId'
 *   },
 * });
 */
export function useGetBookiesByOutcomeIdQuery(baseOptions: Apollo.QueryHookOptions<GetBookiesByOutcomeIdQuery, GetBookiesByOutcomeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookiesByOutcomeIdQuery, GetBookiesByOutcomeIdQueryVariables>(GetBookiesByOutcomeIdDocument, options);
      }
export function useGetBookiesByOutcomeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookiesByOutcomeIdQuery, GetBookiesByOutcomeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookiesByOutcomeIdQuery, GetBookiesByOutcomeIdQueryVariables>(GetBookiesByOutcomeIdDocument, options);
        }
export type GetBookiesByOutcomeIdQueryHookResult = ReturnType<typeof useGetBookiesByOutcomeIdQuery>;
export type GetBookiesByOutcomeIdLazyQueryHookResult = ReturnType<typeof useGetBookiesByOutcomeIdLazyQuery>;
export type GetBookiesByOutcomeIdQueryResult = Apollo.QueryResult<GetBookiesByOutcomeIdQuery, GetBookiesByOutcomeIdQueryVariables>;
export const GetBookiesByEventIdAndMarketIdDocument = gql`
    query GetBookiesByEventIdAndMarketId($eventId: ID!, $marketId: ID!, $outcomeId: ID) {
  bookiesByEventIdAndMarketId(
    eventId: $eventId
    marketId: $marketId
    outcomeId: $outcomeId
  ) {
    bookieId
    bookieName
    bookieImageUrl
    odd
    outcomeId
    outcomeName
    specialBetValue
  }
}
    `;

/**
 * __useGetBookiesByEventIdAndMarketIdQuery__
 *
 * To run a query within a React component, call `useGetBookiesByEventIdAndMarketIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookiesByEventIdAndMarketIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookiesByEventIdAndMarketIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      marketId: // value for 'marketId'
 *      outcomeId: // value for 'outcomeId'
 *   },
 * });
 */
export function useGetBookiesByEventIdAndMarketIdQuery(baseOptions: Apollo.QueryHookOptions<GetBookiesByEventIdAndMarketIdQuery, GetBookiesByEventIdAndMarketIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookiesByEventIdAndMarketIdQuery, GetBookiesByEventIdAndMarketIdQueryVariables>(GetBookiesByEventIdAndMarketIdDocument, options);
      }
export function useGetBookiesByEventIdAndMarketIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookiesByEventIdAndMarketIdQuery, GetBookiesByEventIdAndMarketIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookiesByEventIdAndMarketIdQuery, GetBookiesByEventIdAndMarketIdQueryVariables>(GetBookiesByEventIdAndMarketIdDocument, options);
        }
export type GetBookiesByEventIdAndMarketIdQueryHookResult = ReturnType<typeof useGetBookiesByEventIdAndMarketIdQuery>;
export type GetBookiesByEventIdAndMarketIdLazyQueryHookResult = ReturnType<typeof useGetBookiesByEventIdAndMarketIdLazyQuery>;
export type GetBookiesByEventIdAndMarketIdQueryResult = Apollo.QueryResult<GetBookiesByEventIdAndMarketIdQuery, GetBookiesByEventIdAndMarketIdQueryVariables>;
export const GetEventsVotedDocument = gql`
    query GetEventsVoted($limit: Float, $skip: Float, $startDate: DateTime, $endDate: DateTime, $sportId: [ID!], $status: [ID!], $marketIds: [ID!]) {
  oddVoted(
    limit: $limit
    skip: $skip
    startDate: $startDate
    endDate: $endDate
    sportId: $sportId
    status: $status
    marketIds: $marketIds
  ) {
    totalCount
    avgProfit
    eventOddTypeOutcomeMarketVoteds {
      id
      result
      numberOfTips
      event {
        id
        competitors {
          id
          name
          type
        }
      }
      market {
        id
        name
      }
      outcome {
        id
        name
      }
      profit
    }
  }
}
    `;

/**
 * __useGetEventsVotedQuery__
 *
 * To run a query within a React component, call `useGetEventsVotedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsVotedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsVotedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sportId: // value for 'sportId'
 *      status: // value for 'status'
 *      marketIds: // value for 'marketIds'
 *   },
 * });
 */
export function useGetEventsVotedQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsVotedQuery, GetEventsVotedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsVotedQuery, GetEventsVotedQueryVariables>(GetEventsVotedDocument, options);
      }
export function useGetEventsVotedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsVotedQuery, GetEventsVotedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsVotedQuery, GetEventsVotedQueryVariables>(GetEventsVotedDocument, options);
        }
export type GetEventsVotedQueryHookResult = ReturnType<typeof useGetEventsVotedQuery>;
export type GetEventsVotedLazyQueryHookResult = ReturnType<typeof useGetEventsVotedLazyQuery>;
export type GetEventsVotedQueryResult = Apollo.QueryResult<GetEventsVotedQuery, GetEventsVotedQueryVariables>;
export const SearchEventsByNameDocument = gql`
    query SearchEventsByName($competitorName: String!, $from: DateTime, $to: DateTime, $bookmakerId: String, $marketId: String, $sportId: [ID!]!) {
  sportEventByCompetitorName(
    competitorName: $competitorName
    from: $from
    to: $to
    bookmakerId: $bookmakerId
    marketId: $marketId
    sportId: $sportId
  ) {
    id
    bookmakerId
    competitors {
      id
      type
      name
    }
    eventDate
    votes
    numberOfTips
    tournament {
      id
      name
      category {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useSearchEventsByNameQuery__
 *
 * To run a query within a React component, call `useSearchEventsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsByNameQuery({
 *   variables: {
 *      competitorName: // value for 'competitorName'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      bookmakerId: // value for 'bookmakerId'
 *      marketId: // value for 'marketId'
 *      sportId: // value for 'sportId'
 *   },
 * });
 */
export function useSearchEventsByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchEventsByNameQuery, SearchEventsByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEventsByNameQuery, SearchEventsByNameQueryVariables>(SearchEventsByNameDocument, options);
      }
export function useSearchEventsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEventsByNameQuery, SearchEventsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEventsByNameQuery, SearchEventsByNameQueryVariables>(SearchEventsByNameDocument, options);
        }
export type SearchEventsByNameQueryHookResult = ReturnType<typeof useSearchEventsByNameQuery>;
export type SearchEventsByNameLazyQueryHookResult = ReturnType<typeof useSearchEventsByNameLazyQuery>;
export type SearchEventsByNameQueryResult = Apollo.QueryResult<SearchEventsByNameQuery, SearchEventsByNameQueryVariables>;
export const GetCategoryByIdDocument = gql`
    query GetCategoryById($id: ID!) {
  categoryById(id: $id) {
    id
    name
    code
  }
}
    `;

/**
 * __useGetCategoryByIdQuery__
 *
 * To run a query within a React component, call `useGetCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
      }
export function useGetCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
        }
export type GetCategoryByIdQueryHookResult = ReturnType<typeof useGetCategoryByIdQuery>;
export type GetCategoryByIdLazyQueryHookResult = ReturnType<typeof useGetCategoryByIdLazyQuery>;
export type GetCategoryByIdQueryResult = Apollo.QueryResult<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>;
export const GetCompetitorsByExternalIdsDocument = gql`
    query GetCompetitorsByExternalIds($extIds: [ID!]!, $sportId: [ID!]!) {
  getTeamsByExtIds(extIds: $extIds, sportId: $sportId) {
    id
    imageUrl
    externalId
  }
}
    `;

/**
 * __useGetCompetitorsByExternalIdsQuery__
 *
 * To run a query within a React component, call `useGetCompetitorsByExternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitorsByExternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitorsByExternalIdsQuery({
 *   variables: {
 *      extIds: // value for 'extIds'
 *      sportId: // value for 'sportId'
 *   },
 * });
 */
export function useGetCompetitorsByExternalIdsQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitorsByExternalIdsQuery, GetCompetitorsByExternalIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitorsByExternalIdsQuery, GetCompetitorsByExternalIdsQueryVariables>(GetCompetitorsByExternalIdsDocument, options);
      }
export function useGetCompetitorsByExternalIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitorsByExternalIdsQuery, GetCompetitorsByExternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitorsByExternalIdsQuery, GetCompetitorsByExternalIdsQueryVariables>(GetCompetitorsByExternalIdsDocument, options);
        }
export type GetCompetitorsByExternalIdsQueryHookResult = ReturnType<typeof useGetCompetitorsByExternalIdsQuery>;
export type GetCompetitorsByExternalIdsLazyQueryHookResult = ReturnType<typeof useGetCompetitorsByExternalIdsLazyQuery>;
export type GetCompetitorsByExternalIdsQueryResult = Apollo.QueryResult<GetCompetitorsByExternalIdsQuery, GetCompetitorsByExternalIdsQueryVariables>;
export const GetTournamentsByIdsDocument = gql`
    query GetTournamentsByIds($ids: [ID!]!) {
  tournamentsByIds(ids: $ids) {
    id
    name
  }
}
    `;

/**
 * __useGetTournamentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetTournamentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetTournamentsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentsByIdsQuery, GetTournamentsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsByIdsQuery, GetTournamentsByIdsQueryVariables>(GetTournamentsByIdsDocument, options);
      }
export function useGetTournamentsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsByIdsQuery, GetTournamentsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsByIdsQuery, GetTournamentsByIdsQueryVariables>(GetTournamentsByIdsDocument, options);
        }
export type GetTournamentsByIdsQueryHookResult = ReturnType<typeof useGetTournamentsByIdsQuery>;
export type GetTournamentsByIdsLazyQueryHookResult = ReturnType<typeof useGetTournamentsByIdsLazyQuery>;
export type GetTournamentsByIdsQueryResult = Apollo.QueryResult<GetTournamentsByIdsQuery, GetTournamentsByIdsQueryVariables>;
export const PollDocument = gql`
    query Poll($pollId: ID!) {
  poll(id: $pollId) {
    category
    createdAt
    deletedAt
    downvoted
    expirationDate
    id
    isCommentsAllow
    options {
      count
      createdAt
      deletedAt
      id
      option
      pollId
      position
      updatedAt
    }
    question
    updatedAt
    upvoted
    userId
    votes {
      id
      selectedOptionId
      userId
    }
    upvotedStatus {
      downvoted
      upvoted
    }
  }
}
    `;

/**
 * __usePollQuery__
 *
 * To run a query within a React component, call `usePollQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollQuery({
 *   variables: {
 *      pollId: // value for 'pollId'
 *   },
 * });
 */
export function usePollQuery(baseOptions: Apollo.QueryHookOptions<PollQuery, PollQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollQuery, PollQueryVariables>(PollDocument, options);
      }
export function usePollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollQuery, PollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollQuery, PollQueryVariables>(PollDocument, options);
        }
export type PollQueryHookResult = ReturnType<typeof usePollQuery>;
export type PollLazyQueryHookResult = ReturnType<typeof usePollLazyQuery>;
export type PollQueryResult = Apollo.QueryResult<PollQuery, PollQueryVariables>;
export const PollDetailedDocument = gql`
    query PollDetailed($pollDetailedId: ID!) {
  pollDetailed(id: $pollDetailedId) {
    ...PollDetailedFields
  }
}
    ${PollDetailedFieldsFragmentDoc}`;

/**
 * __usePollDetailedQuery__
 *
 * To run a query within a React component, call `usePollDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollDetailedQuery({
 *   variables: {
 *      pollDetailedId: // value for 'pollDetailedId'
 *   },
 * });
 */
export function usePollDetailedQuery(baseOptions: Apollo.QueryHookOptions<PollDetailedQuery, PollDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollDetailedQuery, PollDetailedQueryVariables>(PollDetailedDocument, options);
      }
export function usePollDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollDetailedQuery, PollDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollDetailedQuery, PollDetailedQueryVariables>(PollDetailedDocument, options);
        }
export type PollDetailedQueryHookResult = ReturnType<typeof usePollDetailedQuery>;
export type PollDetailedLazyQueryHookResult = ReturnType<typeof usePollDetailedLazyQuery>;
export type PollDetailedQueryResult = Apollo.QueryResult<PollDetailedQuery, PollDetailedQueryVariables>;
export const PollsByUserIdDocument = gql`
    query PollsByUserId($userId: ID!) {
  pollsByUserId(userId: $userId) {
    category
    createdAt
    deletedAt
    downvoted
    expirationDate
    id
    isCommentsAllow
    options {
      count
      createdAt
      deletedAt
      id
      option
      position
      updatedAt
    }
    question
    updatedAt
    upvoted
    userId
    votes {
      id
      selectedOptionId
      userId
    }
  }
}
    `;

/**
 * __usePollsByUserIdQuery__
 *
 * To run a query within a React component, call `usePollsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePollsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<PollsByUserIdQuery, PollsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollsByUserIdQuery, PollsByUserIdQueryVariables>(PollsByUserIdDocument, options);
      }
export function usePollsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollsByUserIdQuery, PollsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollsByUserIdQuery, PollsByUserIdQueryVariables>(PollsByUserIdDocument, options);
        }
export type PollsByUserIdQueryHookResult = ReturnType<typeof usePollsByUserIdQuery>;
export type PollsByUserIdLazyQueryHookResult = ReturnType<typeof usePollsByUserIdLazyQuery>;
export type PollsByUserIdQueryResult = Apollo.QueryResult<PollsByUserIdQuery, PollsByUserIdQueryVariables>;
export const PostDocument = gql`
    query Post($postId: ID!) {
  post(id: $postId) {
    category
    content
    createdAt
    deletedAt
    downvoted
    isCommentsAllow
    id
    mediaLink
    title
    type
    updatedAt
    upvoted
    userId
    upvotedStatus {
      downvoted
      upvoted
    }
  }
}
    `;

/**
 * __usePostQuery__
 *
 * To run a query within a React component, call `usePostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostQuery(baseOptions: Apollo.QueryHookOptions<PostQuery, PostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostQuery, PostQueryVariables>(PostDocument, options);
      }
export function usePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export type PostQueryHookResult = ReturnType<typeof usePostQuery>;
export type PostLazyQueryHookResult = ReturnType<typeof usePostLazyQuery>;
export type PostQueryResult = Apollo.QueryResult<PostQuery, PostQueryVariables>;
export const PostDetailedDocument = gql`
    query PostDetailed($postDetailedId: ID!) {
  postDetailed(id: $postDetailedId) {
    ...PostDetailedFields
  }
}
    ${PostDetailedFieldsFragmentDoc}`;

/**
 * __usePostDetailedQuery__
 *
 * To run a query within a React component, call `usePostDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailedQuery({
 *   variables: {
 *      postDetailedId: // value for 'postDetailedId'
 *   },
 * });
 */
export function usePostDetailedQuery(baseOptions: Apollo.QueryHookOptions<PostDetailedQuery, PostDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostDetailedQuery, PostDetailedQueryVariables>(PostDetailedDocument, options);
      }
export function usePostDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostDetailedQuery, PostDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostDetailedQuery, PostDetailedQueryVariables>(PostDetailedDocument, options);
        }
export type PostDetailedQueryHookResult = ReturnType<typeof usePostDetailedQuery>;
export type PostDetailedLazyQueryHookResult = ReturnType<typeof usePostDetailedLazyQuery>;
export type PostDetailedQueryResult = Apollo.QueryResult<PostDetailedQuery, PostDetailedQueryVariables>;
export const TipDetailedDocument = gql`
    query TipDetailed($tipDetailedId: ID!) {
  tipDetailed(id: $tipDetailedId) {
    ...TipDetailedFields
  }
}
    ${TipDetailedFieldsFragmentDoc}`;

/**
 * __useTipDetailedQuery__
 *
 * To run a query within a React component, call `useTipDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipDetailedQuery({
 *   variables: {
 *      tipDetailedId: // value for 'tipDetailedId'
 *   },
 * });
 */
export function useTipDetailedQuery(baseOptions: Apollo.QueryHookOptions<TipDetailedQuery, TipDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TipDetailedQuery, TipDetailedQueryVariables>(TipDetailedDocument, options);
      }
export function useTipDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TipDetailedQuery, TipDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TipDetailedQuery, TipDetailedQueryVariables>(TipDetailedDocument, options);
        }
export type TipDetailedQueryHookResult = ReturnType<typeof useTipDetailedQuery>;
export type TipDetailedLazyQueryHookResult = ReturnType<typeof useTipDetailedLazyQuery>;
export type TipDetailedQueryResult = Apollo.QueryResult<TipDetailedQuery, TipDetailedQueryVariables>;
export const GetTipRoomDocument = gql`
    query GetTipRoom($tipId: ID!) {
  getTipRoom(tipId: $tipId) {
    tipId
    name
    streamUrl
    coverImageUrl
    streamStartTime
    streamEndTime
  }
}
    `;

/**
 * __useGetTipRoomQuery__
 *
 * To run a query within a React component, call `useGetTipRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipRoomQuery({
 *   variables: {
 *      tipId: // value for 'tipId'
 *   },
 * });
 */
export function useGetTipRoomQuery(baseOptions: Apollo.QueryHookOptions<GetTipRoomQuery, GetTipRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipRoomQuery, GetTipRoomQueryVariables>(GetTipRoomDocument, options);
      }
export function useGetTipRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipRoomQuery, GetTipRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipRoomQuery, GetTipRoomQueryVariables>(GetTipRoomDocument, options);
        }
export type GetTipRoomQueryHookResult = ReturnType<typeof useGetTipRoomQuery>;
export type GetTipRoomLazyQueryHookResult = ReturnType<typeof useGetTipRoomLazyQuery>;
export type GetTipRoomQueryResult = Apollo.QueryResult<GetTipRoomQuery, GetTipRoomQueryVariables>;
export const MultitipDetailedDocument = gql`
    query MultitipDetailed($multitipDetailedId: ID!) {
  multitipDetailed(id: $multitipDetailedId) {
    ...MultitipDetailedFields
  }
}
    ${MultitipDetailedFieldsFragmentDoc}`;

/**
 * __useMultitipDetailedQuery__
 *
 * To run a query within a React component, call `useMultitipDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultitipDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultitipDetailedQuery({
 *   variables: {
 *      multitipDetailedId: // value for 'multitipDetailedId'
 *   },
 * });
 */
export function useMultitipDetailedQuery(baseOptions: Apollo.QueryHookOptions<MultitipDetailedQuery, MultitipDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultitipDetailedQuery, MultitipDetailedQueryVariables>(MultitipDetailedDocument, options);
      }
export function useMultitipDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultitipDetailedQuery, MultitipDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultitipDetailedQuery, MultitipDetailedQueryVariables>(MultitipDetailedDocument, options);
        }
export type MultitipDetailedQueryHookResult = ReturnType<typeof useMultitipDetailedQuery>;
export type MultitipDetailedLazyQueryHookResult = ReturnType<typeof useMultitipDetailedLazyQuery>;
export type MultitipDetailedQueryResult = Apollo.QueryResult<MultitipDetailedQuery, MultitipDetailedQueryVariables>;
export const GetTipListDocument = gql`
    query GetTipList($input: TipsFilterInput!, $limit: Float, $skip: Float) {
  detailedTipsAndMultitips(input: $input, limit: $limit, skip: $skip) {
    ... on TipDetailed {
      ...TipDetailedFields
    }
    ... on MultitipDetailed {
      ...MultitipDetailedFields
    }
  }
}
    ${TipDetailedFieldsFragmentDoc}
${MultitipDetailedFieldsFragmentDoc}`;

/**
 * __useGetTipListQuery__
 *
 * To run a query within a React component, call `useGetTipListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetTipListQuery(baseOptions: Apollo.QueryHookOptions<GetTipListQuery, GetTipListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipListQuery, GetTipListQueryVariables>(GetTipListDocument, options);
      }
export function useGetTipListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipListQuery, GetTipListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipListQuery, GetTipListQueryVariables>(GetTipListDocument, options);
        }
export type GetTipListQueryHookResult = ReturnType<typeof useGetTipListQuery>;
export type GetTipListLazyQueryHookResult = ReturnType<typeof useGetTipListLazyQuery>;
export type GetTipListQueryResult = Apollo.QueryResult<GetTipListQuery, GetTipListQueryVariables>;
export const SavedTipsDocument = gql`
    query SavedTips($endDate: DateTime, $limit: Float, $skip: Float, $sportIds: [String!], $startDate: DateTime) {
  savedTips(
    endDate: $endDate
    limit: $limit
    skip: $skip
    sportIds: $sportIds
    startDate: $startDate
  ) {
    totalCount
    savedTips {
      ... on MultitipDetailed {
        ...MultitipDetailedFields
        anonymized
      }
      ... on TipDetailed {
        ...TipDetailedFields
        anonymized
      }
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}`;

/**
 * __useSavedTipsQuery__
 *
 * To run a query within a React component, call `useSavedTipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedTipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedTipsQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      sportIds: // value for 'sportIds'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useSavedTipsQuery(baseOptions?: Apollo.QueryHookOptions<SavedTipsQuery, SavedTipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedTipsQuery, SavedTipsQueryVariables>(SavedTipsDocument, options);
      }
export function useSavedTipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedTipsQuery, SavedTipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedTipsQuery, SavedTipsQueryVariables>(SavedTipsDocument, options);
        }
export type SavedTipsQueryHookResult = ReturnType<typeof useSavedTipsQuery>;
export type SavedTipsLazyQueryHookResult = ReturnType<typeof useSavedTipsLazyQuery>;
export type SavedTipsQueryResult = Apollo.QueryResult<SavedTipsQuery, SavedTipsQueryVariables>;
export const GetPublicChannelDataDocument = gql`
    query GetPublicChannelData($channelId: String! = "1", $limit: Int! = 10, $cursor: FeedCursorInput, $filter: ChannelFeedFilter) {
  publicChannelContent(limit: $limit, cursor: $cursor, filter: $filter) {
    nextCursor {
      id
      createdAt
    }
    previousCursor {
      id
      createdAt
    }
    feed {
      ... on MultitipDetailed {
        ...MultitipDetailedFields
      }
      ... on PollDetailed {
        ...PollDetailedFields
      }
      ... on PostDetailed {
        ...PostDetailedFields
      }
      ... on TipDetailed {
        ...TipDetailedFields
      }
    }
  }
  channelDetailed(channelId: $channelId) {
    pinnedContent {
      ...PinnedContentFields
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${PollDetailedFieldsFragmentDoc}
${PostDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}
${PinnedContentFieldsFragmentDoc}`;

/**
 * __useGetPublicChannelDataQuery__
 *
 * To run a query within a React component, call `useGetPublicChannelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicChannelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicChannelDataQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPublicChannelDataQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicChannelDataQuery, GetPublicChannelDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicChannelDataQuery, GetPublicChannelDataQueryVariables>(GetPublicChannelDataDocument, options);
      }
export function useGetPublicChannelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicChannelDataQuery, GetPublicChannelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicChannelDataQuery, GetPublicChannelDataQueryVariables>(GetPublicChannelDataDocument, options);
        }
export type GetPublicChannelDataQueryHookResult = ReturnType<typeof useGetPublicChannelDataQuery>;
export type GetPublicChannelDataLazyQueryHookResult = ReturnType<typeof useGetPublicChannelDataLazyQuery>;
export type GetPublicChannelDataQueryResult = Apollo.QueryResult<GetPublicChannelDataQuery, GetPublicChannelDataQueryVariables>;
export const GetPrivateChannelDataDocument = gql`
    query GetPrivateChannelData($channelId: String!, $limit: Int! = 10, $cursor: FeedCursorInput, $filter: ChannelFeedFilter) {
  privateChannelContent(
    channelId: $channelId
    limit: $limit
    cursor: $cursor
    filter: $filter
  ) {
    nextCursor {
      id
      createdAt
    }
    previousCursor {
      id
      createdAt
    }
    feed {
      ... on MultitipDetailed {
        ...MultitipDetailedFields
      }
      ... on PollDetailed {
        ...PollDetailedFields
      }
      ... on PostDetailed {
        ...PostDetailedFields
      }
      ... on TipDetailed {
        ...TipDetailedFields
      }
    }
  }
  channelDetailed(channelId: $channelId) {
    pinnedContent {
      ...PinnedContentFields
    }
  }
}
    ${MultitipDetailedFieldsFragmentDoc}
${PollDetailedFieldsFragmentDoc}
${PostDetailedFieldsFragmentDoc}
${TipDetailedFieldsFragmentDoc}
${PinnedContentFieldsFragmentDoc}`;

/**
 * __useGetPrivateChannelDataQuery__
 *
 * To run a query within a React component, call `useGetPrivateChannelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrivateChannelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrivateChannelDataQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPrivateChannelDataQuery(baseOptions: Apollo.QueryHookOptions<GetPrivateChannelDataQuery, GetPrivateChannelDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrivateChannelDataQuery, GetPrivateChannelDataQueryVariables>(GetPrivateChannelDataDocument, options);
      }
export function useGetPrivateChannelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrivateChannelDataQuery, GetPrivateChannelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrivateChannelDataQuery, GetPrivateChannelDataQueryVariables>(GetPrivateChannelDataDocument, options);
        }
export type GetPrivateChannelDataQueryHookResult = ReturnType<typeof useGetPrivateChannelDataQuery>;
export type GetPrivateChannelDataLazyQueryHookResult = ReturnType<typeof useGetPrivateChannelDataLazyQuery>;
export type GetPrivateChannelDataQueryResult = Apollo.QueryResult<GetPrivateChannelDataQuery, GetPrivateChannelDataQueryVariables>;
export const GetTipsterFollowersBySourceDocument = gql`
    query GetTipsterFollowersBySource($userId: String!, $startDate: String, $endDate: String) {
  getTipsterFollowersBySource(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
  ) {
    source
    userCount
  }
}
    `;

/**
 * __useGetTipsterFollowersBySourceQuery__
 *
 * To run a query within a React component, call `useGetTipsterFollowersBySourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterFollowersBySourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterFollowersBySourceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTipsterFollowersBySourceQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterFollowersBySourceQuery, GetTipsterFollowersBySourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterFollowersBySourceQuery, GetTipsterFollowersBySourceQueryVariables>(GetTipsterFollowersBySourceDocument, options);
      }
export function useGetTipsterFollowersBySourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterFollowersBySourceQuery, GetTipsterFollowersBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterFollowersBySourceQuery, GetTipsterFollowersBySourceQueryVariables>(GetTipsterFollowersBySourceDocument, options);
        }
export type GetTipsterFollowersBySourceQueryHookResult = ReturnType<typeof useGetTipsterFollowersBySourceQuery>;
export type GetTipsterFollowersBySourceLazyQueryHookResult = ReturnType<typeof useGetTipsterFollowersBySourceLazyQuery>;
export type GetTipsterFollowersBySourceQueryResult = Apollo.QueryResult<GetTipsterFollowersBySourceQuery, GetTipsterFollowersBySourceQueryVariables>;
export const GetTipsterUsersSignupMethodsDocument = gql`
    query GetTipsterUsersSignupMethods($userId: String!, $startDate: String, $endDate: String) {
  getTipsterUsersSignupMethods(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
  ) {
    pool
    userCount
  }
}
    `;

/**
 * __useGetTipsterUsersSignupMethodsQuery__
 *
 * To run a query within a React component, call `useGetTipsterUsersSignupMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterUsersSignupMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterUsersSignupMethodsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTipsterUsersSignupMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterUsersSignupMethodsQuery, GetTipsterUsersSignupMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterUsersSignupMethodsQuery, GetTipsterUsersSignupMethodsQueryVariables>(GetTipsterUsersSignupMethodsDocument, options);
      }
export function useGetTipsterUsersSignupMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterUsersSignupMethodsQuery, GetTipsterUsersSignupMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterUsersSignupMethodsQuery, GetTipsterUsersSignupMethodsQueryVariables>(GetTipsterUsersSignupMethodsDocument, options);
        }
export type GetTipsterUsersSignupMethodsQueryHookResult = ReturnType<typeof useGetTipsterUsersSignupMethodsQuery>;
export type GetTipsterUsersSignupMethodsLazyQueryHookResult = ReturnType<typeof useGetTipsterUsersSignupMethodsLazyQuery>;
export type GetTipsterUsersSignupMethodsQueryResult = Apollo.QueryResult<GetTipsterUsersSignupMethodsQuery, GetTipsterUsersSignupMethodsQueryVariables>;
export const GetActiveTipsCountDocument = gql`
    query GetActiveTipsCount {
  countActiveTips
}
    `;

/**
 * __useGetActiveTipsCountQuery__
 *
 * To run a query within a React component, call `useGetActiveTipsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveTipsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveTipsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveTipsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveTipsCountQuery, GetActiveTipsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveTipsCountQuery, GetActiveTipsCountQueryVariables>(GetActiveTipsCountDocument, options);
      }
export function useGetActiveTipsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveTipsCountQuery, GetActiveTipsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveTipsCountQuery, GetActiveTipsCountQueryVariables>(GetActiveTipsCountDocument, options);
        }
export type GetActiveTipsCountQueryHookResult = ReturnType<typeof useGetActiveTipsCountQuery>;
export type GetActiveTipsCountLazyQueryHookResult = ReturnType<typeof useGetActiveTipsCountLazyQuery>;
export type GetActiveTipsCountQueryResult = Apollo.QueryResult<GetActiveTipsCountQuery, GetActiveTipsCountQueryVariables>;
export const GetTipsterLeaderboardDocument = gql`
    query GetTipsterLeaderboard($filter: LeaderboardFilterInput) {
  tipsterLeaderboard(filter: $filter) {
    top {
      ...LeaderboardEntryFields
    }
    entries {
      ...LeaderboardEntryFields
    }
    offset
    limit
    totalCount
    hasNextPage
    snapshotId
    minTipsThreshold
  }
}
    ${LeaderboardEntryFieldsFragmentDoc}`;

/**
 * __useGetTipsterLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetTipsterLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterLeaderboardQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTipsterLeaderboardQuery(baseOptions?: Apollo.QueryHookOptions<GetTipsterLeaderboardQuery, GetTipsterLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterLeaderboardQuery, GetTipsterLeaderboardQueryVariables>(GetTipsterLeaderboardDocument, options);
      }
export function useGetTipsterLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterLeaderboardQuery, GetTipsterLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterLeaderboardQuery, GetTipsterLeaderboardQueryVariables>(GetTipsterLeaderboardDocument, options);
        }
export type GetTipsterLeaderboardQueryHookResult = ReturnType<typeof useGetTipsterLeaderboardQuery>;
export type GetTipsterLeaderboardLazyQueryHookResult = ReturnType<typeof useGetTipsterLeaderboardLazyQuery>;
export type GetTipsterLeaderboardQueryResult = Apollo.QueryResult<GetTipsterLeaderboardQuery, GetTipsterLeaderboardQueryVariables>;
export const GetMyLeaderboardPositionDocument = gql`
    query GetMyLeaderboardPosition($filter: LeaderboardFilterInput) {
  myLeaderboardPosition(filter: $filter) {
    rank
    previousRank
    rankChange
    qualifies
    totalTips
    minTipsThreshold
    entry {
      ...LeaderboardEntryFields
    }
  }
}
    ${LeaderboardEntryFieldsFragmentDoc}`;

/**
 * __useGetMyLeaderboardPositionQuery__
 *
 * To run a query within a React component, call `useGetMyLeaderboardPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLeaderboardPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLeaderboardPositionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMyLeaderboardPositionQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLeaderboardPositionQuery, GetMyLeaderboardPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLeaderboardPositionQuery, GetMyLeaderboardPositionQueryVariables>(GetMyLeaderboardPositionDocument, options);
      }
export function useGetMyLeaderboardPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLeaderboardPositionQuery, GetMyLeaderboardPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLeaderboardPositionQuery, GetMyLeaderboardPositionQueryVariables>(GetMyLeaderboardPositionDocument, options);
        }
export type GetMyLeaderboardPositionQueryHookResult = ReturnType<typeof useGetMyLeaderboardPositionQuery>;
export type GetMyLeaderboardPositionLazyQueryHookResult = ReturnType<typeof useGetMyLeaderboardPositionLazyQuery>;
export type GetMyLeaderboardPositionQueryResult = Apollo.QueryResult<GetMyLeaderboardPositionQuery, GetMyLeaderboardPositionQueryVariables>;
export const MarketsDocument = gql`
    query Markets {
  markets {
    id
    name
  }
}
    `;

/**
 * __useMarketsQuery__
 *
 * To run a query within a React component, call `useMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketsQuery(baseOptions?: Apollo.QueryHookOptions<MarketsQuery, MarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketsQuery, MarketsQueryVariables>(MarketsDocument, options);
      }
export function useMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketsQuery, MarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketsQuery, MarketsQueryVariables>(MarketsDocument, options);
        }
export type MarketsQueryHookResult = ReturnType<typeof useMarketsQuery>;
export type MarketsLazyQueryHookResult = ReturnType<typeof useMarketsLazyQuery>;
export type MarketsQueryResult = Apollo.QueryResult<MarketsQuery, MarketsQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications($channelIds: [String!]!, $isNew: Boolean, $limit: Float!, $skip: Float!) {
  notifications(
    channelIds: $channelIds
    isNew: $isNew
    limit: $limit
    skip: $skip
  ) {
    count
    notifications {
      createdAt
      iconUrl
      id
      info
      isNew
      type
      userId
      createdByUser {
        id
        displayName
        firstName
        avatarUrl
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      isNew: // value for 'isNew'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetNotificationsCountDocument = gql`
    query GetNotificationsCount($channelIds: [String!]!, $isNew: Boolean, $limit: Float!, $skip: Float!) {
  notifications(
    channelIds: $channelIds
    isNew: $isNew
    limit: $limit
    skip: $skip
  ) {
    count
  }
}
    `;

/**
 * __useGetNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsCountQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      isNew: // value for 'isNew'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNotificationsCountQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>(GetNotificationsCountDocument, options);
      }
export function useGetNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>(GetNotificationsCountDocument, options);
        }
export type GetNotificationsCountQueryHookResult = ReturnType<typeof useGetNotificationsCountQuery>;
export type GetNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetNotificationsCountLazyQuery>;
export type GetNotificationsCountQueryResult = Apollo.QueryResult<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>;
export const GetNotificationSettingsDocument = gql`
    query GetNotificationSettings($entityId: ID, $scope: NotificationSettingScope!) {
  entityNotificationSettingsByEntityId(entityId: $entityId, scope: $scope) {
    id
    isEditable
    notificationSetting {
      id
      name
      category
    }
    value
  }
}
    `;

/**
 * __useGetNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSettingsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetNotificationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
      }
export function useGetNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
        }
export type GetNotificationSettingsQueryHookResult = ReturnType<typeof useGetNotificationSettingsQuery>;
export type GetNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetNotificationSettingsLazyQuery>;
export type GetNotificationSettingsQueryResult = Apollo.QueryResult<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const GetNotificationsAndMessagesCountDocument = gql`
    query GetNotificationsAndMessagesCount($channelIds: [String!]!, $isNew: Boolean, $limit: Float!, $skip: Float!) {
  notifications(
    channelIds: $channelIds
    isNew: $isNew
    limit: $limit
    skip: $skip
  ) {
    count
  }
  unreadChatsCount
}
    `;

/**
 * __useGetNotificationsAndMessagesCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationsAndMessagesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsAndMessagesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsAndMessagesCountQuery({
 *   variables: {
 *      channelIds: // value for 'channelIds'
 *      isNew: // value for 'isNew'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetNotificationsAndMessagesCountQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsAndMessagesCountQuery, GetNotificationsAndMessagesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsAndMessagesCountQuery, GetNotificationsAndMessagesCountQueryVariables>(GetNotificationsAndMessagesCountDocument, options);
      }
export function useGetNotificationsAndMessagesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsAndMessagesCountQuery, GetNotificationsAndMessagesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsAndMessagesCountQuery, GetNotificationsAndMessagesCountQueryVariables>(GetNotificationsAndMessagesCountDocument, options);
        }
export type GetNotificationsAndMessagesCountQueryHookResult = ReturnType<typeof useGetNotificationsAndMessagesCountQuery>;
export type GetNotificationsAndMessagesCountLazyQueryHookResult = ReturnType<typeof useGetNotificationsAndMessagesCountLazyQuery>;
export type GetNotificationsAndMessagesCountQueryResult = Apollo.QueryResult<GetNotificationsAndMessagesCountQuery, GetNotificationsAndMessagesCountQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    id
    name
    code
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetSportsDocument = gql`
    query GetSports {
  sports {
    id
    name
  }
}
    `;

/**
 * __useGetSportsQuery__
 *
 * To run a query within a React component, call `useGetSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSportsQuery(baseOptions?: Apollo.QueryHookOptions<GetSportsQuery, GetSportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportsQuery, GetSportsQueryVariables>(GetSportsDocument, options);
      }
export function useGetSportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportsQuery, GetSportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportsQuery, GetSportsQueryVariables>(GetSportsDocument, options);
        }
export type GetSportsQueryHookResult = ReturnType<typeof useGetSportsQuery>;
export type GetSportsLazyQueryHookResult = ReturnType<typeof useGetSportsLazyQuery>;
export type GetSportsQueryResult = Apollo.QueryResult<GetSportsQuery, GetSportsQueryVariables>;
export const GetTournamentsBySportIdsDocument = gql`
    query GetTournamentsBySportIds($ids: [ID!]!, $limit: Float, $skip: Float, $search: String) {
  tournamentsBySportIds(ids: $ids, limit: $limit, skip: $skip, search: $search) {
    totalCount
    tournaments {
      id
      name
      category {
        id
        name
        externalId
        sportId
      }
    }
  }
}
    `;

/**
 * __useGetTournamentsBySportIdsQuery__
 *
 * To run a query within a React component, call `useGetTournamentsBySportIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentsBySportIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentsBySportIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTournamentsBySportIdsQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentsBySportIdsQuery, GetTournamentsBySportIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentsBySportIdsQuery, GetTournamentsBySportIdsQueryVariables>(GetTournamentsBySportIdsDocument, options);
      }
export function useGetTournamentsBySportIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentsBySportIdsQuery, GetTournamentsBySportIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentsBySportIdsQuery, GetTournamentsBySportIdsQueryVariables>(GetTournamentsBySportIdsDocument, options);
        }
export type GetTournamentsBySportIdsQueryHookResult = ReturnType<typeof useGetTournamentsBySportIdsQuery>;
export type GetTournamentsBySportIdsLazyQueryHookResult = ReturnType<typeof useGetTournamentsBySportIdsLazyQuery>;
export type GetTournamentsBySportIdsQueryResult = Apollo.QueryResult<GetTournamentsBySportIdsQuery, GetTournamentsBySportIdsQueryVariables>;
export const GetCountryByIpDocument = gql`
    query GetCountryByIp {
  countryByIp {
    id
    isBlacklisted
    code
    name
    continent
  }
}
    `;

/**
 * __useGetCountryByIpQuery__
 *
 * To run a query within a React component, call `useGetCountryByIpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryByIpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryByIpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryByIpQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryByIpQuery, GetCountryByIpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryByIpQuery, GetCountryByIpQueryVariables>(GetCountryByIpDocument, options);
      }
export function useGetCountryByIpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryByIpQuery, GetCountryByIpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryByIpQuery, GetCountryByIpQueryVariables>(GetCountryByIpDocument, options);
        }
export type GetCountryByIpQueryHookResult = ReturnType<typeof useGetCountryByIpQuery>;
export type GetCountryByIpLazyQueryHookResult = ReturnType<typeof useGetCountryByIpLazyQuery>;
export type GetCountryByIpQueryResult = Apollo.QueryResult<GetCountryByIpQuery, GetCountryByIpQueryVariables>;
export const GetBookiesDocument = gql`
    query GetBookies {
  bookies {
    id
    name
  }
}
    `;

/**
 * __useGetBookiesQuery__
 *
 * To run a query within a React component, call `useGetBookiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookiesQuery(baseOptions?: Apollo.QueryHookOptions<GetBookiesQuery, GetBookiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookiesQuery, GetBookiesQueryVariables>(GetBookiesDocument, options);
      }
export function useGetBookiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookiesQuery, GetBookiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookiesQuery, GetBookiesQueryVariables>(GetBookiesDocument, options);
        }
export type GetBookiesQueryHookResult = ReturnType<typeof useGetBookiesQuery>;
export type GetBookiesLazyQueryHookResult = ReturnType<typeof useGetBookiesLazyQuery>;
export type GetBookiesQueryResult = Apollo.QueryResult<GetBookiesQuery, GetBookiesQueryVariables>;
export const GetFavouriteListForProfileDocument = gql`
    query GetFavouriteListForProfile {
  sports {
    id
    name
  }
  markets {
    id
    name
    sportId
  }
}
    `;

/**
 * __useGetFavouriteListForProfileQuery__
 *
 * To run a query within a React component, call `useGetFavouriteListForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavouriteListForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavouriteListForProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavouriteListForProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetFavouriteListForProfileQuery, GetFavouriteListForProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavouriteListForProfileQuery, GetFavouriteListForProfileQueryVariables>(GetFavouriteListForProfileDocument, options);
      }
export function useGetFavouriteListForProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavouriteListForProfileQuery, GetFavouriteListForProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavouriteListForProfileQuery, GetFavouriteListForProfileQueryVariables>(GetFavouriteListForProfileDocument, options);
        }
export type GetFavouriteListForProfileQueryHookResult = ReturnType<typeof useGetFavouriteListForProfileQuery>;
export type GetFavouriteListForProfileLazyQueryHookResult = ReturnType<typeof useGetFavouriteListForProfileLazyQuery>;
export type GetFavouriteListForProfileQueryResult = Apollo.QueryResult<GetFavouriteListForProfileQuery, GetFavouriteListForProfileQueryVariables>;
export const GetTranslatedCountriesDocument = gql`
    query GetTranslatedCountries($country_name: String!) {
  translateCountries(country_name: $country_name) {
    id
    name
    code
  }
}
    `;

/**
 * __useGetTranslatedCountriesQuery__
 *
 * To run a query within a React component, call `useGetTranslatedCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslatedCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslatedCountriesQuery({
 *   variables: {
 *      country_name: // value for 'country_name'
 *   },
 * });
 */
export function useGetTranslatedCountriesQuery(baseOptions: Apollo.QueryHookOptions<GetTranslatedCountriesQuery, GetTranslatedCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslatedCountriesQuery, GetTranslatedCountriesQueryVariables>(GetTranslatedCountriesDocument, options);
      }
export function useGetTranslatedCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslatedCountriesQuery, GetTranslatedCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslatedCountriesQuery, GetTranslatedCountriesQueryVariables>(GetTranslatedCountriesDocument, options);
        }
export type GetTranslatedCountriesQueryHookResult = ReturnType<typeof useGetTranslatedCountriesQuery>;
export type GetTranslatedCountriesLazyQueryHookResult = ReturnType<typeof useGetTranslatedCountriesLazyQuery>;
export type GetTranslatedCountriesQueryResult = Apollo.QueryResult<GetTranslatedCountriesQuery, GetTranslatedCountriesQueryVariables>;
export const GetSportsWithoutCategoriesDocument = gql`
    query GetSportsWithoutCategories {
  sportWithoutCategories {
    id
    name
  }
}
    `;

/**
 * __useGetSportsWithoutCategoriesQuery__
 *
 * To run a query within a React component, call `useGetSportsWithoutCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportsWithoutCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportsWithoutCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSportsWithoutCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetSportsWithoutCategoriesQuery, GetSportsWithoutCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportsWithoutCategoriesQuery, GetSportsWithoutCategoriesQueryVariables>(GetSportsWithoutCategoriesDocument, options);
      }
export function useGetSportsWithoutCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportsWithoutCategoriesQuery, GetSportsWithoutCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportsWithoutCategoriesQuery, GetSportsWithoutCategoriesQueryVariables>(GetSportsWithoutCategoriesDocument, options);
        }
export type GetSportsWithoutCategoriesQueryHookResult = ReturnType<typeof useGetSportsWithoutCategoriesQuery>;
export type GetSportsWithoutCategoriesLazyQueryHookResult = ReturnType<typeof useGetSportsWithoutCategoriesLazyQuery>;
export type GetSportsWithoutCategoriesQueryResult = Apollo.QueryResult<GetSportsWithoutCategoriesQuery, GetSportsWithoutCategoriesQueryVariables>;
export const GetPlansByChannelDocument = gql`
    query GetPlansByChannel($channelId: Float!) {
  plansByChannel(channelId: $channelId) {
    id
    channelId
    tipsterId
    scope
    name
    description
    price
    currencyCode
    durationDays
    freeTrialDays
    status
    createdAt
    paymentMethods {
      id
      paymentType {
        id
        paymentName
        isAutoActivated
        category
        imageUrl
      }
    }
    isLocked
    activeSubscriberCount
  }
}
    `;

/**
 * __useGetPlansByChannelQuery__
 *
 * To run a query within a React component, call `useGetPlansByChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansByChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansByChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetPlansByChannelQuery(baseOptions: Apollo.QueryHookOptions<GetPlansByChannelQuery, GetPlansByChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansByChannelQuery, GetPlansByChannelQueryVariables>(GetPlansByChannelDocument, options);
      }
export function useGetPlansByChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansByChannelQuery, GetPlansByChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansByChannelQuery, GetPlansByChannelQueryVariables>(GetPlansByChannelDocument, options);
        }
export type GetPlansByChannelQueryHookResult = ReturnType<typeof useGetPlansByChannelQuery>;
export type GetPlansByChannelLazyQueryHookResult = ReturnType<typeof useGetPlansByChannelLazyQuery>;
export type GetPlansByChannelQueryResult = Apollo.QueryResult<GetPlansByChannelQuery, GetPlansByChannelQueryVariables>;
export const GetPlansByTipsterIdDocument = gql`
    query GetPlansByTipsterId($tipsterId: String!) {
  plansByTipsterId(tipsterId: $tipsterId) {
    id
    channelId
    tipsterId
    scope
    name
    description
    price
    currencyCode
    durationDays
    freeTrialDays
    status
    createdAt
    paymentMethods {
      id
      paymentType {
        id
        paymentName
        isAutoActivated
        category
        imageUrl
      }
    }
    isLocked
    activeSubscriberCount
  }
}
    `;

/**
 * __useGetPlansByTipsterIdQuery__
 *
 * To run a query within a React component, call `useGetPlansByTipsterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansByTipsterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansByTipsterIdQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetPlansByTipsterIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlansByTipsterIdQuery, GetPlansByTipsterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansByTipsterIdQuery, GetPlansByTipsterIdQueryVariables>(GetPlansByTipsterIdDocument, options);
      }
export function useGetPlansByTipsterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansByTipsterIdQuery, GetPlansByTipsterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansByTipsterIdQuery, GetPlansByTipsterIdQueryVariables>(GetPlansByTipsterIdDocument, options);
        }
export type GetPlansByTipsterIdQueryHookResult = ReturnType<typeof useGetPlansByTipsterIdQuery>;
export type GetPlansByTipsterIdLazyQueryHookResult = ReturnType<typeof useGetPlansByTipsterIdLazyQuery>;
export type GetPlansByTipsterIdQueryResult = Apollo.QueryResult<GetPlansByTipsterIdQuery, GetPlansByTipsterIdQueryVariables>;
export const GetPlansDocument = gql`
    query GetPlans {
  plans {
    id
    channelId
    tipsterId
    scope
    name
    description
    price
    currencyCode
    durationDays
    freeTrialDays
    status
    createdAt
    paymentMethods {
      id
      paymentType {
        id
        paymentName
        isAutoActivated
        category
        imageUrl
      }
    }
    isLocked
    activeSubscriberCount
  }
}
    `;

/**
 * __useGetPlansQuery__
 *
 * To run a query within a React component, call `useGetPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
      }
export function useGetPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
        }
export type GetPlansQueryHookResult = ReturnType<typeof useGetPlansQuery>;
export type GetPlansLazyQueryHookResult = ReturnType<typeof useGetPlansLazyQuery>;
export type GetPlansQueryResult = Apollo.QueryResult<GetPlansQuery, GetPlansQueryVariables>;
export const HasAccessDocument = gql`
    query HasAccess($channelId: Int!, $tipsterId: String) {
  hasAccess(channelId: $channelId, tipsterId: $tipsterId)
}
    `;

/**
 * __useHasAccessQuery__
 *
 * To run a query within a React component, call `useHasAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAccessQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useHasAccessQuery(baseOptions: Apollo.QueryHookOptions<HasAccessQuery, HasAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasAccessQuery, HasAccessQueryVariables>(HasAccessDocument, options);
      }
export function useHasAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasAccessQuery, HasAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasAccessQuery, HasAccessQueryVariables>(HasAccessDocument, options);
        }
export type HasAccessQueryHookResult = ReturnType<typeof useHasAccessQuery>;
export type HasAccessLazyQueryHookResult = ReturnType<typeof useHasAccessLazyQuery>;
export type HasAccessQueryResult = Apollo.QueryResult<HasAccessQuery, HasAccessQueryVariables>;
export const GetMyAccessGrantsDocument = gql`
    query GetMyAccessGrants {
  myAccessGrants {
    id
    channelId
    tipsterId
    scope
    status
    startedAt
    expiration
    createdAt
    planId
    planName
    planPrice
    planCurrencyCode
    planDurationDays
    planFreeTrialDays
  }
}
    `;

/**
 * __useGetMyAccessGrantsQuery__
 *
 * To run a query within a React component, call `useGetMyAccessGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAccessGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAccessGrantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAccessGrantsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAccessGrantsQuery, GetMyAccessGrantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAccessGrantsQuery, GetMyAccessGrantsQueryVariables>(GetMyAccessGrantsDocument, options);
      }
export function useGetMyAccessGrantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAccessGrantsQuery, GetMyAccessGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAccessGrantsQuery, GetMyAccessGrantsQueryVariables>(GetMyAccessGrantsDocument, options);
        }
export type GetMyAccessGrantsQueryHookResult = ReturnType<typeof useGetMyAccessGrantsQuery>;
export type GetMyAccessGrantsLazyQueryHookResult = ReturnType<typeof useGetMyAccessGrantsLazyQuery>;
export type GetMyAccessGrantsQueryResult = Apollo.QueryResult<GetMyAccessGrantsQuery, GetMyAccessGrantsQueryVariables>;
export const GetGrantsByTipsterDocument = gql`
    query GetGrantsByTipster {
  grantsByTipster {
    id
    userId
    displayName
    channelId
    scope
    status
    startedAt
    expiration
    createdAt
    planId
    planName
    planPrice
    planCurrencyCode
  }
}
    `;

/**
 * __useGetGrantsByTipsterQuery__
 *
 * To run a query within a React component, call `useGetGrantsByTipsterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrantsByTipsterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrantsByTipsterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGrantsByTipsterQuery(baseOptions?: Apollo.QueryHookOptions<GetGrantsByTipsterQuery, GetGrantsByTipsterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGrantsByTipsterQuery, GetGrantsByTipsterQueryVariables>(GetGrantsByTipsterDocument, options);
      }
export function useGetGrantsByTipsterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGrantsByTipsterQuery, GetGrantsByTipsterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGrantsByTipsterQuery, GetGrantsByTipsterQueryVariables>(GetGrantsByTipsterDocument, options);
        }
export type GetGrantsByTipsterQueryHookResult = ReturnType<typeof useGetGrantsByTipsterQuery>;
export type GetGrantsByTipsterLazyQueryHookResult = ReturnType<typeof useGetGrantsByTipsterLazyQuery>;
export type GetGrantsByTipsterQueryResult = Apollo.QueryResult<GetGrantsByTipsterQuery, GetGrantsByTipsterQueryVariables>;
export const GetVipInvitesDocument = gql`
    query GetVipInvites {
  vipInvites {
    id
    token
    shareUrl
    isValid
    usedCount
    expiresAt
    createdAt
  }
}
    `;

/**
 * __useGetVipInvitesQuery__
 *
 * To run a query within a React component, call `useGetVipInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVipInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVipInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVipInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetVipInvitesQuery, GetVipInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVipInvitesQuery, GetVipInvitesQueryVariables>(GetVipInvitesDocument, options);
      }
export function useGetVipInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVipInvitesQuery, GetVipInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVipInvitesQuery, GetVipInvitesQueryVariables>(GetVipInvitesDocument, options);
        }
export type GetVipInvitesQueryHookResult = ReturnType<typeof useGetVipInvitesQuery>;
export type GetVipInvitesLazyQueryHookResult = ReturnType<typeof useGetVipInvitesLazyQuery>;
export type GetVipInvitesQueryResult = Apollo.QueryResult<GetVipInvitesQuery, GetVipInvitesQueryVariables>;
export const GetRevenueByDateDocument = gql`
    query GetRevenueByDate($tipsterId: String!, $startDate: String, $endDate: String) {
  getRevenueByDate(
    tipsterId: $tipsterId
    startDate: $startDate
    endDate: $endDate
  ) {
    date
    totalAmount
  }
}
    `;

/**
 * __useGetRevenueByDateQuery__
 *
 * To run a query within a React component, call `useGetRevenueByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueByDateQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetRevenueByDateQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueByDateQuery, GetRevenueByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueByDateQuery, GetRevenueByDateQueryVariables>(GetRevenueByDateDocument, options);
      }
export function useGetRevenueByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueByDateQuery, GetRevenueByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueByDateQuery, GetRevenueByDateQueryVariables>(GetRevenueByDateDocument, options);
        }
export type GetRevenueByDateQueryHookResult = ReturnType<typeof useGetRevenueByDateQuery>;
export type GetRevenueByDateLazyQueryHookResult = ReturnType<typeof useGetRevenueByDateLazyQuery>;
export type GetRevenueByDateQueryResult = Apollo.QueryResult<GetRevenueByDateQuery, GetRevenueByDateQueryVariables>;
export const GetServiceByTipsterAndChannelDocument = gql`
    query GetServiceByTipsterAndChannel($channelId: String!, $tipsterId: String!) {
  serviceByChannelIdAndTipsterId(channelId: $channelId, tipsterId: $tipsterId) {
    id
    title
    subTitle
    ctaTitle
    ctaSubTitle
    imageLink
  }
}
    `;

/**
 * __useGetServiceByTipsterAndChannelQuery__
 *
 * To run a query within a React component, call `useGetServiceByTipsterAndChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceByTipsterAndChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceByTipsterAndChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetServiceByTipsterAndChannelQuery(baseOptions: Apollo.QueryHookOptions<GetServiceByTipsterAndChannelQuery, GetServiceByTipsterAndChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceByTipsterAndChannelQuery, GetServiceByTipsterAndChannelQueryVariables>(GetServiceByTipsterAndChannelDocument, options);
      }
export function useGetServiceByTipsterAndChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceByTipsterAndChannelQuery, GetServiceByTipsterAndChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceByTipsterAndChannelQuery, GetServiceByTipsterAndChannelQueryVariables>(GetServiceByTipsterAndChannelDocument, options);
        }
export type GetServiceByTipsterAndChannelQueryHookResult = ReturnType<typeof useGetServiceByTipsterAndChannelQuery>;
export type GetServiceByTipsterAndChannelLazyQueryHookResult = ReturnType<typeof useGetServiceByTipsterAndChannelLazyQuery>;
export type GetServiceByTipsterAndChannelQueryResult = Apollo.QueryResult<GetServiceByTipsterAndChannelQuery, GetServiceByTipsterAndChannelQueryVariables>;
export const GetServicesByTipsterIdDocument = gql`
    query GetServicesByTipsterId($tipsterId: String!) {
  services(filter: {tipsterId: $tipsterId}) {
    edges {
      node {
        id
        serviceName
        channelId
        channelName
      }
    }
  }
}
    `;

/**
 * __useGetServicesByTipsterIdQuery__
 *
 * To run a query within a React component, call `useGetServicesByTipsterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesByTipsterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesByTipsterIdQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetServicesByTipsterIdQuery(baseOptions: Apollo.QueryHookOptions<GetServicesByTipsterIdQuery, GetServicesByTipsterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesByTipsterIdQuery, GetServicesByTipsterIdQueryVariables>(GetServicesByTipsterIdDocument, options);
      }
export function useGetServicesByTipsterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesByTipsterIdQuery, GetServicesByTipsterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesByTipsterIdQuery, GetServicesByTipsterIdQueryVariables>(GetServicesByTipsterIdDocument, options);
        }
export type GetServicesByTipsterIdQueryHookResult = ReturnType<typeof useGetServicesByTipsterIdQuery>;
export type GetServicesByTipsterIdLazyQueryHookResult = ReturnType<typeof useGetServicesByTipsterIdLazyQuery>;
export type GetServicesByTipsterIdQueryResult = Apollo.QueryResult<GetServicesByTipsterIdQuery, GetServicesByTipsterIdQueryVariables>;
export const GetAvailablePaymentMethodsDocument = gql`
    query GetAvailablePaymentMethods {
  availablePayments {
    edges {
      node {
        id
        paymentName
        imageUrl
        isAutoActivated
      }
    }
  }
}
    `;

/**
 * __useGetAvailablePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetAvailablePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailablePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailablePaymentMethodsQuery, GetAvailablePaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailablePaymentMethodsQuery, GetAvailablePaymentMethodsQueryVariables>(GetAvailablePaymentMethodsDocument, options);
      }
export function useGetAvailablePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailablePaymentMethodsQuery, GetAvailablePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailablePaymentMethodsQuery, GetAvailablePaymentMethodsQueryVariables>(GetAvailablePaymentMethodsDocument, options);
        }
export type GetAvailablePaymentMethodsQueryHookResult = ReturnType<typeof useGetAvailablePaymentMethodsQuery>;
export type GetAvailablePaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetAvailablePaymentMethodsLazyQuery>;
export type GetAvailablePaymentMethodsQueryResult = Apollo.QueryResult<GetAvailablePaymentMethodsQuery, GetAvailablePaymentMethodsQueryVariables>;
export const CurrentUserHasPendingSubscriptionDocument = gql`
    query currentUserHasPendingSubscription {
  checkCurrentUserHasPendingSubscription
}
    `;

/**
 * __useCurrentUserHasPendingSubscriptionQuery__
 *
 * To run a query within a React component, call `useCurrentUserHasPendingSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserHasPendingSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserHasPendingSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserHasPendingSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserHasPendingSubscriptionQuery, CurrentUserHasPendingSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserHasPendingSubscriptionQuery, CurrentUserHasPendingSubscriptionQueryVariables>(CurrentUserHasPendingSubscriptionDocument, options);
      }
export function useCurrentUserHasPendingSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserHasPendingSubscriptionQuery, CurrentUserHasPendingSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserHasPendingSubscriptionQuery, CurrentUserHasPendingSubscriptionQueryVariables>(CurrentUserHasPendingSubscriptionDocument, options);
        }
export type CurrentUserHasPendingSubscriptionQueryHookResult = ReturnType<typeof useCurrentUserHasPendingSubscriptionQuery>;
export type CurrentUserHasPendingSubscriptionLazyQueryHookResult = ReturnType<typeof useCurrentUserHasPendingSubscriptionLazyQuery>;
export type CurrentUserHasPendingSubscriptionQueryResult = Apollo.QueryResult<CurrentUserHasPendingSubscriptionQuery, CurrentUserHasPendingSubscriptionQueryVariables>;
export const GetSubscriptionsByTipsterAndChannelDocument = gql`
    query GetSubscriptionsByTipsterAndChannel($channelId: String, $tipsterId: String!, $countryId: String!, $limit: Float) {
  subscriptionByChannelIdAndTipsterId(
    channelId: $channelId
    tipsterId: $tipsterId
    countryId: $countryId
    limit: $limit
  ) {
    edges {
      node {
        id
        freeTrialPeriod
        price {
          id
          price
          currency {
            id
            name
            symbol
          }
          priceBreakdown {
            taxRate
            subTotal
            total
            vat
          }
        }
        serviceDuration {
          id
          duration
        }
        service {
          id
          tipsterId
          tipsterName
          imageLink
          info
          imageLink
          status
          title
          subTitle
          ctaTitle
          ctaSubTitle
          serviceName
          channelId
          channelName
          paymentMethods {
            id
            paymentInfo
            paymentComment
            paymentType {
              paymentName
              id
              imageUrl
              isAutoActivated
              category
            }
          }
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionsByTipsterAndChannelQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsByTipsterAndChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsByTipsterAndChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsByTipsterAndChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      tipsterId: // value for 'tipsterId'
 *      countryId: // value for 'countryId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSubscriptionsByTipsterAndChannelQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionsByTipsterAndChannelQuery, GetSubscriptionsByTipsterAndChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsByTipsterAndChannelQuery, GetSubscriptionsByTipsterAndChannelQueryVariables>(GetSubscriptionsByTipsterAndChannelDocument, options);
      }
export function useGetSubscriptionsByTipsterAndChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsByTipsterAndChannelQuery, GetSubscriptionsByTipsterAndChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsByTipsterAndChannelQuery, GetSubscriptionsByTipsterAndChannelQueryVariables>(GetSubscriptionsByTipsterAndChannelDocument, options);
        }
export type GetSubscriptionsByTipsterAndChannelQueryHookResult = ReturnType<typeof useGetSubscriptionsByTipsterAndChannelQuery>;
export type GetSubscriptionsByTipsterAndChannelLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsByTipsterAndChannelLazyQuery>;
export type GetSubscriptionsByTipsterAndChannelQueryResult = Apollo.QueryResult<GetSubscriptionsByTipsterAndChannelQuery, GetSubscriptionsByTipsterAndChannelQueryVariables>;
export const GetServicesWithSubscriptionsDocument = gql`
    query GetServicesWithSubscriptions($tipsterId: String!, $channelId: String, $countryId: String) {
  servicesByTipsterId(tipsterId: $tipsterId, channelId: $channelId) {
    id
    tipsterId
    tipsterName
    imageLink
    info
    status
    title
    subTitle
    ctaTitle
    ctaSubTitle
    serviceName
    channelId
    channelName
    email
    paymentMethods {
      id
      paymentInfo
      paymentComment
      paymentType {
        paymentName
        id
        imageUrl
        isAutoActivated
        category
      }
    }
    subscriptions(countryId: $countryId) {
      id
      freeTrialPeriod
      price {
        id
        price
        currency {
          id
          name
          symbol
        }
        priceBreakdown {
          taxRate
          subTotal
          total
          vat
        }
      }
      serviceDuration {
        id
        duration
      }
    }
  }
}
    `;

/**
 * __useGetServicesWithSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetServicesWithSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesWithSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesWithSubscriptionsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      channelId: // value for 'channelId'
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetServicesWithSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<GetServicesWithSubscriptionsQuery, GetServicesWithSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesWithSubscriptionsQuery, GetServicesWithSubscriptionsQueryVariables>(GetServicesWithSubscriptionsDocument, options);
      }
export function useGetServicesWithSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesWithSubscriptionsQuery, GetServicesWithSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesWithSubscriptionsQuery, GetServicesWithSubscriptionsQueryVariables>(GetServicesWithSubscriptionsDocument, options);
        }
export type GetServicesWithSubscriptionsQueryHookResult = ReturnType<typeof useGetServicesWithSubscriptionsQuery>;
export type GetServicesWithSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetServicesWithSubscriptionsLazyQuery>;
export type GetServicesWithSubscriptionsQueryResult = Apollo.QueryResult<GetServicesWithSubscriptionsQuery, GetServicesWithSubscriptionsQueryVariables>;
export const GetServiceSubByUserAndSubDocument = gql`
    query GetServiceSubByUserAndSub($subscriptionId: String!, $userId: String!) {
  serviceSubscriptionByUserIdAndSubscriptionId(
    subscriptionId: $subscriptionId
    userId: $userId
  ) {
    id
    isTrialUsed
    status
  }
}
    `;

/**
 * __useGetServiceSubByUserAndSubQuery__
 *
 * To run a query within a React component, call `useGetServiceSubByUserAndSubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceSubByUserAndSubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceSubByUserAndSubQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetServiceSubByUserAndSubQuery(baseOptions: Apollo.QueryHookOptions<GetServiceSubByUserAndSubQuery, GetServiceSubByUserAndSubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceSubByUserAndSubQuery, GetServiceSubByUserAndSubQueryVariables>(GetServiceSubByUserAndSubDocument, options);
      }
export function useGetServiceSubByUserAndSubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceSubByUserAndSubQuery, GetServiceSubByUserAndSubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceSubByUserAndSubQuery, GetServiceSubByUserAndSubQueryVariables>(GetServiceSubByUserAndSubDocument, options);
        }
export type GetServiceSubByUserAndSubQueryHookResult = ReturnType<typeof useGetServiceSubByUserAndSubQuery>;
export type GetServiceSubByUserAndSubLazyQueryHookResult = ReturnType<typeof useGetServiceSubByUserAndSubLazyQuery>;
export type GetServiceSubByUserAndSubQueryResult = Apollo.QueryResult<GetServiceSubByUserAndSubQuery, GetServiceSubByUserAndSubQueryVariables>;
export const GetServiceSubscriptionDocument = gql`
    query GetServiceSubscription($id: String!) {
  serviceSubscription(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useGetServiceSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetServiceSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetServiceSubscriptionQuery, GetServiceSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceSubscriptionQuery, GetServiceSubscriptionQueryVariables>(GetServiceSubscriptionDocument, options);
      }
export function useGetServiceSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceSubscriptionQuery, GetServiceSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceSubscriptionQuery, GetServiceSubscriptionQueryVariables>(GetServiceSubscriptionDocument, options);
        }
export type GetServiceSubscriptionQueryHookResult = ReturnType<typeof useGetServiceSubscriptionQuery>;
export type GetServiceSubscriptionLazyQueryHookResult = ReturnType<typeof useGetServiceSubscriptionLazyQuery>;
export type GetServiceSubscriptionQueryResult = Apollo.QueryResult<GetServiceSubscriptionQuery, GetServiceSubscriptionQueryVariables>;
export const CreatePriceDocument = gql`
    mutation CreatePrice($input: PriceCreateInput!) {
  priceCreate(input: $input) {
    id
  }
}
    `;
export type CreatePriceMutationFn = Apollo.MutationFunction<CreatePriceMutation, CreatePriceMutationVariables>;

/**
 * __useCreatePriceMutation__
 *
 * To run a mutation, you first call `useCreatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriceMutation, { data, loading, error }] = useCreatePriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePriceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriceMutation, CreatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriceMutation, CreatePriceMutationVariables>(CreatePriceDocument, options);
      }
export type CreatePriceMutationHookResult = ReturnType<typeof useCreatePriceMutation>;
export type CreatePriceMutationResult = Apollo.MutationResult<CreatePriceMutation>;
export type CreatePriceMutationOptions = Apollo.BaseMutationOptions<CreatePriceMutation, CreatePriceMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: SubscriptionCreateInput!) {
  subscriptionCreate(input: $input) {
    id
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const GetSubscriptionsDocument = gql`
    query GetSubscriptions($limit: Float, $skip: Float, $reverse: Boolean, $sortKey: String) {
  subscriptions(limit: $limit, skip: $skip, reverse: $reverse, sortKey: $sortKey) {
    pageInfo {
      totalCount
    }
    edges {
      node {
        id
        countryIds
        price {
          currency {
            code
            name
            id
            symbol
          }
          priceBreakdown {
            taxRate
            subTotal
            total
            vat
          }
          price
          id
        }
        serviceId
        freeTrialPeriod
        service {
          tipsterId
          channelId
          channelName
          serviceName
          id
          status
          autoRenewal
          info
          imageLink
          paymentMethods {
            id
            paymentInfo
            paymentComment
            paymentType {
              paymentName
              id
              imageUrl
              isAutoActivated
            }
          }
        }
        serviceDuration {
          id
          duration
        }
        totalActiveSubs
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      reverse: // value for 'reverse'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetSubscribersListByTipsterDocument = gql`
    query GetSubscribersListByTipster($filter: ServiceSubscriberFilterInput) {
  getTipsterSubscribers(filter: $filter) {
    edges {
      node {
        id
        user {
          id
          displayName
        }
        name
        price
        status
        isPaid
        expiration
        isAutoActivated
        currencyCode
        currencySymbol
        paymentName
        subscriptionId
        createdAt
        paymentMethodId
        isTrialUsed
      }
    }
  }
}
    `;

/**
 * __useGetSubscribersListByTipsterQuery__
 *
 * To run a query within a React component, call `useGetSubscribersListByTipsterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscribersListByTipsterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscribersListByTipsterQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSubscribersListByTipsterQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscribersListByTipsterQuery, GetSubscribersListByTipsterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscribersListByTipsterQuery, GetSubscribersListByTipsterQueryVariables>(GetSubscribersListByTipsterDocument, options);
      }
export function useGetSubscribersListByTipsterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscribersListByTipsterQuery, GetSubscribersListByTipsterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscribersListByTipsterQuery, GetSubscribersListByTipsterQueryVariables>(GetSubscribersListByTipsterDocument, options);
        }
export type GetSubscribersListByTipsterQueryHookResult = ReturnType<typeof useGetSubscribersListByTipsterQuery>;
export type GetSubscribersListByTipsterLazyQueryHookResult = ReturnType<typeof useGetSubscribersListByTipsterLazyQuery>;
export type GetSubscribersListByTipsterQueryResult = Apollo.QueryResult<GetSubscribersListByTipsterQuery, GetSubscribersListByTipsterQueryVariables>;
export const GetUserPendingSubscriptionDocument = gql`
    query GetUserPendingSubscription {
  serviceSubscriptionsByUserId(includeExpired: true, status: "ONHOLD", limit: 1) {
    pageInfo {
      totalCount
    }
    edges {
      node {
        id
        expiration
        status
        userId
        createdAt
        paymentMethodId
        subscription {
          id
          freeTrialPeriod
          price {
            id
            price
            currency {
              id
              name
            }
            priceBreakdown {
              taxRate
              subTotal
              total
              vat
            }
          }
          serviceDuration {
            id
            duration
          }
          service {
            id
            tipsterId
            tipsterName
            imageLink
            info
            imageLink
            title
            subTitle
            ctaTitle
            ctaSubTitle
            serviceName
            paymentMethods {
              id
              paymentInfo
              paymentComment
              paymentType {
                paymentName
                id
                imageUrl
                isAutoActivated
              }
            }
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserPendingSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetUserPendingSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPendingSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPendingSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPendingSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPendingSubscriptionQuery, GetUserPendingSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPendingSubscriptionQuery, GetUserPendingSubscriptionQueryVariables>(GetUserPendingSubscriptionDocument, options);
      }
export function useGetUserPendingSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPendingSubscriptionQuery, GetUserPendingSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPendingSubscriptionQuery, GetUserPendingSubscriptionQueryVariables>(GetUserPendingSubscriptionDocument, options);
        }
export type GetUserPendingSubscriptionQueryHookResult = ReturnType<typeof useGetUserPendingSubscriptionQuery>;
export type GetUserPendingSubscriptionLazyQueryHookResult = ReturnType<typeof useGetUserPendingSubscriptionLazyQuery>;
export type GetUserPendingSubscriptionQueryResult = Apollo.QueryResult<GetUserPendingSubscriptionQuery, GetUserPendingSubscriptionQueryVariables>;
export const GetSubscriptionMetricsDocument = gql`
    query GetSubscriptionMetrics($tipsterId: String!, $startDate: String, $endDate: String) {
  getSubscriptionMetrics(
    tipsterId: $tipsterId
    startDate: $startDate
    endDate: $endDate
  ) {
    date
    newSubscriptions
    cumulativeActiveSubscriptions
  }
}
    `;

/**
 * __useGetSubscriptionMetricsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionMetricsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetSubscriptionMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionMetricsQuery, GetSubscriptionMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionMetricsQuery, GetSubscriptionMetricsQueryVariables>(GetSubscriptionMetricsDocument, options);
      }
export function useGetSubscriptionMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionMetricsQuery, GetSubscriptionMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionMetricsQuery, GetSubscriptionMetricsQueryVariables>(GetSubscriptionMetricsDocument, options);
        }
export type GetSubscriptionMetricsQueryHookResult = ReturnType<typeof useGetSubscriptionMetricsQuery>;
export type GetSubscriptionMetricsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionMetricsLazyQuery>;
export type GetSubscriptionMetricsQueryResult = Apollo.QueryResult<GetSubscriptionMetricsQuery, GetSubscriptionMetricsQueryVariables>;
export const GetTenantConfigDocument = gql`
    query GetTenantConfig {
  tenantConfig {
    tenantId
    demoProfileId
    featureFlags {
      key
      enabled
      metadata
    }
    branding {
      appName
      primaryColor
      secondaryColor
      logoUrl
      faviconUrl
      termsContent
      privacyContent
      rulesContent
    }
    integrationConfig {
      stripePublishableKey
      watchersApiKey
      watchersToken
      ssoProviders {
        provider
        allowedOrigins
      }
    }
  }
}
    `;

/**
 * __useGetTenantConfigQuery__
 *
 * To run a query within a React component, call `useGetTenantConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantConfigQuery, GetTenantConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantConfigQuery, GetTenantConfigQueryVariables>(GetTenantConfigDocument, options);
      }
export function useGetTenantConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantConfigQuery, GetTenantConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantConfigQuery, GetTenantConfigQueryVariables>(GetTenantConfigDocument, options);
        }
export type GetTenantConfigQueryHookResult = ReturnType<typeof useGetTenantConfigQuery>;
export type GetTenantConfigLazyQueryHookResult = ReturnType<typeof useGetTenantConfigLazyQuery>;
export type GetTenantConfigQueryResult = Apollo.QueryResult<GetTenantConfigQuery, GetTenantConfigQueryVariables>;
export const GetTipsSportDistributionDocument = gql`
    query GetTipsSportDistribution($userId: ID!, $startDate: String, $endDate: String, $sportIds: [String!]) {
  tipsSportDistribution(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
    sportIds: $sportIds
  ) {
    sports {
      sportId
      sportName
      count
    }
    totalCount
  }
}
    `;

/**
 * __useGetTipsSportDistributionQuery__
 *
 * To run a query within a React component, call `useGetTipsSportDistributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsSportDistributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsSportDistributionQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sportIds: // value for 'sportIds'
 *   },
 * });
 */
export function useGetTipsSportDistributionQuery(baseOptions: Apollo.QueryHookOptions<GetTipsSportDistributionQuery, GetTipsSportDistributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsSportDistributionQuery, GetTipsSportDistributionQueryVariables>(GetTipsSportDistributionDocument, options);
      }
export function useGetTipsSportDistributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsSportDistributionQuery, GetTipsSportDistributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsSportDistributionQuery, GetTipsSportDistributionQueryVariables>(GetTipsSportDistributionDocument, options);
        }
export type GetTipsSportDistributionQueryHookResult = ReturnType<typeof useGetTipsSportDistributionQuery>;
export type GetTipsSportDistributionLazyQueryHookResult = ReturnType<typeof useGetTipsSportDistributionLazyQuery>;
export type GetTipsSportDistributionQueryResult = Apollo.QueryResult<GetTipsSportDistributionQuery, GetTipsSportDistributionQueryVariables>;
export const GetTipsWithOutcomeNamesDocument = gql`
    query GetTipsWithOutcomeNames($userId: ID!, $startDate: String, $endDate: String, $sportIds: [String!]) {
  tipsWithOutcomeNames(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
    sportIds: $sportIds
  ) {
    tipId
    eventId
    outcomeId
    result
    outcomeName
    createdAt
  }
}
    `;

/**
 * __useGetTipsWithOutcomeNamesQuery__
 *
 * To run a query within a React component, call `useGetTipsWithOutcomeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsWithOutcomeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsWithOutcomeNamesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sportIds: // value for 'sportIds'
 *   },
 * });
 */
export function useGetTipsWithOutcomeNamesQuery(baseOptions: Apollo.QueryHookOptions<GetTipsWithOutcomeNamesQuery, GetTipsWithOutcomeNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsWithOutcomeNamesQuery, GetTipsWithOutcomeNamesQueryVariables>(GetTipsWithOutcomeNamesDocument, options);
      }
export function useGetTipsWithOutcomeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsWithOutcomeNamesQuery, GetTipsWithOutcomeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsWithOutcomeNamesQuery, GetTipsWithOutcomeNamesQueryVariables>(GetTipsWithOutcomeNamesDocument, options);
        }
export type GetTipsWithOutcomeNamesQueryHookResult = ReturnType<typeof useGetTipsWithOutcomeNamesQuery>;
export type GetTipsWithOutcomeNamesLazyQueryHookResult = ReturnType<typeof useGetTipsWithOutcomeNamesLazyQuery>;
export type GetTipsWithOutcomeNamesQueryResult = Apollo.QueryResult<GetTipsWithOutcomeNamesQuery, GetTipsWithOutcomeNamesQueryVariables>;
export const GetTipsterProfileDocument = gql`
    query GetTipsterProfile($id: ID!) {
  tipsterProfile(id: $id) {
    user {
      avatarUrl
      background
      bio
      bookies {
        bookieId
      }
      canEditPermissions
      competitions {
        competitionId
      }
      displayName
      firstName
      id
      lastName
      markets {
        marketId
      }
      role
      sports {
        sportId
      }
      subscriptionToTipster
      suggestedBank
    }
    avarageMonthFreeTips
    avarageMonthVipTips
    followers
    isFollowing
    subscribers
    totalTips
    winRate
  }
}
    `;

/**
 * __useGetTipsterProfileQuery__
 *
 * To run a query within a React component, call `useGetTipsterProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTipsterProfileQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterProfileQuery, GetTipsterProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterProfileQuery, GetTipsterProfileQueryVariables>(GetTipsterProfileDocument, options);
      }
export function useGetTipsterProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterProfileQuery, GetTipsterProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterProfileQuery, GetTipsterProfileQueryVariables>(GetTipsterProfileDocument, options);
        }
export type GetTipsterProfileQueryHookResult = ReturnType<typeof useGetTipsterProfileQuery>;
export type GetTipsterProfileLazyQueryHookResult = ReturnType<typeof useGetTipsterProfileLazyQuery>;
export type GetTipsterProfileQueryResult = Apollo.QueryResult<GetTipsterProfileQuery, GetTipsterProfileQueryVariables>;
export const GetTipsterStatsDocument = gql`
    query GetTipsterStats($tipsterId: ID!, $sportId: [ID!], $startDate: DateTime) {
  stats(tipsterId: $tipsterId, sportId: $sportId, startDate: $startDate) {
    avgOdds
    avgStake
    lost
    pending
    profit
    roi
    totalTips
    void
    winRate
    won
  }
}
    `;

/**
 * __useGetTipsterStatsQuery__
 *
 * To run a query within a React component, call `useGetTipsterStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterStatsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      sportId: // value for 'sportId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetTipsterStatsQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterStatsQuery, GetTipsterStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterStatsQuery, GetTipsterStatsQueryVariables>(GetTipsterStatsDocument, options);
      }
export function useGetTipsterStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterStatsQuery, GetTipsterStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterStatsQuery, GetTipsterStatsQueryVariables>(GetTipsterStatsDocument, options);
        }
export type GetTipsterStatsQueryHookResult = ReturnType<typeof useGetTipsterStatsQuery>;
export type GetTipsterStatsLazyQueryHookResult = ReturnType<typeof useGetTipsterStatsLazyQuery>;
export type GetTipsterStatsQueryResult = Apollo.QueryResult<GetTipsterStatsQuery, GetTipsterStatsQueryVariables>;
export const GetChatByTipsterIdDocument = gql`
    query GetChatByTipsterId($tipsterId: ID!) {
  chatByTipsterId(tipsterId: $tipsterId) {
    id
  }
}
    `;

/**
 * __useGetChatByTipsterIdQuery__
 *
 * To run a query within a React component, call `useGetChatByTipsterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByTipsterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByTipsterIdQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetChatByTipsterIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatByTipsterIdQuery, GetChatByTipsterIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatByTipsterIdQuery, GetChatByTipsterIdQueryVariables>(GetChatByTipsterIdDocument, options);
      }
export function useGetChatByTipsterIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatByTipsterIdQuery, GetChatByTipsterIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatByTipsterIdQuery, GetChatByTipsterIdQueryVariables>(GetChatByTipsterIdDocument, options);
        }
export type GetChatByTipsterIdQueryHookResult = ReturnType<typeof useGetChatByTipsterIdQuery>;
export type GetChatByTipsterIdLazyQueryHookResult = ReturnType<typeof useGetChatByTipsterIdLazyQuery>;
export type GetChatByTipsterIdQueryResult = Apollo.QueryResult<GetChatByTipsterIdQuery, GetChatByTipsterIdQueryVariables>;
export const GetTipsterStatImagesDocument = gql`
    query GetTipsterStatImages {
  getTipsterStatImages {
    id
    image
  }
}
    `;

/**
 * __useGetTipsterStatImagesQuery__
 *
 * To run a query within a React component, call `useGetTipsterStatImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterStatImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterStatImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTipsterStatImagesQuery(baseOptions?: Apollo.QueryHookOptions<GetTipsterStatImagesQuery, GetTipsterStatImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterStatImagesQuery, GetTipsterStatImagesQueryVariables>(GetTipsterStatImagesDocument, options);
      }
export function useGetTipsterStatImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterStatImagesQuery, GetTipsterStatImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterStatImagesQuery, GetTipsterStatImagesQueryVariables>(GetTipsterStatImagesDocument, options);
        }
export type GetTipsterStatImagesQueryHookResult = ReturnType<typeof useGetTipsterStatImagesQuery>;
export type GetTipsterStatImagesLazyQueryHookResult = ReturnType<typeof useGetTipsterStatImagesLazyQuery>;
export type GetTipsterStatImagesQueryResult = Apollo.QueryResult<GetTipsterStatImagesQuery, GetTipsterStatImagesQueryVariables>;
export const FindTipsterChannelsByDisplayNameDocument = gql`
    query FindTipsterChannelsByDisplayName($displayName: String!) {
  getTipsterChannelsByDisplayName(displayName: $displayName) {
    displayName
    id
    channelsWhereUserIsTipster {
      id
      channelName
      logo
    }
  }
}
    `;

/**
 * __useFindTipsterChannelsByDisplayNameQuery__
 *
 * To run a query within a React component, call `useFindTipsterChannelsByDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTipsterChannelsByDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTipsterChannelsByDisplayNameQuery({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useFindTipsterChannelsByDisplayNameQuery(baseOptions: Apollo.QueryHookOptions<FindTipsterChannelsByDisplayNameQuery, FindTipsterChannelsByDisplayNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTipsterChannelsByDisplayNameQuery, FindTipsterChannelsByDisplayNameQueryVariables>(FindTipsterChannelsByDisplayNameDocument, options);
      }
export function useFindTipsterChannelsByDisplayNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTipsterChannelsByDisplayNameQuery, FindTipsterChannelsByDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTipsterChannelsByDisplayNameQuery, FindTipsterChannelsByDisplayNameQueryVariables>(FindTipsterChannelsByDisplayNameDocument, options);
        }
export type FindTipsterChannelsByDisplayNameQueryHookResult = ReturnType<typeof useFindTipsterChannelsByDisplayNameQuery>;
export type FindTipsterChannelsByDisplayNameLazyQueryHookResult = ReturnType<typeof useFindTipsterChannelsByDisplayNameLazyQuery>;
export type FindTipsterChannelsByDisplayNameQueryResult = Apollo.QueryResult<FindTipsterChannelsByDisplayNameQuery, FindTipsterChannelsByDisplayNameQueryVariables>;
export const GetTipsterCurrenciesDocument = gql`
    query GetTipsterCurrencies($tipsterId: String!) {
  tipsterCurrencies(tipsterId: $tipsterId, limit: 9999999, skip: 0) {
    edges {
      node {
        id
        code
        name
        symbol
      }
    }
  }
}
    `;

/**
 * __useGetTipsterCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetTipsterCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterCurrenciesQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetTipsterCurrenciesQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterCurrenciesQuery, GetTipsterCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterCurrenciesQuery, GetTipsterCurrenciesQueryVariables>(GetTipsterCurrenciesDocument, options);
      }
export function useGetTipsterCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterCurrenciesQuery, GetTipsterCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterCurrenciesQuery, GetTipsterCurrenciesQueryVariables>(GetTipsterCurrenciesDocument, options);
        }
export type GetTipsterCurrenciesQueryHookResult = ReturnType<typeof useGetTipsterCurrenciesQuery>;
export type GetTipsterCurrenciesLazyQueryHookResult = ReturnType<typeof useGetTipsterCurrenciesLazyQuery>;
export type GetTipsterCurrenciesQueryResult = Apollo.QueryResult<GetTipsterCurrenciesQuery, GetTipsterCurrenciesQueryVariables>;
export const GetTipsterAvailablePaymentsDocument = gql`
    query GetTipsterAvailablePayments($tipsterId: String!) {
  tipsterAvailablePayments(tipsterId: $tipsterId, limit: 9999999, skip: 0) {
    edges {
      node {
        id
        imageUrl
        paymentName
        isAutoActivated
      }
    }
  }
}
    `;

/**
 * __useGetTipsterAvailablePaymentsQuery__
 *
 * To run a query within a React component, call `useGetTipsterAvailablePaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterAvailablePaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterAvailablePaymentsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetTipsterAvailablePaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterAvailablePaymentsQuery, GetTipsterAvailablePaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterAvailablePaymentsQuery, GetTipsterAvailablePaymentsQueryVariables>(GetTipsterAvailablePaymentsDocument, options);
      }
export function useGetTipsterAvailablePaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterAvailablePaymentsQuery, GetTipsterAvailablePaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterAvailablePaymentsQuery, GetTipsterAvailablePaymentsQueryVariables>(GetTipsterAvailablePaymentsDocument, options);
        }
export type GetTipsterAvailablePaymentsQueryHookResult = ReturnType<typeof useGetTipsterAvailablePaymentsQuery>;
export type GetTipsterAvailablePaymentsLazyQueryHookResult = ReturnType<typeof useGetTipsterAvailablePaymentsLazyQuery>;
export type GetTipsterAvailablePaymentsQueryResult = Apollo.QueryResult<GetTipsterAvailablePaymentsQuery, GetTipsterAvailablePaymentsQueryVariables>;
export const GetTipsterProfileStatsDocument = gql`
    query GetTipsterProfileStats($tipsterId: ID!) {
  tipsterProfileStats(tipsterId: $tipsterId) {
    winRate
    totalTips
    avgFreeTipsPerMonth
    avgVipTipsPerMonth
  }
}
    `;

/**
 * __useGetTipsterProfileStatsQuery__
 *
 * To run a query within a React component, call `useGetTipsterProfileStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterProfileStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterProfileStatsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetTipsterProfileStatsQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterProfileStatsQuery, GetTipsterProfileStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterProfileStatsQuery, GetTipsterProfileStatsQueryVariables>(GetTipsterProfileStatsDocument, options);
      }
export function useGetTipsterProfileStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterProfileStatsQuery, GetTipsterProfileStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterProfileStatsQuery, GetTipsterProfileStatsQueryVariables>(GetTipsterProfileStatsDocument, options);
        }
export type GetTipsterProfileStatsQueryHookResult = ReturnType<typeof useGetTipsterProfileStatsQuery>;
export type GetTipsterProfileStatsLazyQueryHookResult = ReturnType<typeof useGetTipsterProfileStatsLazyQuery>;
export type GetTipsterProfileStatsQueryResult = Apollo.QueryResult<GetTipsterProfileStatsQuery, GetTipsterProfileStatsQueryVariables>;
export const GetTipstersDocument = gql`
    query GetTipsters($limit: Int, $skip: Int) {
  tipsters: users(filter: {role: TIPSTER}, limit: $limit, skip: $skip) {
    count
    tipsterList: users {
      createdAt
      displayName
      emailAddress
      id
      lastName
      firstName
      onboardingStage
    }
  }
}
    `;

/**
 * __useGetTipstersQuery__
 *
 * To run a query within a React component, call `useGetTipstersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipstersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipstersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetTipstersQuery(baseOptions?: Apollo.QueryHookOptions<GetTipstersQuery, GetTipstersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipstersQuery, GetTipstersQueryVariables>(GetTipstersDocument, options);
      }
export function useGetTipstersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipstersQuery, GetTipstersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipstersQuery, GetTipstersQueryVariables>(GetTipstersDocument, options);
        }
export type GetTipstersQueryHookResult = ReturnType<typeof useGetTipstersQuery>;
export type GetTipstersLazyQueryHookResult = ReturnType<typeof useGetTipstersLazyQuery>;
export type GetTipstersQueryResult = Apollo.QueryResult<GetTipstersQuery, GetTipstersQueryVariables>;
export const GetTipsterOwnedChannelsDocument = gql`
    query GetTipsterOwnedChannels {
  tipsterOwnedChannels {
    id
    channelName
  }
}
    `;

/**
 * __useGetTipsterOwnedChannelsQuery__
 *
 * To run a query within a React component, call `useGetTipsterOwnedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterOwnedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterOwnedChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTipsterOwnedChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetTipsterOwnedChannelsQuery, GetTipsterOwnedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterOwnedChannelsQuery, GetTipsterOwnedChannelsQueryVariables>(GetTipsterOwnedChannelsDocument, options);
      }
export function useGetTipsterOwnedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterOwnedChannelsQuery, GetTipsterOwnedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterOwnedChannelsQuery, GetTipsterOwnedChannelsQueryVariables>(GetTipsterOwnedChannelsDocument, options);
        }
export type GetTipsterOwnedChannelsQueryHookResult = ReturnType<typeof useGetTipsterOwnedChannelsQuery>;
export type GetTipsterOwnedChannelsLazyQueryHookResult = ReturnType<typeof useGetTipsterOwnedChannelsLazyQuery>;
export type GetTipsterOwnedChannelsQueryResult = Apollo.QueryResult<GetTipsterOwnedChannelsQuery, GetTipsterOwnedChannelsQueryVariables>;
export const GetTotalChannelUsersDocument = gql`
    query GetTotalChannelUsers($userId: String!, $startDate: String, $endDate: String) {
  getTotalChannelUsers(userId: $userId, startDate: $startDate, endDate: $endDate) {
    date
    totalUsers
  }
}
    `;

/**
 * __useGetTotalChannelUsersQuery__
 *
 * To run a query within a React component, call `useGetTotalChannelUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalChannelUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalChannelUsersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTotalChannelUsersQuery(baseOptions: Apollo.QueryHookOptions<GetTotalChannelUsersQuery, GetTotalChannelUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalChannelUsersQuery, GetTotalChannelUsersQueryVariables>(GetTotalChannelUsersDocument, options);
      }
export function useGetTotalChannelUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalChannelUsersQuery, GetTotalChannelUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalChannelUsersQuery, GetTotalChannelUsersQueryVariables>(GetTotalChannelUsersDocument, options);
        }
export type GetTotalChannelUsersQueryHookResult = ReturnType<typeof useGetTotalChannelUsersQuery>;
export type GetTotalChannelUsersLazyQueryHookResult = ReturnType<typeof useGetTotalChannelUsersLazyQuery>;
export type GetTotalChannelUsersQueryResult = Apollo.QueryResult<GetTotalChannelUsersQuery, GetTotalChannelUsersQueryVariables>;
export const GetTrialMetricsDocument = gql`
    query GetTrialMetrics($tipsterId: String!, $startDate: String, $endDate: String) {
  getTrialMetrics(tipsterId: $tipsterId, startDate: $startDate, endDate: $endDate) {
    trialUsedCount
    percentageTrialUsedAndPaid
  }
}
    `;

/**
 * __useGetTrialMetricsQuery__
 *
 * To run a query within a React component, call `useGetTrialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialMetricsQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetTrialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetTrialMetricsQuery, GetTrialMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialMetricsQuery, GetTrialMetricsQueryVariables>(GetTrialMetricsDocument, options);
      }
export function useGetTrialMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialMetricsQuery, GetTrialMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialMetricsQuery, GetTrialMetricsQueryVariables>(GetTrialMetricsDocument, options);
        }
export type GetTrialMetricsQueryHookResult = ReturnType<typeof useGetTrialMetricsQuery>;
export type GetTrialMetricsLazyQueryHookResult = ReturnType<typeof useGetTrialMetricsLazyQuery>;
export type GetTrialMetricsQueryResult = Apollo.QueryResult<GetTrialMetricsQuery, GetTrialMetricsQueryVariables>;
export const GetUserStatsDocument = gql`
    query GetUserStats($sportId: [ID!], $startDate: DateTime, $endDate: DateTime) {
  userStats(sportId: $sportId, startDate: $startDate, endDate: $endDate) {
    avgOdds
    avgStake
    lost
    pending
    profit
    roi
    totalVotes
    void
    winRate
    won
    avgMonthVotes
  }
}
    `;

/**
 * __useGetUserStatsQuery__
 *
 * To run a query within a React component, call `useGetUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStatsQuery({
 *   variables: {
 *      sportId: // value for 'sportId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetUserStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserStatsQuery, GetUserStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserStatsQuery, GetUserStatsQueryVariables>(GetUserStatsDocument, options);
      }
export function useGetUserStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserStatsQuery, GetUserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserStatsQuery, GetUserStatsQueryVariables>(GetUserStatsDocument, options);
        }
export type GetUserStatsQueryHookResult = ReturnType<typeof useGetUserStatsQuery>;
export type GetUserStatsLazyQueryHookResult = ReturnType<typeof useGetUserStatsLazyQuery>;
export type GetUserStatsQueryResult = Apollo.QueryResult<GetUserStatsQuery, GetUserStatsQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  userCurrent {
    isTipsterAdmin
    countryId
    dateOfBirth
    displayName
    emailAddress
    firstName
    gender
    id
    lastName
    phoneNumber
    role
    avatarUrl
    background
    gender
    bio
    tipsterStatus
    userStatus
    permissions
    onboardingStage
    channelsWhereUserIsTipster {
      id
      channelName
      logo
    }
    followedChannels {
      id
      channelName
      logo
      settings {
        id
        value
        name
        scope
        category
        externalId
      }
    }
    unitValue
    unitShare
    oddsFormat
    favoriteTenantBookieId
    onboardingProgress {
      basicWelcome
      basicVideoExplainer
      contentWelcome
      contentVideoExplainer
      contentTipComparison
      contentTipMenu
      ContentDataTip
      ContentImageTip
      subscriptionMenu
      subscriptionWelcome
      subscriptionVideoExplainer
      subcriptionServiceMenu
      subscriptionFeatureBanner
      userInviteWelcome
      userInviteMenu
      startAppBanner
    }
  }
  hasPendingSubscription: checkCurrentUserHasPendingSubscription
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const UserDocument = gql`
    query User($userId: ID!) {
  user(id: $userId) {
    alternativeAvatarUrl
    alternativeName
    avatarUrl
    background
    bio
    bookies {
      bookieId
      userId
    }
    competitions {
      competitionId
      userId
    }
    country {
      code
      continent
      id
      name
    }
    countryId
    createdAt
    dateOfBirth
    deletedAt
    displayName
    emailAddress
    externalId
    firstName
    gender
    id
    lastName
    markets {
      marketId
      userId
    }
    minTipsNumber
    phoneNumber
    role
    sports {
      sportId
      userId
    }
    subscriptionDate
    subscriptionToContents {
      contentId
      contentType
      id
      paid
      userId
    }
    subscriptionToTipster
    tipsterStatus
    userStatus
    unitValue
    unitShare
    oddsFormat
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const GetCurrentUserFavouritesDocument = gql`
    query GetCurrentUserFavourites {
  userCurrent {
    bookies {
      bookieId
      userId
    }
    competitions {
      competitionId
      userId
    }
    markets {
      marketId
      userId
    }
    sports {
      sportId
      userId
    }
  }
}
    `;

/**
 * __useGetCurrentUserFavouritesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserFavouritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserFavouritesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserFavouritesQuery, GetCurrentUserFavouritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserFavouritesQuery, GetCurrentUserFavouritesQueryVariables>(GetCurrentUserFavouritesDocument, options);
      }
export function useGetCurrentUserFavouritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserFavouritesQuery, GetCurrentUserFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserFavouritesQuery, GetCurrentUserFavouritesQueryVariables>(GetCurrentUserFavouritesDocument, options);
        }
export type GetCurrentUserFavouritesQueryHookResult = ReturnType<typeof useGetCurrentUserFavouritesQuery>;
export type GetCurrentUserFavouritesLazyQueryHookResult = ReturnType<typeof useGetCurrentUserFavouritesLazyQuery>;
export type GetCurrentUserFavouritesQueryResult = Apollo.QueryResult<GetCurrentUserFavouritesQuery, GetCurrentUserFavouritesQueryVariables>;
export const GetUserRoleDocument = gql`
    query GetUserRole($userId: ID!) {
  user(id: $userId) {
    role
  }
}
    `;

/**
 * __useGetUserRoleQuery__
 *
 * To run a query within a React component, call `useGetUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUserRoleQuery, GetUserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRoleQuery, GetUserRoleQueryVariables>(GetUserRoleDocument, options);
      }
export function useGetUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRoleQuery, GetUserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRoleQuery, GetUserRoleQueryVariables>(GetUserRoleDocument, options);
        }
export type GetUserRoleQueryHookResult = ReturnType<typeof useGetUserRoleQuery>;
export type GetUserRoleLazyQueryHookResult = ReturnType<typeof useGetUserRoleLazyQuery>;
export type GetUserRoleQueryResult = Apollo.QueryResult<GetUserRoleQuery, GetUserRoleQueryVariables>;
export const UsersByIdsDocument = gql`
    query UsersByIds($userIds: [String!]!) {
  usersByIds(userIds: $userIds) {
    displayName
    avatarUrl
    id
    role
  }
}
    `;

/**
 * __useUsersByIdsQuery__
 *
 * To run a query within a React component, call `useUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUsersByIdsQuery(baseOptions: Apollo.QueryHookOptions<UsersByIdsQuery, UsersByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByIdsQuery, UsersByIdsQueryVariables>(UsersByIdsDocument, options);
      }
export function useUsersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByIdsQuery, UsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByIdsQuery, UsersByIdsQueryVariables>(UsersByIdsDocument, options);
        }
export type UsersByIdsQueryHookResult = ReturnType<typeof useUsersByIdsQuery>;
export type UsersByIdsLazyQueryHookResult = ReturnType<typeof useUsersByIdsLazyQuery>;
export type UsersByIdsQueryResult = Apollo.QueryResult<UsersByIdsQuery, UsersByIdsQueryVariables>;
export const GetCurrentUserSubsDocument = gql`
    query GetCurrentUserSubs($includeExpired: Boolean!, $limit: Float, $skip: Float) {
  serviceSubscriptionsByUserId(
    includeExpired: $includeExpired
    limit: $limit
    skip: $skip
  ) {
    pageInfo {
      totalCount
      hasNextPage
    }
    edges {
      node {
        expiration
        id
        status
        serviceName
        subscriptionDuration
        subscriptionPrice
        subscriptionCurrencyCode
        subscriptionCurrencySymbol
        channelId
        paymentMethodId
        isTrialUsed
        createdAt
        subscription {
          freeTrialPeriod
          service {
            avatarUrl
            tipsterName
            status
            paymentMethods {
              id
              paymentType {
                id
                paymentName
                imageUrl
                isAutoActivated
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserSubsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserSubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserSubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserSubsQuery({
 *   variables: {
 *      includeExpired: // value for 'includeExpired'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetCurrentUserSubsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserSubsQuery, GetCurrentUserSubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserSubsQuery, GetCurrentUserSubsQueryVariables>(GetCurrentUserSubsDocument, options);
      }
export function useGetCurrentUserSubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserSubsQuery, GetCurrentUserSubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserSubsQuery, GetCurrentUserSubsQueryVariables>(GetCurrentUserSubsDocument, options);
        }
export type GetCurrentUserSubsQueryHookResult = ReturnType<typeof useGetCurrentUserSubsQuery>;
export type GetCurrentUserSubsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserSubsLazyQuery>;
export type GetCurrentUserSubsQueryResult = Apollo.QueryResult<GetCurrentUserSubsQuery, GetCurrentUserSubsQueryVariables>;
export const GetUserDataForChatDocument = gql`
    query GetUserDataForChat($userId: ID!) {
  user(id: $userId) {
    avatarUrl
    displayName
    id
    role
  }
}
    `;

/**
 * __useGetUserDataForChatQuery__
 *
 * To run a query within a React component, call `useGetUserDataForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataForChatQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDataForChatQuery(baseOptions: Apollo.QueryHookOptions<GetUserDataForChatQuery, GetUserDataForChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataForChatQuery, GetUserDataForChatQueryVariables>(GetUserDataForChatDocument, options);
      }
export function useGetUserDataForChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataForChatQuery, GetUserDataForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataForChatQuery, GetUserDataForChatQueryVariables>(GetUserDataForChatDocument, options);
        }
export type GetUserDataForChatQueryHookResult = ReturnType<typeof useGetUserDataForChatQuery>;
export type GetUserDataForChatLazyQueryHookResult = ReturnType<typeof useGetUserDataForChatLazyQuery>;
export type GetUserDataForChatQueryResult = Apollo.QueryResult<GetUserDataForChatQuery, GetUserDataForChatQueryVariables>;
export const GetTipsterFollowersDocument = gql`
    query GetTipsterFollowers($tipsterId: ID!) {
  tipsterFollowers(tipsterId: $tipsterId)
}
    `;

/**
 * __useGetTipsterFollowersQuery__
 *
 * To run a query within a React component, call `useGetTipsterFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTipsterFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTipsterFollowersQuery({
 *   variables: {
 *      tipsterId: // value for 'tipsterId'
 *   },
 * });
 */
export function useGetTipsterFollowersQuery(baseOptions: Apollo.QueryHookOptions<GetTipsterFollowersQuery, GetTipsterFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTipsterFollowersQuery, GetTipsterFollowersQueryVariables>(GetTipsterFollowersDocument, options);
      }
export function useGetTipsterFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTipsterFollowersQuery, GetTipsterFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTipsterFollowersQuery, GetTipsterFollowersQueryVariables>(GetTipsterFollowersDocument, options);
        }
export type GetTipsterFollowersQueryHookResult = ReturnType<typeof useGetTipsterFollowersQuery>;
export type GetTipsterFollowersLazyQueryHookResult = ReturnType<typeof useGetTipsterFollowersLazyQuery>;
export type GetTipsterFollowersQueryResult = Apollo.QueryResult<GetTipsterFollowersQuery, GetTipsterFollowersQueryVariables>;
export const GetVerifiedEmailFromTokenDocument = gql`
    query GetVerifiedEmailFromToken($token: String!) {
  verifyEmailToken(token: $token)
}
    `;

/**
 * __useGetVerifiedEmailFromTokenQuery__
 *
 * To run a query within a React component, call `useGetVerifiedEmailFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedEmailFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedEmailFromTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetVerifiedEmailFromTokenQuery(baseOptions: Apollo.QueryHookOptions<GetVerifiedEmailFromTokenQuery, GetVerifiedEmailFromTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVerifiedEmailFromTokenQuery, GetVerifiedEmailFromTokenQueryVariables>(GetVerifiedEmailFromTokenDocument, options);
      }
export function useGetVerifiedEmailFromTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVerifiedEmailFromTokenQuery, GetVerifiedEmailFromTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVerifiedEmailFromTokenQuery, GetVerifiedEmailFromTokenQueryVariables>(GetVerifiedEmailFromTokenDocument, options);
        }
export type GetVerifiedEmailFromTokenQueryHookResult = ReturnType<typeof useGetVerifiedEmailFromTokenQuery>;
export type GetVerifiedEmailFromTokenLazyQueryHookResult = ReturnType<typeof useGetVerifiedEmailFromTokenLazyQuery>;
export type GetVerifiedEmailFromTokenQueryResult = Apollo.QueryResult<GetVerifiedEmailFromTokenQuery, GetVerifiedEmailFromTokenQueryVariables>;
export const GetSignupEmailFromTokenDocument = gql`
    query GetSignupEmailFromToken($token: String!) {
  getSignupEmailFromToken(token: $token) {
    email
  }
}
    `;

/**
 * __useGetSignupEmailFromTokenQuery__
 *
 * To run a query within a React component, call `useGetSignupEmailFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignupEmailFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignupEmailFromTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetSignupEmailFromTokenQuery(baseOptions: Apollo.QueryHookOptions<GetSignupEmailFromTokenQuery, GetSignupEmailFromTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignupEmailFromTokenQuery, GetSignupEmailFromTokenQueryVariables>(GetSignupEmailFromTokenDocument, options);
      }
export function useGetSignupEmailFromTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignupEmailFromTokenQuery, GetSignupEmailFromTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignupEmailFromTokenQuery, GetSignupEmailFromTokenQueryVariables>(GetSignupEmailFromTokenDocument, options);
        }
export type GetSignupEmailFromTokenQueryHookResult = ReturnType<typeof useGetSignupEmailFromTokenQuery>;
export type GetSignupEmailFromTokenLazyQueryHookResult = ReturnType<typeof useGetSignupEmailFromTokenLazyQuery>;
export type GetSignupEmailFromTokenQueryResult = Apollo.QueryResult<GetSignupEmailFromTokenQuery, GetSignupEmailFromTokenQueryVariables>;
export const PollResultSubscriptionDocument = gql`
    subscription PollResultSubscription {
  pollResult
}
    `;

/**
 * __usePollResultSubscriptionSubscription__
 *
 * To run a query within a React component, call `usePollResultSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePollResultSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollResultSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePollResultSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PollResultSubscriptionSubscription, PollResultSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PollResultSubscriptionSubscription, PollResultSubscriptionSubscriptionVariables>(PollResultSubscriptionDocument, options);
      }
export type PollResultSubscriptionSubscriptionHookResult = ReturnType<typeof usePollResultSubscriptionSubscription>;
export type PollResultSubscriptionSubscriptionResult = Apollo.SubscriptionResult<PollResultSubscriptionSubscription>;